(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8aa2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8aa2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2kzMM", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1b2935584d52f656$export$ffb0004e005737fa, (v) => $1b2935584d52f656$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $1b2935584d52f656$export$34b9dba7ce09269b, (v) => $1b2935584d52f656$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $1b2935584d52f656$export$25062201e9e25d76, (v) => $1b2935584d52f656$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1b2935584d52f656$export$ffb0004e005737fa;
var $1b2935584d52f656$export$34b9dba7ce09269b;
var $1b2935584d52f656$export$25062201e9e25d76;
"use strict";
var $1b2935584d52f656$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $1b2935584d52f656$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $1b2935584d52f656$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $1b2935584d52f656$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$1b2935584d52f656$export$ffb0004e005737fa = $1b2935584d52f656$var$REACT_FRAGMENT_TYPE;
$1b2935584d52f656$export$34b9dba7ce09269b = $1b2935584d52f656$var$jsxProd;
$1b2935584d52f656$export$25062201e9e25d76 = $1b2935584d52f656$var$jsxProd;

});

parcelRegister("gNTjK", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $c3bc21db9fc66909$export$882461b6382ed46c, (v) => $c3bc21db9fc66909$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $c3bc21db9fc66909$export$757ceba2d55c277e, (v) => $c3bc21db9fc66909$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $c3bc21db9fc66909$export$83d89fbfd8236492, (v) => $c3bc21db9fc66909$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c3bc21db9fc66909$export$882461b6382ed46c;
var $c3bc21db9fc66909$export$757ceba2d55c277e;
var $c3bc21db9fc66909$export$83d89fbfd8236492;
"use strict";

var $clk2u = parcelRequire("clk2u");

var $8NFma = parcelRequire("8NFma");

var $2pmb0 = parcelRequire("2pmb0");
function $c3bc21db9fc66909$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c3bc21db9fc66909$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $c3bc21db9fc66909$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $c3bc21db9fc66909$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $c3bc21db9fc66909$var$assertIsMounted(fiber) {
    if ($c3bc21db9fc66909$var$getNearestMountedFiber(fiber) !== fiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
}
function $c3bc21db9fc66909$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $c3bc21db9fc66909$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $c3bc21db9fc66909$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $c3bc21db9fc66909$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $c3bc21db9fc66909$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $c3bc21db9fc66909$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $c3bc21db9fc66909$var$assign = Object.assign, $c3bc21db9fc66909$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $c3bc21db9fc66909$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $c3bc21db9fc66909$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $c3bc21db9fc66909$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $c3bc21db9fc66909$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $c3bc21db9fc66909$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $c3bc21db9fc66909$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $c3bc21db9fc66909$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $c3bc21db9fc66909$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $c3bc21db9fc66909$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $c3bc21db9fc66909$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $c3bc21db9fc66909$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$c3bc21db9fc66909$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $c3bc21db9fc66909$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $c3bc21db9fc66909$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $c3bc21db9fc66909$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $c3bc21db9fc66909$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $c3bc21db9fc66909$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $c3bc21db9fc66909$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $c3bc21db9fc66909$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $c3bc21db9fc66909$var$getComponentNameFromType(type.type) || "Memo";
        case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $c3bc21db9fc66909$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $c3bc21db9fc66909$var$isArrayImpl = Array.isArray, $c3bc21db9fc66909$var$ReactSharedInternals = $8NFma.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c3bc21db9fc66909$var$ReactDOMSharedInternals = $2pmb0.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c3bc21db9fc66909$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $c3bc21db9fc66909$var$valueStack = [], $c3bc21db9fc66909$var$index = -1;
function $c3bc21db9fc66909$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $c3bc21db9fc66909$var$pop(cursor) {
    0 > $c3bc21db9fc66909$var$index || (cursor.current = $c3bc21db9fc66909$var$valueStack[$c3bc21db9fc66909$var$index], $c3bc21db9fc66909$var$valueStack[$c3bc21db9fc66909$var$index] = null, $c3bc21db9fc66909$var$index--);
}
function $c3bc21db9fc66909$var$push(cursor, value) {
    $c3bc21db9fc66909$var$index++;
    $c3bc21db9fc66909$var$valueStack[$c3bc21db9fc66909$var$index] = cursor.current;
    cursor.current = value;
}
var $c3bc21db9fc66909$var$contextStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$contextFiberStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$rootInstanceStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$hostTransitionProviderCursor = $c3bc21db9fc66909$var$createCursor(null);
function $c3bc21db9fc66909$var$pushHostContainer(fiber, nextRootInstance) {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$rootInstanceStackCursor, nextRootInstance);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextFiberStackCursor, fiber);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $c3bc21db9fc66909$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $c3bc21db9fc66909$var$getOwnHostContext(nextRootInstance), fiber = $c3bc21db9fc66909$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextStackCursor);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextStackCursor, fiber);
}
function $c3bc21db9fc66909$var$popHostContainer() {
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextStackCursor);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextFiberStackCursor);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$rootInstanceStackCursor);
}
function $c3bc21db9fc66909$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$hostTransitionProviderCursor, fiber);
    var context = $c3bc21db9fc66909$var$contextStackCursor.current;
    var JSCompiler_inline_result = $c3bc21db9fc66909$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextFiberStackCursor, fiber), $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$contextStackCursor, JSCompiler_inline_result));
}
function $c3bc21db9fc66909$var$popHostContext(fiber) {
    $c3bc21db9fc66909$var$contextFiberStackCursor.current === fiber && ($c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextStackCursor), $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$contextFiberStackCursor));
    $c3bc21db9fc66909$var$hostTransitionProviderCursor.current === fiber && ($c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$hostTransitionProviderCursor), $c3bc21db9fc66909$var$HostTransitionContext._currentValue = $c3bc21db9fc66909$var$sharedNotPendingObject);
}
var $c3bc21db9fc66909$var$hasOwnProperty = Object.prototype.hasOwnProperty, $c3bc21db9fc66909$var$scheduleCallback$3 = $clk2u.unstable_scheduleCallback, $c3bc21db9fc66909$var$cancelCallback$1 = $clk2u.unstable_cancelCallback, $c3bc21db9fc66909$var$shouldYield = $clk2u.unstable_shouldYield, $c3bc21db9fc66909$var$requestPaint = $clk2u.unstable_requestPaint, $c3bc21db9fc66909$var$now = $clk2u.unstable_now, $c3bc21db9fc66909$var$getCurrentPriorityLevel = $clk2u.unstable_getCurrentPriorityLevel, $c3bc21db9fc66909$var$ImmediatePriority = $clk2u.unstable_ImmediatePriority, $c3bc21db9fc66909$var$UserBlockingPriority = $clk2u.unstable_UserBlockingPriority, $c3bc21db9fc66909$var$NormalPriority$1 = $clk2u.unstable_NormalPriority, $c3bc21db9fc66909$var$LowPriority = $clk2u.unstable_LowPriority, $c3bc21db9fc66909$var$IdlePriority = $clk2u.unstable_IdlePriority, $c3bc21db9fc66909$var$log$1 = $clk2u.log, $c3bc21db9fc66909$var$unstable_setDisableYieldValue = $clk2u.unstable_setDisableYieldValue, $c3bc21db9fc66909$var$rendererID = null, $c3bc21db9fc66909$var$injectedHook = null;
function $c3bc21db9fc66909$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $c3bc21db9fc66909$var$log$1 && $c3bc21db9fc66909$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.setStrictMode) try {
        $c3bc21db9fc66909$var$injectedHook.setStrictMode($c3bc21db9fc66909$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $c3bc21db9fc66909$var$clz32 = Math.clz32 ? Math.clz32 : $c3bc21db9fc66909$var$clz32Fallback, $c3bc21db9fc66909$var$log = Math.log, $c3bc21db9fc66909$var$LN2 = Math.LN2;
function $c3bc21db9fc66909$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($c3bc21db9fc66909$var$log(x) / $c3bc21db9fc66909$var$LN2 | 0) | 0;
}
var $c3bc21db9fc66909$var$nextTransitionLane = 256, $c3bc21db9fc66909$var$nextRetryLane = 4194304;
function $c3bc21db9fc66909$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $c3bc21db9fc66909$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $c3bc21db9fc66909$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c3bc21db9fc66909$var$claimNextTransitionLane() {
    var lane = $c3bc21db9fc66909$var$nextTransitionLane;
    $c3bc21db9fc66909$var$nextTransitionLane <<= 1;
    0 === ($c3bc21db9fc66909$var$nextTransitionLane & 4194048) && ($c3bc21db9fc66909$var$nextTransitionLane = 256);
    return lane;
}
function $c3bc21db9fc66909$var$claimNextRetryLane() {
    var lane = $c3bc21db9fc66909$var$nextRetryLane;
    $c3bc21db9fc66909$var$nextRetryLane <<= 1;
    0 === ($c3bc21db9fc66909$var$nextRetryLane & 62914560) && ($c3bc21db9fc66909$var$nextRetryLane = 4194304);
    return lane;
}
function $c3bc21db9fc66909$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $c3bc21db9fc66909$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $c3bc21db9fc66909$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $c3bc21db9fc66909$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $c3bc21db9fc66909$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $c3bc21db9fc66909$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $c3bc21db9fc66909$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $c3bc21db9fc66909$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $c3bc21db9fc66909$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $c3bc21db9fc66909$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $c3bc21db9fc66909$var$resolveUpdatePriority() {
    var updatePriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $c3bc21db9fc66909$var$getEventPriority(updatePriority.type);
}
function $c3bc21db9fc66909$var$runWithPriority(priority, fn) {
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        return $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $c3bc21db9fc66909$var$randomKey = Math.random().toString(36).slice(2), $c3bc21db9fc66909$var$internalInstanceKey = "__reactFiber$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalPropsKey = "__reactProps$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalContainerInstanceKey = "__reactContainer$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalEventHandlersKey = "__reactEvents$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalEventHandlerListenersKey = "__reactListeners$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalEventHandlesSetKey = "__reactHandles$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalRootNodeResourcesKey = "__reactResources$" + $c3bc21db9fc66909$var$randomKey, $c3bc21db9fc66909$var$internalHoistableMarker = "__reactMarker$" + $c3bc21db9fc66909$var$randomKey;
function $c3bc21db9fc66909$var$detachDeletedInstance(node) {
    delete node[$c3bc21db9fc66909$var$internalInstanceKey];
    delete node[$c3bc21db9fc66909$var$internalPropsKey];
    delete node[$c3bc21db9fc66909$var$internalEventHandlersKey];
    delete node[$c3bc21db9fc66909$var$internalEventHandlerListenersKey];
    delete node[$c3bc21db9fc66909$var$internalEventHandlesSetKey];
}
function $c3bc21db9fc66909$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$c3bc21db9fc66909$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$c3bc21db9fc66909$var$internalContainerInstanceKey] || parentNode[$c3bc21db9fc66909$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $c3bc21db9fc66909$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$c3bc21db9fc66909$var$internalInstanceKey]) return parentNode;
                targetNode = $c3bc21db9fc66909$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $c3bc21db9fc66909$var$getInstanceFromNode(node) {
    if (node = node[$c3bc21db9fc66909$var$internalInstanceKey] || node[$c3bc21db9fc66909$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $c3bc21db9fc66909$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(33));
}
function $c3bc21db9fc66909$var$getResourcesFromRoot(root) {
    var resources = root[$c3bc21db9fc66909$var$internalRootNodeResourcesKey];
    resources || (resources = root[$c3bc21db9fc66909$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $c3bc21db9fc66909$var$markNodeAsHoistable(node) {
    node[$c3bc21db9fc66909$var$internalHoistableMarker] = !0;
}
var $c3bc21db9fc66909$var$allNativeEvents = new Set(), $c3bc21db9fc66909$var$registrationNameDependencies = {};
function $c3bc21db9fc66909$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $c3bc21db9fc66909$var$registerDirectEvent(registrationName, dependencies);
    $c3bc21db9fc66909$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $c3bc21db9fc66909$var$registerDirectEvent(registrationName, dependencies) {
    $c3bc21db9fc66909$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$c3bc21db9fc66909$var$allNativeEvents.add(dependencies[registrationName]);
}
var $c3bc21db9fc66909$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $c3bc21db9fc66909$var$illegalAttributeNameCache = {}, $c3bc21db9fc66909$var$validatedAttributeNameCache = {};
function $c3bc21db9fc66909$var$isAttributeNameSafe(attributeName) {
    if ($c3bc21db9fc66909$var$hasOwnProperty.call($c3bc21db9fc66909$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($c3bc21db9fc66909$var$hasOwnProperty.call($c3bc21db9fc66909$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($c3bc21db9fc66909$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $c3bc21db9fc66909$var$validatedAttributeNameCache[attributeName] = !0;
    $c3bc21db9fc66909$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $c3bc21db9fc66909$var$setValueForAttribute(node, name, value) {
    if ($c3bc21db9fc66909$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $c3bc21db9fc66909$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $c3bc21db9fc66909$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $c3bc21db9fc66909$var$prefix, $c3bc21db9fc66909$var$suffix;
function $c3bc21db9fc66909$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $c3bc21db9fc66909$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $c3bc21db9fc66909$var$prefix = match && match[1] || "";
        $c3bc21db9fc66909$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $c3bc21db9fc66909$var$prefix + name + $c3bc21db9fc66909$var$suffix;
}
var $c3bc21db9fc66909$var$reentry = !1;
function $c3bc21db9fc66909$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $c3bc21db9fc66909$var$reentry) return "";
    $c3bc21db9fc66909$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $c3bc21db9fc66909$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $c3bc21db9fc66909$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $c3bc21db9fc66909$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $c3bc21db9fc66909$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $c3bc21db9fc66909$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $c3bc21db9fc66909$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $c3bc21db9fc66909$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $c3bc21db9fc66909$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $c3bc21db9fc66909$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $c3bc21db9fc66909$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $c3bc21db9fc66909$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $c3bc21db9fc66909$var$trackValueOnNode(node) {
    var valueField = $c3bc21db9fc66909$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $c3bc21db9fc66909$var$track(node) {
    node._valueTracker || (node._valueTracker = $c3bc21db9fc66909$var$trackValueOnNode(node));
}
function $c3bc21db9fc66909$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $c3bc21db9fc66909$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $c3bc21db9fc66909$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $c3bc21db9fc66909$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $c3bc21db9fc66909$var$getToStringValue(value);
        } else element.value !== "" + $c3bc21db9fc66909$var$getToStringValue(value) && (element.value = "" + $c3bc21db9fc66909$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $c3bc21db9fc66909$var$setDefaultValue(element, type, $c3bc21db9fc66909$var$getToStringValue(value)) : null != defaultValue ? $c3bc21db9fc66909$var$setDefaultValue(element, type, $c3bc21db9fc66909$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $c3bc21db9fc66909$var$getToStringValue(name) : element.removeAttribute("name");
}
function $c3bc21db9fc66909$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $c3bc21db9fc66909$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $c3bc21db9fc66909$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $c3bc21db9fc66909$var$setDefaultValue(node, type, value) {
    "number" === type && $c3bc21db9fc66909$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $c3bc21db9fc66909$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $c3bc21db9fc66909$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $c3bc21db9fc66909$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $c3bc21db9fc66909$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $c3bc21db9fc66909$var$getToStringValue(defaultValue) : "";
}
function $c3bc21db9fc66909$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(92));
            if ($c3bc21db9fc66909$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $c3bc21db9fc66909$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $c3bc21db9fc66909$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $c3bc21db9fc66909$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $c3bc21db9fc66909$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $c3bc21db9fc66909$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $c3bc21db9fc66909$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $c3bc21db9fc66909$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $c3bc21db9fc66909$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $c3bc21db9fc66909$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c3bc21db9fc66909$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $c3bc21db9fc66909$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $c3bc21db9fc66909$var$sanitizeURL(url) {
    return $c3bc21db9fc66909$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $c3bc21db9fc66909$var$currentReplayingEvent = null;
function $c3bc21db9fc66909$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $c3bc21db9fc66909$var$restoreTarget = null, $c3bc21db9fc66909$var$restoreQueue = null;
function $c3bc21db9fc66909$var$restoreStateOfTarget(target) {
    var internalInstance = $c3bc21db9fc66909$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$c3bc21db9fc66909$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $c3bc21db9fc66909$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$c3bc21db9fc66909$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(90));
                            $c3bc21db9fc66909$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $c3bc21db9fc66909$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $c3bc21db9fc66909$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $c3bc21db9fc66909$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $c3bc21db9fc66909$var$isInsideEventHandler = !1;
function $c3bc21db9fc66909$var$batchedUpdates$1(fn, a, b) {
    if ($c3bc21db9fc66909$var$isInsideEventHandler) return fn(a, b);
    $c3bc21db9fc66909$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($c3bc21db9fc66909$var$isInsideEventHandler = !1, null !== $c3bc21db9fc66909$var$restoreTarget || null !== $c3bc21db9fc66909$var$restoreQueue) {
            if ($c3bc21db9fc66909$var$flushSyncWork$1(), $c3bc21db9fc66909$var$restoreTarget && (a = $c3bc21db9fc66909$var$restoreTarget, fn = $c3bc21db9fc66909$var$restoreQueue, $c3bc21db9fc66909$var$restoreQueue = $c3bc21db9fc66909$var$restoreTarget = null, $c3bc21db9fc66909$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$c3bc21db9fc66909$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $c3bc21db9fc66909$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$c3bc21db9fc66909$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $c3bc21db9fc66909$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c3bc21db9fc66909$var$passiveBrowserEventsSupported = !1;
if ($c3bc21db9fc66909$var$canUseDOM) try {
    var $c3bc21db9fc66909$var$options = {};
    Object.defineProperty($c3bc21db9fc66909$var$options, "passive", {
        get: function() {
            $c3bc21db9fc66909$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $c3bc21db9fc66909$var$options, $c3bc21db9fc66909$var$options);
    window.removeEventListener("test", $c3bc21db9fc66909$var$options, $c3bc21db9fc66909$var$options);
} catch (e) {
    $c3bc21db9fc66909$var$passiveBrowserEventsSupported = !1;
}
var $c3bc21db9fc66909$var$root = null, $c3bc21db9fc66909$var$startText = null, $c3bc21db9fc66909$var$fallbackText = null;
function $c3bc21db9fc66909$var$getData() {
    if ($c3bc21db9fc66909$var$fallbackText) return $c3bc21db9fc66909$var$fallbackText;
    var start, startValue = $c3bc21db9fc66909$var$startText, startLength = startValue.length, end, endValue = "value" in $c3bc21db9fc66909$var$root ? $c3bc21db9fc66909$var$root.value : $c3bc21db9fc66909$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $c3bc21db9fc66909$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $c3bc21db9fc66909$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $c3bc21db9fc66909$var$functionThatReturnsTrue() {
    return !0;
}
function $c3bc21db9fc66909$var$functionThatReturnsFalse() {
    return !1;
}
function $c3bc21db9fc66909$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $c3bc21db9fc66909$var$functionThatReturnsTrue : $c3bc21db9fc66909$var$functionThatReturnsFalse;
        this.isPropagationStopped = $c3bc21db9fc66909$var$functionThatReturnsFalse;
        return this;
    }
    $c3bc21db9fc66909$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $c3bc21db9fc66909$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $c3bc21db9fc66909$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $c3bc21db9fc66909$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $c3bc21db9fc66909$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c3bc21db9fc66909$var$SyntheticEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$EventInterface), $c3bc21db9fc66909$var$UIEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    view: 0,
    detail: 0
}), $c3bc21db9fc66909$var$SyntheticUIEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$UIEventInterface), $c3bc21db9fc66909$var$lastMovementX, $c3bc21db9fc66909$var$lastMovementY, $c3bc21db9fc66909$var$lastMouseEvent, $c3bc21db9fc66909$var$MouseEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c3bc21db9fc66909$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $c3bc21db9fc66909$var$lastMouseEvent && ($c3bc21db9fc66909$var$lastMouseEvent && "mousemove" === event.type ? ($c3bc21db9fc66909$var$lastMovementX = event.screenX - $c3bc21db9fc66909$var$lastMouseEvent.screenX, $c3bc21db9fc66909$var$lastMovementY = event.screenY - $c3bc21db9fc66909$var$lastMouseEvent.screenY) : $c3bc21db9fc66909$var$lastMovementY = $c3bc21db9fc66909$var$lastMovementX = 0, $c3bc21db9fc66909$var$lastMouseEvent = event);
        return $c3bc21db9fc66909$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $c3bc21db9fc66909$var$lastMovementY;
    }
}), $c3bc21db9fc66909$var$SyntheticMouseEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$MouseEventInterface), $c3bc21db9fc66909$var$DragEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$MouseEventInterface, {
    dataTransfer: 0
}), $c3bc21db9fc66909$var$SyntheticDragEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$DragEventInterface), $c3bc21db9fc66909$var$FocusEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    relatedTarget: 0
}), $c3bc21db9fc66909$var$SyntheticFocusEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$FocusEventInterface), $c3bc21db9fc66909$var$AnimationEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c3bc21db9fc66909$var$SyntheticAnimationEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$AnimationEventInterface), $c3bc21db9fc66909$var$ClipboardEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $c3bc21db9fc66909$var$SyntheticClipboardEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$ClipboardEventInterface), $c3bc21db9fc66909$var$CompositionEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    data: 0
}), $c3bc21db9fc66909$var$SyntheticCompositionEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$CompositionEventInterface), $c3bc21db9fc66909$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c3bc21db9fc66909$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c3bc21db9fc66909$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c3bc21db9fc66909$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $c3bc21db9fc66909$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $c3bc21db9fc66909$var$getEventModifierState() {
    return $c3bc21db9fc66909$var$modifierStateGetter;
}
var $c3bc21db9fc66909$var$KeyboardEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $c3bc21db9fc66909$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $c3bc21db9fc66909$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $c3bc21db9fc66909$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c3bc21db9fc66909$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $c3bc21db9fc66909$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $c3bc21db9fc66909$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $c3bc21db9fc66909$var$SyntheticKeyboardEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$KeyboardEventInterface), $c3bc21db9fc66909$var$PointerEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c3bc21db9fc66909$var$SyntheticPointerEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$PointerEventInterface), $c3bc21db9fc66909$var$TouchEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c3bc21db9fc66909$var$getEventModifierState
}), $c3bc21db9fc66909$var$SyntheticTouchEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$TouchEventInterface), $c3bc21db9fc66909$var$TransitionEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c3bc21db9fc66909$var$SyntheticTransitionEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$TransitionEventInterface), $c3bc21db9fc66909$var$WheelEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c3bc21db9fc66909$var$SyntheticWheelEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$WheelEventInterface), $c3bc21db9fc66909$var$ToggleEventInterface = $c3bc21db9fc66909$var$assign({}, $c3bc21db9fc66909$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $c3bc21db9fc66909$var$SyntheticToggleEvent = $c3bc21db9fc66909$var$createSyntheticEvent($c3bc21db9fc66909$var$ToggleEventInterface), $c3bc21db9fc66909$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $c3bc21db9fc66909$var$canUseCompositionEvent = $c3bc21db9fc66909$var$canUseDOM && "CompositionEvent" in window, $c3bc21db9fc66909$var$documentMode = null;
$c3bc21db9fc66909$var$canUseDOM && "documentMode" in document && ($c3bc21db9fc66909$var$documentMode = document.documentMode);
var $c3bc21db9fc66909$var$canUseTextInputEvent = $c3bc21db9fc66909$var$canUseDOM && "TextEvent" in window && !$c3bc21db9fc66909$var$documentMode, $c3bc21db9fc66909$var$useFallbackCompositionData = $c3bc21db9fc66909$var$canUseDOM && (!$c3bc21db9fc66909$var$canUseCompositionEvent || $c3bc21db9fc66909$var$documentMode && 8 < $c3bc21db9fc66909$var$documentMode && 11 >= $c3bc21db9fc66909$var$documentMode), $c3bc21db9fc66909$var$SPACEBAR_CHAR = String.fromCharCode(32), $c3bc21db9fc66909$var$hasSpaceKeypress = !1;
function $c3bc21db9fc66909$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $c3bc21db9fc66909$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c3bc21db9fc66909$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $c3bc21db9fc66909$var$isComposing = !1;
function $c3bc21db9fc66909$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $c3bc21db9fc66909$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $c3bc21db9fc66909$var$hasSpaceKeypress = !0;
            return $c3bc21db9fc66909$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $c3bc21db9fc66909$var$SPACEBAR_CHAR && $c3bc21db9fc66909$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $c3bc21db9fc66909$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($c3bc21db9fc66909$var$isComposing) return "compositionend" === domEventName || !$c3bc21db9fc66909$var$canUseCompositionEvent && $c3bc21db9fc66909$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $c3bc21db9fc66909$var$getData(), $c3bc21db9fc66909$var$fallbackText = $c3bc21db9fc66909$var$startText = $c3bc21db9fc66909$var$root = null, $c3bc21db9fc66909$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $c3bc21db9fc66909$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $c3bc21db9fc66909$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c3bc21db9fc66909$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$c3bc21db9fc66909$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $c3bc21db9fc66909$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $c3bc21db9fc66909$var$restoreTarget ? $c3bc21db9fc66909$var$restoreQueue ? $c3bc21db9fc66909$var$restoreQueue.push(target) : $c3bc21db9fc66909$var$restoreQueue = [
        target
    ] : $c3bc21db9fc66909$var$restoreTarget = target;
    inst = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $c3bc21db9fc66909$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $c3bc21db9fc66909$var$activeElement$1 = null, $c3bc21db9fc66909$var$activeElementInst$1 = null;
function $c3bc21db9fc66909$var$runEventInBatch(dispatchQueue) {
    $c3bc21db9fc66909$var$processDispatchQueue(dispatchQueue, 0);
}
function $c3bc21db9fc66909$var$getInstIfValueChanged(targetInst) {
    var targetNode = $c3bc21db9fc66909$var$getNodeFromInstance(targetInst);
    if ($c3bc21db9fc66909$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $c3bc21db9fc66909$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $c3bc21db9fc66909$var$isInputEventSupported = !1;
if ($c3bc21db9fc66909$var$canUseDOM) {
    var $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$282;
    if ($c3bc21db9fc66909$var$canUseDOM) {
        var $c3bc21db9fc66909$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$c3bc21db9fc66909$var$isSupported$jscomp$inline_417) {
            var $c3bc21db9fc66909$var$element$jscomp$inline_418 = document.createElement("div");
            $c3bc21db9fc66909$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $c3bc21db9fc66909$var$isSupported$jscomp$inline_417 = "function" === typeof $c3bc21db9fc66909$var$element$jscomp$inline_418.oninput;
        }
        $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$282 = $c3bc21db9fc66909$var$isSupported$jscomp$inline_417;
    } else $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$282 = !1;
    $c3bc21db9fc66909$var$isInputEventSupported = $c3bc21db9fc66909$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $c3bc21db9fc66909$var$stopWatchingForValueChange() {
    $c3bc21db9fc66909$var$activeElement$1 && ($c3bc21db9fc66909$var$activeElement$1.detachEvent("onpropertychange", $c3bc21db9fc66909$var$handlePropertyChange), $c3bc21db9fc66909$var$activeElementInst$1 = $c3bc21db9fc66909$var$activeElement$1 = null);
}
function $c3bc21db9fc66909$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $c3bc21db9fc66909$var$getInstIfValueChanged($c3bc21db9fc66909$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $c3bc21db9fc66909$var$createAndAccumulateChangeEvent(dispatchQueue, $c3bc21db9fc66909$var$activeElementInst$1, nativeEvent, $c3bc21db9fc66909$var$getEventTarget(nativeEvent));
        $c3bc21db9fc66909$var$batchedUpdates$1($c3bc21db9fc66909$var$runEventInBatch, dispatchQueue);
    }
}
function $c3bc21db9fc66909$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($c3bc21db9fc66909$var$stopWatchingForValueChange(), $c3bc21db9fc66909$var$activeElement$1 = target, $c3bc21db9fc66909$var$activeElementInst$1 = targetInst, $c3bc21db9fc66909$var$activeElement$1.attachEvent("onpropertychange", $c3bc21db9fc66909$var$handlePropertyChange)) : "focusout" === domEventName && $c3bc21db9fc66909$var$stopWatchingForValueChange();
}
function $c3bc21db9fc66909$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $c3bc21db9fc66909$var$getInstIfValueChanged($c3bc21db9fc66909$var$activeElementInst$1);
}
function $c3bc21db9fc66909$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $c3bc21db9fc66909$var$getInstIfValueChanged(targetInst);
}
function $c3bc21db9fc66909$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $c3bc21db9fc66909$var$getInstIfValueChanged(targetInst);
}
function $c3bc21db9fc66909$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c3bc21db9fc66909$var$objectIs = "function" === typeof Object.is ? Object.is : $c3bc21db9fc66909$var$is;
function $c3bc21db9fc66909$var$shallowEqual(objA, objB) {
    if ($c3bc21db9fc66909$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$c3bc21db9fc66909$var$hasOwnProperty.call(objB, currentKey) || !$c3bc21db9fc66909$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $c3bc21db9fc66909$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $c3bc21db9fc66909$var$getNodeForCharacterOffset(root, offset) {
    var node = $c3bc21db9fc66909$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $c3bc21db9fc66909$var$getLeafNode(node);
    }
}
function $c3bc21db9fc66909$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $c3bc21db9fc66909$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $c3bc21db9fc66909$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $c3bc21db9fc66909$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $c3bc21db9fc66909$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $c3bc21db9fc66909$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $c3bc21db9fc66909$var$skipSelectionChangeEvent = $c3bc21db9fc66909$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $c3bc21db9fc66909$var$activeElement = null, $c3bc21db9fc66909$var$activeElementInst = null, $c3bc21db9fc66909$var$lastSelection = null, $c3bc21db9fc66909$var$mouseDown = !1;
function $c3bc21db9fc66909$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $c3bc21db9fc66909$var$mouseDown || null == $c3bc21db9fc66909$var$activeElement || $c3bc21db9fc66909$var$activeElement !== $c3bc21db9fc66909$var$getActiveElement(doc) || (doc = $c3bc21db9fc66909$var$activeElement, "selectionStart" in doc && $c3bc21db9fc66909$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $c3bc21db9fc66909$var$lastSelection && $c3bc21db9fc66909$var$shallowEqual($c3bc21db9fc66909$var$lastSelection, doc) || ($c3bc21db9fc66909$var$lastSelection = doc, doc = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners($c3bc21db9fc66909$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $c3bc21db9fc66909$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $c3bc21db9fc66909$var$activeElement)));
}
function $c3bc21db9fc66909$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $c3bc21db9fc66909$var$vendorPrefixes = {
    animationend: $c3bc21db9fc66909$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $c3bc21db9fc66909$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $c3bc21db9fc66909$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $c3bc21db9fc66909$var$makePrefixMap("Transition", "TransitionEnd")
}, $c3bc21db9fc66909$var$prefixedEventNames = {}, $c3bc21db9fc66909$var$style = {};
$c3bc21db9fc66909$var$canUseDOM && ($c3bc21db9fc66909$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $c3bc21db9fc66909$var$vendorPrefixes.animationend.animation, delete $c3bc21db9fc66909$var$vendorPrefixes.animationiteration.animation, delete $c3bc21db9fc66909$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $c3bc21db9fc66909$var$vendorPrefixes.transitionend.transition);
function $c3bc21db9fc66909$var$getVendorPrefixedEventName(eventName) {
    if ($c3bc21db9fc66909$var$prefixedEventNames[eventName]) return $c3bc21db9fc66909$var$prefixedEventNames[eventName];
    if (!$c3bc21db9fc66909$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $c3bc21db9fc66909$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $c3bc21db9fc66909$var$style) return $c3bc21db9fc66909$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $c3bc21db9fc66909$var$ANIMATION_END = $c3bc21db9fc66909$var$getVendorPrefixedEventName("animationend"), $c3bc21db9fc66909$var$ANIMATION_ITERATION = $c3bc21db9fc66909$var$getVendorPrefixedEventName("animationiteration"), $c3bc21db9fc66909$var$ANIMATION_START = $c3bc21db9fc66909$var$getVendorPrefixedEventName("animationstart"), $c3bc21db9fc66909$var$TRANSITION_RUN = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitionrun"), $c3bc21db9fc66909$var$TRANSITION_START = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitionstart"), $c3bc21db9fc66909$var$TRANSITION_CANCEL = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitioncancel"), $c3bc21db9fc66909$var$TRANSITION_END = $c3bc21db9fc66909$var$getVendorPrefixedEventName("transitionend"), $c3bc21db9fc66909$var$topLevelEventsToReactNames = new Map(), $c3bc21db9fc66909$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$c3bc21db9fc66909$var$simpleEventPluginEvents.push("scrollEnd");
function $c3bc21db9fc66909$var$registerSimpleEvent(domEventName, reactName) {
    $c3bc21db9fc66909$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $c3bc21db9fc66909$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $c3bc21db9fc66909$var$CapturedStacks = new WeakMap();
function $c3bc21db9fc66909$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $c3bc21db9fc66909$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $c3bc21db9fc66909$var$getStackByFiberInDevAndProd(source)
        };
        $c3bc21db9fc66909$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $c3bc21db9fc66909$var$getStackByFiberInDevAndProd(source)
    };
}
var $c3bc21db9fc66909$var$concurrentQueues = [], $c3bc21db9fc66909$var$concurrentQueuesIndex = 0, $c3bc21db9fc66909$var$concurrentlyUpdatedLanes = 0;
function $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $c3bc21db9fc66909$var$concurrentQueuesIndex, i = $c3bc21db9fc66909$var$concurrentlyUpdatedLanes = $c3bc21db9fc66909$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        var queue = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        var update = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        var lane = $c3bc21db9fc66909$var$concurrentQueues[i];
        $c3bc21db9fc66909$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $c3bc21db9fc66909$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = fiber;
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = queue;
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = update;
    $c3bc21db9fc66909$var$concurrentQueues[$c3bc21db9fc66909$var$concurrentQueuesIndex++] = lane;
    $c3bc21db9fc66909$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
}
function $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, null, null, lane);
    return $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
}
function $c3bc21db9fc66909$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $c3bc21db9fc66909$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $c3bc21db9fc66909$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $c3bc21db9fc66909$var$nestedUpdateCount) throw $c3bc21db9fc66909$var$nestedUpdateCount = 0, $c3bc21db9fc66909$var$rootWithNestedUpdates = null, Error($c3bc21db9fc66909$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $c3bc21db9fc66909$var$emptyContextObject = {};
function $c3bc21db9fc66909$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c3bc21db9fc66909$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $c3bc21db9fc66909$var$FiberNode(tag, pendingProps, key, mode);
}
function $c3bc21db9fc66909$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $c3bc21db9fc66909$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $c3bc21db9fc66909$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $c3bc21db9fc66909$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $c3bc21db9fc66909$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $c3bc21db9fc66909$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $c3bc21db9fc66909$var$isHostHoistableType(type, pendingProps, $c3bc21db9fc66909$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $c3bc21db9fc66909$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE:
            return $c3bc21db9fc66909$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $c3bc21db9fc66909$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $c3bc21db9fc66909$var$REACT_PROFILER_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $c3bc21db9fc66909$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $c3bc21db9fc66909$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $c3bc21db9fc66909$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $c3bc21db9fc66909$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $c3bc21db9fc66909$var$REACT_PROVIDER_TYPE:
                case $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $c3bc21db9fc66909$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $c3bc21db9fc66909$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($c3bc21db9fc66909$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $c3bc21db9fc66909$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $c3bc21db9fc66909$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $c3bc21db9fc66909$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $c3bc21db9fc66909$var$createFiberFromText(content, mode, lanes) {
    content = $c3bc21db9fc66909$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $c3bc21db9fc66909$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $c3bc21db9fc66909$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $c3bc21db9fc66909$var$forkStack = [], $c3bc21db9fc66909$var$forkStackIndex = 0, $c3bc21db9fc66909$var$treeForkProvider = null, $c3bc21db9fc66909$var$treeForkCount = 0, $c3bc21db9fc66909$var$idStack = [], $c3bc21db9fc66909$var$idStackIndex = 0, $c3bc21db9fc66909$var$treeContextProvider = null, $c3bc21db9fc66909$var$treeContextId = 1, $c3bc21db9fc66909$var$treeContextOverflow = "";
function $c3bc21db9fc66909$var$pushTreeFork(workInProgress, totalChildren) {
    $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex++] = $c3bc21db9fc66909$var$treeForkCount;
    $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex++] = $c3bc21db9fc66909$var$treeForkProvider;
    $c3bc21db9fc66909$var$treeForkProvider = workInProgress;
    $c3bc21db9fc66909$var$treeForkCount = totalChildren;
}
function $c3bc21db9fc66909$var$pushTreeId(workInProgress, totalChildren, index) {
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextId;
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextOverflow;
    $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextProvider;
    $c3bc21db9fc66909$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $c3bc21db9fc66909$var$treeContextId;
    workInProgress = $c3bc21db9fc66909$var$treeContextOverflow;
    var baseLength = 32 - $c3bc21db9fc66909$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $c3bc21db9fc66909$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $c3bc21db9fc66909$var$treeContextId = 1 << 32 - $c3bc21db9fc66909$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $c3bc21db9fc66909$var$treeContextOverflow = length + workInProgress;
    } else $c3bc21db9fc66909$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $c3bc21db9fc66909$var$treeContextOverflow = workInProgress;
}
function $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($c3bc21db9fc66909$var$pushTreeFork(workInProgress, 1), $c3bc21db9fc66909$var$pushTreeId(workInProgress, 1, 0));
}
function $c3bc21db9fc66909$var$popTreeContext(workInProgress) {
    for(; workInProgress === $c3bc21db9fc66909$var$treeForkProvider;)$c3bc21db9fc66909$var$treeForkProvider = $c3bc21db9fc66909$var$forkStack[--$c3bc21db9fc66909$var$forkStackIndex], $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex] = null, $c3bc21db9fc66909$var$treeForkCount = $c3bc21db9fc66909$var$forkStack[--$c3bc21db9fc66909$var$forkStackIndex], $c3bc21db9fc66909$var$forkStack[$c3bc21db9fc66909$var$forkStackIndex] = null;
    for(; workInProgress === $c3bc21db9fc66909$var$treeContextProvider;)$c3bc21db9fc66909$var$treeContextProvider = $c3bc21db9fc66909$var$idStack[--$c3bc21db9fc66909$var$idStackIndex], $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex] = null, $c3bc21db9fc66909$var$treeContextOverflow = $c3bc21db9fc66909$var$idStack[--$c3bc21db9fc66909$var$idStackIndex], $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex] = null, $c3bc21db9fc66909$var$treeContextId = $c3bc21db9fc66909$var$idStack[--$c3bc21db9fc66909$var$idStackIndex], $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex] = null;
}
var $c3bc21db9fc66909$var$hydrationParentFiber = null, $c3bc21db9fc66909$var$nextHydratableInstance = null, $c3bc21db9fc66909$var$isHydrating = !1, $c3bc21db9fc66909$var$hydrationErrors = null, $c3bc21db9fc66909$var$rootOrSingletonContext = !1, $c3bc21db9fc66909$var$HydrationMismatchException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(519));
function $c3bc21db9fc66909$var$throwOnHydrationMismatch(fiber) {
    var error = Error($c3bc21db9fc66909$var$formatProdErrorMessage(418, ""));
    $c3bc21db9fc66909$var$queueHydrationError($c3bc21db9fc66909$var$createCapturedValueAtFiber(error, fiber));
    throw $c3bc21db9fc66909$var$HydrationMismatchException;
}
function $c3bc21db9fc66909$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$c3bc21db9fc66909$var$internalInstanceKey] = fiber;
    instance[$c3bc21db9fc66909$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("cancel", instance);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $c3bc21db9fc66909$var$mediaEventTypes.length; type++)$c3bc21db9fc66909$var$listenToNonDelegatedEvent($c3bc21db9fc66909$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", instance);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", instance);
            $c3bc21db9fc66909$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $c3bc21db9fc66909$var$track(instance);
            break;
        case "select":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", instance), $c3bc21db9fc66909$var$initTextarea(instance, props.value, props.defaultValue, props.children), $c3bc21db9fc66909$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $c3bc21db9fc66909$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($c3bc21db9fc66909$var$listenToNonDelegatedEvent("beforetoggle", instance), $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $c3bc21db9fc66909$var$noop$1), instance = !0) : instance = !1;
    instance || $c3bc21db9fc66909$var$throwOnHydrationMismatch(fiber);
}
function $c3bc21db9fc66909$var$popToNextHostParent(fiber) {
    for($c3bc21db9fc66909$var$hydrationParentFiber = fiber.return; $c3bc21db9fc66909$var$hydrationParentFiber;)switch($c3bc21db9fc66909$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $c3bc21db9fc66909$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $c3bc21db9fc66909$var$rootOrSingletonContext = !0;
            return;
        default:
            $c3bc21db9fc66909$var$hydrationParentFiber = $c3bc21db9fc66909$var$hydrationParentFiber.return;
    }
}
function $c3bc21db9fc66909$var$popHydrationState(fiber) {
    if (fiber !== $c3bc21db9fc66909$var$hydrationParentFiber) return !1;
    if (!$c3bc21db9fc66909$var$isHydrating) return $c3bc21db9fc66909$var$popToNextHostParent(fiber), $c3bc21db9fc66909$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $c3bc21db9fc66909$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $c3bc21db9fc66909$var$nextHydratableInstance && $c3bc21db9fc66909$var$throwOnHydrationMismatch(fiber);
    $c3bc21db9fc66909$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $c3bc21db9fc66909$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $c3bc21db9fc66909$var$nextHydratableInstance, $c3bc21db9fc66909$var$isSingletonScope(fiber.type) ? (fiber = $c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton, $c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton = null, $c3bc21db9fc66909$var$nextHydratableInstance = fiber) : $c3bc21db9fc66909$var$nextHydratableInstance = tag) : $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$hydrationParentFiber ? $c3bc21db9fc66909$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $c3bc21db9fc66909$var$resetHydrationState() {
    $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$hydrationParentFiber = null;
    $c3bc21db9fc66909$var$isHydrating = !1;
}
function $c3bc21db9fc66909$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $c3bc21db9fc66909$var$hydrationErrors;
    null !== queuedErrors && (null === $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors ? $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = queuedErrors : $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors.push.apply($c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, queuedErrors), $c3bc21db9fc66909$var$hydrationErrors = null);
    return queuedErrors;
}
function $c3bc21db9fc66909$var$queueHydrationError(error) {
    null === $c3bc21db9fc66909$var$hydrationErrors ? $c3bc21db9fc66909$var$hydrationErrors = [
        error
    ] : $c3bc21db9fc66909$var$hydrationErrors.push(error);
}
var $c3bc21db9fc66909$var$valueCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null, $c3bc21db9fc66909$var$lastContextDependency = null;
function $c3bc21db9fc66909$var$pushProvider(providerFiber, context, nextValue) {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $c3bc21db9fc66909$var$popProvider(context) {
    context._currentValue = $c3bc21db9fc66909$var$valueCursor.current;
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$valueCursor);
}
function $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $c3bc21db9fc66909$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $c3bc21db9fc66909$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($c3bc21db9fc66909$var$HostTransitionContext) : current = [
                $c3bc21db9fc66909$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $c3bc21db9fc66909$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$c3bc21db9fc66909$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $c3bc21db9fc66909$var$prepareToReadContext(workInProgress) {
    $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = workInProgress;
    $c3bc21db9fc66909$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $c3bc21db9fc66909$var$readContext(context) {
    return $c3bc21db9fc66909$var$readContextForConsumer($c3bc21db9fc66909$var$currentlyRenderingFiber$1, context);
}
function $c3bc21db9fc66909$var$readContextDuringReconciliation(consumer, context) {
    null === $c3bc21db9fc66909$var$currentlyRenderingFiber$1 && $c3bc21db9fc66909$var$prepareToReadContext(consumer);
    return $c3bc21db9fc66909$var$readContextForConsumer(consumer, context);
}
function $c3bc21db9fc66909$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $c3bc21db9fc66909$var$lastContextDependency) {
        if (null === consumer) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(308));
        $c3bc21db9fc66909$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$lastContextDependency.next = context;
    return value;
}
var $c3bc21db9fc66909$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $c3bc21db9fc66909$var$scheduleCallback$2 = $clk2u.unstable_scheduleCallback, $c3bc21db9fc66909$var$NormalPriority = $clk2u.unstable_NormalPriority, $c3bc21db9fc66909$var$CacheContext = {
    $$typeof: $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $c3bc21db9fc66909$var$createCache() {
    return {
        controller: new $c3bc21db9fc66909$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $c3bc21db9fc66909$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $c3bc21db9fc66909$var$scheduleCallback$2($c3bc21db9fc66909$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $c3bc21db9fc66909$var$currentEntangledListeners = null, $c3bc21db9fc66909$var$currentEntangledPendingCount = 0, $c3bc21db9fc66909$var$currentEntangledLane = 0, $c3bc21db9fc66909$var$currentEntangledActionThenable = null;
function $c3bc21db9fc66909$var$entangleAsyncAction(transition, thenable) {
    if (null === $c3bc21db9fc66909$var$currentEntangledListeners) {
        var entangledListeners = $c3bc21db9fc66909$var$currentEntangledListeners = [];
        $c3bc21db9fc66909$var$currentEntangledPendingCount = 0;
        $c3bc21db9fc66909$var$currentEntangledLane = $c3bc21db9fc66909$var$requestTransitionLane();
        $c3bc21db9fc66909$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $c3bc21db9fc66909$var$currentEntangledPendingCount++;
    thenable.then($c3bc21db9fc66909$var$pingEngtangledActionScope, $c3bc21db9fc66909$var$pingEngtangledActionScope);
    return thenable;
}
function $c3bc21db9fc66909$var$pingEngtangledActionScope() {
    if (0 === --$c3bc21db9fc66909$var$currentEntangledPendingCount && null !== $c3bc21db9fc66909$var$currentEntangledListeners) {
        null !== $c3bc21db9fc66909$var$currentEntangledActionThenable && ($c3bc21db9fc66909$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $c3bc21db9fc66909$var$currentEntangledListeners;
        $c3bc21db9fc66909$var$currentEntangledListeners = null;
        $c3bc21db9fc66909$var$currentEntangledLane = 0;
        $c3bc21db9fc66909$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $c3bc21db9fc66909$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $c3bc21db9fc66909$var$prevOnStartTransitionFinish = $c3bc21db9fc66909$var$ReactSharedInternals.S;
$c3bc21db9fc66909$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $c3bc21db9fc66909$var$entangleAsyncAction(transition, returnValue);
    null !== $c3bc21db9fc66909$var$prevOnStartTransitionFinish && $c3bc21db9fc66909$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $c3bc21db9fc66909$var$resumedCache = $c3bc21db9fc66909$var$createCursor(null);
function $c3bc21db9fc66909$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $c3bc21db9fc66909$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $c3bc21db9fc66909$var$workInProgressRoot.pooledCache;
}
function $c3bc21db9fc66909$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$resumedCache, $c3bc21db9fc66909$var$resumedCache.current) : $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$resumedCache, prevCachePool.pool);
}
function $c3bc21db9fc66909$var$getSuspendedCache() {
    var cacheFromPool = $c3bc21db9fc66909$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $c3bc21db9fc66909$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $c3bc21db9fc66909$var$SuspenseException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(460)), $c3bc21db9fc66909$var$SuspenseyCommitException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(474)), $c3bc21db9fc66909$var$SuspenseActionException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(542)), $c3bc21db9fc66909$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $c3bc21db9fc66909$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $c3bc21db9fc66909$var$noop$3() {}
function $c3bc21db9fc66909$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($c3bc21db9fc66909$var$noop$3, $c3bc21db9fc66909$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $c3bc21db9fc66909$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($c3bc21db9fc66909$var$noop$3, $c3bc21db9fc66909$var$noop$3);
            else {
                thenableState = $c3bc21db9fc66909$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $c3bc21db9fc66909$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $c3bc21db9fc66909$var$suspendedThenable = thenable;
            throw $c3bc21db9fc66909$var$SuspenseException;
    }
}
var $c3bc21db9fc66909$var$suspendedThenable = null;
function $c3bc21db9fc66909$var$getSuspendedThenable() {
    if (null === $c3bc21db9fc66909$var$suspendedThenable) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(459));
    var thenable = $c3bc21db9fc66909$var$suspendedThenable;
    $c3bc21db9fc66909$var$suspendedThenable = null;
    return thenable;
}
function $c3bc21db9fc66909$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $c3bc21db9fc66909$var$SuspenseException || rejectedReason === $c3bc21db9fc66909$var$SuspenseActionException) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(483));
}
var $c3bc21db9fc66909$var$hasForceUpdate = !1;
function $c3bc21db9fc66909$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $c3bc21db9fc66909$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c3bc21db9fc66909$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($c3bc21db9fc66909$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
        $c3bc21db9fc66909$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $c3bc21db9fc66909$var$getRootForUpdatedFiber(fiber);
}
function $c3bc21db9fc66909$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $c3bc21db9fc66909$var$markRootEntangled(root, lane);
    }
}
function $c3bc21db9fc66909$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $c3bc21db9fc66909$var$didReadFromEntangledAsyncAction = !1;
function $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($c3bc21db9fc66909$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $c3bc21db9fc66909$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $c3bc21db9fc66909$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $c3bc21db9fc66909$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $c3bc21db9fc66909$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $c3bc21db9fc66909$var$currentEntangledLane && ($c3bc21db9fc66909$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $c3bc21db9fc66909$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $c3bc21db9fc66909$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $c3bc21db9fc66909$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $c3bc21db9fc66909$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$c3bc21db9fc66909$var$callCallback(callbacks[updateQueue], context);
}
var $c3bc21db9fc66909$var$currentTreeHiddenStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$prevEntangledRenderLanesCursor = $c3bc21db9fc66909$var$createCursor(0);
function $c3bc21db9fc66909$var$pushHiddenContext(fiber, context) {
    fiber = $c3bc21db9fc66909$var$entangledRenderLanes;
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$prevEntangledRenderLanesCursor, fiber);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$currentTreeHiddenStackCursor, context);
    $c3bc21db9fc66909$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $c3bc21db9fc66909$var$reuseHiddenContextOnStack() {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$prevEntangledRenderLanesCursor, $c3bc21db9fc66909$var$entangledRenderLanes);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$currentTreeHiddenStackCursor, $c3bc21db9fc66909$var$currentTreeHiddenStackCursor.current);
}
function $c3bc21db9fc66909$var$popHiddenContext() {
    $c3bc21db9fc66909$var$entangledRenderLanes = $c3bc21db9fc66909$var$prevEntangledRenderLanesCursor.current;
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$currentTreeHiddenStackCursor);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$prevEntangledRenderLanesCursor);
}
var $c3bc21db9fc66909$var$renderLanes = 0, $c3bc21db9fc66909$var$currentlyRenderingFiber = null, $c3bc21db9fc66909$var$currentHook = null, $c3bc21db9fc66909$var$workInProgressHook = null, $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !1, $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $c3bc21db9fc66909$var$localIdCounter = 0, $c3bc21db9fc66909$var$thenableIndexCounter$1 = 0, $c3bc21db9fc66909$var$thenableState$1 = null, $c3bc21db9fc66909$var$globalClientIdCounter = 0;
function $c3bc21db9fc66909$var$throwInvalidHookError() {
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(321));
}
function $c3bc21db9fc66909$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$c3bc21db9fc66909$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $c3bc21db9fc66909$var$renderLanes = nextRenderLanes;
    $c3bc21db9fc66909$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $c3bc21db9fc66909$var$HooksDispatcherOnMount : $c3bc21db9fc66909$var$HooksDispatcherOnUpdate;
    $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $c3bc21db9fc66909$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $c3bc21db9fc66909$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $c3bc21db9fc66909$var$finishRenderingHooks(current) {
    $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $c3bc21db9fc66909$var$currentHook && null !== $c3bc21db9fc66909$var$currentHook.next;
    $c3bc21db9fc66909$var$renderLanes = 0;
    $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$currentHook = $c3bc21db9fc66909$var$currentlyRenderingFiber = null;
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !1;
    $c3bc21db9fc66909$var$thenableIndexCounter$1 = 0;
    $c3bc21db9fc66909$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(300));
    null === current || $c3bc21db9fc66909$var$didReceiveUpdate || (current = current.dependencies, null !== current && $c3bc21db9fc66909$var$checkIfContextChanged(current) && ($c3bc21db9fc66909$var$didReceiveUpdate = !0));
}
function $c3bc21db9fc66909$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $c3bc21db9fc66909$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass && ($c3bc21db9fc66909$var$thenableState$1 = null);
        $c3bc21db9fc66909$var$thenableIndexCounter$1 = 0;
        $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $c3bc21db9fc66909$var$TransitionAwareHostComponent() {
    var dispatcher = $c3bc21db9fc66909$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $c3bc21db9fc66909$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $c3bc21db9fc66909$var$currentHook ? $c3bc21db9fc66909$var$currentHook.memoizedState : null) !== dispatcher && ($c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $c3bc21db9fc66909$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $c3bc21db9fc66909$var$localIdCounter;
    $c3bc21db9fc66909$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $c3bc21db9fc66909$var$resetHooksOnUnwind(workInProgress) {
    if ($c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !1;
    }
    $c3bc21db9fc66909$var$renderLanes = 0;
    $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$currentHook = $c3bc21db9fc66909$var$currentlyRenderingFiber = null;
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $c3bc21db9fc66909$var$thenableIndexCounter$1 = $c3bc21db9fc66909$var$localIdCounter = 0;
    $c3bc21db9fc66909$var$thenableState$1 = null;
}
function $c3bc21db9fc66909$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c3bc21db9fc66909$var$workInProgressHook ? $c3bc21db9fc66909$var$currentlyRenderingFiber.memoizedState = $c3bc21db9fc66909$var$workInProgressHook = hook : $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$workInProgressHook.next = hook;
    return $c3bc21db9fc66909$var$workInProgressHook;
}
function $c3bc21db9fc66909$var$updateWorkInProgressHook() {
    if (null === $c3bc21db9fc66909$var$currentHook) {
        var nextCurrentHook = $c3bc21db9fc66909$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $c3bc21db9fc66909$var$currentHook.next;
    var nextWorkInProgressHook = null === $c3bc21db9fc66909$var$workInProgressHook ? $c3bc21db9fc66909$var$currentlyRenderingFiber.memoizedState : $c3bc21db9fc66909$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $c3bc21db9fc66909$var$workInProgressHook = nextWorkInProgressHook, $c3bc21db9fc66909$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $c3bc21db9fc66909$var$currentlyRenderingFiber.alternate) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(467));
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(310));
        }
        $c3bc21db9fc66909$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $c3bc21db9fc66909$var$currentHook.memoizedState,
            baseState: $c3bc21db9fc66909$var$currentHook.baseState,
            baseQueue: $c3bc21db9fc66909$var$currentHook.baseQueue,
            queue: $c3bc21db9fc66909$var$currentHook.queue,
            next: null
        };
        null === $c3bc21db9fc66909$var$workInProgressHook ? $c3bc21db9fc66909$var$currentlyRenderingFiber.memoizedState = $c3bc21db9fc66909$var$workInProgressHook = nextCurrentHook : $c3bc21db9fc66909$var$workInProgressHook = $c3bc21db9fc66909$var$workInProgressHook.next = nextCurrentHook;
    }
    return $c3bc21db9fc66909$var$workInProgressHook;
}
function $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $c3bc21db9fc66909$var$useThenable(thenable) {
    var index = $c3bc21db9fc66909$var$thenableIndexCounter$1;
    $c3bc21db9fc66909$var$thenableIndexCounter$1 += 1;
    null === $c3bc21db9fc66909$var$thenableState$1 && ($c3bc21db9fc66909$var$thenableState$1 = []);
    thenable = $c3bc21db9fc66909$var$trackUsedThenable($c3bc21db9fc66909$var$thenableState$1, thenable, index);
    index = $c3bc21db9fc66909$var$currentlyRenderingFiber;
    null === (null === $c3bc21db9fc66909$var$workInProgressHook ? index.memoizedState : $c3bc21db9fc66909$var$workInProgressHook.next) && (index = index.alternate, $c3bc21db9fc66909$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $c3bc21db9fc66909$var$HooksDispatcherOnMount : $c3bc21db9fc66909$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $c3bc21db9fc66909$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $c3bc21db9fc66909$var$useThenable(usable);
        if (usable.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return $c3bc21db9fc66909$var$readContext(usable);
    }
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(438, String(usable)));
}
function $c3bc21db9fc66909$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $c3bc21db9fc66909$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue(), $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $c3bc21db9fc66909$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $c3bc21db9fc66909$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $c3bc21db9fc66909$var$updateReducer(reducer) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    return $c3bc21db9fc66909$var$updateReducerImpl(hook, $c3bc21db9fc66909$var$currentHook, reducer);
}
function $c3bc21db9fc66909$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($c3bc21db9fc66909$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $c3bc21db9fc66909$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($c3bc21db9fc66909$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $c3bc21db9fc66909$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= revertLane, $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= updateLane, $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$c3bc21db9fc66909$var$objectIs(pendingQueue, hook.memoizedState) && ($c3bc21db9fc66909$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $c3bc21db9fc66909$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $c3bc21db9fc66909$var$rerenderReducer(reducer) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $c3bc21db9fc66909$var$objectIs(newState, hook.memoizedState) || ($c3bc21db9fc66909$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $c3bc21db9fc66909$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $c3bc21db9fc66909$var$currentlyRenderingFiber, hook = $c3bc21db9fc66909$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $c3bc21db9fc66909$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$c3bc21db9fc66909$var$objectIs(($c3bc21db9fc66909$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $c3bc21db9fc66909$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $c3bc21db9fc66909$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $c3bc21db9fc66909$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $c3bc21db9fc66909$var$workInProgressHook && $c3bc21db9fc66909$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $c3bc21db9fc66909$var$pushSimpleEffect(9, $c3bc21db9fc66909$var$createEffectInstance(), $c3bc21db9fc66909$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $c3bc21db9fc66909$var$workInProgressRoot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($c3bc21db9fc66909$var$renderLanes & 124) || $c3bc21db9fc66909$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $c3bc21db9fc66909$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue(), $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $c3bc21db9fc66909$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $c3bc21db9fc66909$var$checkIfSnapshotChanged(inst) && $c3bc21db9fc66909$var$forceStoreRerender(fiber);
}
function $c3bc21db9fc66909$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $c3bc21db9fc66909$var$checkIfSnapshotChanged(inst) && $c3bc21db9fc66909$var$forceStoreRerender(fiber);
    });
}
function $c3bc21db9fc66909$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c3bc21db9fc66909$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c3bc21db9fc66909$var$forceStoreRerender(fiber) {
    var root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $c3bc21db9fc66909$var$mountStateImpl(initialState) {
    var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c3bc21db9fc66909$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $c3bc21db9fc66909$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $c3bc21db9fc66909$var$updateReducerImpl(hook, $c3bc21db9fc66909$var$currentHook, "function" === typeof reducer ? reducer : $c3bc21db9fc66909$var$basicStateReducer);
}
function $c3bc21db9fc66909$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $c3bc21db9fc66909$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $c3bc21db9fc66909$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $c3bc21db9fc66909$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T, currentTransition = {};
        $c3bc21db9fc66909$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $c3bc21db9fc66909$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $c3bc21db9fc66909$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $c3bc21db9fc66909$var$onActionError(actionQueue, node, error);
        } finally{
            $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $c3bc21db9fc66909$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $c3bc21db9fc66909$var$onActionError(actionQueue, node, error$38);
    }
}
function $c3bc21db9fc66909$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $c3bc21db9fc66909$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $c3bc21db9fc66909$var$onActionError(actionQueue, node, error);
    }) : $c3bc21db9fc66909$var$onActionSuccess(actionQueue, node, returnValue);
}
function $c3bc21db9fc66909$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $c3bc21db9fc66909$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $c3bc21db9fc66909$var$runActionStateAction(actionQueue, nextState)));
}
function $c3bc21db9fc66909$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $c3bc21db9fc66909$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $c3bc21db9fc66909$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $c3bc21db9fc66909$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $c3bc21db9fc66909$var$mountActionState(action, initialStateProp) {
    if ($c3bc21db9fc66909$var$isHydrating) {
        var ssrFormState = $c3bc21db9fc66909$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $c3bc21db9fc66909$var$currentlyRenderingFiber;
                if ($c3bc21db9fc66909$var$isHydrating) {
                    if ($c3bc21db9fc66909$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $c3bc21db9fc66909$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $c3bc21db9fc66909$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $c3bc21db9fc66909$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $c3bc21db9fc66909$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c3bc21db9fc66909$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $c3bc21db9fc66909$var$dispatchSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $c3bc21db9fc66909$var$mountStateImpl(!1);
    inRootOrSingleton = $c3bc21db9fc66909$var$dispatchOptimisticSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $c3bc21db9fc66909$var$dispatchActionState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $c3bc21db9fc66909$var$updateActionState(action) {
    var stateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    return $c3bc21db9fc66909$var$updateActionStateImpl(stateHook, $c3bc21db9fc66909$var$currentHook, action);
}
function $c3bc21db9fc66909$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $c3bc21db9fc66909$var$updateReducerImpl(stateHook, currentStateHook, $c3bc21db9fc66909$var$actionStateReducer)[0];
    stateHook = $c3bc21db9fc66909$var$updateReducer($c3bc21db9fc66909$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $c3bc21db9fc66909$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $c3bc21db9fc66909$var$SuspenseException) throw $c3bc21db9fc66909$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= 2048, $c3bc21db9fc66909$var$pushSimpleEffect(9, $c3bc21db9fc66909$var$createEffectInstance(), $c3bc21db9fc66909$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $c3bc21db9fc66909$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $c3bc21db9fc66909$var$rerenderActionState(action) {
    var stateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook(), currentStateHook = $c3bc21db9fc66909$var$currentHook;
    if (null !== currentStateHook) return $c3bc21db9fc66909$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $c3bc21db9fc66909$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $c3bc21db9fc66909$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $c3bc21db9fc66909$var$createFunctionComponentUpdateQueue(), $c3bc21db9fc66909$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $c3bc21db9fc66909$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $c3bc21db9fc66909$var$updateRef() {
    return $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
}
function $c3bc21db9fc66909$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $c3bc21db9fc66909$var$pushSimpleEffect(1 | hookFlags, $c3bc21db9fc66909$var$createEffectInstance(), create, createDeps);
}
function $c3bc21db9fc66909$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $c3bc21db9fc66909$var$currentHook && null !== deps && $c3bc21db9fc66909$var$areHookInputsEqual(deps, $c3bc21db9fc66909$var$currentHook.memoizedState.deps) ? hook.memoizedState = $c3bc21db9fc66909$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($c3bc21db9fc66909$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $c3bc21db9fc66909$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $c3bc21db9fc66909$var$mountEffect(create, createDeps) {
    $c3bc21db9fc66909$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $c3bc21db9fc66909$var$updateEffect(create, createDeps) {
    $c3bc21db9fc66909$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $c3bc21db9fc66909$var$updateInsertionEffect(create, deps) {
    return $c3bc21db9fc66909$var$updateEffectImpl(4, 2, create, deps);
}
function $c3bc21db9fc66909$var$updateLayoutEffect(create, deps) {
    return $c3bc21db9fc66909$var$updateEffectImpl(4, 4, create, deps);
}
function $c3bc21db9fc66909$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $c3bc21db9fc66909$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $c3bc21db9fc66909$var$updateEffectImpl(4, 4, $c3bc21db9fc66909$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $c3bc21db9fc66909$var$mountDebugValue() {}
function $c3bc21db9fc66909$var$updateCallback(callback, deps) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c3bc21db9fc66909$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $c3bc21db9fc66909$var$updateMemo(nextCreate, deps) {
    var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c3bc21db9fc66909$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($c3bc21db9fc66909$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $c3bc21db9fc66909$var$requestDeferredLane();
    $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= hook;
    $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $c3bc21db9fc66909$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($c3bc21db9fc66909$var$objectIs(value, prevValue)) return value;
    if (null !== $c3bc21db9fc66909$var$currentTreeHiddenStackCursor.current) return hook = $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue), $c3bc21db9fc66909$var$objectIs(hook, prevValue) || ($c3bc21db9fc66909$var$didReceiveUpdate = !0), hook;
    if (0 === ($c3bc21db9fc66909$var$renderLanes & 42)) return $c3bc21db9fc66909$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $c3bc21db9fc66909$var$requestDeferredLane();
    $c3bc21db9fc66909$var$currentlyRenderingFiber.lanes |= hook;
    $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $c3bc21db9fc66909$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T, currentTransition = {};
    $c3bc21db9fc66909$var$ReactSharedInternals.T = currentTransition;
    $c3bc21db9fc66909$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $c3bc21db9fc66909$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $c3bc21db9fc66909$var$chainThenableValue(returnValue, finishedState);
            $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $c3bc21db9fc66909$var$requestUpdateLane(fiber));
        } else $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, finishedState, $c3bc21db9fc66909$var$requestUpdateLane(fiber));
    } catch (error) {
        $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $c3bc21db9fc66909$var$requestUpdateLane());
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c3bc21db9fc66909$var$noop$2() {}
function $c3bc21db9fc66909$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(476));
    var queue = $c3bc21db9fc66909$var$ensureFormComponentIsStateful(formFiber).queue;
    $c3bc21db9fc66909$var$startTransition(formFiber, queue, pendingState, $c3bc21db9fc66909$var$sharedNotPendingObject, null === action ? $c3bc21db9fc66909$var$noop$2 : function() {
        $c3bc21db9fc66909$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $c3bc21db9fc66909$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $c3bc21db9fc66909$var$sharedNotPendingObject,
        baseState: $c3bc21db9fc66909$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c3bc21db9fc66909$var$basicStateReducer,
            lastRenderedState: $c3bc21db9fc66909$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c3bc21db9fc66909$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $c3bc21db9fc66909$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $c3bc21db9fc66909$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $c3bc21db9fc66909$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $c3bc21db9fc66909$var$requestUpdateLane());
}
function $c3bc21db9fc66909$var$useHostTransitionStatus() {
    return $c3bc21db9fc66909$var$readContext($c3bc21db9fc66909$var$HostTransitionContext);
}
function $c3bc21db9fc66909$var$updateId() {
    return $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
}
function $c3bc21db9fc66909$var$updateRefresh() {
    return $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
}
function $c3bc21db9fc66909$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $c3bc21db9fc66909$var$requestUpdateLane();
                fiber = $c3bc21db9fc66909$var$createUpdate(lane);
                var root$41 = $c3bc21db9fc66909$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(root$41, provider, lane), $c3bc21db9fc66909$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $c3bc21db9fc66909$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $c3bc21db9fc66909$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $c3bc21db9fc66909$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber) ? $c3bc21db9fc66909$var$enqueueRenderPhaseUpdate(queue, action) : (action = $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(action, fiber, lane), $c3bc21db9fc66909$var$entangleTransitionUpdate(action, queue, lane)));
}
function $c3bc21db9fc66909$var$dispatchSetState(fiber, queue, action) {
    var lane = $c3bc21db9fc66909$var$requestUpdateLane();
    $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $c3bc21db9fc66909$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber)) $c3bc21db9fc66909$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($c3bc21db9fc66909$var$objectIs(eagerState, currentState)) return $c3bc21db9fc66909$var$enqueueUpdate$1(fiber, queue, update, 0), null === $c3bc21db9fc66909$var$workInProgressRoot && $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $c3bc21db9fc66909$var$scheduleUpdateOnFiber(action, fiber, lane), $c3bc21db9fc66909$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $c3bc21db9fc66909$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $c3bc21db9fc66909$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $c3bc21db9fc66909$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $c3bc21db9fc66909$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $c3bc21db9fc66909$var$currentlyRenderingFiber || null !== alternate && alternate === $c3bc21db9fc66909$var$currentlyRenderingFiber;
}
function $c3bc21db9fc66909$var$enqueueRenderPhaseUpdate(queue, update) {
    $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdateDuringThisPass = $c3bc21db9fc66909$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $c3bc21db9fc66909$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $c3bc21db9fc66909$var$markRootEntangled(root, lane);
    }
}
var $c3bc21db9fc66909$var$ContextOnlyDispatcher = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: $c3bc21db9fc66909$var$throwInvalidHookError,
    useContext: $c3bc21db9fc66909$var$throwInvalidHookError,
    useEffect: $c3bc21db9fc66909$var$throwInvalidHookError,
    useImperativeHandle: $c3bc21db9fc66909$var$throwInvalidHookError,
    useLayoutEffect: $c3bc21db9fc66909$var$throwInvalidHookError,
    useInsertionEffect: $c3bc21db9fc66909$var$throwInvalidHookError,
    useMemo: $c3bc21db9fc66909$var$throwInvalidHookError,
    useReducer: $c3bc21db9fc66909$var$throwInvalidHookError,
    useRef: $c3bc21db9fc66909$var$throwInvalidHookError,
    useState: $c3bc21db9fc66909$var$throwInvalidHookError,
    useDebugValue: $c3bc21db9fc66909$var$throwInvalidHookError,
    useDeferredValue: $c3bc21db9fc66909$var$throwInvalidHookError,
    useTransition: $c3bc21db9fc66909$var$throwInvalidHookError,
    useSyncExternalStore: $c3bc21db9fc66909$var$throwInvalidHookError,
    useId: $c3bc21db9fc66909$var$throwInvalidHookError,
    useHostTransitionStatus: $c3bc21db9fc66909$var$throwInvalidHookError,
    useFormState: $c3bc21db9fc66909$var$throwInvalidHookError,
    useActionState: $c3bc21db9fc66909$var$throwInvalidHookError,
    useOptimistic: $c3bc21db9fc66909$var$throwInvalidHookError,
    useMemoCache: $c3bc21db9fc66909$var$throwInvalidHookError,
    useCacheRefresh: $c3bc21db9fc66909$var$throwInvalidHookError
}, $c3bc21db9fc66909$var$HooksDispatcherOnMount = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: function(callback, deps) {
        $c3bc21db9fc66909$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $c3bc21db9fc66909$var$readContext,
    useEffect: $c3bc21db9fc66909$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $c3bc21db9fc66909$var$mountEffectImpl(4194308, 4, $c3bc21db9fc66909$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $c3bc21db9fc66909$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $c3bc21db9fc66909$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($c3bc21db9fc66909$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $c3bc21db9fc66909$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $c3bc21db9fc66909$var$dispatchReducerAction.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $c3bc21db9fc66909$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $c3bc21db9fc66909$var$dispatchSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $c3bc21db9fc66909$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        return $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $c3bc21db9fc66909$var$mountStateImpl(!1);
        stateHook = $c3bc21db9fc66909$var$startTransition.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $c3bc21db9fc66909$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $c3bc21db9fc66909$var$currentlyRenderingFiber, hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        if ($c3bc21db9fc66909$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $c3bc21db9fc66909$var$workInProgressRoot) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(349));
            0 !== ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 124) || $c3bc21db9fc66909$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $c3bc21db9fc66909$var$mountEffect($c3bc21db9fc66909$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $c3bc21db9fc66909$var$pushSimpleEffect(9, $c3bc21db9fc66909$var$createEffectInstance(), $c3bc21db9fc66909$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook(), identifierPrefix = $c3bc21db9fc66909$var$workInProgressRoot.identifierPrefix;
        if ($c3bc21db9fc66909$var$isHydrating) {
            var JSCompiler_inline_result = $c3bc21db9fc66909$var$treeContextOverflow;
            var idWithLeadingBit = $c3bc21db9fc66909$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $c3bc21db9fc66909$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $c3bc21db9fc66909$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $c3bc21db9fc66909$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $c3bc21db9fc66909$var$useHostTransitionStatus,
    useFormState: $c3bc21db9fc66909$var$mountActionState,
    useActionState: $c3bc21db9fc66909$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $c3bc21db9fc66909$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $c3bc21db9fc66909$var$dispatchOptimisticSetState.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $c3bc21db9fc66909$var$useMemoCache,
    useCacheRefresh: function() {
        return $c3bc21db9fc66909$var$mountWorkInProgressHook().memoizedState = $c3bc21db9fc66909$var$refreshCache.bind(null, $c3bc21db9fc66909$var$currentlyRenderingFiber);
    }
}, $c3bc21db9fc66909$var$HooksDispatcherOnUpdate = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: $c3bc21db9fc66909$var$updateCallback,
    useContext: $c3bc21db9fc66909$var$readContext,
    useEffect: $c3bc21db9fc66909$var$updateEffect,
    useImperativeHandle: $c3bc21db9fc66909$var$updateImperativeHandle,
    useInsertionEffect: $c3bc21db9fc66909$var$updateInsertionEffect,
    useLayoutEffect: $c3bc21db9fc66909$var$updateLayoutEffect,
    useMemo: $c3bc21db9fc66909$var$updateMemo,
    useReducer: $c3bc21db9fc66909$var$updateReducer,
    useRef: $c3bc21db9fc66909$var$updateRef,
    useState: function() {
        return $c3bc21db9fc66909$var$updateReducer($c3bc21db9fc66909$var$basicStateReducer);
    },
    useDebugValue: $c3bc21db9fc66909$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        return $c3bc21db9fc66909$var$updateDeferredValueImpl(hook, $c3bc21db9fc66909$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c3bc21db9fc66909$var$updateReducer($c3bc21db9fc66909$var$basicStateReducer)[0], start = $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c3bc21db9fc66909$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c3bc21db9fc66909$var$updateSyncExternalStore,
    useId: $c3bc21db9fc66909$var$updateId,
    useHostTransitionStatus: $c3bc21db9fc66909$var$useHostTransitionStatus,
    useFormState: $c3bc21db9fc66909$var$updateActionState,
    useActionState: $c3bc21db9fc66909$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        return $c3bc21db9fc66909$var$updateOptimisticImpl(hook, $c3bc21db9fc66909$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $c3bc21db9fc66909$var$useMemoCache,
    useCacheRefresh: $c3bc21db9fc66909$var$updateRefresh
}, $c3bc21db9fc66909$var$HooksDispatcherOnRerender = {
    readContext: $c3bc21db9fc66909$var$readContext,
    use: $c3bc21db9fc66909$var$use,
    useCallback: $c3bc21db9fc66909$var$updateCallback,
    useContext: $c3bc21db9fc66909$var$readContext,
    useEffect: $c3bc21db9fc66909$var$updateEffect,
    useImperativeHandle: $c3bc21db9fc66909$var$updateImperativeHandle,
    useInsertionEffect: $c3bc21db9fc66909$var$updateInsertionEffect,
    useLayoutEffect: $c3bc21db9fc66909$var$updateLayoutEffect,
    useMemo: $c3bc21db9fc66909$var$updateMemo,
    useReducer: $c3bc21db9fc66909$var$rerenderReducer,
    useRef: $c3bc21db9fc66909$var$updateRef,
    useState: function() {
        return $c3bc21db9fc66909$var$rerenderReducer($c3bc21db9fc66909$var$basicStateReducer);
    },
    useDebugValue: $c3bc21db9fc66909$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        return null === $c3bc21db9fc66909$var$currentHook ? $c3bc21db9fc66909$var$mountDeferredValueImpl(hook, value, initialValue) : $c3bc21db9fc66909$var$updateDeferredValueImpl(hook, $c3bc21db9fc66909$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c3bc21db9fc66909$var$rerenderReducer($c3bc21db9fc66909$var$basicStateReducer)[0], start = $c3bc21db9fc66909$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c3bc21db9fc66909$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c3bc21db9fc66909$var$updateSyncExternalStore,
    useId: $c3bc21db9fc66909$var$updateId,
    useHostTransitionStatus: $c3bc21db9fc66909$var$useHostTransitionStatus,
    useFormState: $c3bc21db9fc66909$var$rerenderActionState,
    useActionState: $c3bc21db9fc66909$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $c3bc21db9fc66909$var$updateWorkInProgressHook();
        if (null !== $c3bc21db9fc66909$var$currentHook) return $c3bc21db9fc66909$var$updateOptimisticImpl(hook, $c3bc21db9fc66909$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $c3bc21db9fc66909$var$useMemoCache,
    useCacheRefresh: $c3bc21db9fc66909$var$updateRefresh
}, $c3bc21db9fc66909$var$thenableState = null, $c3bc21db9fc66909$var$thenableIndexCounter = 0;
function $c3bc21db9fc66909$var$unwrapThenable(thenable) {
    var index = $c3bc21db9fc66909$var$thenableIndexCounter;
    $c3bc21db9fc66909$var$thenableIndexCounter += 1;
    null === $c3bc21db9fc66909$var$thenableState && ($c3bc21db9fc66909$var$thenableState = []);
    return $c3bc21db9fc66909$var$trackUsedThenable($c3bc21db9fc66909$var$thenableState, thenable, index);
}
function $c3bc21db9fc66909$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $c3bc21db9fc66909$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $c3bc21db9fc66909$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $c3bc21db9fc66909$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $c3bc21db9fc66909$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $c3bc21db9fc66909$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $c3bc21db9fc66909$var$REACT_LAZY_TYPE && $c3bc21db9fc66909$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $c3bc21db9fc66909$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $c3bc21db9fc66909$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $c3bc21db9fc66909$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $c3bc21db9fc66909$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $c3bc21db9fc66909$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    return lanes = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c3bc21db9fc66909$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    return newChild = $c3bc21db9fc66909$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild) || $c3bc21db9fc66909$var$getIteratorFn(newChild)) return newChild = $c3bc21db9fc66909$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild) || $c3bc21db9fc66909$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild) || $c3bc21db9fc66909$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c3bc21db9fc66909$var$isHydrating && $c3bc21db9fc66909$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c3bc21db9fc66909$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $c3bc21db9fc66909$var$REACT_LAZY_TYPE && $c3bc21db9fc66909$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $c3bc21db9fc66909$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $c3bc21db9fc66909$var$REACT_FRAGMENT_TYPE ? (lanes = $c3bc21db9fc66909$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c3bc21db9fc66909$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $c3bc21db9fc66909$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $c3bc21db9fc66909$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $c3bc21db9fc66909$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($c3bc21db9fc66909$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($c3bc21db9fc66909$var$getIteratorFn(newChild)) {
                key = $c3bc21db9fc66909$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c3bc21db9fc66909$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c3bc21db9fc66909$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c3bc21db9fc66909$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $c3bc21db9fc66909$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $c3bc21db9fc66909$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $c3bc21db9fc66909$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $c3bc21db9fc66909$var$SuspenseException || x === $c3bc21db9fc66909$var$SuspenseActionException) throw x;
            var fiber = $c3bc21db9fc66909$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $c3bc21db9fc66909$var$reconcileChildFibers = $c3bc21db9fc66909$var$createChildReconciler(!0), $c3bc21db9fc66909$var$mountChildFibers = $c3bc21db9fc66909$var$createChildReconciler(!1), $c3bc21db9fc66909$var$suspenseHandlerStackCursor = $c3bc21db9fc66909$var$createCursor(null), $c3bc21db9fc66909$var$shellBoundary = null;
function $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current & 1);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, handler);
    null === $c3bc21db9fc66909$var$shellBoundary && (null === current || null !== $c3bc21db9fc66909$var$currentTreeHiddenStackCursor.current ? $c3bc21db9fc66909$var$shellBoundary = handler : null !== current.memoizedState && ($c3bc21db9fc66909$var$shellBoundary = handler));
}
function $c3bc21db9fc66909$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current), $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, fiber), null === $c3bc21db9fc66909$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($c3bc21db9fc66909$var$shellBoundary = fiber);
        }
    } else $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(fiber);
}
function $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack() {
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current);
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseHandlerStackCursor, $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current);
}
function $c3bc21db9fc66909$var$popSuspenseHandler(fiber) {
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseHandlerStackCursor);
    $c3bc21db9fc66909$var$shellBoundary === fiber && ($c3bc21db9fc66909$var$shellBoundary = null);
    $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseStackCursor);
}
var $c3bc21db9fc66909$var$suspenseStackCursor = $c3bc21db9fc66909$var$createCursor(0);
function $c3bc21db9fc66909$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $c3bc21db9fc66909$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $c3bc21db9fc66909$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $c3bc21db9fc66909$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c3bc21db9fc66909$var$requestUpdateLane(), update = $c3bc21db9fc66909$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c3bc21db9fc66909$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(payload, inst, lane), $c3bc21db9fc66909$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c3bc21db9fc66909$var$requestUpdateLane(), update = $c3bc21db9fc66909$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c3bc21db9fc66909$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(payload, inst, lane), $c3bc21db9fc66909$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $c3bc21db9fc66909$var$requestUpdateLane(), update = $c3bc21db9fc66909$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $c3bc21db9fc66909$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(callback, inst, lane), $c3bc21db9fc66909$var$entangleTransitions(callback, inst, lane));
    }
};
function $c3bc21db9fc66909$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$c3bc21db9fc66909$var$shallowEqual(oldProps, newProps) || !$c3bc21db9fc66909$var$shallowEqual(oldState, newState) : !0;
}
function $c3bc21db9fc66909$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $c3bc21db9fc66909$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $c3bc21db9fc66909$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $c3bc21db9fc66909$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $c3bc21db9fc66909$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $c3bc21db9fc66909$var$defaultOnUncaughtError(error) {
    $c3bc21db9fc66909$var$reportGlobalError(error);
}
function $c3bc21db9fc66909$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $c3bc21db9fc66909$var$defaultOnRecoverableError(error) {
    $c3bc21db9fc66909$var$reportGlobalError(error);
}
function $c3bc21db9fc66909$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $c3bc21db9fc66909$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $c3bc21db9fc66909$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $c3bc21db9fc66909$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $c3bc21db9fc66909$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $c3bc21db9fc66909$var$createClassErrorUpdate(lane) {
    lane = $c3bc21db9fc66909$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $c3bc21db9fc66909$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $c3bc21db9fc66909$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $c3bc21db9fc66909$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed ? $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $c3bc21db9fc66909$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $c3bc21db9fc66909$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $c3bc21db9fc66909$var$shellBoundary ? $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $c3bc21db9fc66909$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $c3bc21db9fc66909$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $c3bc21db9fc66909$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $c3bc21db9fc66909$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $c3bc21db9fc66909$var$attachPingListener(root, value, rootRenderLanes);
        $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($c3bc21db9fc66909$var$isHydrating) return returnFiber = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $c3bc21db9fc66909$var$HydrationMismatchException && (root = Error($c3bc21db9fc66909$var$formatProdErrorMessage(422), {
        cause: value
    }), $c3bc21db9fc66909$var$queueHydrationError($c3bc21db9fc66909$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $c3bc21db9fc66909$var$HydrationMismatchException && (returnFiber = Error($c3bc21db9fc66909$var$formatProdErrorMessage(423), {
        cause: value
    }), $c3bc21db9fc66909$var$queueHydrationError($c3bc21db9fc66909$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $c3bc21db9fc66909$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $c3bc21db9fc66909$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $c3bc21db9fc66909$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($c3bc21db9fc66909$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $c3bc21db9fc66909$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors ? $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $c3bc21db9fc66909$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $c3bc21db9fc66909$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $c3bc21db9fc66909$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed || !$c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $c3bc21db9fc66909$var$createClassErrorUpdate(rootRenderLanes), $c3bc21db9fc66909$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $c3bc21db9fc66909$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $c3bc21db9fc66909$var$SelectiveHydrationException = Error($c3bc21db9fc66909$var$formatProdErrorMessage(461)), $c3bc21db9fc66909$var$didReceiveUpdate = !1;
function $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $c3bc21db9fc66909$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $c3bc21db9fc66909$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    nextProps = $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $c3bc21db9fc66909$var$checkDidRenderIdHook();
    if (null !== current && !$c3bc21db9fc66909$var$didReceiveUpdate) return $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, renderLanes), $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c3bc21db9fc66909$var$isHydrating && key && $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$c3bc21db9fc66909$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $c3bc21db9fc66909$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $c3bc21db9fc66909$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $c3bc21db9fc66909$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $c3bc21db9fc66909$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $c3bc21db9fc66909$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($c3bc21db9fc66909$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($c3bc21db9fc66909$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($c3bc21db9fc66909$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $c3bc21db9fc66909$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $c3bc21db9fc66909$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $c3bc21db9fc66909$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $c3bc21db9fc66909$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $c3bc21db9fc66909$var$pushHiddenContext(workInProgress, prevState) : $c3bc21db9fc66909$var$reuseHiddenContextOnStack(), $c3bc21db9fc66909$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $c3bc21db9fc66909$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($c3bc21db9fc66909$var$pushTransition(workInProgress, prevState.cachePool), $c3bc21db9fc66909$var$pushHiddenContext(workInProgress, prevState), $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $c3bc21db9fc66909$var$pushTransition(workInProgress, null), $c3bc21db9fc66909$var$reuseHiddenContextOnStack(), $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress));
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $c3bc21db9fc66909$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $c3bc21db9fc66909$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $c3bc21db9fc66909$var$pushTransition(workInProgress, null);
    $c3bc21db9fc66909$var$reuseHiddenContextOnStack();
    $c3bc21db9fc66909$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $c3bc21db9fc66909$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $c3bc21db9fc66909$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    Component = $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $c3bc21db9fc66909$var$checkDidRenderIdHook();
    if (null !== current && !$c3bc21db9fc66909$var$didReceiveUpdate) return $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, renderLanes), $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c3bc21db9fc66909$var$isHydrating && nextProps && $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $c3bc21db9fc66909$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $c3bc21db9fc66909$var$finishRenderingHooks(current);
    Component = $c3bc21db9fc66909$var$checkDidRenderIdHook();
    if (null !== current && !$c3bc21db9fc66909$var$didReceiveUpdate) return $c3bc21db9fc66909$var$bailoutHooks(current, workInProgress, renderLanes), $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c3bc21db9fc66909$var$isHydrating && Component && $c3bc21db9fc66909$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c3bc21db9fc66909$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $c3bc21db9fc66909$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $c3bc21db9fc66909$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $c3bc21db9fc66909$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $c3bc21db9fc66909$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $c3bc21db9fc66909$var$readContext(contextType) : $c3bc21db9fc66909$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $c3bc21db9fc66909$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $c3bc21db9fc66909$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $c3bc21db9fc66909$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $c3bc21db9fc66909$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $c3bc21db9fc66909$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $c3bc21db9fc66909$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $c3bc21db9fc66909$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $c3bc21db9fc66909$var$hasForceUpdate || $c3bc21db9fc66909$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $c3bc21db9fc66909$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $c3bc21db9fc66909$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $c3bc21db9fc66909$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $c3bc21db9fc66909$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $c3bc21db9fc66909$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $c3bc21db9fc66909$var$hasForceUpdate || null !== current && null !== current.dependencies && $c3bc21db9fc66909$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($c3bc21db9fc66909$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $c3bc21db9fc66909$var$hasForceUpdate || $c3bc21db9fc66909$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $c3bc21db9fc66909$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $c3bc21db9fc66909$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $c3bc21db9fc66909$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $c3bc21db9fc66909$var$resetHydrationState();
    workInProgress.flags |= 256;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $c3bc21db9fc66909$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $c3bc21db9fc66909$var$getSuspendedCache()
    };
}
function $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $c3bc21db9fc66909$var$workInProgressDeferredLane);
    return current;
}
function $c3bc21db9fc66909$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($c3bc21db9fc66909$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($c3bc21db9fc66909$var$isHydrating) {
            showFallback ? $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($c3bc21db9fc66909$var$isHydrating) {
                var nextInstance = $c3bc21db9fc66909$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $c3bc21db9fc66909$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $c3bc21db9fc66909$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $c3bc21db9fc66909$var$treeContextProvider ? {
                            id: $c3bc21db9fc66909$var$treeContextId,
                            overflow: $c3bc21db9fc66909$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $c3bc21db9fc66909$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $c3bc21db9fc66909$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $c3bc21db9fc66909$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c3bc21db9fc66909$var$SUSPENDED_MARKER, nextProps;
        $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $c3bc21db9fc66909$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c3bc21db9fc66909$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress), $c3bc21db9fc66909$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($c3bc21db9fc66909$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $c3bc21db9fc66909$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($c3bc21db9fc66909$var$didReceiveUpdate || $c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $c3bc21db9fc66909$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $c3bc21db9fc66909$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(current, nextProps), $c3bc21db9fc66909$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $c3bc21db9fc66909$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible();
            workInProgress = $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(nextInstance.nextSibling), $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$isHydrating = !0, $c3bc21db9fc66909$var$hydrationErrors = null, $c3bc21db9fc66909$var$rootOrSingletonContext = !1, null !== current && ($c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextId, $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextOverflow, $c3bc21db9fc66909$var$idStack[$c3bc21db9fc66909$var$idStackIndex++] = $c3bc21db9fc66909$var$treeContextProvider, $c3bc21db9fc66909$var$treeContextId = current.id, $c3bc21db9fc66909$var$treeContextOverflow = current.overflow, $c3bc21db9fc66909$var$treeContextProvider = workInProgress), workInProgress = $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $c3bc21db9fc66909$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $c3bc21db9fc66909$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $c3bc21db9fc66909$var$createWorkInProgress(digest, showFallback) : (showFallback = $c3bc21db9fc66909$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $c3bc21db9fc66909$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $c3bc21db9fc66909$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $c3bc21db9fc66909$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $c3bc21db9fc66909$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c3bc21db9fc66909$var$SUSPENDED_MARKER, nextProps;
    $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $c3bc21db9fc66909$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $c3bc21db9fc66909$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $c3bc21db9fc66909$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c3bc21db9fc66909$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $c3bc21db9fc66909$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $c3bc21db9fc66909$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $c3bc21db9fc66909$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $c3bc21db9fc66909$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $c3bc21db9fc66909$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $c3bc21db9fc66909$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $c3bc21db9fc66909$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $c3bc21db9fc66909$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $c3bc21db9fc66909$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $c3bc21db9fc66909$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $c3bc21db9fc66909$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $c3bc21db9fc66909$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $c3bc21db9fc66909$var$checkIfContextChanged(current) ? !0 : !1;
}
function $c3bc21db9fc66909$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, current.memoizedState.cache);
            $c3bc21db9fc66909$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $c3bc21db9fc66909$var$pushHostContext(workInProgress);
            break;
        case 4:
            $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $c3bc21db9fc66909$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $c3bc21db9fc66909$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $c3bc21db9fc66909$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($c3bc21db9fc66909$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $c3bc21db9fc66909$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $c3bc21db9fc66909$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, current.memoizedState.cache);
    }
    return $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $c3bc21db9fc66909$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $c3bc21db9fc66909$var$didReceiveUpdate = !0;
        else {
            if (!$c3bc21db9fc66909$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $c3bc21db9fc66909$var$didReceiveUpdate = !1, $c3bc21db9fc66909$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $c3bc21db9fc66909$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $c3bc21db9fc66909$var$didReceiveUpdate = !1, $c3bc21db9fc66909$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $c3bc21db9fc66909$var$pushTreeId(workInProgress, $c3bc21db9fc66909$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $c3bc21db9fc66909$var$shouldConstruct(lazyComponent) ? (current = $c3bc21db9fc66909$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $c3bc21db9fc66909$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $c3bc21db9fc66909$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $c3bc21db9fc66909$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $c3bc21db9fc66909$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $c3bc21db9fc66909$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $c3bc21db9fc66909$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $c3bc21db9fc66909$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $c3bc21db9fc66909$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $c3bc21db9fc66909$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $c3bc21db9fc66909$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress);
                $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, [
                    $c3bc21db9fc66909$var$CacheContext
                ], renderLanes, !0);
                $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $c3bc21db9fc66909$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $c3bc21db9fc66909$var$createCapturedValueAtFiber(Error($c3bc21db9fc66909$var$formatProdErrorMessage(424)), workInProgress);
                        $c3bc21db9fc66909$var$queueHydrationError(init);
                        workInProgress = $c3bc21db9fc66909$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(current.firstChild);
                        $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress;
                        $c3bc21db9fc66909$var$isHydrating = !0;
                        $c3bc21db9fc66909$var$hydrationErrors = null;
                        $c3bc21db9fc66909$var$rootOrSingletonContext = !0;
                        renderLanes = $c3bc21db9fc66909$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $c3bc21db9fc66909$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $c3bc21db9fc66909$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $c3bc21db9fc66909$var$markRef(current, workInProgress), null === current ? (renderLanes = $c3bc21db9fc66909$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $c3bc21db9fc66909$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer($c3bc21db9fc66909$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress, lazyComponent[$c3bc21db9fc66909$var$internalPropsKey] = current, $c3bc21db9fc66909$var$setInitialProperties(lazyComponent, renderLanes, current), $c3bc21db9fc66909$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $c3bc21db9fc66909$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $c3bc21db9fc66909$var$pushHostContext(workInProgress), null === current && $c3bc21db9fc66909$var$isHydrating && (lazyComponent = workInProgress.stateNode = $c3bc21db9fc66909$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $c3bc21db9fc66909$var$rootInstanceStackCursor.current), $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$rootOrSingletonContext = !0, init = $c3bc21db9fc66909$var$nextHydratableInstance, $c3bc21db9fc66909$var$isSingletonScope(workInProgress.type) ? ($c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton = init, $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(lazyComponent.firstChild)) : $c3bc21db9fc66909$var$nextHydratableInstance = init), $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $c3bc21db9fc66909$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $c3bc21db9fc66909$var$isHydrating) {
                if (init = lazyComponent = $c3bc21db9fc66909$var$nextHydratableInstance) lazyComponent = $c3bc21db9fc66909$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $c3bc21db9fc66909$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$nextHydratableInstance = $c3bc21db9fc66909$var$getNextHydratable(lazyComponent.firstChild), $c3bc21db9fc66909$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
            }
            $c3bc21db9fc66909$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $c3bc21db9fc66909$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $c3bc21db9fc66909$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $c3bc21db9fc66909$var$renderWithHooks(current, workInProgress, $c3bc21db9fc66909$var$TransitionAwareHostComponent, null, null, renderLanes), $c3bc21db9fc66909$var$HostTransitionContext._currentValue = init);
            $c3bc21db9fc66909$var$markRef(current, workInProgress);
            $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $c3bc21db9fc66909$var$isHydrating) {
                if (current = renderLanes = $c3bc21db9fc66909$var$nextHydratableInstance) renderLanes = $c3bc21db9fc66909$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $c3bc21db9fc66909$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $c3bc21db9fc66909$var$hydrationParentFiber = workInProgress, $c3bc21db9fc66909$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $c3bc21db9fc66909$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $c3bc21db9fc66909$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $c3bc21db9fc66909$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $c3bc21db9fc66909$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $c3bc21db9fc66909$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $c3bc21db9fc66909$var$prepareToReadContext(workInProgress), init = $c3bc21db9fc66909$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $c3bc21db9fc66909$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $c3bc21db9fc66909$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $c3bc21db9fc66909$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $c3bc21db9fc66909$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $c3bc21db9fc66909$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $c3bc21db9fc66909$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $c3bc21db9fc66909$var$prepareToReadContext(workInProgress), lazyComponent = $c3bc21db9fc66909$var$readContext($c3bc21db9fc66909$var$CacheContext), null === current ? (init = $c3bc21db9fc66909$var$peekCacheFromPool(), null === init && (init = $c3bc21db9fc66909$var$workInProgressRoot, prevState = $c3bc21db9fc66909$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $c3bc21db9fc66909$var$initializeUpdateQueue(workInProgress), $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($c3bc21db9fc66909$var$cloneUpdateQueue(current, workInProgress), $c3bc21db9fc66909$var$processUpdateQueue(workInProgress, null, null, renderLanes), $c3bc21db9fc66909$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $c3bc21db9fc66909$var$pushProvider(workInProgress, $c3bc21db9fc66909$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $c3bc21db9fc66909$var$propagateContextChanges(workInProgress, [
                $c3bc21db9fc66909$var$CacheContext
            ], renderLanes, !0))), $c3bc21db9fc66909$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c3bc21db9fc66909$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $c3bc21db9fc66909$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$c3bc21db9fc66909$var$preloadResource(resource)) {
        resource = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 4194048) === $c3bc21db9fc66909$var$workInProgressRootRenderLanes ? null !== $c3bc21db9fc66909$var$shellBoundary : ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 62914560) !== $c3bc21db9fc66909$var$workInProgressRootRenderLanes && 0 === ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 536870912) || resource !== $c3bc21db9fc66909$var$shellBoundary)) throw $c3bc21db9fc66909$var$suspendedThenable = $c3bc21db9fc66909$var$noopSuspenseyCommitThenable, $c3bc21db9fc66909$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $c3bc21db9fc66909$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $c3bc21db9fc66909$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$c3bc21db9fc66909$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $c3bc21db9fc66909$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $c3bc21db9fc66909$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $c3bc21db9fc66909$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 1:
            return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext);
            $c3bc21db9fc66909$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $c3bc21db9fc66909$var$popHydrationState(workInProgress) ? $c3bc21db9fc66909$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $c3bc21db9fc66909$var$upgradeHydrationErrorsToRecoverable());
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($c3bc21db9fc66909$var$markUpdate(workInProgress), null !== renderLanes ? ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), $c3bc21db9fc66909$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($c3bc21db9fc66909$var$markUpdate(workInProgress), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), $c3bc21db9fc66909$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $c3bc21db9fc66909$var$popHostContext(workInProgress);
            renderLanes = $c3bc21db9fc66909$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(166));
                    $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $c3bc21db9fc66909$var$contextStackCursor.current;
                $c3bc21db9fc66909$var$popHydrationState(workInProgress) ? $c3bc21db9fc66909$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $c3bc21db9fc66909$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $c3bc21db9fc66909$var$markUpdate(workInProgress));
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $c3bc21db9fc66909$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(166));
                    $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $c3bc21db9fc66909$var$contextStackCursor.current;
                if ($c3bc21db9fc66909$var$popHydrationState(workInProgress)) $c3bc21db9fc66909$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer($c3bc21db9fc66909$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress;
                    current[$c3bc21db9fc66909$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($c3bc21db9fc66909$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $c3bc21db9fc66909$var$markUpdate(workInProgress);
                }
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c3bc21db9fc66909$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(166));
                current = $c3bc21db9fc66909$var$rootInstanceStackCursor.current;
                if ($c3bc21db9fc66909$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $c3bc21db9fc66909$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $c3bc21db9fc66909$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $c3bc21db9fc66909$var$throwOnHydrationMismatch(workInProgress);
                } else current = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $c3bc21db9fc66909$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(317));
                        type[$c3bc21db9fc66909$var$internalInstanceKey] = workInProgress;
                    } else $c3bc21db9fc66909$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $c3bc21db9fc66909$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $c3bc21db9fc66909$var$popHostContainer(), null === current && $c3bc21db9fc66909$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 10:
            return $c3bc21db9fc66909$var$popProvider(workInProgress.type), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 19:
            $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $c3bc21db9fc66909$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $c3bc21db9fc66909$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $c3bc21db9fc66909$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $c3bc21db9fc66909$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$c3bc21db9fc66909$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, $c3bc21db9fc66909$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $c3bc21db9fc66909$var$now() > $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $c3bc21db9fc66909$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $c3bc21db9fc66909$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, current), $c3bc21db9fc66909$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$c3bc21db9fc66909$var$isHydrating) return $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
                    } else 2 * $c3bc21db9fc66909$var$now() - type.renderingStartTime > $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $c3bc21db9fc66909$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $c3bc21db9fc66909$var$now(), workInProgress.sibling = null, current = $c3bc21db9fc66909$var$suspenseStackCursor.current, $c3bc21db9fc66909$var$push($c3bc21db9fc66909$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $c3bc21db9fc66909$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress), $c3bc21db9fc66909$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($c3bc21db9fc66909$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $c3bc21db9fc66909$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $c3bc21db9fc66909$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext), $c3bc21db9fc66909$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c3bc21db9fc66909$var$unwindWork(current, workInProgress) {
    $c3bc21db9fc66909$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext), $c3bc21db9fc66909$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $c3bc21db9fc66909$var$popHostContext(workInProgress), null;
        case 13:
            $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(340));
                $c3bc21db9fc66909$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseStackCursor), null;
        case 4:
            return $c3bc21db9fc66909$var$popHostContainer(), null;
        case 10:
            return $c3bc21db9fc66909$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $c3bc21db9fc66909$var$popSuspenseHandler(workInProgress), $c3bc21db9fc66909$var$popHiddenContext(), null !== current && $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $c3bc21db9fc66909$var$unwindInterruptedWork(current, interruptedWork) {
    $c3bc21db9fc66909$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext);
            $c3bc21db9fc66909$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $c3bc21db9fc66909$var$popHostContext(interruptedWork);
            break;
        case 4:
            $c3bc21db9fc66909$var$popHostContainer();
            break;
        case 13:
            $c3bc21db9fc66909$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$suspenseStackCursor);
            break;
        case 10:
            $c3bc21db9fc66909$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $c3bc21db9fc66909$var$popSuspenseHandler(interruptedWork);
            $c3bc21db9fc66909$var$popHiddenContext();
            null !== current && $c3bc21db9fc66909$var$pop($c3bc21db9fc66909$var$resumedCache);
            break;
        case 24:
            $c3bc21db9fc66909$var$popProvider($c3bc21db9fc66909$var$CacheContext);
    }
}
function $c3bc21db9fc66909$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $c3bc21db9fc66909$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $c3bc21db9fc66909$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c3bc21db9fc66909$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $c3bc21db9fc66909$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c3bc21db9fc66909$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c3bc21db9fc66909$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $c3bc21db9fc66909$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $c3bc21db9fc66909$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$c3bc21db9fc66909$var$internalPropsKey] = newProps;
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $c3bc21db9fc66909$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $c3bc21db9fc66909$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $c3bc21db9fc66909$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $c3bc21db9fc66909$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $c3bc21db9fc66909$var$noop$1));
    else if (4 !== tag && (27 === tag && $c3bc21db9fc66909$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $c3bc21db9fc66909$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $c3bc21db9fc66909$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($c3bc21db9fc66909$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$c3bc21db9fc66909$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $c3bc21db9fc66909$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $c3bc21db9fc66909$var$setInitialProperties(singleton, type, props);
        singleton[$c3bc21db9fc66909$var$internalInstanceKey] = finishedWork;
        singleton[$c3bc21db9fc66909$var$internalPropsKey] = props;
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = !1, $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = !1, $c3bc21db9fc66909$var$needsFormReset = !1, $c3bc21db9fc66909$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $c3bc21db9fc66909$var$nextEffect = null;
function $c3bc21db9fc66909$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $c3bc21db9fc66909$var$eventsEnabled = $c3bc21db9fc66909$var$_enabled;
    root = $c3bc21db9fc66909$var$getActiveElementDeep(root);
    if ($c3bc21db9fc66909$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $c3bc21db9fc66909$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $c3bc21db9fc66909$var$_enabled = !1;
    for($c3bc21db9fc66909$var$nextEffect = firstChild; null !== $c3bc21db9fc66909$var$nextEffect;)if (firstChild = $c3bc21db9fc66909$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $c3bc21db9fc66909$var$nextEffect = root;
    else for(; null !== $c3bc21db9fc66909$var$nextEffect;){
        firstChild = $c3bc21db9fc66909$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $c3bc21db9fc66909$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $c3bc21db9fc66909$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $c3bc21db9fc66909$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $c3bc21db9fc66909$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $c3bc21db9fc66909$var$nextEffect = root;
            break;
        }
        $c3bc21db9fc66909$var$nextEffect = firstChild.return;
    }
}
function $c3bc21db9fc66909$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c3bc21db9fc66909$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $c3bc21db9fc66909$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $c3bc21db9fc66909$var$commitClassCallbacks(finishedWork);
            flags & 512 && $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $c3bc21db9fc66909$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $c3bc21db9fc66909$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $c3bc21db9fc66909$var$commitHostMount(finishedWork);
            flags & 512 && $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c3bc21db9fc66909$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $c3bc21db9fc66909$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $c3bc21db9fc66909$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $c3bc21db9fc66909$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $c3bc21db9fc66909$var$offscreenSubtreeWasHidden;
                prevProps = $c3bc21db9fc66909$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $c3bc21db9fc66909$var$offscreenSubtreeWasHidden;
                $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = flags;
                ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = prevProps;
                $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $c3bc21db9fc66909$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $c3bc21db9fc66909$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $c3bc21db9fc66909$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $c3bc21db9fc66909$var$hostParent = null, $c3bc21db9fc66909$var$hostParentIsContainer = !1;
function $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$c3bc21db9fc66909$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $c3bc21db9fc66909$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.onCommitFiberUnmount) try {
        $c3bc21db9fc66909$var$injectedHook.onCommitFiberUnmount($c3bc21db9fc66909$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $c3bc21db9fc66909$var$hostParent, prevHostParentIsContainer = $c3bc21db9fc66909$var$hostParentIsContainer;
            $c3bc21db9fc66909$var$isSingletonScope(deletedFiber.type) && ($c3bc21db9fc66909$var$hostParent = deletedFiber.stateNode, $c3bc21db9fc66909$var$hostParentIsContainer = !1);
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$releaseSingletonInstance(deletedFiber.stateNode);
            $c3bc21db9fc66909$var$hostParent = prevHostParent;
            $c3bc21db9fc66909$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $c3bc21db9fc66909$var$hostParent;
            prevHostParentIsContainer = $c3bc21db9fc66909$var$hostParentIsContainer;
            $c3bc21db9fc66909$var$hostParent = null;
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$hostParent = prevHostParent;
            $c3bc21db9fc66909$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $c3bc21db9fc66909$var$hostParent) {
                if ($c3bc21db9fc66909$var$hostParentIsContainer) try {
                    (9 === $c3bc21db9fc66909$var$hostParent.nodeType ? $c3bc21db9fc66909$var$hostParent.body : "HTML" === $c3bc21db9fc66909$var$hostParent.nodeName ? $c3bc21db9fc66909$var$hostParent.ownerDocument.body : $c3bc21db9fc66909$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $c3bc21db9fc66909$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $c3bc21db9fc66909$var$hostParent && ($c3bc21db9fc66909$var$hostParentIsContainer ? (finishedRoot = $c3bc21db9fc66909$var$hostParent, $c3bc21db9fc66909$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $c3bc21db9fc66909$var$retryIfBlockedOn(finishedRoot)) : $c3bc21db9fc66909$var$clearSuspenseBoundary($c3bc21db9fc66909$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $c3bc21db9fc66909$var$hostParent;
            prevHostParentIsContainer = $c3bc21db9fc66909$var$hostParentIsContainer;
            $c3bc21db9fc66909$var$hostParent = deletedFiber.stateNode.containerInfo;
            $c3bc21db9fc66909$var$hostParentIsContainer = !0;
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$hostParent = prevHostParent;
            $c3bc21db9fc66909$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || ($c3bc21db9fc66909$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $c3bc21db9fc66909$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = (prevHostParent = $c3bc21db9fc66909$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $c3bc21db9fc66909$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $c3bc21db9fc66909$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c3bc21db9fc66909$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $c3bc21db9fc66909$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $c3bc21db9fc66909$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $c3bc21db9fc66909$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $c3bc21db9fc66909$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($c3bc21db9fc66909$var$isSingletonScope(parent.type)) {
                        $c3bc21db9fc66909$var$hostParent = parent.stateNode;
                        $c3bc21db9fc66909$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $c3bc21db9fc66909$var$hostParent = parent.stateNode;
                    $c3bc21db9fc66909$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $c3bc21db9fc66909$var$hostParent = parent.stateNode.containerInfo;
                    $c3bc21db9fc66909$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $c3bc21db9fc66909$var$hostParent) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(160));
        $c3bc21db9fc66909$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $c3bc21db9fc66909$var$hostParent = null;
        $c3bc21db9fc66909$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $c3bc21db9fc66909$var$currentHoistableRoot = null;
function $c3bc21db9fc66909$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($c3bc21db9fc66909$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $c3bc21db9fc66909$var$commitHookEffectListMount(3, finishedWork), $c3bc21db9fc66909$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            flags & 64 && $c3bc21db9fc66909$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$c3bc21db9fc66909$var$internalHoistableMarker] || currentResource[$c3bc21db9fc66909$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $c3bc21db9fc66909$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$c3bc21db9fc66909$var$internalInstanceKey] = finishedWork;
                                        $c3bc21db9fc66909$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $c3bc21db9fc66909$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c3bc21db9fc66909$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $c3bc21db9fc66909$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c3bc21db9fc66909$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$c3bc21db9fc66909$var$internalInstanceKey] = finishedWork;
                                $c3bc21db9fc66909$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $c3bc21db9fc66909$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $c3bc21db9fc66909$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $c3bc21db9fc66909$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $c3bc21db9fc66909$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c3bc21db9fc66909$var$offscreenSubtreeWasHidden || null === current || $c3bc21db9fc66909$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $c3bc21db9fc66909$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $c3bc21db9fc66909$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($c3bc21db9fc66909$var$needsFormReset = !0);
            break;
        case 6:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $c3bc21db9fc66909$var$tagCaches = null;
            hoistableRoot = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$currentHoistableRoot = $c3bc21db9fc66909$var$getHoistableRoot(root.containerInfo);
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$currentHoistableRoot = hoistableRoot;
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $c3bc21db9fc66909$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $c3bc21db9fc66909$var$needsFormReset && ($c3bc21db9fc66909$var$needsFormReset = !1, $c3bc21db9fc66909$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$currentHoistableRoot = $c3bc21db9fc66909$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            $c3bc21db9fc66909$var$currentHoistableRoot = flags;
            break;
        case 12:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($c3bc21db9fc66909$var$globalMostRecentFallbackTime = $c3bc21db9fc66909$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $c3bc21db9fc66909$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $c3bc21db9fc66909$var$offscreenSubtreeWasHidden;
            $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $c3bc21db9fc66909$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $c3bc21db9fc66909$var$offscreenSubtreeIsHidden || $c3bc21db9fc66909$var$offscreenSubtreeWasHidden || $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $c3bc21db9fc66909$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $c3bc21db9fc66909$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c3bc21db9fc66909$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraverseMutationEffects(root, finishedWork), $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork);
    }
}
function $c3bc21db9fc66909$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($c3bc21db9fc66909$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $c3bc21db9fc66909$var$getHostSibling(finishedWork);
                    $c3bc21db9fc66909$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($c3bc21db9fc66909$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $c3bc21db9fc66909$var$getHostSibling(finishedWork);
                    $c3bc21db9fc66909$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $c3bc21db9fc66909$var$getHostSibling(finishedWork);
                    $c3bc21db9fc66909$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $c3bc21db9fc66909$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $c3bc21db9fc66909$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $c3bc21db9fc66909$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $c3bc21db9fc66909$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $c3bc21db9fc66909$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $c3bc21db9fc66909$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $c3bc21db9fc66909$var$safelyDetachRef(finishedWork, finishedWork.return);
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c3bc21db9fc66909$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$c3bc21db9fc66909$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $c3bc21db9fc66909$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $c3bc21db9fc66909$var$commitClassCallbacks(finishedWork);
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $c3bc21db9fc66909$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $c3bc21db9fc66909$var$commitHostMount(finishedWork);
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $c3bc21db9fc66909$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c3bc21db9fc66909$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $c3bc21db9fc66909$var$releaseCache(previousCache));
}
function $c3bc21db9fc66909$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $c3bc21db9fc66909$var$releaseCache(current));
}
function $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c3bc21db9fc66909$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $c3bc21db9fc66909$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $c3bc21db9fc66909$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c3bc21db9fc66909$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $c3bc21db9fc66909$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $c3bc21db9fc66909$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c3bc21db9fc66909$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c3bc21db9fc66909$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $c3bc21db9fc66909$var$suspenseyCommitFlag = 8192;
function $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $c3bc21db9fc66909$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $c3bc21db9fc66909$var$suspenseyCommitFlag && null !== fiber.memoizedState && $c3bc21db9fc66909$var$suspendResource($c3bc21db9fc66909$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $c3bc21db9fc66909$var$currentHoistableRoot;
            $c3bc21db9fc66909$var$currentHoistableRoot = $c3bc21db9fc66909$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $c3bc21db9fc66909$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $c3bc21db9fc66909$var$suspenseyCommitFlag, $c3bc21db9fc66909$var$suspenseyCommitFlag = 16777216, $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber), $c3bc21db9fc66909$var$suspenseyCommitFlag = previousHoistableRoot) : $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $c3bc21db9fc66909$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c3bc21db9fc66909$var$nextEffect = childToDelete;
            $c3bc21db9fc66909$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c3bc21db9fc66909$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c3bc21db9fc66909$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c3bc21db9fc66909$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $c3bc21db9fc66909$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $c3bc21db9fc66909$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c3bc21db9fc66909$var$nextEffect = childToDelete;
            $c3bc21db9fc66909$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c3bc21db9fc66909$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $c3bc21db9fc66909$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c3bc21db9fc66909$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $c3bc21db9fc66909$var$nextEffect;){
        var fiber = $c3bc21db9fc66909$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $c3bc21db9fc66909$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $c3bc21db9fc66909$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $c3bc21db9fc66909$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $c3bc21db9fc66909$var$nextEffect;){
            cache = $c3bc21db9fc66909$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $c3bc21db9fc66909$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $c3bc21db9fc66909$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $c3bc21db9fc66909$var$nextEffect = sibling;
                break a;
            }
            $c3bc21db9fc66909$var$nextEffect = returnFiber;
        }
    }
}
var $c3bc21db9fc66909$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $c3bc21db9fc66909$var$readContext($c3bc21db9fc66909$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $c3bc21db9fc66909$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $c3bc21db9fc66909$var$executionContext = 0, $c3bc21db9fc66909$var$workInProgressRoot = null, $c3bc21db9fc66909$var$workInProgress = null, $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0, $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings = !1, $c3bc21db9fc66909$var$workInProgressRootIsPrerendering = !1, $c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener = !1, $c3bc21db9fc66909$var$entangledRenderLanes = 0, $c3bc21db9fc66909$var$workInProgressRootExitStatus = 0, $c3bc21db9fc66909$var$workInProgressRootSkippedLanes = 0, $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes = 0, $c3bc21db9fc66909$var$workInProgressRootPingedLanes = 0, $c3bc21db9fc66909$var$workInProgressDeferredLane = 0, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes = 0, $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors = null, $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = null, $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $c3bc21db9fc66909$var$globalMostRecentFallbackTime = 0, $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime = Infinity, $c3bc21db9fc66909$var$workInProgressTransitions = null, $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed = null, $c3bc21db9fc66909$var$pendingEffectsStatus = 0, $c3bc21db9fc66909$var$pendingEffectsRoot = null, $c3bc21db9fc66909$var$pendingFinishedWork = null, $c3bc21db9fc66909$var$pendingEffectsLanes = 0, $c3bc21db9fc66909$var$pendingEffectsRemainingLanes = 0, $c3bc21db9fc66909$var$pendingPassiveTransitions = null, $c3bc21db9fc66909$var$pendingRecoverableErrors = null, $c3bc21db9fc66909$var$nestedUpdateCount = 0, $c3bc21db9fc66909$var$rootWithNestedUpdates = null;
function $c3bc21db9fc66909$var$requestUpdateLane() {
    if (0 !== ($c3bc21db9fc66909$var$executionContext & 2) && 0 !== $c3bc21db9fc66909$var$workInProgressRootRenderLanes) return $c3bc21db9fc66909$var$workInProgressRootRenderLanes & -$c3bc21db9fc66909$var$workInProgressRootRenderLanes;
    if (null !== $c3bc21db9fc66909$var$ReactSharedInternals.T) {
        var actionScopeLane = $c3bc21db9fc66909$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $c3bc21db9fc66909$var$requestTransitionLane();
    }
    return $c3bc21db9fc66909$var$resolveUpdatePriority();
}
function $c3bc21db9fc66909$var$requestDeferredLane() {
    0 === $c3bc21db9fc66909$var$workInProgressDeferredLane && ($c3bc21db9fc66909$var$workInProgressDeferredLane = 0 === ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 536870912) || $c3bc21db9fc66909$var$isHydrating ? $c3bc21db9fc66909$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $c3bc21db9fc66909$var$workInProgressDeferredLane;
}
function $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $c3bc21db9fc66909$var$workInProgressRoot && (2 === $c3bc21db9fc66909$var$workInProgressSuspendedReason || 9 === $c3bc21db9fc66909$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $c3bc21db9fc66909$var$prepareFreshStack(root, 0), $c3bc21db9fc66909$var$markRootSuspended(root, $c3bc21db9fc66909$var$workInProgressRootRenderLanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !1);
    $c3bc21db9fc66909$var$markRootUpdated$1(root, lane);
    if (0 === ($c3bc21db9fc66909$var$executionContext & 2) || root !== $c3bc21db9fc66909$var$workInProgressRoot) root === $c3bc21db9fc66909$var$workInProgressRoot && (0 === ($c3bc21db9fc66909$var$executionContext & 2) && ($c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && $c3bc21db9fc66909$var$markRootSuspended(root, $c3bc21db9fc66909$var$workInProgressRootRenderLanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !1)), $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
}
function $c3bc21db9fc66909$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($c3bc21db9fc66909$var$executionContext & 6)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $c3bc21db9fc66909$var$renderRootConcurrent(root$jscomp$0, lanes) : $c3bc21db9fc66909$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $c3bc21db9fc66909$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $c3bc21db9fc66909$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$c3bc21db9fc66909$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $c3bc21db9fc66909$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($c3bc21db9fc66909$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $c3bc21db9fc66909$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors;
                            $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors ? $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors.push.apply($c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $c3bc21db9fc66909$var$prepareFreshStack(root$jscomp$0, 0);
                $c3bc21db9fc66909$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $c3bc21db9fc66909$var$markRootSuspended(shouldTimeSlice, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !$c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $c3bc21db9fc66909$var$globalMostRecentFallbackTime + 300 - $c3bc21db9fc66909$var$now(), 10 < exitStatus)) {
                    $c3bc21db9fc66909$var$markRootSuspended(shouldTimeSlice, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !$c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $c3bc21db9fc66909$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $c3bc21db9fc66909$var$scheduleTimeout($c3bc21db9fc66909$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, $c3bc21db9fc66909$var$workInProgressTransitions, $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $c3bc21db9fc66909$var$commitRootWhenReady(shouldTimeSlice, forceSync, $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors, $c3bc21db9fc66909$var$workInProgressTransitions, $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $c3bc21db9fc66909$var$ensureRootIsScheduled(root$jscomp$0);
}
function $c3bc21db9fc66909$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($c3bc21db9fc66909$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $c3bc21db9fc66909$var$noop
        }, $c3bc21db9fc66909$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $c3bc21db9fc66909$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($c3bc21db9fc66909$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $c3bc21db9fc66909$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $c3bc21db9fc66909$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $c3bc21db9fc66909$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$c3bc21db9fc66909$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $c3bc21db9fc66909$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$c3bc21db9fc66909$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $c3bc21db9fc66909$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $c3bc21db9fc66909$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $c3bc21db9fc66909$var$flushSyncWork$1() {
    return 0 === ($c3bc21db9fc66909$var$executionContext & 6) ? ($c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $c3bc21db9fc66909$var$resetWorkInProgressStack() {
    if (null !== $c3bc21db9fc66909$var$workInProgress) {
        if (0 === $c3bc21db9fc66909$var$workInProgressSuspendedReason) var interruptedWork = $c3bc21db9fc66909$var$workInProgress.return;
        else interruptedWork = $c3bc21db9fc66909$var$workInProgress, $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null, $c3bc21db9fc66909$var$resetHooksOnUnwind(interruptedWork), $c3bc21db9fc66909$var$thenableState = null, $c3bc21db9fc66909$var$thenableIndexCounter = 0, interruptedWork = $c3bc21db9fc66909$var$workInProgress;
        for(; null !== interruptedWork;)$c3bc21db9fc66909$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $c3bc21db9fc66909$var$workInProgress = null;
    }
}
function $c3bc21db9fc66909$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $c3bc21db9fc66909$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $c3bc21db9fc66909$var$resetWorkInProgressStack();
    $c3bc21db9fc66909$var$workInProgressRoot = root;
    $c3bc21db9fc66909$var$workInProgress = timeoutHandle = $c3bc21db9fc66909$var$createWorkInProgress(root.current, null);
    $c3bc21db9fc66909$var$workInProgressRootRenderLanes = lanes;
    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
    $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $c3bc21db9fc66909$var$workInProgressRootIsPrerendering = $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, lanes);
    $c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener = !1;
    $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes = $c3bc21db9fc66909$var$workInProgressDeferredLane = $c3bc21db9fc66909$var$workInProgressRootPingedLanes = $c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes = $c3bc21db9fc66909$var$workInProgressRootSkippedLanes = $c3bc21db9fc66909$var$workInProgressRootExitStatus = 0;
    $c3bc21db9fc66909$var$workInProgressRootRecoverableErrors = $c3bc21db9fc66909$var$workInProgressRootConcurrentErrors = null;
    $c3bc21db9fc66909$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $c3bc21db9fc66909$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $c3bc21db9fc66909$var$entangledRenderLanes = lanes;
    $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $c3bc21db9fc66909$var$handleThrow(root, thrownValue) {
    $c3bc21db9fc66909$var$currentlyRenderingFiber = null;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$ContextOnlyDispatcher;
    thrownValue === $c3bc21db9fc66909$var$SuspenseException || thrownValue === $c3bc21db9fc66909$var$SuspenseActionException ? (thrownValue = $c3bc21db9fc66909$var$getSuspendedThenable(), $c3bc21db9fc66909$var$workInProgressSuspendedReason = 3) : thrownValue === $c3bc21db9fc66909$var$SuspenseyCommitException ? (thrownValue = $c3bc21db9fc66909$var$getSuspendedThenable(), $c3bc21db9fc66909$var$workInProgressSuspendedReason = 4) : $c3bc21db9fc66909$var$workInProgressSuspendedReason = thrownValue === $c3bc21db9fc66909$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $c3bc21db9fc66909$var$workInProgressThrownValue = thrownValue;
    null === $c3bc21db9fc66909$var$workInProgress && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 1, $c3bc21db9fc66909$var$logUncaughtError(root, $c3bc21db9fc66909$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $c3bc21db9fc66909$var$pushDispatcher() {
    var prevDispatcher = $c3bc21db9fc66909$var$ReactSharedInternals.H;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = $c3bc21db9fc66909$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $c3bc21db9fc66909$var$ContextOnlyDispatcher : prevDispatcher;
}
function $c3bc21db9fc66909$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $c3bc21db9fc66909$var$ReactSharedInternals.A;
    $c3bc21db9fc66909$var$ReactSharedInternals.A = $c3bc21db9fc66909$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $c3bc21db9fc66909$var$renderDidSuspendDelayIfPossible() {
    $c3bc21db9fc66909$var$workInProgressRootExitStatus = 4;
    $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings || ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 4194048) !== $c3bc21db9fc66909$var$workInProgressRootRenderLanes && null !== $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current || ($c3bc21db9fc66909$var$workInProgressRootIsPrerendering = !0);
    0 === ($c3bc21db9fc66909$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($c3bc21db9fc66909$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $c3bc21db9fc66909$var$workInProgressRoot || $c3bc21db9fc66909$var$markRootSuspended($c3bc21db9fc66909$var$workInProgressRoot, $c3bc21db9fc66909$var$workInProgressRootRenderLanes, $c3bc21db9fc66909$var$workInProgressDeferredLane, !1);
}
function $c3bc21db9fc66909$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
    $c3bc21db9fc66909$var$executionContext |= 2;
    var prevDispatcher = $c3bc21db9fc66909$var$pushDispatcher(), prevAsyncDispatcher = $c3bc21db9fc66909$var$pushAsyncDispatcher();
    if ($c3bc21db9fc66909$var$workInProgressRoot !== root || $c3bc21db9fc66909$var$workInProgressRootRenderLanes !== lanes) $c3bc21db9fc66909$var$workInProgressTransitions = null, $c3bc21db9fc66909$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $c3bc21db9fc66909$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason && null !== $c3bc21db9fc66909$var$workInProgress) {
            var unitOfWork = $c3bc21db9fc66909$var$workInProgress, thrownValue = $c3bc21db9fc66909$var$workInProgressThrownValue;
            switch($c3bc21db9fc66909$var$workInProgressSuspendedReason){
                case 8:
                    $c3bc21db9fc66909$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $c3bc21db9fc66909$var$workInProgressSuspendedReason;
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $c3bc21db9fc66909$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $c3bc21db9fc66909$var$workInProgressSuspendedReason, $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $c3bc21db9fc66909$var$workLoopSync();
        exitStatus = $c3bc21db9fc66909$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $c3bc21db9fc66909$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null;
    $c3bc21db9fc66909$var$executionContext = prevExecutionContext;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = prevDispatcher;
    $c3bc21db9fc66909$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $c3bc21db9fc66909$var$workInProgress && ($c3bc21db9fc66909$var$workInProgressRoot = null, $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0, $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $c3bc21db9fc66909$var$workLoopSync() {
    for(; null !== $c3bc21db9fc66909$var$workInProgress;)$c3bc21db9fc66909$var$performUnitOfWork($c3bc21db9fc66909$var$workInProgress);
}
function $c3bc21db9fc66909$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
    $c3bc21db9fc66909$var$executionContext |= 2;
    var prevDispatcher = $c3bc21db9fc66909$var$pushDispatcher(), prevAsyncDispatcher = $c3bc21db9fc66909$var$pushAsyncDispatcher();
    $c3bc21db9fc66909$var$workInProgressRoot !== root || $c3bc21db9fc66909$var$workInProgressRootRenderLanes !== lanes ? ($c3bc21db9fc66909$var$workInProgressTransitions = null, $c3bc21db9fc66909$var$workInProgressRootRenderTargetTime = $c3bc21db9fc66909$var$now() + 500, $c3bc21db9fc66909$var$prepareFreshStack(root, lanes)) : $c3bc21db9fc66909$var$workInProgressRootIsPrerendering = $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason && null !== $c3bc21db9fc66909$var$workInProgress) {
            lanes = $c3bc21db9fc66909$var$workInProgress;
            var thrownValue = $c3bc21db9fc66909$var$workInProgressThrownValue;
            b: switch($c3bc21db9fc66909$var$workInProgressSuspendedReason){
                case 1:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($c3bc21db9fc66909$var$isThenableResolved(thrownValue)) {
                        $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                        $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                        $c3bc21db9fc66909$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason && 9 !== $c3bc21db9fc66909$var$workInProgressSuspendedReason || $c3bc21db9fc66909$var$workInProgressRoot !== root || ($c3bc21db9fc66909$var$workInProgressSuspendedReason = 7);
                        $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $c3bc21db9fc66909$var$isThenableResolved(thrownValue) ? ($c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$replaySuspendedUnitOfWork(lanes)) : ($c3bc21db9fc66909$var$workInProgressSuspendedReason = 0, $c3bc21db9fc66909$var$workInProgressThrownValue = null, $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($c3bc21db9fc66909$var$workInProgress.tag){
                        case 26:
                            resource = $c3bc21db9fc66909$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $c3bc21db9fc66909$var$workInProgress;
                            if (resource ? $c3bc21db9fc66909$var$preloadResource(resource) : 1) {
                                $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                                $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $c3bc21db9fc66909$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($c3bc21db9fc66909$var$workInProgress = returnFiber, $c3bc21db9fc66909$var$completeUnitOfWork(returnFiber)) : $c3bc21db9fc66909$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $c3bc21db9fc66909$var$workInProgressSuspendedReason = 0;
                    $c3bc21db9fc66909$var$workInProgressThrownValue = null;
                    $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $c3bc21db9fc66909$var$resetWorkInProgressStack();
                    $c3bc21db9fc66909$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(462));
            }
        }
        $c3bc21db9fc66909$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $c3bc21db9fc66909$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null;
    $c3bc21db9fc66909$var$ReactSharedInternals.H = prevDispatcher;
    $c3bc21db9fc66909$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $c3bc21db9fc66909$var$executionContext = prevExecutionContext;
    if (null !== $c3bc21db9fc66909$var$workInProgress) return 0;
    $c3bc21db9fc66909$var$workInProgressRoot = null;
    $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0;
    $c3bc21db9fc66909$var$finishQueueingConcurrentUpdates();
    return $c3bc21db9fc66909$var$workInProgressRootExitStatus;
}
function $c3bc21db9fc66909$var$workLoopConcurrentByScheduler() {
    for(; null !== $c3bc21db9fc66909$var$workInProgress && !$c3bc21db9fc66909$var$shouldYield();)$c3bc21db9fc66909$var$performUnitOfWork($c3bc21db9fc66909$var$workInProgress);
}
function $c3bc21db9fc66909$var$performUnitOfWork(unitOfWork) {
    var next = $c3bc21db9fc66909$var$beginWork(unitOfWork.alternate, unitOfWork, $c3bc21db9fc66909$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork) : $c3bc21db9fc66909$var$workInProgress = next;
}
function $c3bc21db9fc66909$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $c3bc21db9fc66909$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $c3bc21db9fc66909$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $c3bc21db9fc66909$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $c3bc21db9fc66909$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $c3bc21db9fc66909$var$resetHooksOnUnwind(next);
        default:
            $c3bc21db9fc66909$var$unwindInterruptedWork(current, next), next = $c3bc21db9fc66909$var$workInProgress = $c3bc21db9fc66909$var$resetWorkInProgress(next, $c3bc21db9fc66909$var$entangledRenderLanes), next = $c3bc21db9fc66909$var$beginWork(current, next, $c3bc21db9fc66909$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork) : $c3bc21db9fc66909$var$workInProgress = next;
}
function $c3bc21db9fc66909$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $c3bc21db9fc66909$var$lastContextDependency = $c3bc21db9fc66909$var$currentlyRenderingFiber$1 = null;
    $c3bc21db9fc66909$var$resetHooksOnUnwind(unitOfWork);
    $c3bc21db9fc66909$var$thenableState = null;
    $c3bc21db9fc66909$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($c3bc21db9fc66909$var$throwException(root, returnFiber, unitOfWork, thrownValue, $c3bc21db9fc66909$var$workInProgressRootRenderLanes)) {
            $c3bc21db9fc66909$var$workInProgressRootExitStatus = 1;
            $c3bc21db9fc66909$var$logUncaughtError(root, $c3bc21db9fc66909$var$createCapturedValueAtFiber(thrownValue, root.current));
            $c3bc21db9fc66909$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $c3bc21db9fc66909$var$workInProgress = returnFiber, error;
        $c3bc21db9fc66909$var$workInProgressRootExitStatus = 1;
        $c3bc21db9fc66909$var$logUncaughtError(root, $c3bc21db9fc66909$var$createCapturedValueAtFiber(thrownValue, root.current));
        $c3bc21db9fc66909$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($c3bc21db9fc66909$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($c3bc21db9fc66909$var$workInProgressRootIsPrerendering || 0 !== ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $c3bc21db9fc66909$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $c3bc21db9fc66909$var$unwindUnitOfWork(unitOfWork, root);
    } else $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork);
}
function $c3bc21db9fc66909$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $c3bc21db9fc66909$var$unwindUnitOfWork(completedWork, $c3bc21db9fc66909$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $c3bc21db9fc66909$var$completeWork(completedWork.alternate, completedWork, $c3bc21db9fc66909$var$entangledRenderLanes);
        if (null !== next) {
            $c3bc21db9fc66909$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $c3bc21db9fc66909$var$workInProgress = completedWork;
            return;
        }
        $c3bc21db9fc66909$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootExitStatus = 5);
}
function $c3bc21db9fc66909$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $c3bc21db9fc66909$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $c3bc21db9fc66909$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $c3bc21db9fc66909$var$workInProgress = unitOfWork;
            return;
        }
        $c3bc21db9fc66909$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $c3bc21db9fc66909$var$workInProgressRootExitStatus = 6;
    $c3bc21db9fc66909$var$workInProgress = null;
}
function $c3bc21db9fc66909$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $c3bc21db9fc66909$var$flushPendingEffects();
    while (0 !== $c3bc21db9fc66909$var$pendingEffectsStatus);
    if (0 !== ($c3bc21db9fc66909$var$executionContext & 6)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $c3bc21db9fc66909$var$concurrentlyUpdatedLanes;
        $c3bc21db9fc66909$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $c3bc21db9fc66909$var$workInProgressRoot && ($c3bc21db9fc66909$var$workInProgress = $c3bc21db9fc66909$var$workInProgressRoot = null, $c3bc21db9fc66909$var$workInProgressRootRenderLanes = 0);
        $c3bc21db9fc66909$var$pendingFinishedWork = finishedWork;
        $c3bc21db9fc66909$var$pendingEffectsRoot = root;
        $c3bc21db9fc66909$var$pendingEffectsLanes = lanes;
        $c3bc21db9fc66909$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $c3bc21db9fc66909$var$pendingPassiveTransitions = transitions;
        $c3bc21db9fc66909$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $c3bc21db9fc66909$var$scheduleCallback$1($c3bc21db9fc66909$var$NormalPriority$1, function() {
            $c3bc21db9fc66909$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $c3bc21db9fc66909$var$ReactSharedInternals.T;
            $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
            transitions = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
            $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $c3bc21db9fc66909$var$executionContext;
            $c3bc21db9fc66909$var$executionContext |= 4;
            try {
                $c3bc21db9fc66909$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $c3bc21db9fc66909$var$executionContext = spawnedLane, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = transitions, $c3bc21db9fc66909$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $c3bc21db9fc66909$var$pendingEffectsStatus = 1;
        $c3bc21db9fc66909$var$flushMutationEffects();
        $c3bc21db9fc66909$var$flushLayoutEffects();
        $c3bc21db9fc66909$var$flushSpawnedWork();
    }
}
function $c3bc21db9fc66909$var$flushMutationEffects() {
    if (1 === $c3bc21db9fc66909$var$pendingEffectsStatus) {
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        var root = $c3bc21db9fc66909$var$pendingEffectsRoot, finishedWork = $c3bc21db9fc66909$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $c3bc21db9fc66909$var$ReactSharedInternals.T;
            $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
            var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
            $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
            $c3bc21db9fc66909$var$executionContext |= 4;
            try {
                $c3bc21db9fc66909$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $c3bc21db9fc66909$var$selectionInformation, curFocusedElem = $c3bc21db9fc66909$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $c3bc21db9fc66909$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $c3bc21db9fc66909$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $c3bc21db9fc66909$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $c3bc21db9fc66909$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $c3bc21db9fc66909$var$_enabled = !!$c3bc21db9fc66909$var$eventsEnabled;
                $c3bc21db9fc66909$var$selectionInformation = $c3bc21db9fc66909$var$eventsEnabled = null;
            } finally{
                $c3bc21db9fc66909$var$executionContext = prevExecutionContext, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $c3bc21db9fc66909$var$pendingEffectsStatus = 2;
    }
}
function $c3bc21db9fc66909$var$flushLayoutEffects() {
    if (2 === $c3bc21db9fc66909$var$pendingEffectsStatus) {
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        var root = $c3bc21db9fc66909$var$pendingEffectsRoot, finishedWork = $c3bc21db9fc66909$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $c3bc21db9fc66909$var$ReactSharedInternals.T;
            $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
            var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
            $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
            $c3bc21db9fc66909$var$executionContext |= 4;
            try {
                $c3bc21db9fc66909$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $c3bc21db9fc66909$var$executionContext = prevExecutionContext, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $c3bc21db9fc66909$var$pendingEffectsStatus = 3;
    }
}
function $c3bc21db9fc66909$var$flushSpawnedWork() {
    if (4 === $c3bc21db9fc66909$var$pendingEffectsStatus || 3 === $c3bc21db9fc66909$var$pendingEffectsStatus) {
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        $c3bc21db9fc66909$var$requestPaint();
        var root = $c3bc21db9fc66909$var$pendingEffectsRoot, finishedWork = $c3bc21db9fc66909$var$pendingFinishedWork, lanes = $c3bc21db9fc66909$var$pendingEffectsLanes, recoverableErrors = $c3bc21db9fc66909$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $c3bc21db9fc66909$var$pendingEffectsStatus = 5 : ($c3bc21db9fc66909$var$pendingEffectsStatus = 0, $c3bc21db9fc66909$var$pendingFinishedWork = $c3bc21db9fc66909$var$pendingEffectsRoot = null, $c3bc21db9fc66909$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $c3bc21db9fc66909$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.onCommitFiberRoot) try {
            $c3bc21db9fc66909$var$injectedHook.onCommitFiberRoot($c3bc21db9fc66909$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $c3bc21db9fc66909$var$ReactSharedInternals.T;
            remainingLanes = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
            $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2;
            $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $c3bc21db9fc66909$var$ReactSharedInternals.T = finishedWork, $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($c3bc21db9fc66909$var$pendingEffectsLanes & 3) && $c3bc21db9fc66909$var$flushPendingEffects();
        $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $c3bc21db9fc66909$var$rootWithNestedUpdates ? $c3bc21db9fc66909$var$nestedUpdateCount++ : ($c3bc21db9fc66909$var$nestedUpdateCount = 0, $c3bc21db9fc66909$var$rootWithNestedUpdates = root) : $c3bc21db9fc66909$var$nestedUpdateCount = 0;
        $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $c3bc21db9fc66909$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $c3bc21db9fc66909$var$releaseCache(remainingLanes)));
}
function $c3bc21db9fc66909$var$flushPendingEffects(wasDelayedCommit) {
    $c3bc21db9fc66909$var$flushMutationEffects();
    $c3bc21db9fc66909$var$flushLayoutEffects();
    $c3bc21db9fc66909$var$flushSpawnedWork();
    return $c3bc21db9fc66909$var$flushPassiveEffects(wasDelayedCommit);
}
function $c3bc21db9fc66909$var$flushPassiveEffects() {
    if (5 !== $c3bc21db9fc66909$var$pendingEffectsStatus) return !1;
    var root = $c3bc21db9fc66909$var$pendingEffectsRoot, remainingLanes = $c3bc21db9fc66909$var$pendingEffectsRemainingLanes;
    $c3bc21db9fc66909$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $c3bc21db9fc66909$var$lanesToEventPriority($c3bc21db9fc66909$var$pendingEffectsLanes), prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T, previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
        renderPriority = $c3bc21db9fc66909$var$pendingPassiveTransitions;
        $c3bc21db9fc66909$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $c3bc21db9fc66909$var$pendingEffectsRoot, lanes = $c3bc21db9fc66909$var$pendingEffectsLanes;
        $c3bc21db9fc66909$var$pendingEffectsStatus = 0;
        $c3bc21db9fc66909$var$pendingFinishedWork = $c3bc21db9fc66909$var$pendingEffectsRoot = null;
        $c3bc21db9fc66909$var$pendingEffectsLanes = 0;
        if (0 !== ($c3bc21db9fc66909$var$executionContext & 6)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(331));
        var prevExecutionContext = $c3bc21db9fc66909$var$executionContext;
        $c3bc21db9fc66909$var$executionContext |= 4;
        $c3bc21db9fc66909$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $c3bc21db9fc66909$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $c3bc21db9fc66909$var$executionContext = prevExecutionContext;
        $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($c3bc21db9fc66909$var$injectedHook && "function" === typeof $c3bc21db9fc66909$var$injectedHook.onPostCommitFiberRoot) try {
            $c3bc21db9fc66909$var$injectedHook.onPostCommitFiberRoot($c3bc21db9fc66909$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition, $c3bc21db9fc66909$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $c3bc21db9fc66909$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $c3bc21db9fc66909$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $c3bc21db9fc66909$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $c3bc21db9fc66909$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($c3bc21db9fc66909$var$markRootUpdated$1(rootFiber, 2), $c3bc21db9fc66909$var$ensureRootIsScheduled(rootFiber));
}
function $c3bc21db9fc66909$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $c3bc21db9fc66909$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $c3bc21db9fc66909$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed || !$c3bc21db9fc66909$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $c3bc21db9fc66909$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $c3bc21db9fc66909$var$createClassErrorUpdate(2);
                instance = $c3bc21db9fc66909$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($c3bc21db9fc66909$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $c3bc21db9fc66909$var$markRootUpdated$1(instance, 2), $c3bc21db9fc66909$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $c3bc21db9fc66909$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $c3bc21db9fc66909$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($c3bc21db9fc66909$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $c3bc21db9fc66909$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $c3bc21db9fc66909$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $c3bc21db9fc66909$var$workInProgressRoot === root && ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $c3bc21db9fc66909$var$workInProgressRootExitStatus || 3 === $c3bc21db9fc66909$var$workInProgressRootExitStatus && ($c3bc21db9fc66909$var$workInProgressRootRenderLanes & 62914560) === $c3bc21db9fc66909$var$workInProgressRootRenderLanes && 300 > $c3bc21db9fc66909$var$now() - $c3bc21db9fc66909$var$globalMostRecentFallbackTime ? 0 === ($c3bc21db9fc66909$var$executionContext & 2) && $c3bc21db9fc66909$var$prepareFreshStack(root, 0) : $c3bc21db9fc66909$var$workInProgressRootPingedLanes |= pingedLanes, $c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes === $c3bc21db9fc66909$var$workInProgressRootRenderLanes && ($c3bc21db9fc66909$var$workInProgressSuspendedRetryLanes = 0));
    $c3bc21db9fc66909$var$ensureRootIsScheduled(root);
}
function $c3bc21db9fc66909$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $c3bc21db9fc66909$var$claimNextRetryLane());
    boundaryFiber = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($c3bc21db9fc66909$var$markRootUpdated$1(boundaryFiber, retryLane), $c3bc21db9fc66909$var$ensureRootIsScheduled(boundaryFiber));
}
function $c3bc21db9fc66909$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $c3bc21db9fc66909$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c3bc21db9fc66909$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $c3bc21db9fc66909$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c3bc21db9fc66909$var$scheduleCallback$1(priorityLevel, callback) {
    return $c3bc21db9fc66909$var$scheduleCallback$3(priorityLevel, callback);
}
var $c3bc21db9fc66909$var$firstScheduledRoot = null, $c3bc21db9fc66909$var$lastScheduledRoot = null, $c3bc21db9fc66909$var$didScheduleMicrotask = !1, $c3bc21db9fc66909$var$mightHavePendingSyncWork = !1, $c3bc21db9fc66909$var$isFlushingWork = !1, $c3bc21db9fc66909$var$currentEventTransitionLane = 0;
function $c3bc21db9fc66909$var$ensureRootIsScheduled(root) {
    root !== $c3bc21db9fc66909$var$lastScheduledRoot && null === root.next && (null === $c3bc21db9fc66909$var$lastScheduledRoot ? $c3bc21db9fc66909$var$firstScheduledRoot = $c3bc21db9fc66909$var$lastScheduledRoot = root : $c3bc21db9fc66909$var$lastScheduledRoot = $c3bc21db9fc66909$var$lastScheduledRoot.next = root);
    $c3bc21db9fc66909$var$mightHavePendingSyncWork = !0;
    $c3bc21db9fc66909$var$didScheduleMicrotask || ($c3bc21db9fc66909$var$didScheduleMicrotask = !0, $c3bc21db9fc66909$var$scheduleImmediateRootScheduleTask());
}
function $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$c3bc21db9fc66909$var$isFlushingWork && $c3bc21db9fc66909$var$mightHavePendingSyncWork) {
        $c3bc21db9fc66909$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $c3bc21db9fc66909$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $c3bc21db9fc66909$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $c3bc21db9fc66909$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $c3bc21db9fc66909$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $c3bc21db9fc66909$var$getNextLanes(root$174, root$174 === $c3bc21db9fc66909$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $c3bc21db9fc66909$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $c3bc21db9fc66909$var$isFlushingWork = !1;
    }
}
function $c3bc21db9fc66909$var$processRootScheduleInImmediateTask() {
    $c3bc21db9fc66909$var$processRootScheduleInMicrotask();
}
function $c3bc21db9fc66909$var$processRootScheduleInMicrotask() {
    $c3bc21db9fc66909$var$mightHavePendingSyncWork = $c3bc21db9fc66909$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $c3bc21db9fc66909$var$currentEventTransitionLane && ($c3bc21db9fc66909$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $c3bc21db9fc66909$var$currentEventTransitionLane), $c3bc21db9fc66909$var$currentEventTransitionLane = 0);
    for(var currentTime = $c3bc21db9fc66909$var$now(), prev = null, root = $c3bc21db9fc66909$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $c3bc21db9fc66909$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $c3bc21db9fc66909$var$firstScheduledRoot = next : prev.next = next, null === next && ($c3bc21db9fc66909$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $c3bc21db9fc66909$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $c3bc21db9fc66909$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $c3bc21db9fc66909$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $c3bc21db9fc66909$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $c3bc21db9fc66909$var$workInProgressRoot;
    suspendedLanes = $c3bc21db9fc66909$var$workInProgressRootRenderLanes;
    suspendedLanes = $c3bc21db9fc66909$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $c3bc21db9fc66909$var$workInProgressSuspendedReason || 9 === $c3bc21db9fc66909$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $c3bc21db9fc66909$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $c3bc21db9fc66909$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $c3bc21db9fc66909$var$cancelCallback$1(pingedLanes);
        switch($c3bc21db9fc66909$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $c3bc21db9fc66909$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $c3bc21db9fc66909$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $c3bc21db9fc66909$var$IdlePriority;
                break;
            default:
                suspendedLanes = $c3bc21db9fc66909$var$NormalPriority$1;
        }
        pingedLanes = $c3bc21db9fc66909$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $c3bc21db9fc66909$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $c3bc21db9fc66909$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $c3bc21db9fc66909$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $c3bc21db9fc66909$var$pendingEffectsStatus && 5 !== $c3bc21db9fc66909$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($c3bc21db9fc66909$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $c3bc21db9fc66909$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $c3bc21db9fc66909$var$getNextLanes(root, root === $c3bc21db9fc66909$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $c3bc21db9fc66909$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $c3bc21db9fc66909$var$scheduleTaskForRootDuringMicrotask(root, $c3bc21db9fc66909$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $c3bc21db9fc66909$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $c3bc21db9fc66909$var$performSyncWorkOnRoot(root, lanes) {
    if ($c3bc21db9fc66909$var$flushPendingEffects()) return null;
    $c3bc21db9fc66909$var$performWorkOnRoot(root, lanes, !0);
}
function $c3bc21db9fc66909$var$scheduleImmediateRootScheduleTask() {
    $c3bc21db9fc66909$var$scheduleMicrotask(function() {
        0 !== ($c3bc21db9fc66909$var$executionContext & 6) ? $c3bc21db9fc66909$var$scheduleCallback$3($c3bc21db9fc66909$var$ImmediatePriority, $c3bc21db9fc66909$var$processRootScheduleInImmediateTask) : $c3bc21db9fc66909$var$processRootScheduleInMicrotask();
    });
}
function $c3bc21db9fc66909$var$requestTransitionLane() {
    0 === $c3bc21db9fc66909$var$currentEventTransitionLane && ($c3bc21db9fc66909$var$currentEventTransitionLane = $c3bc21db9fc66909$var$claimNextTransitionLane());
    return $c3bc21db9fc66909$var$currentEventTransitionLane;
}
function $c3bc21db9fc66909$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $c3bc21db9fc66909$var$sanitizeURL("" + actionProp);
}
function $c3bc21db9fc66909$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $c3bc21db9fc66909$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $c3bc21db9fc66909$var$coerceFormActionProp((nativeEventTarget[$c3bc21db9fc66909$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$c3bc21db9fc66909$var$internalPropsKey] || null) ? $c3bc21db9fc66909$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $c3bc21db9fc66909$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $c3bc21db9fc66909$var$currentEventTransitionLane) {
                                var formData = submitter ? $c3bc21db9fc66909$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $c3bc21db9fc66909$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $c3bc21db9fc66909$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $c3bc21db9fc66909$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $c3bc21db9fc66909$var$i$jscomp$inline_1528 = 0; $c3bc21db9fc66909$var$i$jscomp$inline_1528 < $c3bc21db9fc66909$var$simpleEventPluginEvents.length; $c3bc21db9fc66909$var$i$jscomp$inline_1528++){
    var $c3bc21db9fc66909$var$eventName$jscomp$inline_1529 = $c3bc21db9fc66909$var$simpleEventPluginEvents[$c3bc21db9fc66909$var$i$jscomp$inline_1528], $c3bc21db9fc66909$var$domEventName$jscomp$inline_1530 = $c3bc21db9fc66909$var$eventName$jscomp$inline_1529.toLowerCase(), $c3bc21db9fc66909$var$capitalizedEvent$jscomp$inline_1531 = $c3bc21db9fc66909$var$eventName$jscomp$inline_1529[0].toUpperCase() + $c3bc21db9fc66909$var$eventName$jscomp$inline_1529.slice(1);
    $c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$domEventName$jscomp$inline_1530, "on" + $c3bc21db9fc66909$var$capitalizedEvent$jscomp$inline_1531);
}
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$ANIMATION_END, "onAnimationEnd");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$ANIMATION_ITERATION, "onAnimationIteration");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$ANIMATION_START, "onAnimationStart");
$c3bc21db9fc66909$var$registerSimpleEvent("dblclick", "onDoubleClick");
$c3bc21db9fc66909$var$registerSimpleEvent("focusin", "onFocus");
$c3bc21db9fc66909$var$registerSimpleEvent("focusout", "onBlur");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_RUN, "onTransitionRun");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_START, "onTransitionStart");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_CANCEL, "onTransitionCancel");
$c3bc21db9fc66909$var$registerSimpleEvent($c3bc21db9fc66909$var$TRANSITION_END, "onTransitionEnd");
$c3bc21db9fc66909$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c3bc21db9fc66909$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c3bc21db9fc66909$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c3bc21db9fc66909$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c3bc21db9fc66909$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c3bc21db9fc66909$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c3bc21db9fc66909$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($c3bc21db9fc66909$var$mediaEventTypes));
function $c3bc21db9fc66909$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c3bc21db9fc66909$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c3bc21db9fc66909$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $c3bc21db9fc66909$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$c3bc21db9fc66909$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$c3bc21db9fc66909$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($c3bc21db9fc66909$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $c3bc21db9fc66909$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $c3bc21db9fc66909$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $c3bc21db9fc66909$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $c3bc21db9fc66909$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$c3bc21db9fc66909$var$listeningMarker]) {
        rootContainerElement[$c3bc21db9fc66909$var$listeningMarker] = !0;
        $c3bc21db9fc66909$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($c3bc21db9fc66909$var$nonDelegatedEvents.has(domEventName) || $c3bc21db9fc66909$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $c3bc21db9fc66909$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$c3bc21db9fc66909$var$listeningMarker] || (ownerDocument[$c3bc21db9fc66909$var$listeningMarker] = !0, $c3bc21db9fc66909$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $c3bc21db9fc66909$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($c3bc21db9fc66909$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $c3bc21db9fc66909$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $c3bc21db9fc66909$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $c3bc21db9fc66909$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$c3bc21db9fc66909$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $c3bc21db9fc66909$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $c3bc21db9fc66909$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $c3bc21db9fc66909$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $c3bc21db9fc66909$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $c3bc21db9fc66909$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticTouchEvent;
                        break;
                    case $c3bc21db9fc66909$var$ANIMATION_END:
                    case $c3bc21db9fc66909$var$ANIMATION_ITERATION:
                    case $c3bc21db9fc66909$var$ANIMATION_START:
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticAnimationEvent;
                        break;
                    case $c3bc21db9fc66909$var$TRANSITION_END:
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $c3bc21db9fc66909$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $c3bc21db9fc66909$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($c3bc21db9fc66909$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $c3bc21db9fc66909$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($c3bc21db9fc66909$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$c3bc21db9fc66909$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $c3bc21db9fc66909$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $c3bc21db9fc66909$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $c3bc21db9fc66909$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $c3bc21db9fc66909$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $c3bc21db9fc66909$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $c3bc21db9fc66909$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $c3bc21db9fc66909$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $c3bc21db9fc66909$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $c3bc21db9fc66909$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $c3bc21db9fc66909$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $c3bc21db9fc66909$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $c3bc21db9fc66909$var$getParent(inCapturePhase);
                                reactEventName = $c3bc21db9fc66909$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $c3bc21db9fc66909$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $c3bc21db9fc66909$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $c3bc21db9fc66909$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForChangeEvent;
                else if ($c3bc21db9fc66909$var$isTextInputElement(reactName)) {
                    if ($c3bc21db9fc66909$var$isInputEventSupported) getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $c3bc21db9fc66909$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $c3bc21db9fc66909$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForChangeEvent) : getTargetInstFunc = $c3bc21db9fc66909$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $c3bc21db9fc66909$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $c3bc21db9fc66909$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $c3bc21db9fc66909$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($c3bc21db9fc66909$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $c3bc21db9fc66909$var$activeElement = handleEventFunc, $c3bc21db9fc66909$var$activeElementInst = targetInst, $c3bc21db9fc66909$var$lastSelection = null;
                    break;
                case "focusout":
                    $c3bc21db9fc66909$var$lastSelection = $c3bc21db9fc66909$var$activeElementInst = $c3bc21db9fc66909$var$activeElement = null;
                    break;
                case "mousedown":
                    $c3bc21db9fc66909$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c3bc21db9fc66909$var$mouseDown = !1;
                    $c3bc21db9fc66909$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($c3bc21db9fc66909$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $c3bc21db9fc66909$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($c3bc21db9fc66909$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $c3bc21db9fc66909$var$isComposing ? $c3bc21db9fc66909$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($c3bc21db9fc66909$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($c3bc21db9fc66909$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $c3bc21db9fc66909$var$isComposing && (fallbackData = $c3bc21db9fc66909$var$getData()) : ($c3bc21db9fc66909$var$root = nativeEventTarget, $c3bc21db9fc66909$var$startText = "value" in $c3bc21db9fc66909$var$root ? $c3bc21db9fc66909$var$root.value : $c3bc21db9fc66909$var$root.textContent, $c3bc21db9fc66909$var$isComposing = !0)), handleEventFunc = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $c3bc21db9fc66909$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $c3bc21db9fc66909$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $c3bc21db9fc66909$var$canUseTextInputEvent ? $c3bc21db9fc66909$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $c3bc21db9fc66909$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $c3bc21db9fc66909$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $c3bc21db9fc66909$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $c3bc21db9fc66909$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $c3bc21db9fc66909$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $c3bc21db9fc66909$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $c3bc21db9fc66909$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($c3bc21db9fc66909$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $c3bc21db9fc66909$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($c3bc21db9fc66909$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $c3bc21db9fc66909$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $c3bc21db9fc66909$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $c3bc21db9fc66909$var$getListener(target, registrationName), null != stateNode && listeners.unshift($c3bc21db9fc66909$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $c3bc21db9fc66909$var$getListener(target, registrationName), null != stateNode && listeners.push($c3bc21db9fc66909$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $c3bc21db9fc66909$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $c3bc21db9fc66909$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $c3bc21db9fc66909$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($c3bc21db9fc66909$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($c3bc21db9fc66909$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $c3bc21db9fc66909$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $c3bc21db9fc66909$var$normalizeMarkupForTextOrAttribute(clientText);
    return $c3bc21db9fc66909$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $c3bc21db9fc66909$var$noop$1() {}
function $c3bc21db9fc66909$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $c3bc21db9fc66909$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $c3bc21db9fc66909$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $c3bc21db9fc66909$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $c3bc21db9fc66909$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c3bc21db9fc66909$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $c3bc21db9fc66909$var$setProp(domElement, tag, "name", props.name, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($c3bc21db9fc66909$var$setProp(domElement, tag, "encType", props.encType, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "method", props.method, props, null), $c3bc21db9fc66909$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c3bc21db9fc66909$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c3bc21db9fc66909$var$noop$1);
            break;
        case "onScroll":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $c3bc21db9fc66909$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", domElement);
            $c3bc21db9fc66909$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $c3bc21db9fc66909$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $c3bc21db9fc66909$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $c3bc21db9fc66909$var$aliases.get(key) || key, $c3bc21db9fc66909$var$setValueForAttribute(domElement, key, value);
    }
}
function $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $c3bc21db9fc66909$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $c3bc21db9fc66909$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $c3bc21db9fc66909$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c3bc21db9fc66909$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c3bc21db9fc66909$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$c3bc21db9fc66909$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$c3bc21db9fc66909$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $c3bc21db9fc66909$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $c3bc21db9fc66909$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                    default:
                        $c3bc21db9fc66909$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $c3bc21db9fc66909$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $c3bc21db9fc66909$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $c3bc21db9fc66909$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $c3bc21db9fc66909$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $c3bc21db9fc66909$var$track(domElement);
            return;
        case "select":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $c3bc21db9fc66909$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $c3bc21db9fc66909$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(91));
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $c3bc21db9fc66909$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $c3bc21db9fc66909$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("cancel", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $c3bc21db9fc66909$var$mediaEventTypes.length; hasSrc++)$c3bc21db9fc66909$var$listenToNonDelegatedEvent($c3bc21db9fc66909$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", domElement);
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $c3bc21db9fc66909$var$listenToNonDelegatedEvent("error", domElement), $c3bc21db9fc66909$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($c3bc21db9fc66909$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $c3bc21db9fc66909$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $c3bc21db9fc66909$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $c3bc21db9fc66909$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $c3bc21db9fc66909$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $c3bc21db9fc66909$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $c3bc21db9fc66909$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $c3bc21db9fc66909$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $c3bc21db9fc66909$var$updateOptions(domElement, !!lastProps, tag, !0) : $c3bc21db9fc66909$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $c3bc21db9fc66909$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $c3bc21db9fc66909$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $c3bc21db9fc66909$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($c3bc21db9fc66909$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $c3bc21db9fc66909$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $c3bc21db9fc66909$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $c3bc21db9fc66909$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $c3bc21db9fc66909$var$eventsEnabled = null, $c3bc21db9fc66909$var$selectionInformation = null;
function $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $c3bc21db9fc66909$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $c3bc21db9fc66909$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $c3bc21db9fc66909$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $c3bc21db9fc66909$var$currentPopstateTransitionEvent = null;
function $c3bc21db9fc66909$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $c3bc21db9fc66909$var$currentPopstateTransitionEvent) return !1;
        $c3bc21db9fc66909$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $c3bc21db9fc66909$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $c3bc21db9fc66909$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $c3bc21db9fc66909$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $c3bc21db9fc66909$var$localPromise = "function" === typeof Promise ? Promise : void 0, $c3bc21db9fc66909$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c3bc21db9fc66909$var$localPromise ? function(callback) {
    return $c3bc21db9fc66909$var$localPromise.resolve(null).then(callback).catch($c3bc21db9fc66909$var$handleErrorInNextTick);
} : $c3bc21db9fc66909$var$scheduleTimeout;
function $c3bc21db9fc66909$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $c3bc21db9fc66909$var$isSingletonScope(type) {
    return "head" === type;
}
function $c3bc21db9fc66909$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $c3bc21db9fc66909$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $c3bc21db9fc66909$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $c3bc21db9fc66909$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$c3bc21db9fc66909$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $c3bc21db9fc66909$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $c3bc21db9fc66909$var$retryIfBlockedOn(suspenseInstance);
}
function $c3bc21db9fc66909$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $c3bc21db9fc66909$var$clearContainerSparingly(node);
                $c3bc21db9fc66909$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $c3bc21db9fc66909$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$c3bc21db9fc66909$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $c3bc21db9fc66909$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $c3bc21db9fc66909$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c3bc21db9fc66909$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c3bc21db9fc66909$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $c3bc21db9fc66909$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $c3bc21db9fc66909$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $c3bc21db9fc66909$var$previousHydratableOnEnteringScopedSingleton = null;
function $c3bc21db9fc66909$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $c3bc21db9fc66909$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $c3bc21db9fc66909$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(451));
    }
}
function $c3bc21db9fc66909$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $c3bc21db9fc66909$var$detachDeletedInstance(instance);
}
var $c3bc21db9fc66909$var$preloadPropsMap = new Map(), $c3bc21db9fc66909$var$preconnectsSet = new Set();
function $c3bc21db9fc66909$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $c3bc21db9fc66909$var$previousDispatcher = $c3bc21db9fc66909$var$ReactDOMSharedInternals.d;
$c3bc21db9fc66909$var$ReactDOMSharedInternals.d = {
    f: $c3bc21db9fc66909$var$flushSyncWork,
    r: $c3bc21db9fc66909$var$requestFormReset,
    D: $c3bc21db9fc66909$var$prefetchDNS,
    C: $c3bc21db9fc66909$var$preconnect,
    L: $c3bc21db9fc66909$var$preload,
    m: $c3bc21db9fc66909$var$preloadModule,
    X: $c3bc21db9fc66909$var$preinitScript,
    S: $c3bc21db9fc66909$var$preinitStyle,
    M: $c3bc21db9fc66909$var$preinitModuleScript
};
function $c3bc21db9fc66909$var$flushSyncWork() {
    var previousWasRendering = $c3bc21db9fc66909$var$previousDispatcher.f(), wasRendering = $c3bc21db9fc66909$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $c3bc21db9fc66909$var$requestFormReset(form) {
    var formInst = $c3bc21db9fc66909$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $c3bc21db9fc66909$var$requestFormReset$1(formInst) : $c3bc21db9fc66909$var$previousDispatcher.r(form);
}
var $c3bc21db9fc66909$var$globalDocument = "undefined" === typeof document ? null : document;
function $c3bc21db9fc66909$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $c3bc21db9fc66909$var$preconnectsSet.has(limitedEscapedHref) || ($c3bc21db9fc66909$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $c3bc21db9fc66909$var$setInitialProperties(href, "link", rel), $c3bc21db9fc66909$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $c3bc21db9fc66909$var$prefetchDNS(href) {
    $c3bc21db9fc66909$var$previousDispatcher.D(href);
    $c3bc21db9fc66909$var$preconnectAs("dns-prefetch", href, null);
}
function $c3bc21db9fc66909$var$preconnect(href, crossOrigin) {
    $c3bc21db9fc66909$var$previousDispatcher.C(href, crossOrigin);
    $c3bc21db9fc66909$var$preconnectAs("preconnect", href, crossOrigin);
}
function $c3bc21db9fc66909$var$preload(href, as, options) {
    $c3bc21db9fc66909$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $c3bc21db9fc66909$var$getStyleKey(href);
                break;
            case "script":
                key = $c3bc21db9fc66909$var$getScriptKey(href);
        }
        $c3bc21db9fc66909$var$preloadPropsMap.has(key) || (href = $c3bc21db9fc66909$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $c3bc21db9fc66909$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $c3bc21db9fc66909$var$setInitialProperties(as, "link", href), $c3bc21db9fc66909$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $c3bc21db9fc66909$var$preloadModule(href, options) {
    $c3bc21db9fc66909$var$previousDispatcher.m(href, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $c3bc21db9fc66909$var$getScriptKey(href);
        }
        if (!$c3bc21db9fc66909$var$preloadPropsMap.has(key) && (href = $c3bc21db9fc66909$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $c3bc21db9fc66909$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $c3bc21db9fc66909$var$setInitialProperties(as, "link", href);
            $c3bc21db9fc66909$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $c3bc21db9fc66909$var$preinitStyle(href, precedence, options) {
    $c3bc21db9fc66909$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $c3bc21db9fc66909$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $c3bc21db9fc66909$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $c3bc21db9fc66909$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $c3bc21db9fc66909$var$markNodeAsHoistable(link);
                $c3bc21db9fc66909$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $c3bc21db9fc66909$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $c3bc21db9fc66909$var$preinitScript(src, options) {
    $c3bc21db9fc66909$var$previousDispatcher.X(src, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c3bc21db9fc66909$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c3bc21db9fc66909$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key)), resource || (src = $c3bc21db9fc66909$var$assign({
            src: src,
            async: !0
        }, options), (options = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c3bc21db9fc66909$var$markNodeAsHoistable(resource), $c3bc21db9fc66909$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c3bc21db9fc66909$var$preinitModuleScript(src, options) {
    $c3bc21db9fc66909$var$previousDispatcher.M(src, options);
    var ownerDocument = $c3bc21db9fc66909$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c3bc21db9fc66909$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c3bc21db9fc66909$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(key)), resource || (src = $c3bc21db9fc66909$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c3bc21db9fc66909$var$markNodeAsHoistable(resource), $c3bc21db9fc66909$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c3bc21db9fc66909$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $c3bc21db9fc66909$var$rootInstanceStackCursor.current) ? $c3bc21db9fc66909$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $c3bc21db9fc66909$var$getStyleKey(pendingProps.href), pendingProps = $c3bc21db9fc66909$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $c3bc21db9fc66909$var$getStyleKey(pendingProps.href);
                var styles$244 = $c3bc21db9fc66909$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $c3bc21db9fc66909$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $c3bc21db9fc66909$var$preloadPropsMap.set(type, pendingProps), styles$244 || $c3bc21db9fc66909$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $c3bc21db9fc66909$var$getScriptKey(pendingProps), pendingProps = $c3bc21db9fc66909$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(444, type));
    }
}
function $c3bc21db9fc66909$var$getStyleKey(href) {
    return 'href="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $c3bc21db9fc66909$var$stylesheetPropsFromRawProps(rawProps) {
    return $c3bc21db9fc66909$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $c3bc21db9fc66909$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $c3bc21db9fc66909$var$setInitialProperties(key, "link", preloadProps), $c3bc21db9fc66909$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $c3bc21db9fc66909$var$getScriptKey(src) {
    return '[src="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $c3bc21db9fc66909$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $c3bc21db9fc66909$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $c3bc21db9fc66909$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $c3bc21db9fc66909$var$markNodeAsHoistable(instance), instance;
            var styleProps = $c3bc21db9fc66909$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $c3bc21db9fc66909$var$markNodeAsHoistable(instance);
            $c3bc21db9fc66909$var$setInitialProperties(instance, "style", styleProps);
            $c3bc21db9fc66909$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $c3bc21db9fc66909$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $c3bc21db9fc66909$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $c3bc21db9fc66909$var$stylesheetPropsFromRawProps(props);
            (styleProps = $c3bc21db9fc66909$var$preloadPropsMap.get(styleProps)) && $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $c3bc21db9fc66909$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c3bc21db9fc66909$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $c3bc21db9fc66909$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $c3bc21db9fc66909$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($c3bc21db9fc66909$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $c3bc21db9fc66909$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $c3bc21db9fc66909$var$preloadPropsMap.get(instance$250)) instance = $c3bc21db9fc66909$var$assign({}, props), $c3bc21db9fc66909$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $c3bc21db9fc66909$var$markNodeAsHoistable(styleProps);
            $c3bc21db9fc66909$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $c3bc21db9fc66909$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $c3bc21db9fc66909$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $c3bc21db9fc66909$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $c3bc21db9fc66909$var$tagCaches = null;
function $c3bc21db9fc66909$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $c3bc21db9fc66909$var$tagCaches) {
        var cache = new Map();
        var caches = $c3bc21db9fc66909$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $c3bc21db9fc66909$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$c3bc21db9fc66909$var$internalHoistableMarker] || node[$c3bc21db9fc66909$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $c3bc21db9fc66909$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $c3bc21db9fc66909$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $c3bc21db9fc66909$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $c3bc21db9fc66909$var$suspendedState = null;
function $c3bc21db9fc66909$var$noop() {}
function $c3bc21db9fc66909$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $c3bc21db9fc66909$var$suspendedState) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(475));
    var state = $c3bc21db9fc66909$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $c3bc21db9fc66909$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($c3bc21db9fc66909$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $c3bc21db9fc66909$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $c3bc21db9fc66909$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $c3bc21db9fc66909$var$stylesheetPropsFromRawProps(props);
            (key = $c3bc21db9fc66909$var$preloadPropsMap.get(key)) && $c3bc21db9fc66909$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $c3bc21db9fc66909$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c3bc21db9fc66909$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $c3bc21db9fc66909$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $c3bc21db9fc66909$var$waitForCommitToBeReady() {
    if (null === $c3bc21db9fc66909$var$suspendedState) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(475));
    var state = $c3bc21db9fc66909$var$suspendedState;
    state.stylesheets && 0 === state.count && $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $c3bc21db9fc66909$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $c3bc21db9fc66909$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $c3bc21db9fc66909$var$precedencesByRoot = null;
function $c3bc21db9fc66909$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $c3bc21db9fc66909$var$precedencesByRoot = new Map(), resources.forEach($c3bc21db9fc66909$var$insertStylesheetIntoRoot, state), $c3bc21db9fc66909$var$precedencesByRoot = null, $c3bc21db9fc66909$var$onUnsuspend.call(state));
}
function $c3bc21db9fc66909$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $c3bc21db9fc66909$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $c3bc21db9fc66909$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $c3bc21db9fc66909$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $c3bc21db9fc66909$var$HostTransitionContext = {
    $$typeof: $c3bc21db9fc66909$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $c3bc21db9fc66909$var$sharedNotPendingObject,
    _currentValue2: $c3bc21db9fc66909$var$sharedNotPendingObject,
    _threadCount: 0
};
function $c3bc21db9fc66909$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $c3bc21db9fc66909$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c3bc21db9fc66909$var$createLaneMap(0);
    this.hiddenUpdates = $c3bc21db9fc66909$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $c3bc21db9fc66909$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $c3bc21db9fc66909$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $c3bc21db9fc66909$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $c3bc21db9fc66909$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $c3bc21db9fc66909$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $c3bc21db9fc66909$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $c3bc21db9fc66909$var$emptyContextObject;
    parentComponent = $c3bc21db9fc66909$var$emptyContextObject;
    return parentComponent;
}
function $c3bc21db9fc66909$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $c3bc21db9fc66909$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $c3bc21db9fc66909$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $c3bc21db9fc66909$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($c3bc21db9fc66909$var$scheduleUpdateOnFiber(element, rootFiber, lane), $c3bc21db9fc66909$var$entangleTransitions(element, rootFiber, lane));
}
function $c3bc21db9fc66909$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $c3bc21db9fc66909$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $c3bc21db9fc66909$var$markRetryLaneImpl(fiber, retryLane);
}
function $c3bc21db9fc66909$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $c3bc21db9fc66909$var$_enabled = !0;
function $c3bc21db9fc66909$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T;
    $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 2, $c3bc21db9fc66909$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c3bc21db9fc66909$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c3bc21db9fc66909$var$ReactSharedInternals.T;
    $c3bc21db9fc66909$var$ReactSharedInternals.T = null;
    var previousPriority = $c3bc21db9fc66909$var$ReactDOMSharedInternals.p;
    try {
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = 8, $c3bc21db9fc66909$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c3bc21db9fc66909$var$ReactDOMSharedInternals.p = previousPriority, $c3bc21db9fc66909$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c3bc21db9fc66909$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($c3bc21db9fc66909$var$_enabled) {
        var blockedOn = $c3bc21db9fc66909$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c3bc21db9fc66909$var$return_targetInst, targetContainer), $c3bc21db9fc66909$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($c3bc21db9fc66909$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($c3bc21db9fc66909$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $c3bc21db9fc66909$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $c3bc21db9fc66909$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $c3bc21db9fc66909$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $c3bc21db9fc66909$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $c3bc21db9fc66909$var$ensureRootIsScheduled(fiber);
                                0 === ($c3bc21db9fc66909$var$executionContext & 6) && ($c3bc21db9fc66909$var$workInProgressRootRenderTargetTime = $c3bc21db9fc66909$var$now() + 500, $c3bc21db9fc66909$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, fiber, 2), $c3bc21db9fc66909$var$flushSyncWork$1(), $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $c3bc21db9fc66909$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c3bc21db9fc66909$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $c3bc21db9fc66909$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $c3bc21db9fc66909$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $c3bc21db9fc66909$var$getEventTarget(nativeEvent);
    return $c3bc21db9fc66909$var$findInstanceBlockingTarget(nativeEvent);
}
var $c3bc21db9fc66909$var$return_targetInst = null;
function $c3bc21db9fc66909$var$findInstanceBlockingTarget(targetNode) {
    $c3bc21db9fc66909$var$return_targetInst = null;
    targetNode = $c3bc21db9fc66909$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $c3bc21db9fc66909$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $c3bc21db9fc66909$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $c3bc21db9fc66909$var$return_targetInst = targetNode;
    return null;
}
function $c3bc21db9fc66909$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($c3bc21db9fc66909$var$getCurrentPriorityLevel()){
                case $c3bc21db9fc66909$var$ImmediatePriority:
                    return 2;
                case $c3bc21db9fc66909$var$UserBlockingPriority:
                    return 8;
                case $c3bc21db9fc66909$var$NormalPriority$1:
                case $c3bc21db9fc66909$var$LowPriority:
                    return 32;
                case $c3bc21db9fc66909$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $c3bc21db9fc66909$var$hasScheduledReplayAttempt = !1, $c3bc21db9fc66909$var$queuedFocus = null, $c3bc21db9fc66909$var$queuedDrag = null, $c3bc21db9fc66909$var$queuedMouse = null, $c3bc21db9fc66909$var$queuedPointers = new Map(), $c3bc21db9fc66909$var$queuedPointerCaptures = new Map(), $c3bc21db9fc66909$var$queuedExplicitHydrationTargets = [], $c3bc21db9fc66909$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $c3bc21db9fc66909$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $c3bc21db9fc66909$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $c3bc21db9fc66909$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $c3bc21db9fc66909$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $c3bc21db9fc66909$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c3bc21db9fc66909$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $c3bc21db9fc66909$var$getInstanceFromNode(blockedOn), null !== blockedOn && $c3bc21db9fc66909$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $c3bc21db9fc66909$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $c3bc21db9fc66909$var$queuedFocus = $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $c3bc21db9fc66909$var$queuedDrag = $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $c3bc21db9fc66909$var$queuedMouse = $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $c3bc21db9fc66909$var$queuedPointers.set(pointerId, $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $c3bc21db9fc66909$var$queuedPointerCaptures.set(pointerId, $c3bc21db9fc66909$var$accumulateOrCreateContinuousQueuedReplayableEvent($c3bc21db9fc66909$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $c3bc21db9fc66909$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $c3bc21db9fc66909$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $c3bc21db9fc66909$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $c3bc21db9fc66909$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c3bc21db9fc66909$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $c3bc21db9fc66909$var$requestUpdateLane();
                            lane = $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $c3bc21db9fc66909$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $c3bc21db9fc66909$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $c3bc21db9fc66909$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $c3bc21db9fc66909$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $c3bc21db9fc66909$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $c3bc21db9fc66909$var$currentReplayingEvent = null;
        } else return targetContainers = $c3bc21db9fc66909$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $c3bc21db9fc66909$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $c3bc21db9fc66909$var$replayUnblockedEvents() {
    $c3bc21db9fc66909$var$hasScheduledReplayAttempt = !1;
    null !== $c3bc21db9fc66909$var$queuedFocus && $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent($c3bc21db9fc66909$var$queuedFocus) && ($c3bc21db9fc66909$var$queuedFocus = null);
    null !== $c3bc21db9fc66909$var$queuedDrag && $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent($c3bc21db9fc66909$var$queuedDrag) && ($c3bc21db9fc66909$var$queuedDrag = null);
    null !== $c3bc21db9fc66909$var$queuedMouse && $c3bc21db9fc66909$var$attemptReplayContinuousQueuedEvent($c3bc21db9fc66909$var$queuedMouse) && ($c3bc21db9fc66909$var$queuedMouse = null);
    $c3bc21db9fc66909$var$queuedPointers.forEach($c3bc21db9fc66909$var$attemptReplayContinuousQueuedEventInMap);
    $c3bc21db9fc66909$var$queuedPointerCaptures.forEach($c3bc21db9fc66909$var$attemptReplayContinuousQueuedEventInMap);
}
function $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $c3bc21db9fc66909$var$hasScheduledReplayAttempt || ($c3bc21db9fc66909$var$hasScheduledReplayAttempt = !0, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, $c3bc21db9fc66909$var$replayUnblockedEvents)));
}
var $c3bc21db9fc66909$var$lastScheduledReplayQueue = null;
function $c3bc21db9fc66909$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $c3bc21db9fc66909$var$lastScheduledReplayQueue !== formReplayingQueue && ($c3bc21db9fc66909$var$lastScheduledReplayQueue = formReplayingQueue, $clk2u.unstable_scheduleCallback($clk2u.unstable_NormalPriority, function() {
        $c3bc21db9fc66909$var$lastScheduledReplayQueue === formReplayingQueue && ($c3bc21db9fc66909$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $c3bc21db9fc66909$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $c3bc21db9fc66909$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $c3bc21db9fc66909$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $c3bc21db9fc66909$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $c3bc21db9fc66909$var$queuedFocus && $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked($c3bc21db9fc66909$var$queuedFocus, unblocked);
    null !== $c3bc21db9fc66909$var$queuedDrag && $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked($c3bc21db9fc66909$var$queuedDrag, unblocked);
    null !== $c3bc21db9fc66909$var$queuedMouse && $c3bc21db9fc66909$var$scheduleCallbackIfUnblocked($c3bc21db9fc66909$var$queuedMouse, unblocked);
    $c3bc21db9fc66909$var$queuedPointers.forEach(unblock);
    $c3bc21db9fc66909$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $c3bc21db9fc66909$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.length && (i = $c3bc21db9fc66909$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$c3bc21db9fc66909$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$c3bc21db9fc66909$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $c3bc21db9fc66909$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$c3bc21db9fc66909$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $c3bc21db9fc66909$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $c3bc21db9fc66909$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $c3bc21db9fc66909$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c3bc21db9fc66909$var$ReactDOMHydrationRoot.prototype.render = $c3bc21db9fc66909$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(409));
    var current = root.current, lane = $c3bc21db9fc66909$var$requestUpdateLane();
    $c3bc21db9fc66909$var$updateContainerImpl(current, lane, children, root, null, null);
};
$c3bc21db9fc66909$var$ReactDOMHydrationRoot.prototype.unmount = $c3bc21db9fc66909$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $c3bc21db9fc66909$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $c3bc21db9fc66909$var$flushSyncWork$1();
        container[$c3bc21db9fc66909$var$internalContainerInstanceKey] = null;
    }
};
function $c3bc21db9fc66909$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c3bc21db9fc66909$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $c3bc21db9fc66909$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $c3bc21db9fc66909$var$queuedExplicitHydrationTargets[i].priority; i++);
        $c3bc21db9fc66909$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $c3bc21db9fc66909$var$attemptExplicitHydrationTarget(target);
    }
};
var $c3bc21db9fc66909$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $8NFma.version;
if ("19.1.5" !== $c3bc21db9fc66909$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(527, $c3bc21db9fc66909$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.5"));
$c3bc21db9fc66909$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $c3bc21db9fc66909$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $c3bc21db9fc66909$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $c3bc21db9fc66909$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.5",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $c3bc21db9fc66909$var$ReactSharedInternals,
    reconcilerVersion: "19.1.5"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c3bc21db9fc66909$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c3bc21db9fc66909$var$hook$jscomp$inline_2257.isDisabled && $c3bc21db9fc66909$var$hook$jscomp$inline_2257.supportsFiber) try {
        $c3bc21db9fc66909$var$rendererID = $c3bc21db9fc66909$var$hook$jscomp$inline_2257.inject($c3bc21db9fc66909$var$internals$jscomp$inline_2256), $c3bc21db9fc66909$var$injectedHook = $c3bc21db9fc66909$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$c3bc21db9fc66909$export$882461b6382ed46c = function(container, options) {
    if (!$c3bc21db9fc66909$var$isValidContainer(container)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c3bc21db9fc66909$var$defaultOnUncaughtError, onCaughtError = $c3bc21db9fc66909$var$defaultOnCaughtError, onRecoverableError = $c3bc21db9fc66909$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $c3bc21db9fc66909$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$c3bc21db9fc66909$var$internalContainerInstanceKey] = options.current;
    $c3bc21db9fc66909$var$listenToAllSupportedEvents(container);
    return new $c3bc21db9fc66909$var$ReactDOMRoot(options);
};
$c3bc21db9fc66909$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$c3bc21db9fc66909$var$isValidContainer(container)) throw Error($c3bc21db9fc66909$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c3bc21db9fc66909$var$defaultOnUncaughtError, onCaughtError = $c3bc21db9fc66909$var$defaultOnCaughtError, onRecoverableError = $c3bc21db9fc66909$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $c3bc21db9fc66909$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $c3bc21db9fc66909$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $c3bc21db9fc66909$var$requestUpdateLane();
    isStrictMode = $c3bc21db9fc66909$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $c3bc21db9fc66909$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $c3bc21db9fc66909$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $c3bc21db9fc66909$var$markRootUpdated$1(initialChildren, options);
    $c3bc21db9fc66909$var$ensureRootIsScheduled(initialChildren);
    container[$c3bc21db9fc66909$var$internalContainerInstanceKey] = initialChildren.current;
    $c3bc21db9fc66909$var$listenToAllSupportedEvents(container);
    return new $c3bc21db9fc66909$var$ReactDOMHydrationRoot(initialChildren);
};
$c3bc21db9fc66909$export$83d89fbfd8236492 = "19.1.5";

});
parcelRegister("clk2u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("epnUP"));

});
parcelRegister("epnUP", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $a7d5f39a74a2399f$export$c4744153514ff05d, (v) => $a7d5f39a74a2399f$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a7d5f39a74a2399f$export$3e506c1ccc9cc1a7, (v) => $a7d5f39a74a2399f$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a7d5f39a74a2399f$export$e26fe2ed2fa76875, (v) => $a7d5f39a74a2399f$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a7d5f39a74a2399f$export$502329bbf4b505b1, (v) => $a7d5f39a74a2399f$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a7d5f39a74a2399f$export$6e3807111c4874c4, (v) => $a7d5f39a74a2399f$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a7d5f39a74a2399f$export$c27134553091fb3a, (v) => $a7d5f39a74a2399f$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a7d5f39a74a2399f$export$33ee1acdc04fd2a2, (v) => $a7d5f39a74a2399f$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a7d5f39a74a2399f$export$b00a404bbd5edef2, (v) => $a7d5f39a74a2399f$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a7d5f39a74a2399f$export$d66a1c1c77bd778b, (v) => $a7d5f39a74a2399f$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a7d5f39a74a2399f$export$d3dfb8e4810cb555, (v) => $a7d5f39a74a2399f$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $a7d5f39a74a2399f$export$72fdf0e06517287b, (v) => $a7d5f39a74a2399f$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a7d5f39a74a2399f$export$816d2913ae6b83b1, (v) => $a7d5f39a74a2399f$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a7d5f39a74a2399f$export$61bcfe829111a1d0, (v) => $a7d5f39a74a2399f$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a7d5f39a74a2399f$export$7ee8c9beb337bc3f, (v) => $a7d5f39a74a2399f$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a7d5f39a74a2399f$export$b5836b71941fa3ed, (v) => $a7d5f39a74a2399f$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a7d5f39a74a2399f$export$cf845f2c119da08a, (v) => $a7d5f39a74a2399f$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a7d5f39a74a2399f$export$c4744153514ff05d;
var $a7d5f39a74a2399f$export$3e506c1ccc9cc1a7;
var $a7d5f39a74a2399f$export$e26fe2ed2fa76875;
var $a7d5f39a74a2399f$export$502329bbf4b505b1;
var $a7d5f39a74a2399f$export$6e3807111c4874c4;
var $a7d5f39a74a2399f$export$c27134553091fb3a;
var $a7d5f39a74a2399f$export$33ee1acdc04fd2a2;
var $a7d5f39a74a2399f$export$b00a404bbd5edef2;
var $a7d5f39a74a2399f$export$d66a1c1c77bd778b;
var $a7d5f39a74a2399f$export$d3dfb8e4810cb555;
var $a7d5f39a74a2399f$export$72fdf0e06517287b;
var $a7d5f39a74a2399f$export$816d2913ae6b83b1;
var $a7d5f39a74a2399f$export$61bcfe829111a1d0;
var $a7d5f39a74a2399f$export$7ee8c9beb337bc3f;
var $a7d5f39a74a2399f$export$b5836b71941fa3ed;
var $a7d5f39a74a2399f$export$cf845f2c119da08a;
"use strict";
function $a7d5f39a74a2399f$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $a7d5f39a74a2399f$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $a7d5f39a74a2399f$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $a7d5f39a74a2399f$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $a7d5f39a74a2399f$var$compare(left, last)) rightIndex < length && 0 > $a7d5f39a74a2399f$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $a7d5f39a74a2399f$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $a7d5f39a74a2399f$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$a7d5f39a74a2399f$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a7d5f39a74a2399f$var$localPerformance = performance;
    $a7d5f39a74a2399f$export$c4744153514ff05d = function() {
        return $a7d5f39a74a2399f$var$localPerformance.now();
    };
} else {
    var $a7d5f39a74a2399f$var$localDate = Date, $a7d5f39a74a2399f$var$initialTime = $a7d5f39a74a2399f$var$localDate.now();
    $a7d5f39a74a2399f$export$c4744153514ff05d = function() {
        return $a7d5f39a74a2399f$var$localDate.now() - $a7d5f39a74a2399f$var$initialTime;
    };
}
var $a7d5f39a74a2399f$var$taskQueue = [], $a7d5f39a74a2399f$var$timerQueue = [], $a7d5f39a74a2399f$var$taskIdCounter = 1, $a7d5f39a74a2399f$var$currentTask = null, $a7d5f39a74a2399f$var$currentPriorityLevel = 3, $a7d5f39a74a2399f$var$isPerformingWork = !1, $a7d5f39a74a2399f$var$isHostCallbackScheduled = !1, $a7d5f39a74a2399f$var$isHostTimeoutScheduled = !1, $a7d5f39a74a2399f$var$needsPaint = !1, $a7d5f39a74a2399f$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $a7d5f39a74a2399f$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $a7d5f39a74a2399f$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $a7d5f39a74a2399f$var$advanceTimers(currentTime) {
    for(var timer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue); null !== timer;){
        if (null === timer.callback) $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$timerQueue);
        else if (timer.startTime <= currentTime) $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$timerQueue), timer.sortIndex = timer.expirationTime, $a7d5f39a74a2399f$var$push($a7d5f39a74a2399f$var$taskQueue, timer);
        else break;
        timer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue);
    }
}
function $a7d5f39a74a2399f$var$handleTimeout(currentTime) {
    $a7d5f39a74a2399f$var$isHostTimeoutScheduled = !1;
    $a7d5f39a74a2399f$var$advanceTimers(currentTime);
    if (!$a7d5f39a74a2399f$var$isHostCallbackScheduled) {
        if (null !== $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue)) $a7d5f39a74a2399f$var$isHostCallbackScheduled = !0, $a7d5f39a74a2399f$var$isMessageLoopRunning || ($a7d5f39a74a2399f$var$isMessageLoopRunning = !0, $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue);
            null !== firstTimer && $a7d5f39a74a2399f$var$requestHostTimeout($a7d5f39a74a2399f$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $a7d5f39a74a2399f$var$isMessageLoopRunning = !1, $a7d5f39a74a2399f$var$taskTimeoutID = -1, $a7d5f39a74a2399f$var$frameInterval = 5, $a7d5f39a74a2399f$var$startTime = -1;
function $a7d5f39a74a2399f$var$shouldYieldToHost() {
    return $a7d5f39a74a2399f$var$needsPaint ? !0 : $a7d5f39a74a2399f$export$c4744153514ff05d() - $a7d5f39a74a2399f$var$startTime < $a7d5f39a74a2399f$var$frameInterval ? !1 : !0;
}
function $a7d5f39a74a2399f$var$performWorkUntilDeadline() {
    $a7d5f39a74a2399f$var$needsPaint = !1;
    if ($a7d5f39a74a2399f$var$isMessageLoopRunning) {
        var currentTime = $a7d5f39a74a2399f$export$c4744153514ff05d();
        $a7d5f39a74a2399f$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $a7d5f39a74a2399f$var$isHostCallbackScheduled = !1;
                $a7d5f39a74a2399f$var$isHostTimeoutScheduled && ($a7d5f39a74a2399f$var$isHostTimeoutScheduled = !1, $a7d5f39a74a2399f$var$localClearTimeout($a7d5f39a74a2399f$var$taskTimeoutID), $a7d5f39a74a2399f$var$taskTimeoutID = -1);
                $a7d5f39a74a2399f$var$isPerformingWork = !0;
                var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
                try {
                    b: {
                        $a7d5f39a74a2399f$var$advanceTimers(currentTime);
                        for($a7d5f39a74a2399f$var$currentTask = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue); null !== $a7d5f39a74a2399f$var$currentTask && !($a7d5f39a74a2399f$var$currentTask.expirationTime > currentTime && $a7d5f39a74a2399f$var$shouldYieldToHost());){
                            var callback = $a7d5f39a74a2399f$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $a7d5f39a74a2399f$var$currentTask.callback = null;
                                $a7d5f39a74a2399f$var$currentPriorityLevel = $a7d5f39a74a2399f$var$currentTask.priorityLevel;
                                var continuationCallback = callback($a7d5f39a74a2399f$var$currentTask.expirationTime <= currentTime);
                                currentTime = $a7d5f39a74a2399f$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $a7d5f39a74a2399f$var$currentTask.callback = continuationCallback;
                                    $a7d5f39a74a2399f$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $a7d5f39a74a2399f$var$currentTask === $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue) && $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$taskQueue);
                                $a7d5f39a74a2399f$var$advanceTimers(currentTime);
                            } else $a7d5f39a74a2399f$var$pop($a7d5f39a74a2399f$var$taskQueue);
                            $a7d5f39a74a2399f$var$currentTask = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue);
                        }
                        if (null !== $a7d5f39a74a2399f$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue);
                            null !== firstTimer && $a7d5f39a74a2399f$var$requestHostTimeout($a7d5f39a74a2399f$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $a7d5f39a74a2399f$var$currentTask = null, $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel, $a7d5f39a74a2399f$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline() : $a7d5f39a74a2399f$var$isMessageLoopRunning = !1;
        }
    }
}
var $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $a7d5f39a74a2399f$var$localSetImmediate) $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline = function() {
    $a7d5f39a74a2399f$var$localSetImmediate($a7d5f39a74a2399f$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a7d5f39a74a2399f$var$channel = new MessageChannel(), $a7d5f39a74a2399f$var$port = $a7d5f39a74a2399f$var$channel.port2;
    $a7d5f39a74a2399f$var$channel.port1.onmessage = $a7d5f39a74a2399f$var$performWorkUntilDeadline;
    $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline = function() {
        $a7d5f39a74a2399f$var$port.postMessage(null);
    };
} else $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline = function() {
    $a7d5f39a74a2399f$var$localSetTimeout($a7d5f39a74a2399f$var$performWorkUntilDeadline, 0);
};
function $a7d5f39a74a2399f$var$requestHostTimeout(callback, ms) {
    $a7d5f39a74a2399f$var$taskTimeoutID = $a7d5f39a74a2399f$var$localSetTimeout(function() {
        callback($a7d5f39a74a2399f$export$c4744153514ff05d());
    }, ms);
}
$a7d5f39a74a2399f$export$3e506c1ccc9cc1a7 = 5;
$a7d5f39a74a2399f$export$e26fe2ed2fa76875 = 1;
$a7d5f39a74a2399f$export$502329bbf4b505b1 = 4;
$a7d5f39a74a2399f$export$6e3807111c4874c4 = 3;
$a7d5f39a74a2399f$export$c27134553091fb3a = null;
$a7d5f39a74a2399f$export$33ee1acdc04fd2a2 = 2;
$a7d5f39a74a2399f$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$a7d5f39a74a2399f$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a7d5f39a74a2399f$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$a7d5f39a74a2399f$export$d3dfb8e4810cb555 = function() {
    return $a7d5f39a74a2399f$var$currentPriorityLevel;
};
$a7d5f39a74a2399f$export$72fdf0e06517287b = function(eventHandler) {
    switch($a7d5f39a74a2399f$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    $a7d5f39a74a2399f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$a7d5f39a74a2399f$export$816d2913ae6b83b1 = function() {
    $a7d5f39a74a2399f$var$needsPaint = !0;
};
$a7d5f39a74a2399f$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    $a7d5f39a74a2399f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$a7d5f39a74a2399f$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $a7d5f39a74a2399f$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $a7d5f39a74a2399f$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $a7d5f39a74a2399f$var$push($a7d5f39a74a2399f$var$timerQueue, priorityLevel), null === $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$taskQueue) && priorityLevel === $a7d5f39a74a2399f$var$peek($a7d5f39a74a2399f$var$timerQueue) && ($a7d5f39a74a2399f$var$isHostTimeoutScheduled ? ($a7d5f39a74a2399f$var$localClearTimeout($a7d5f39a74a2399f$var$taskTimeoutID), $a7d5f39a74a2399f$var$taskTimeoutID = -1) : $a7d5f39a74a2399f$var$isHostTimeoutScheduled = !0, $a7d5f39a74a2399f$var$requestHostTimeout($a7d5f39a74a2399f$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $a7d5f39a74a2399f$var$push($a7d5f39a74a2399f$var$taskQueue, priorityLevel), $a7d5f39a74a2399f$var$isHostCallbackScheduled || $a7d5f39a74a2399f$var$isPerformingWork || ($a7d5f39a74a2399f$var$isHostCallbackScheduled = !0, $a7d5f39a74a2399f$var$isMessageLoopRunning || ($a7d5f39a74a2399f$var$isMessageLoopRunning = !0, $a7d5f39a74a2399f$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$a7d5f39a74a2399f$export$b5836b71941fa3ed = $a7d5f39a74a2399f$var$shouldYieldToHost;
$a7d5f39a74a2399f$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $a7d5f39a74a2399f$var$currentPriorityLevel;
        $a7d5f39a74a2399f$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $a7d5f39a74a2399f$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("8NFma", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jMs9J"));

});
parcelRegister("jMs9J", function(module, exports) {

$parcel$export(module.exports, "Children", () => $e668572f1c95467d$export$dca3b0875bd9a954, (v) => $e668572f1c95467d$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $e668572f1c95467d$export$16fa2f45be04daa8, (v) => $e668572f1c95467d$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $e668572f1c95467d$export$ffb0004e005737fa, (v) => $e668572f1c95467d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $e668572f1c95467d$export$e2c29f18771995cb, (v) => $e668572f1c95467d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $e668572f1c95467d$export$221d75b3f55bb0bd, (v) => $e668572f1c95467d$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $e668572f1c95467d$export$5f8d39834fd61797, (v) => $e668572f1c95467d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $e668572f1c95467d$export$74bf444e3cd11ea5, (v) => $e668572f1c95467d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $e668572f1c95467d$export$1ced07cd6b1985ce, (v) => $e668572f1c95467d$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $e668572f1c95467d$export$abd8e32b826d7ea7, (v) => $e668572f1c95467d$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $e668572f1c95467d$export$69a3209f1a06c04d, (v) => $e668572f1c95467d$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $e668572f1c95467d$export$e530037191fcd5d7, (v) => $e668572f1c95467d$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $e668572f1c95467d$export$fd42f52fd3ae1109, (v) => $e668572f1c95467d$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $e668572f1c95467d$export$c8a8987d4410bf2d, (v) => $e668572f1c95467d$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $e668572f1c95467d$export$7d1e3a5e95ceca43, (v) => $e668572f1c95467d$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $e668572f1c95467d$export$257a8862b851cb5b, (v) => $e668572f1c95467d$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $e668572f1c95467d$export$a8257692ac88316c, (v) => $e668572f1c95467d$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $e668572f1c95467d$export$488013bae63b21da, (v) => $e668572f1c95467d$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $e668572f1c95467d$export$7c73462e0d25e514, (v) => $e668572f1c95467d$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $e668572f1c95467d$export$7568632d0d33d16d, (v) => $e668572f1c95467d$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $e668572f1c95467d$export$f93f40ac0ca7e3a8, (v) => $e668572f1c95467d$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $e668572f1c95467d$export$1f96ae73734a86cc, (v) => $e668572f1c95467d$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $e668572f1c95467d$export$9a47ced3238df325, (v) => $e668572f1c95467d$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $e668572f1c95467d$export$35808ee640e87ca7, (v) => $e668572f1c95467d$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $e668572f1c95467d$export$fae74005e78b1a27, (v) => $e668572f1c95467d$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $e668572f1c95467d$export$dc8fbce3eb94dc1e, (v) => $e668572f1c95467d$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $e668572f1c95467d$export$6a7bc4e911dc01cf, (v) => $e668572f1c95467d$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $e668572f1c95467d$export$6d9c69b0de29b591, (v) => $e668572f1c95467d$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $e668572f1c95467d$export$f680877a34711e37, (v) => $e668572f1c95467d$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $e668572f1c95467d$export$d5a552a76deda3c2, (v) => $e668572f1c95467d$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $e668572f1c95467d$export$aaabe4eda9ed9969, (v) => $e668572f1c95467d$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $e668572f1c95467d$export$e5c5a5f917a5871c, (v) => $e668572f1c95467d$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $e668572f1c95467d$export$1538c33de8887b59, (v) => $e668572f1c95467d$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $e668572f1c95467d$export$fca7f784ae7a249a, (v) => $e668572f1c95467d$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $e668572f1c95467d$export$13e3392192263954, (v) => $e668572f1c95467d$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $e668572f1c95467d$export$b8f5890fc79d6aca, (v) => $e668572f1c95467d$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $e668572f1c95467d$export$60241385465d0a34, (v) => $e668572f1c95467d$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $e668572f1c95467d$export$306c0aa65ff9ec16, (v) => $e668572f1c95467d$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $e668572f1c95467d$export$7b286972b8d8ccbf, (v) => $e668572f1c95467d$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $e668572f1c95467d$export$83d89fbfd8236492, (v) => $e668572f1c95467d$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e668572f1c95467d$export$dca3b0875bd9a954;
var $e668572f1c95467d$export$16fa2f45be04daa8;
var $e668572f1c95467d$export$ffb0004e005737fa;
var $e668572f1c95467d$export$e2c29f18771995cb;
var $e668572f1c95467d$export$221d75b3f55bb0bd;
var $e668572f1c95467d$export$5f8d39834fd61797;
var $e668572f1c95467d$export$74bf444e3cd11ea5;
var $e668572f1c95467d$export$1ced07cd6b1985ce;
var $e668572f1c95467d$export$abd8e32b826d7ea7;
var $e668572f1c95467d$export$69a3209f1a06c04d;
var $e668572f1c95467d$export$e530037191fcd5d7;
var $e668572f1c95467d$export$fd42f52fd3ae1109;
var $e668572f1c95467d$export$c8a8987d4410bf2d;
var $e668572f1c95467d$export$7d1e3a5e95ceca43;
var $e668572f1c95467d$export$257a8862b851cb5b;
var $e668572f1c95467d$export$a8257692ac88316c;
var $e668572f1c95467d$export$488013bae63b21da;
var $e668572f1c95467d$export$7c73462e0d25e514;
var $e668572f1c95467d$export$7568632d0d33d16d;
var $e668572f1c95467d$export$f93f40ac0ca7e3a8;
var $e668572f1c95467d$export$1f96ae73734a86cc;
var $e668572f1c95467d$export$9a47ced3238df325;
var $e668572f1c95467d$export$35808ee640e87ca7;
var $e668572f1c95467d$export$fae74005e78b1a27;
var $e668572f1c95467d$export$dc8fbce3eb94dc1e;
var $e668572f1c95467d$export$6a7bc4e911dc01cf;
var $e668572f1c95467d$export$6d9c69b0de29b591;
var $e668572f1c95467d$export$f680877a34711e37;
var $e668572f1c95467d$export$d5a552a76deda3c2;
var $e668572f1c95467d$export$aaabe4eda9ed9969;
var $e668572f1c95467d$export$e5c5a5f917a5871c;
var $e668572f1c95467d$export$1538c33de8887b59;
var $e668572f1c95467d$export$fca7f784ae7a249a;
var $e668572f1c95467d$export$13e3392192263954;
var $e668572f1c95467d$export$b8f5890fc79d6aca;
var $e668572f1c95467d$export$60241385465d0a34;
var $e668572f1c95467d$export$306c0aa65ff9ec16;
var $e668572f1c95467d$export$7b286972b8d8ccbf;
var $e668572f1c95467d$export$83d89fbfd8236492;
"use strict";
var $e668572f1c95467d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e668572f1c95467d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $e668572f1c95467d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $e668572f1c95467d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $e668572f1c95467d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $e668572f1c95467d$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $e668572f1c95467d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $e668572f1c95467d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $e668572f1c95467d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $e668572f1c95467d$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $e668572f1c95467d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $e668572f1c95467d$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $e668572f1c95467d$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $e668572f1c95467d$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$e668572f1c95467d$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $e668572f1c95467d$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e668572f1c95467d$var$assign = Object.assign, $e668572f1c95467d$var$emptyObject = {};
function $e668572f1c95467d$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $e668572f1c95467d$var$emptyObject;
    this.updater = updater || $e668572f1c95467d$var$ReactNoopUpdateQueue;
}
$e668572f1c95467d$var$Component.prototype.isReactComponent = {};
$e668572f1c95467d$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$e668572f1c95467d$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $e668572f1c95467d$var$ComponentDummy() {}
$e668572f1c95467d$var$ComponentDummy.prototype = $e668572f1c95467d$var$Component.prototype;
function $e668572f1c95467d$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $e668572f1c95467d$var$emptyObject;
    this.updater = updater || $e668572f1c95467d$var$ReactNoopUpdateQueue;
}
var $e668572f1c95467d$var$pureComponentPrototype = $e668572f1c95467d$var$PureComponent.prototype = new $e668572f1c95467d$var$ComponentDummy();
$e668572f1c95467d$var$pureComponentPrototype.constructor = $e668572f1c95467d$var$PureComponent;
$e668572f1c95467d$var$assign($e668572f1c95467d$var$pureComponentPrototype, $e668572f1c95467d$var$Component.prototype);
$e668572f1c95467d$var$pureComponentPrototype.isPureReactComponent = !0;
var $e668572f1c95467d$var$isArrayImpl = Array.isArray, $e668572f1c95467d$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $e668572f1c95467d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $e668572f1c95467d$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $e668572f1c95467d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $e668572f1c95467d$var$cloneAndReplaceKey(oldElement, newKey) {
    return $e668572f1c95467d$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $e668572f1c95467d$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $e668572f1c95467d$var$REACT_ELEMENT_TYPE;
}
function $e668572f1c95467d$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $e668572f1c95467d$var$userProvidedKeyEscapeRegex = /\/+/g;
function $e668572f1c95467d$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $e668572f1c95467d$var$escape("" + element.key) : index.toString(36);
}
function $e668572f1c95467d$var$noop$1() {}
function $e668572f1c95467d$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($e668572f1c95467d$var$noop$1, $e668572f1c95467d$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $e668572f1c95467d$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $e668572f1c95467d$var$REACT_ELEMENT_TYPE:
                case $e668572f1c95467d$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $e668572f1c95467d$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $e668572f1c95467d$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $e668572f1c95467d$var$getElementKey(children, 0) : nameSoFar, $e668572f1c95467d$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($e668572f1c95467d$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $e668572f1c95467d$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($e668572f1c95467d$var$isValidElement(callback) && (callback = $e668572f1c95467d$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($e668572f1c95467d$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($e668572f1c95467d$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $e668572f1c95467d$var$getElementKey(nameSoFar, i), invokeCallback += $e668572f1c95467d$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $e668572f1c95467d$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $e668572f1c95467d$var$getElementKey(nameSoFar, i++), invokeCallback += $e668572f1c95467d$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $e668572f1c95467d$var$mapIntoArray($e668572f1c95467d$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $e668572f1c95467d$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $e668572f1c95467d$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $e668572f1c95467d$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $e668572f1c95467d$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $e668572f1c95467d$var$noop() {}
$e668572f1c95467d$export$dca3b0875bd9a954 = {
    map: $e668572f1c95467d$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $e668572f1c95467d$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $e668572f1c95467d$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $e668572f1c95467d$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$e668572f1c95467d$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$e668572f1c95467d$export$16fa2f45be04daa8 = $e668572f1c95467d$var$Component;
$e668572f1c95467d$export$ffb0004e005737fa = $e668572f1c95467d$var$REACT_FRAGMENT_TYPE;
$e668572f1c95467d$export$e2c29f18771995cb = $e668572f1c95467d$var$REACT_PROFILER_TYPE;
$e668572f1c95467d$export$221d75b3f55bb0bd = $e668572f1c95467d$var$PureComponent;
$e668572f1c95467d$export$5f8d39834fd61797 = $e668572f1c95467d$var$REACT_STRICT_MODE_TYPE;
$e668572f1c95467d$export$74bf444e3cd11ea5 = $e668572f1c95467d$var$REACT_SUSPENSE_TYPE;
$e668572f1c95467d$export$1ced07cd6b1985ce = $e668572f1c95467d$var$ReactSharedInternals;
$e668572f1c95467d$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $e668572f1c95467d$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$e668572f1c95467d$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$e668572f1c95467d$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $e668572f1c95467d$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$e668572f1c95467d$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $e668572f1c95467d$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$e668572f1c95467d$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $e668572f1c95467d$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $e668572f1c95467d$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$e668572f1c95467d$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$e668572f1c95467d$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $e668572f1c95467d$var$ReactElement(type, key, void 0, void 0, null, props);
};
$e668572f1c95467d$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e668572f1c95467d$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $e668572f1c95467d$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$e668572f1c95467d$export$a8257692ac88316c = $e668572f1c95467d$var$isValidElement;
$e668572f1c95467d$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $e668572f1c95467d$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $e668572f1c95467d$var$lazyInitializer
    };
};
$e668572f1c95467d$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $e668572f1c95467d$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$e668572f1c95467d$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $e668572f1c95467d$var$ReactSharedInternals.T, currentTransition = {};
    $e668572f1c95467d$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $e668572f1c95467d$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($e668572f1c95467d$var$noop, $e668572f1c95467d$var$reportGlobalError);
    } catch (error) {
        $e668572f1c95467d$var$reportGlobalError(error);
    } finally{
        $e668572f1c95467d$var$ReactSharedInternals.T = prevTransition;
    }
};
$e668572f1c95467d$export$f93f40ac0ca7e3a8 = function() {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useCacheRefresh();
};
$e668572f1c95467d$export$1f96ae73734a86cc = function(usable) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.use(usable);
};
$e668572f1c95467d$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$e668572f1c95467d$export$35808ee640e87ca7 = function(callback, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$e668572f1c95467d$export$fae74005e78b1a27 = function(Context) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useContext(Context);
};
$e668572f1c95467d$export$dc8fbce3eb94dc1e = function() {};
$e668572f1c95467d$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$e668572f1c95467d$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $e668572f1c95467d$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$e668572f1c95467d$export$f680877a34711e37 = function() {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useId();
};
$e668572f1c95467d$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$e668572f1c95467d$export$aaabe4eda9ed9969 = function(create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$e668572f1c95467d$export$e5c5a5f917a5871c = function(create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$e668572f1c95467d$export$1538c33de8887b59 = function(create, deps) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useMemo(create, deps);
};
$e668572f1c95467d$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$e668572f1c95467d$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$e668572f1c95467d$export$b8f5890fc79d6aca = function(initialValue) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useRef(initialValue);
};
$e668572f1c95467d$export$60241385465d0a34 = function(initialState) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useState(initialState);
};
$e668572f1c95467d$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$e668572f1c95467d$export$7b286972b8d8ccbf = function() {
    return $e668572f1c95467d$var$ReactSharedInternals.H.useTransition();
};
$e668572f1c95467d$export$83d89fbfd8236492 = "19.1.5";

});


parcelRegister("2pmb0", function(module, exports) {
'use strict';
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1c0f1e610963dfb8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1c0f1e610963dfb8$var$checkDCE();

module.exports = (parcelRequire("jRYbO"));

});
parcelRegister("jRYbO", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $e771a7f3a12c9e1c$export$69ce8ef3fe5cead0, (v) => $e771a7f3a12c9e1c$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $e771a7f3a12c9e1c$export$d39a5bbd09211389, (v) => $e771a7f3a12c9e1c$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $e771a7f3a12c9e1c$export$cd75ccfd720a3cd4, (v) => $e771a7f3a12c9e1c$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $e771a7f3a12c9e1c$export$a0816fa17a9e79be, (v) => $e771a7f3a12c9e1c$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $e771a7f3a12c9e1c$export$7292efcadded39f3, (v) => $e771a7f3a12c9e1c$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $e771a7f3a12c9e1c$export$da407abadb9b8f86, (v) => $e771a7f3a12c9e1c$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $e771a7f3a12c9e1c$export$314cfea32580671c, (v) => $e771a7f3a12c9e1c$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $e771a7f3a12c9e1c$export$513ccb98c53b8039, (v) => $e771a7f3a12c9e1c$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $e771a7f3a12c9e1c$export$dbca993bc2d264a, (v) => $e771a7f3a12c9e1c$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $e771a7f3a12c9e1c$export$4797a8006f0655d0, (v) => $e771a7f3a12c9e1c$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $e771a7f3a12c9e1c$export$c78a37762a8d58e1, (v) => $e771a7f3a12c9e1c$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $e771a7f3a12c9e1c$export$606f11b2eb45ecc6, (v) => $e771a7f3a12c9e1c$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $e771a7f3a12c9e1c$export$f7e8a0bf92324b1e, (v) => $e771a7f3a12c9e1c$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $e771a7f3a12c9e1c$export$83d89fbfd8236492, (v) => $e771a7f3a12c9e1c$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e771a7f3a12c9e1c$export$69ce8ef3fe5cead0;
var $e771a7f3a12c9e1c$export$d39a5bbd09211389;
var $e771a7f3a12c9e1c$export$cd75ccfd720a3cd4;
var $e771a7f3a12c9e1c$export$a0816fa17a9e79be;
var $e771a7f3a12c9e1c$export$7292efcadded39f3;
var $e771a7f3a12c9e1c$export$da407abadb9b8f86;
var $e771a7f3a12c9e1c$export$314cfea32580671c;
var $e771a7f3a12c9e1c$export$513ccb98c53b8039;
var $e771a7f3a12c9e1c$export$dbca993bc2d264a;
var $e771a7f3a12c9e1c$export$4797a8006f0655d0;
var $e771a7f3a12c9e1c$export$c78a37762a8d58e1;
var $e771a7f3a12c9e1c$export$606f11b2eb45ecc6;
var $e771a7f3a12c9e1c$export$f7e8a0bf92324b1e;
var $e771a7f3a12c9e1c$export$83d89fbfd8236492;
"use strict";

var $8NFma = parcelRequire("8NFma");
function $e771a7f3a12c9e1c$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $e771a7f3a12c9e1c$var$noop() {}
var $e771a7f3a12c9e1c$var$Internals = {
    d: {
        f: $e771a7f3a12c9e1c$var$noop,
        r: function() {
            throw Error($e771a7f3a12c9e1c$var$formatProdErrorMessage(522));
        },
        D: $e771a7f3a12c9e1c$var$noop,
        C: $e771a7f3a12c9e1c$var$noop,
        L: $e771a7f3a12c9e1c$var$noop,
        m: $e771a7f3a12c9e1c$var$noop,
        X: $e771a7f3a12c9e1c$var$noop,
        S: $e771a7f3a12c9e1c$var$noop,
        M: $e771a7f3a12c9e1c$var$noop
    },
    p: 0,
    findDOMNode: null
}, $e771a7f3a12c9e1c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $e771a7f3a12c9e1c$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e771a7f3a12c9e1c$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $e771a7f3a12c9e1c$var$ReactSharedInternals = $8NFma.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $e771a7f3a12c9e1c$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$e771a7f3a12c9e1c$export$69ce8ef3fe5cead0 = $e771a7f3a12c9e1c$var$Internals;
$e771a7f3a12c9e1c$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($e771a7f3a12c9e1c$var$formatProdErrorMessage(299));
    return $e771a7f3a12c9e1c$var$createPortal$1(children, container, null, key);
};
$e771a7f3a12c9e1c$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $e771a7f3a12c9e1c$var$ReactSharedInternals.T, previousUpdatePriority = $e771a7f3a12c9e1c$var$Internals.p;
    try {
        if ($e771a7f3a12c9e1c$var$ReactSharedInternals.T = null, $e771a7f3a12c9e1c$var$Internals.p = 2, fn) return fn();
    } finally{
        $e771a7f3a12c9e1c$var$ReactSharedInternals.T = previousTransition, $e771a7f3a12c9e1c$var$Internals.p = previousUpdatePriority, $e771a7f3a12c9e1c$var$Internals.d.f();
    }
};
$e771a7f3a12c9e1c$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $e771a7f3a12c9e1c$var$Internals.d.C(href, options));
};
$e771a7f3a12c9e1c$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $e771a7f3a12c9e1c$var$Internals.d.D(href);
};
$e771a7f3a12c9e1c$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $e771a7f3a12c9e1c$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $e771a7f3a12c9e1c$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$e771a7f3a12c9e1c$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $e771a7f3a12c9e1c$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $e771a7f3a12c9e1c$var$Internals.d.M(href);
    }
};
$e771a7f3a12c9e1c$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(as, options.crossOrigin);
        $e771a7f3a12c9e1c$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$e771a7f3a12c9e1c$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $e771a7f3a12c9e1c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $e771a7f3a12c9e1c$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $e771a7f3a12c9e1c$var$Internals.d.m(href);
    }
};
$e771a7f3a12c9e1c$export$4797a8006f0655d0 = function(form) {
    $e771a7f3a12c9e1c$var$Internals.d.r(form);
};
$e771a7f3a12c9e1c$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$e771a7f3a12c9e1c$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $e771a7f3a12c9e1c$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$e771a7f3a12c9e1c$export$f7e8a0bf92324b1e = function() {
    return $e771a7f3a12c9e1c$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$e771a7f3a12c9e1c$export$83d89fbfd8236492 = "19.1.5";

});



parcelRegister("Oz2mM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $097fd94726457ac1$var$React = $097fd94726457ac1$var$_interopRequireWildcard((parcelRequire("8NFma")));

var $92KUL = parcelRequire("92KUL");

var $097fd94726457ac1$var$_clsx = $097fd94726457ac1$var$_interopRequireDefault((parcelRequire("ase04")));

var $1tBXw = parcelRequire("1tBXw");

var $6AOui = parcelRequire("6AOui");

var $097fd94726457ac1$var$_GridItem = $097fd94726457ac1$var$_interopRequireDefault((parcelRequire("j2P7Z")));

var $097fd94726457ac1$var$_ReactGridLayoutPropTypes = $097fd94726457ac1$var$_interopRequireDefault((parcelRequire("bPL40")));
function $097fd94726457ac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $097fd94726457ac1$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($097fd94726457ac1$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $097fd94726457ac1$var$_defineProperty(e, r, t) {
    return (r = $097fd94726457ac1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $097fd94726457ac1$var$_toPropertyKey(t) {
    var i = $097fd94726457ac1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $097fd94726457ac1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  CompactType,
  GridResizeEvent,
  GridDragEvent,
  DragOverEvent,
  Layout,
  DroppingPosition,
  LayoutItem
} from "./utils";*/ // Types
/*:: import type { PositionParams } from "./calculateUtils";*/ /*:: type State = {
  activeDrag: ?LayoutItem,
  layout: Layout,
  mounted: boolean,
  oldDragItem: ?LayoutItem,
  oldLayout: ?Layout,
  oldResizeItem: ?LayoutItem,
  resizing: boolean,
  droppingDOMNode: ?ReactElement<any>,
  droppingPosition?: DroppingPosition,
  // Mirrored props
  children: ReactChildrenArray<ReactElement<any>>,
  compactType?: CompactType,
  propsLayout?: Layout
};*/ /*:: import type { Props, DefaultProps } from "./ReactGridLayoutPropTypes";*/ // End Types
const $097fd94726457ac1$var$layoutClassName = "react-grid-layout";
let $097fd94726457ac1$var$isFirefox = false;
// Try...catch will protect from navigator not existing (e.g. node) or a bad implementation of navigator
try {
    $097fd94726457ac1$var$isFirefox = /firefox/i.test(navigator.userAgent);
} catch (e) {
/* Ignore */ }
/**
 * A reactive, fluid grid layout with draggable, resizable components.
 */ class $097fd94726457ac1$var$ReactGridLayout extends $097fd94726457ac1$var$React.Component /*:: <Props, State>*/  {
    constructor(){
        super(...arguments);
        $097fd94726457ac1$var$_defineProperty(this, "state", {
            activeDrag: null,
            layout: (0, $1tBXw.synchronizeLayoutWithChildren)(this.props.layout, this.props.children, this.props.cols, // Legacy support for verticalCompact: false
            (0, $1tBXw.compactType)(this.props), this.props.allowOverlap),
            mounted: false,
            oldDragItem: null,
            oldLayout: null,
            oldResizeItem: null,
            resizing: false,
            droppingDOMNode: null,
            children: []
        });
        $097fd94726457ac1$var$_defineProperty(this, "dragEnterCounter", 0);
        /**
     * When dragging starts
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $097fd94726457ac1$var$_defineProperty(this, "onDragStart", (i /*: string*/ , x /*: number*/ , y /*: number*/ , _ref /*:: */ )=>{
            let { e: e, node: node } /*: GridDragEvent*/  = _ref /*: GridDragEvent*/ ;
            const { layout: layout } = this.state;
            const l = (0, $1tBXw.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            this.setState({
                oldDragItem: (0, $1tBXw.cloneLayoutItem)(l),
                oldLayout: layout,
                activeDrag: placeholder
            });
            return this.props.onDragStart(layout, l, l, null, e, node);
        });
        /**
     * Each drag movement create a new dragelement and move the element to the dragged location
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $097fd94726457ac1$var$_defineProperty(this, "onDrag", (i, x, y, _ref2)=>{
            let { e: e, node: node } = _ref2;
            const { oldDragItem: oldDragItem } = this.state;
            let { layout: layout } = this.state;
            const { cols: cols, allowOverlap: allowOverlap, preventCollision: preventCollision } = this.props;
            const l = (0, $1tBXw.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            // Move the element to the dragged location.
            const isUserAction = true;
            layout = (0, $1tBXw.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, $1tBXw.compactType)(this.props), cols, allowOverlap);
            this.props.onDrag(layout, oldDragItem, l, placeholder, e, node);
            this.setState({
                layout: allowOverlap ? layout : (0, $1tBXw.compact)(layout, (0, $1tBXw.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        /**
     * When dragging stops, figure out which position the element is closest to and update its x and y.
     * @param  {String} i Index of the child.
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ $097fd94726457ac1$var$_defineProperty(this, "onDragStop", (i, x, y, _ref3)=>{
            let { e: e, node: node } = _ref3;
            if (!this.state.activeDrag) return;
            const { oldDragItem: oldDragItem } = this.state;
            let { layout: layout } = this.state;
            const { cols: cols, preventCollision: preventCollision, allowOverlap: allowOverlap } = this.props;
            const l = (0, $1tBXw.getLayoutItem)(layout, i);
            if (!l) return;
            // Move the element here
            const isUserAction = true;
            layout = (0, $1tBXw.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, $1tBXw.compactType)(this.props), cols, allowOverlap);
            // Set state
            const newLayout = allowOverlap ? layout : (0, $1tBXw.compact)(layout, (0, $1tBXw.compactType)(this.props), cols);
            this.props.onDragStop(newLayout, oldDragItem, l, null, e, node);
            const { oldLayout: oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldDragItem: null,
                oldLayout: null
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        $097fd94726457ac1$var$_defineProperty(this, "onResizeStart", (i, w, h, _ref4)=>{
            let { e: e, node: node } = _ref4;
            const { layout: layout } = this.state;
            const l = (0, $1tBXw.getLayoutItem)(layout, i);
            if (!l) return;
            this.setState({
                oldResizeItem: (0, $1tBXw.cloneLayoutItem)(l),
                oldLayout: this.state.layout,
                resizing: true
            });
            this.props.onResizeStart(layout, l, l, null, e, node);
        });
        $097fd94726457ac1$var$_defineProperty(this, "onResize", (i, w, h, _ref5)=>{
            let { e: e, node: node, size: size, handle: handle } = _ref5;
            const { oldResizeItem: oldResizeItem } = this.state;
            const { layout: layout } = this.state;
            const { cols: cols, preventCollision: preventCollision, allowOverlap: allowOverlap } = this.props;
            let shouldMoveItem = false;
            let finalLayout;
            let x;
            let y;
            const [newLayout, l] = (0, $1tBXw.withLayoutItem)(layout, i, (l)=>{
                let hasCollisions;
                x = l.x;
                y = l.y;
                if ([
                    "sw",
                    "w",
                    "nw",
                    "n",
                    "ne"
                ].indexOf(handle) !== -1) {
                    if ([
                        "sw",
                        "nw",
                        "w"
                    ].indexOf(handle) !== -1) {
                        x = l.x + (l.w - w);
                        w = l.x !== x && x < 0 ? l.w : w;
                        x = x < 0 ? 0 : x;
                    }
                    if ([
                        "ne",
                        "n",
                        "nw"
                    ].indexOf(handle) !== -1) {
                        y = l.y + (l.h - h);
                        h = l.y !== y && y < 0 ? l.h : h;
                        y = y < 0 ? 0 : y;
                    }
                    shouldMoveItem = true;
                }
                // Something like quad tree should be used
                // to find collisions faster
                if (preventCollision && !allowOverlap) {
                    const collisions = (0, $1tBXw.getAllCollisions)(layout, {
                        ...l,
                        w: w,
                        h: h,
                        x: x,
                        y: y
                    }).filter((layoutItem)=>layoutItem.i !== l.i);
                    hasCollisions = collisions.length > 0;
                    // If we're colliding, we need adjust the placeholder.
                    if (hasCollisions) {
                        // Reset layoutItem dimensions if there were collisions
                        y = l.y;
                        h = l.h;
                        x = l.x;
                        w = l.w;
                        shouldMoveItem = false;
                    }
                }
                l.w = w;
                l.h = h;
                return l;
            });
            // Shouldn't ever happen, but typechecking makes it necessary
            if (!l) return;
            finalLayout = newLayout;
            if (shouldMoveItem) {
                // Move the element to the new position.
                const isUserAction = true;
                finalLayout = (0, $1tBXw.moveElement)(newLayout, l, x, y, isUserAction, this.props.preventCollision, (0, $1tBXw.compactType)(this.props), cols, allowOverlap);
            }
            // Create placeholder element (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                static: true,
                i: i
            };
            this.props.onResize(finalLayout, oldResizeItem, l, placeholder, e, node);
            // Re-compact the newLayout and set the drag placeholder.
            this.setState({
                layout: allowOverlap ? finalLayout : (0, $1tBXw.compact)(finalLayout, (0, $1tBXw.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        $097fd94726457ac1$var$_defineProperty(this, "onResizeStop", (i, w, h, _ref6)=>{
            let { e: e, node: node } = _ref6;
            const { layout: layout, oldResizeItem: oldResizeItem } = this.state;
            const { cols: cols, allowOverlap: allowOverlap } = this.props;
            const l = (0, $1tBXw.getLayoutItem)(layout, i);
            // Set state
            const newLayout = allowOverlap ? layout : (0, $1tBXw.compact)(layout, (0, $1tBXw.compactType)(this.props), cols);
            this.props.onResizeStop(newLayout, oldResizeItem, l, null, e, node);
            const { oldLayout: oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldResizeItem: null,
                oldLayout: null,
                resizing: false
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        // Called while dragging an element. Part of browser native drag/drop API.
        // Native event target might be the layout itself, or an element within the layout.
        $097fd94726457ac1$var$_defineProperty(this, "onDragOver", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            // we should ignore events from layout's children in Firefox
            // to avoid unpredictable jumping of a dropping placeholder
            // FIXME remove this hack
            if ($097fd94726457ac1$var$isFirefox && // $FlowIgnore can't figure this out
            !e.nativeEvent.target?.classList.contains($097fd94726457ac1$var$layoutClassName)) return false;
            const { droppingItem: droppingItem, onDropDragOver: onDropDragOver, margin: margin, cols: cols, rowHeight: rowHeight, maxRows: maxRows, width: width, containerPadding: containerPadding, transformScale: transformScale } = this.props;
            // Allow user to customize the dropping item or short-circuit the drop based on the results
            // of the `onDragOver(e: Event)` callback.
            const onDragOverResult = onDropDragOver?.(e);
            if (onDragOverResult === false) {
                if (this.state.droppingDOMNode) this.removeDroppingPlaceholder();
                return false;
            }
            const finalDroppingItem = {
                ...droppingItem,
                ...onDragOverResult
            };
            const { layout: layout } = this.state;
            // $FlowIgnore missing def
            const gridRect = e.currentTarget.getBoundingClientRect(); // The grid's position in the viewport
            // Calculate the mouse position relative to the grid
            const layerX = e.clientX - gridRect.left;
            const layerY = e.clientY - gridRect.top;
            const droppingPosition = {
                left: layerX / transformScale,
                top: layerY / transformScale,
                e: e
            };
            if (!this.state.droppingDOMNode) {
                const positionParams /*: PositionParams*/  = {
                    cols: cols,
                    margin: margin,
                    maxRows: maxRows,
                    rowHeight: rowHeight,
                    containerWidth: width,
                    containerPadding: containerPadding || margin
                };
                const calculatedPosition = (0, $6AOui.calcXY)(positionParams, layerY, layerX, finalDroppingItem.w, finalDroppingItem.h);
                this.setState({
                    droppingDOMNode: /*#__PURE__*/ $097fd94726457ac1$var$React.createElement("div", {
                        key: finalDroppingItem.i
                    }),
                    droppingPosition: droppingPosition,
                    layout: [
                        ...layout,
                        {
                            ...finalDroppingItem,
                            x: calculatedPosition.x,
                            y: calculatedPosition.y,
                            static: false,
                            isDraggable: true
                        }
                    ]
                });
            } else if (this.state.droppingPosition) {
                const { left: left, top: top } = this.state.droppingPosition;
                const shouldUpdatePosition = left != layerX || top != layerY;
                if (shouldUpdatePosition) this.setState({
                    droppingPosition: droppingPosition
                });
            }
        });
        $097fd94726457ac1$var$_defineProperty(this, "removeDroppingPlaceholder", ()=>{
            const { droppingItem: droppingItem, cols: cols } = this.props;
            const { layout: layout } = this.state;
            const newLayout = (0, $1tBXw.compact)(layout.filter((l)=>l.i !== droppingItem.i), (0, $1tBXw.compactType)(this.props), cols, this.props.allowOverlap);
            this.setState({
                layout: newLayout,
                droppingDOMNode: null,
                activeDrag: null,
                droppingPosition: undefined
            });
        });
        $097fd94726457ac1$var$_defineProperty(this, "onDragLeave", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter--;
            // onDragLeave can be triggered on each layout's child.
            // But we know that count of dragEnter and dragLeave events
            // will be balanced after leaving the layout's container
            // so we can increase and decrease count of dragEnter and
            // when it'll be equal to 0 we'll remove the placeholder
            if (this.dragEnterCounter === 0) this.removeDroppingPlaceholder();
        });
        $097fd94726457ac1$var$_defineProperty(this, "onDragEnter", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter++;
        });
        $097fd94726457ac1$var$_defineProperty(this, "onDrop", (e /*: Event*/ )=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            const { droppingItem: droppingItem } = this.props;
            const { layout: layout } = this.state;
            const item = layout.find((l)=>l.i === droppingItem.i);
            // reset dragEnter counter on drop
            this.dragEnterCounter = 0;
            this.removeDroppingPlaceholder();
            this.props.onDrop(layout, item, e);
        });
    }
    componentDidMount() {
        this.setState({
            mounted: true
        });
        // Possibly call back with layout on mount. This should be done after correcting the layout width
        // to ensure we don't rerender with the wrong width.
        this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
    }
    static getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State> | null*/ {
        let newLayoutBase;
        if (prevState.activeDrag) return null;
        // Legacy support for compactType
        // Allow parent to set layout directly.
        if (!(0, $92KUL.deepEqual)(nextProps.layout, prevState.propsLayout) || nextProps.compactType !== prevState.compactType) newLayoutBase = nextProps.layout;
        else if (!(0, $1tBXw.childrenEqual)(nextProps.children, prevState.children)) // If children change, also regenerate the layout. Use our state
        // as the base in case because it may be more up to date than
        // what is in props.
        newLayoutBase = prevState.layout;
        // We need to regenerate the layout.
        if (newLayoutBase) {
            const newLayout = (0, $1tBXw.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, (0, $1tBXw.compactType)(nextProps), nextProps.allowOverlap);
            return {
                layout: newLayout,
                // We need to save these props to state for using
                // getDerivedStateFromProps instead of componentDidMount (in which we would get extra rerender)
                compactType: nextProps.compactType,
                children: nextProps.children,
                propsLayout: nextProps.layout
            };
        }
        return null;
    }
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        return(// NOTE: this is almost always unequal. Therefore the only way to get better performance
        // from SCU is if the user intentionally memoizes children. If they do, and they can
        // handle changes properly, performance will increase.
        this.props.children !== nextProps.children || !(0, $1tBXw.fastRGLPropsEqual)(this.props, nextProps, $92KUL.deepEqual) || this.state.activeDrag !== nextState.activeDrag || this.state.mounted !== nextState.mounted || this.state.droppingPosition !== nextState.droppingPosition);
    }
    componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
        if (!this.state.activeDrag) {
            const newLayout = this.state.layout;
            const oldLayout = prevState.layout;
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        }
    }
    /**
   * Calculates a pixel value for the container.
   * @return {String} Container height in pixels.
   */ containerHeight() /*: ?string*/ {
        if (!this.props.autoSize) return;
        const nbRow = (0, $1tBXw.bottom)(this.state.layout);
        const containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
        return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
    }
    onLayoutMaybeChanged(newLayout /*: Layout*/ , oldLayout /*: ?Layout*/ ) {
        if (!oldLayout) oldLayout = this.state.layout;
        if (!(0, $92KUL.deepEqual)(oldLayout, newLayout)) this.props.onLayoutChange(newLayout);
    }
    /**
   * Create a placeholder object.
   * @return {Element} Placeholder div.
   */ placeholder() /*: ?ReactElement<any>*/ {
        const { activeDrag: activeDrag } = this.state;
        if (!activeDrag) return null;
        const { width: width, cols: cols, margin: margin, containerPadding: containerPadding, rowHeight: rowHeight, maxRows: maxRows, useCSSTransforms: useCSSTransforms, transformScale: transformScale } = this.props;
        // {...this.state.activeDrag} is pretty slow, actually
        return /*#__PURE__*/ $097fd94726457ac1$var$React.createElement($097fd94726457ac1$var$_GridItem.default, {
            w: activeDrag.w,
            h: activeDrag.h,
            x: activeDrag.x,
            y: activeDrag.y,
            i: activeDrag.i,
            className: `react-grid-placeholder ${this.state.resizing ? "placeholder-resizing" : ""}`,
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            isDraggable: false,
            isResizable: false,
            isBounded: false,
            useCSSTransforms: useCSSTransforms,
            transformScale: transformScale
        }, /*#__PURE__*/ $097fd94726457ac1$var$React.createElement("div", null));
    }
    /**
   * Given a grid item, set its style attributes & surround in a <Draggable>.
   * @param  {Element} child React element.
   * @return {Element}       Element wrapped in draggable and properly placed.
   */ processGridItem(child /*: ReactElement<any>*/ , isDroppingItem /*: boolean*/ ) /*: ?ReactElement<any>*/ {
        if (!child || !child.key) return;
        const l = (0, $1tBXw.getLayoutItem)(this.state.layout, String(child.key));
        if (!l) return null;
        const { width: width, cols: cols, margin: margin, containerPadding: containerPadding, rowHeight: rowHeight, maxRows: maxRows, isDraggable: isDraggable, isResizable: isResizable, isBounded: isBounded, useCSSTransforms: useCSSTransforms, transformScale: transformScale, draggableCancel: draggableCancel, draggableHandle: draggableHandle, resizeHandles: resizeHandles, resizeHandle: resizeHandle } = this.props;
        const { mounted: mounted, droppingPosition: droppingPosition } = this.state;
        // Determine user manipulations possible.
        // If an item is static, it can't be manipulated by default.
        // Any properties defined directly on the grid item will take precedence.
        const draggable = typeof l.isDraggable === "boolean" ? l.isDraggable : !l.static && isDraggable;
        const resizable = typeof l.isResizable === "boolean" ? l.isResizable : !l.static && isResizable;
        const resizeHandlesOptions = l.resizeHandles || resizeHandles;
        // isBounded set on child if set on parent, and child is not explicitly false
        const bounded = draggable && isBounded && l.isBounded !== false;
        return /*#__PURE__*/ $097fd94726457ac1$var$React.createElement($097fd94726457ac1$var$_GridItem.default, {
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            cancel: draggableCancel,
            handle: draggableHandle,
            onDragStop: this.onDragStop,
            onDragStart: this.onDragStart,
            onDrag: this.onDrag,
            onResizeStart: this.onResizeStart,
            onResize: this.onResize,
            onResizeStop: this.onResizeStop,
            isDraggable: draggable,
            isResizable: resizable,
            isBounded: bounded,
            useCSSTransforms: useCSSTransforms && mounted,
            usePercentages: !mounted,
            transformScale: transformScale,
            w: l.w,
            h: l.h,
            x: l.x,
            y: l.y,
            i: l.i,
            minH: l.minH,
            minW: l.minW,
            maxH: l.maxH,
            maxW: l.maxW,
            static: l.static,
            droppingPosition: isDroppingItem ? droppingPosition : undefined,
            resizeHandles: resizeHandlesOptions,
            resizeHandle: resizeHandle
        }, child);
    }
    render() /*: React.Element<"div">*/ {
        const { className: className, style: style, isDroppable: isDroppable, innerRef: innerRef } = this.props;
        const mergedClassName = (0, $097fd94726457ac1$var$_clsx.default)($097fd94726457ac1$var$layoutClassName, className);
        const mergedStyle = {
            height: this.containerHeight(),
            ...style
        };
        return /*#__PURE__*/ $097fd94726457ac1$var$React.createElement("div", {
            ref: innerRef,
            className: mergedClassName,
            style: mergedStyle,
            onDrop: isDroppable ? this.onDrop : $1tBXw.noop,
            onDragLeave: isDroppable ? this.onDragLeave : $1tBXw.noop,
            onDragEnter: isDroppable ? this.onDragEnter : $1tBXw.noop,
            onDragOver: isDroppable ? this.onDragOver : $1tBXw.noop
        }, $097fd94726457ac1$var$React.Children.map(this.props.children, (child)=>this.processGridItem(child)), isDroppable && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, true), this.placeholder());
    }
}
module.exports.default = $097fd94726457ac1$var$ReactGridLayout;
// TODO publish internal ReactClass displayName transform
$097fd94726457ac1$var$_defineProperty($097fd94726457ac1$var$ReactGridLayout, "displayName", "ReactGridLayout");
// Refactored to another module to make way for preval
$097fd94726457ac1$var$_defineProperty($097fd94726457ac1$var$ReactGridLayout, "propTypes", $097fd94726457ac1$var$_ReactGridLayoutPropTypes.default);
$097fd94726457ac1$var$_defineProperty($097fd94726457ac1$var$ReactGridLayout, "defaultProps", {
    autoSize: true,
    cols: 12,
    className: "",
    style: {},
    draggableHandle: "",
    draggableCancel: "",
    containerPadding: null,
    rowHeight: 150,
    maxRows: Infinity,
    // infinite vertical growth
    layout: [],
    margin: [
        10,
        10
    ],
    isBounded: false,
    isDraggable: true,
    isResizable: true,
    allowOverlap: false,
    isDroppable: false,
    useCSSTransforms: true,
    transformScale: 1,
    verticalCompact: true,
    compactType: "vertical",
    preventCollision: false,
    droppingItem: {
        i: "__dropping-elem__",
        h: 1,
        w: 1
    },
    resizeHandles: [
        "se"
    ],
    onLayoutChange: $1tBXw.noop,
    onDragStart: $1tBXw.noop,
    onDrag: $1tBXw.noop,
    onDragStop: $1tBXw.noop,
    onResizeStart: $1tBXw.noop,
    onResize: $1tBXw.noop,
    onResizeStop: $1tBXw.noop,
    onDrop: $1tBXw.noop,
    onDropDragOver: $1tBXw.noop
});

});
parcelRegister("92KUL", function(module, exports) {
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    /**
   * Default equality comparator pass-through, used as the standard `isEqual` creator for
   * use inside the built comparator.
   */ function createDefaultIsNestedEqual(comparator) {
        return function isEqual(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, meta) {
            return comparator(a, b, meta);
        };
    }
    /**
   * Wrap the provided `areItemsEqual` method to manage the circular cache, allowing
   * for circular references to be safely included in the comparison without creating
   * stack overflows.
   */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, isEqual, cache) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, isEqual, cache);
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, isEqual, cache);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
   * Targeted shallow merge of two objects.
   *
   * @NOTE
   * This exists as a tinier compiled version of the `__assign` helper that
   * `tsc` injects in case of `Object.assign` not being present.
   */ function merge(a, b) {
        var merged = {};
        for(var key in a)merged[key] = a[key];
        for(var key in b)merged[key] = b[key];
        return merged;
    }
    /**
   * Whether the value is a plain object.
   *
   * @NOTE
   * This is a same-realm compariosn only.
   */ function isPlainObject(value) {
        return value.constructor === Object || value.constructor == null;
    }
    /**
   * When the value is `Promise`-like, aka "then-able".
   */ function isPromiseLike(value) {
        return typeof value.then === 'function';
    }
    /**
   * Whether the values passed are strictly equal or both NaN.
   */ function sameValueZeroEqual(a, b) {
        return a === b || a !== a && b !== b;
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var REG_EXP_TAG = '[object RegExp]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var toString = Object.prototype.toString;
    function createComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, createIsNestedEqual = _a.createIsNestedEqual;
        var isEqual = createIsNestedEqual(comparator);
        /**
       * compare the value of the two objects and return true if they are equivalent in values
       */ function comparator(a, b, meta) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return a !== a && b !== b;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid the `toString.call()` cost unless necessary.
            if (isPlainObject(a) && isPlainObject(b)) return areObjectsEqual(a, b, isEqual, meta);
            // `isArray()` works on subclasses and is cross-realm, so we can again avoid
            // the `toString.call()` cost unless necessary by just checking if either
            // and then both are arrays.
            var aArray = Array.isArray(a);
            var bArray = Array.isArray(b);
            if (aArray || bArray) return aArray === bArray && areArraysEqual(a, b, isEqual, meta);
            // Since this is a custom object, use the classic `toString.call()` to get its
            // type. This is reasonably performant in modern environments like v8 and
            // SpiderMonkey, and allows for cross-realm comparison when other checks like
            // `instanceof` do not.
            var aTag = toString.call(a);
            if (aTag !== toString.call(b)) return false;
            if (aTag === DATE_TAG) // `getTime()` showed better results compared to alternatives like `valueOf()`
            // or the unary `+` operator.
            return areDatesEqual(a, b, isEqual, meta);
            if (aTag === REG_EXP_TAG) return areRegExpsEqual(a, b, isEqual, meta);
            if (aTag === MAP_TAG) return areMapsEqual(a, b, isEqual, meta);
            if (aTag === SET_TAG) return areSetsEqual(a, b, isEqual, meta);
            // If a simple object tag, then we can prioritize a simple object comparison because
            // it is likely a custom class. If an arguments tag, it should be treated as a standard
            // object.
            if (aTag === OBJECT_TAG || aTag === ARGUMENTS_TAG) // The exception for value comparison is `Promise`-like contracts. These should be
            // treated the same as standard `Promise` objects, which means strict equality.
            return isPromiseLike(a) || isPromiseLike(b) ? false : areObjectsEqual(a, b, isEqual, meta);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (aTag === BOOLEAN_TAG || aTag === NUMBER_TAG || aTag === STRING_TAG) return sameValueZeroEqual(a.valueOf(), b.valueOf());
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        }
        return comparator;
    }
    /**
   * Whether the arrays are equal in value.
   */ function areArraysEqual(a, b, isEqual, meta) {
        var index = a.length;
        if (b.length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isEqual(a[index], b[index], index, index, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the arrays are equal in value, including circular references.
   */ var areArraysEqualCircular = createIsCircular(areArraysEqual);
    /**
   * Whether the dates passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides.
   */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
   * Whether the `Map`s are equal in value.
   */ function areMapsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        var indexA = 0;
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndexB = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndexB] && (hasMatch = isEqual(aKey, bKey, indexA, matchIndexB, a, b, meta) && isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndexB] = true;
                matchIndexB++;
            });
            indexA++;
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Map`s are equal in value, including circular references.
   */ var areMapsEqualCircular = createIsCircular(areMapsEqual);
    var OWNER = '_owner';
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
   * Whether the objects are equal in value.
   */ function areObjectsEqual(a, b, isEqual, meta) {
        var keysA = Object.keys(a);
        var index = keysA.length;
        if (Object.keys(b).length !== index) return false;
        var key;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            key = keysA[index];
            if (key === OWNER) {
                var reactElementA = !!a.$$typeof;
                var reactElementB = !!b.$$typeof;
                if ((reactElementA || reactElementB) && reactElementA !== reactElementB) return false;
            }
            if (!hasOwnProperty.call(b, key) || !isEqual(a[key], b[key], key, key, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the objects are equal in value, including circular references.
   */ var areObjectsEqualCircular = createIsCircular(areObjectsEqual);
    /**
   * Whether the regexps passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides. An example of this would be supporting a
   * pre-ES2015 environment where the `flags` property is not available.
   */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
   * Whether the `Set`s are equal in value.
   */ function areSetsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndex = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndex] = true;
                matchIndex++;
            });
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Set`s are equal in value, including circular references.
   */ var areSetsEqualCircular = createIsCircular(areSetsEqual);
    var DEFAULT_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqual,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqual,
        areObjectsEqual: areObjectsEqual,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqual,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var DEFAULT_CIRCULAR_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqualCircular,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqualCircular,
        areObjectsEqual: areObjectsEqualCircular,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqualCircular,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var isDeepEqual = createComparator(DEFAULT_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value.
   */ function deepEqual(a, b) {
        return isDeepEqual(a, b, undefined);
    }
    var isShallowEqual = createComparator(merge(DEFAULT_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value.
   */ function shallowEqual(a, b) {
        return isShallowEqual(a, b, undefined);
    }
    var isCircularDeepEqual = createComparator(DEFAULT_CIRCULAR_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value, including circular references.
   */ function circularDeepEqual(a, b) {
        return isCircularDeepEqual(a, b, new WeakMap());
    }
    var isCircularShallowEqual = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value, including circular references.
   */ function circularShallowEqual(a, b) {
        return isCircularShallowEqual(a, b, new WeakMap());
    }
    /**
   * Create a custom equality comparison method.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `RegExp.prototype.flags` out of the box.
   */ function createCustomEqual(getComparatorOptions) {
        return createComparator(merge(DEFAULT_CONFIG, getComparatorOptions(DEFAULT_CONFIG)));
    }
    /**
   * Create a custom equality comparison method that handles circular references. This is very
   * similar to `createCustomEqual`, with the only difference being that `meta` expects to be
   * populated with a `WeakMap`-like contract.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `WeakMap` out of the box.
   */ function createCustomCircularEqual(getComparatorOptions) {
        var comparator = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, getComparatorOptions(DEFAULT_CIRCULAR_CONFIG)));
        return function(a, b, meta) {
            if (meta === void 0) meta = new WeakMap();
            return comparator(a, b, meta);
        };
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomCircularEqual = createCustomCircularEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});

parcelRegister("ase04", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $4944fe05cfdb1e2e$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $4944fe05cfdb1e2e$export$2e2bcd8739ae039);
function $4944fe05cfdb1e2e$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $4944fe05cfdb1e2e$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $4944fe05cfdb1e2e$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $4944fe05cfdb1e2e$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $4944fe05cfdb1e2e$export$2e2bcd8739ae039 = $4944fe05cfdb1e2e$export$4f5d2d50c9deca37;

});

parcelRegister("1tBXw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bottom = $1135f1bbdfff0a4d$var$bottom;
module.exports.childrenEqual = $1135f1bbdfff0a4d$var$childrenEqual;
module.exports.cloneLayout = $1135f1bbdfff0a4d$var$cloneLayout;
module.exports.cloneLayoutItem = $1135f1bbdfff0a4d$var$cloneLayoutItem;
module.exports.collides = $1135f1bbdfff0a4d$var$collides;
module.exports.compact = $1135f1bbdfff0a4d$var$compact;
module.exports.compactItem = $1135f1bbdfff0a4d$var$compactItem;
module.exports.compactType = $1135f1bbdfff0a4d$var$compactType;
module.exports.correctBounds = $1135f1bbdfff0a4d$var$correctBounds;
module.exports.fastPositionEqual = $1135f1bbdfff0a4d$var$fastPositionEqual;
module.exports.fastRGLPropsEqual = void 0;
module.exports.getAllCollisions = $1135f1bbdfff0a4d$var$getAllCollisions;
module.exports.getFirstCollision = $1135f1bbdfff0a4d$var$getFirstCollision;
module.exports.getLayoutItem = $1135f1bbdfff0a4d$var$getLayoutItem;
module.exports.getStatics = $1135f1bbdfff0a4d$var$getStatics;
module.exports.modifyLayout = $1135f1bbdfff0a4d$var$modifyLayout;
module.exports.moveElement = $1135f1bbdfff0a4d$var$moveElement;
module.exports.moveElementAwayFromCollision = $1135f1bbdfff0a4d$var$moveElementAwayFromCollision;
module.exports.noop = void 0;
module.exports.perc = $1135f1bbdfff0a4d$var$perc;
module.exports.resizeItemInDirection = $1135f1bbdfff0a4d$var$resizeItemInDirection;
module.exports.setTopLeft = $1135f1bbdfff0a4d$var$setTopLeft;
module.exports.setTransform = $1135f1bbdfff0a4d$var$setTransform;
module.exports.sortLayoutItems = $1135f1bbdfff0a4d$var$sortLayoutItems;
module.exports.sortLayoutItemsByColRow = $1135f1bbdfff0a4d$var$sortLayoutItemsByColRow;
module.exports.sortLayoutItemsByRowCol = $1135f1bbdfff0a4d$var$sortLayoutItemsByRowCol;
module.exports.synchronizeLayoutWithChildren = $1135f1bbdfff0a4d$var$synchronizeLayoutWithChildren;
module.exports.validateLayout = $1135f1bbdfff0a4d$var$validateLayout;
module.exports.withLayoutItem = $1135f1bbdfff0a4d$var$withLayoutItem;

var $92KUL = parcelRequire("92KUL");

var $1135f1bbdfff0a4d$var$_react = $1135f1bbdfff0a4d$var$_interopRequireDefault((parcelRequire("8NFma")));
function $1135f1bbdfff0a4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: export type ResizeHandleAxis =
  | "s"
  | "w"
  | "e"
  | "n"
  | "sw"
  | "nw"
  | "se"
  | "ne";*/ /*:: export type LayoutItem = {
  w: number,
  h: number,
  x: number,
  y: number,
  i: string,
  minW?: number,
  minH?: number,
  maxW?: number,
  maxH?: number,
  moved?: boolean,
  static?: boolean,
  isDraggable?: ?boolean,
  isResizable?: ?boolean,
  resizeHandles?: Array<ResizeHandleAxis>,
  isBounded?: ?boolean
};*/ /*:: export type Layout = $ReadOnlyArray<LayoutItem>;*/ /*:: export type Position = {
  left: number,
  top: number,
  width: number,
  height: number
};*/ /*:: export type ReactDraggableCallbackData = {
  node: HTMLElement,
  x?: number,
  y?: number,
  deltaX: number,
  deltaY: number,
  lastX?: number,
  lastY?: number
};*/ /*:: export type PartialPosition = { left: number, top: number };*/ /*:: export type DroppingPosition = { left: number, top: number, e: Event };*/ /*:: export type Size = { width: number, height: number };*/ /*:: export type GridDragEvent = {
  e: Event,
  node: HTMLElement,
  newPosition: PartialPosition
};*/ /*:: export type GridResizeEvent = {
  e: Event,
  node: HTMLElement,
  size: Size,
  handle: string
};*/ /*:: export type DragOverEvent = MouseEvent & {
  nativeEvent: {
    layerX: number,
    layerY: number,
    ...Event
  }
};*/ /*:: export type Pick<FromType, Properties: { [string]: 0 }> = $Exact<
  $ObjMapi<Properties, <K, V>(k: K, v: V) => $ElementType<FromType, K>>
>;*/ // Helpful port from TS
/*:: type REl = ReactElement<any>;*/ /*:: export type ReactChildren = ReactChildrenArray<REl>;*/ /*:: export type EventCallback = (
  Layout,
  oldItem: ?LayoutItem,
  newItem: ?LayoutItem,
  placeholder: ?LayoutItem,
  Event,
  ?HTMLElement
) => void;*/ // All callbacks are of the signature (layout, oldItem, newItem, placeholder, e).
/*:: export type CompactType = ?("horizontal" | "vertical");*/ const $1135f1bbdfff0a4d$var$isProduction = true;
const $1135f1bbdfff0a4d$var$DEBUG = false;
/**
 * Return the bottom coordinate of the layout.
 *
 * @param  {Array} layout Layout array.
 * @return {Number}       Bottom coordinate.
 */ function $1135f1bbdfff0a4d$var$bottom(layout /*: Layout*/ ) /*: number*/ {
    let max = 0, bottomY;
    for(let i = 0, len = layout.length; i < len; i++){
        bottomY = layout[i].y + layout[i].h;
        if (bottomY > max) max = bottomY;
    }
    return max;
}
function $1135f1bbdfff0a4d$var$cloneLayout(layout /*: Layout*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)newLayout[i] = $1135f1bbdfff0a4d$var$cloneLayoutItem(layout[i]);
    return newLayout;
}
// Modify a layoutItem inside a layout. Returns a new Layout,
// does not mutate. Carries over all other LayoutItems unmodified.
function $1135f1bbdfff0a4d$var$modifyLayout(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)if (layoutItem.i === layout[i].i) newLayout[i] = layoutItem;
    else newLayout[i] = layout[i];
    return newLayout;
}
// Function to be called to modify a layout item.
// Does defensive clones to ensure the layout is not modified.
function $1135f1bbdfff0a4d$var$withLayoutItem(layout /*: Layout*/ , itemKey /*: string*/ , cb /*: LayoutItem => LayoutItem*/ ) /*: [Layout, ?LayoutItem]*/ {
    let item = $1135f1bbdfff0a4d$var$getLayoutItem(layout, itemKey);
    if (!item) return [
        layout,
        null
    ];
    item = cb($1135f1bbdfff0a4d$var$cloneLayoutItem(item)); // defensive clone then modify
    // FIXME could do this faster if we already knew the index
    layout = $1135f1bbdfff0a4d$var$modifyLayout(layout, item);
    return [
        layout,
        item
    ];
}
// Fast path to cloning, since this is monomorphic
function $1135f1bbdfff0a4d$var$cloneLayoutItem(layoutItem /*: LayoutItem*/ ) /*: LayoutItem*/ {
    return {
        w: layoutItem.w,
        h: layoutItem.h,
        x: layoutItem.x,
        y: layoutItem.y,
        i: layoutItem.i,
        minW: layoutItem.minW,
        maxW: layoutItem.maxW,
        minH: layoutItem.minH,
        maxH: layoutItem.maxH,
        moved: Boolean(layoutItem.moved),
        static: Boolean(layoutItem.static),
        // These can be null/undefined
        isDraggable: layoutItem.isDraggable,
        isResizable: layoutItem.isResizable,
        resizeHandles: layoutItem.resizeHandles,
        isBounded: layoutItem.isBounded
    };
}
/**
 * Comparing React `children` is a bit difficult. This is a good way to compare them.
 * This will catch differences in keys, order, and length.
 */ function $1135f1bbdfff0a4d$var$childrenEqual(a /*: ReactChildren*/ , b /*: ReactChildren*/ ) /*: boolean*/ {
    return (0, $92KUL.deepEqual)($1135f1bbdfff0a4d$var$_react.default.Children.map(a, (c)=>c?.key), $1135f1bbdfff0a4d$var$_react.default.Children.map(b, (c)=>c?.key)) && (0, $92KUL.deepEqual)($1135f1bbdfff0a4d$var$_react.default.Children.map(a, (c)=>c?.props["data-grid"]), $1135f1bbdfff0a4d$var$_react.default.Children.map(b, (c)=>c?.props["data-grid"]));
}

/**
 * See `fastRGLPropsEqual.js`.
 * We want this to run as fast as possible - it is called often - and to be
 * resilient to new props that we add. So rather than call lodash.isEqual,
 * which isn't suited to comparing props very well, we use this specialized
 * function in conjunction with preval to generate the fastest possible comparison
 * function, tuned for exactly our props.
 */ /*:: type FastRGLPropsEqual = (Object, Object, Function) => boolean;*/ const $1135f1bbdfff0a4d$var$fastRGLPropsEqual /*: FastRGLPropsEqual*/  = module.exports.fastRGLPropsEqual = (parcelRequire("91jqs"));
// Like the above, but a lot simpler.
function $1135f1bbdfff0a4d$var$fastPositionEqual(a /*: Position*/ , b /*: Position*/ ) /*: boolean*/ {
    return a.left === b.left && a.top === b.top && a.width === b.width && a.height === b.height;
}
/**
 * Given two layoutitems, check if they collide.
 */ function $1135f1bbdfff0a4d$var$collides(l1 /*: LayoutItem*/ , l2 /*: LayoutItem*/ ) /*: boolean*/ {
    if (l1.i === l2.i) return false; // same element
    if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
    if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
    if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
    if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
    return true; // boxes overlap
}
/**
 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
 * between items.
 *
 * Does not modify layout items (clones). Creates a new layout array.
 *
 * @param  {Array} layout Layout.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @param  {Boolean} allowOverlap When `true`, allows overlapping grid items.
 * @return {Array}       Compacted Layout.
 */ function $1135f1bbdfff0a4d$var$compact(layout /*: Layout*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // Statics go in the compareWith array right away so items flow around them.
    const compareWith = $1135f1bbdfff0a4d$var$getStatics(layout);
    // We go through the items by row and column.
    const sorted = $1135f1bbdfff0a4d$var$sortLayoutItems(layout, compactType);
    // Holding for new items.
    const out = Array(layout.length);
    for(let i = 0, len = sorted.length; i < len; i++){
        let l = $1135f1bbdfff0a4d$var$cloneLayoutItem(sorted[i]);
        // Don't move static elements
        if (!l.static) {
            l = $1135f1bbdfff0a4d$var$compactItem(compareWith, l, compactType, cols, sorted, allowOverlap);
            // Add to comparison array. We only collide with items before this one.
            // Statics are already in this array.
            compareWith.push(l);
        }
        // Add to output array to make sure they still come out in the right order.
        out[layout.indexOf(sorted[i])] = l;
        // Clear moved flag, if it exists.
        l.moved = false;
    }
    return out;
}
const $1135f1bbdfff0a4d$var$heightWidth = {
    x: "w",
    y: "h"
};
/**
 * Before moving item down, it will check if the movement will cause collisions and move those items down before.
 */ function $1135f1bbdfff0a4d$var$resolveCompactionCollision(layout /*: Layout*/ , item /*: LayoutItem*/ , moveToCoord /*: number*/ , axis /*: "x" | "y"*/ ) {
    const sizeProp = $1135f1bbdfff0a4d$var$heightWidth[axis];
    item[axis] += 1;
    const itemIndex = layout.map((layoutItem)=>{
        return layoutItem.i;
    }).indexOf(item.i);
    // Go through each item we collide with.
    for(let i = itemIndex + 1; i < layout.length; i++){
        const otherItem = layout[i];
        // Ignore static items
        if (otherItem.static) continue;
        // Optimization: we can break early if we know we're past this el
        // We can do this b/c it's a sorted layout
        if (otherItem.y > item.y + item.h) break;
        if ($1135f1bbdfff0a4d$var$collides(item, otherItem)) $1135f1bbdfff0a4d$var$resolveCompactionCollision(layout, otherItem, moveToCoord + item[sizeProp], axis);
    }
    item[axis] = moveToCoord;
}
/**
 * Compact an item in the layout.
 *
 * Modifies item.
 *
 */ function $1135f1bbdfff0a4d$var$compactItem(compareWith /*: Layout*/ , l /*: LayoutItem*/ , compactType /*: CompactType*/ , cols /*: number*/ , fullLayout /*: Layout*/ , allowOverlap /*: ?boolean*/ ) /*: LayoutItem*/ {
    const compactV = compactType === "vertical";
    const compactH = compactType === "horizontal";
    if (compactV) {
        // Bottom 'y' possible is the bottom of the layout.
        // This allows you to do nice stuff like specify {y: Infinity}
        // This is here because the layout must be sorted in order to get the correct bottom `y`.
        l.y = Math.min($1135f1bbdfff0a4d$var$bottom(compareWith), l.y);
        // Move the element up as far as it can go without colliding.
        while(l.y > 0 && !$1135f1bbdfff0a4d$var$getFirstCollision(compareWith, l))l.y--;
    } else if (compactH) // Move the element left as far as it can go without colliding.
    while(l.x > 0 && !$1135f1bbdfff0a4d$var$getFirstCollision(compareWith, l))l.x--;
    // Move it down, and keep moving it down if it's colliding.
    let collides;
    // Checking the compactType null value to avoid breaking the layout when overlapping is allowed.
    while((collides = $1135f1bbdfff0a4d$var$getFirstCollision(compareWith, l)) && !(compactType === null && allowOverlap)){
        if (compactH) $1135f1bbdfff0a4d$var$resolveCompactionCollision(fullLayout, l, collides.x + collides.w, "x");
        else $1135f1bbdfff0a4d$var$resolveCompactionCollision(fullLayout, l, collides.y + collides.h, "y");
        // Since we can't grow without bounds horizontally, if we've overflown, let's move it down and try again.
        if (compactH && l.x + l.w > cols) {
            l.x = cols - l.w;
            l.y++;
            // ALso move element as left as we can
            while(l.x > 0 && !$1135f1bbdfff0a4d$var$getFirstCollision(compareWith, l))l.x--;
        }
    }
    // Ensure that there are no negative positions
    l.y = Math.max(l.y, 0);
    l.x = Math.max(l.x, 0);
    return l;
}
/**
 * Given a layout, make sure all elements fit within its bounds.
 *
 * Modifies layout items.
 *
 * @param  {Array} layout Layout array.
 * @param  {Number} bounds Number of columns.
 */ function $1135f1bbdfff0a4d$var$correctBounds(layout /*: Layout*/ , bounds /*: { cols: number }*/ ) /*: Layout*/ {
    const collidesWith = $1135f1bbdfff0a4d$var$getStatics(layout);
    for(let i = 0, len = layout.length; i < len; i++){
        const l = layout[i];
        // Overflows right
        if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w;
        // Overflows left
        if (l.x < 0) {
            l.x = 0;
            l.w = bounds.cols;
        }
        if (!l.static) collidesWith.push(l);
        else // If this is static and collides with other statics, we must move it down.
        // We have to do something nicer than just letting them overlap.
        while($1135f1bbdfff0a4d$var$getFirstCollision(collidesWith, l))l.y++;
    }
    return layout;
}
/**
 * Get a layout item by ID. Used so we can override later on if necessary.
 *
 * @param  {Array}  layout Layout array.
 * @param  {String} id     ID
 * @return {LayoutItem}    Item at ID.
 */ function $1135f1bbdfff0a4d$var$getLayoutItem(layout /*: Layout*/ , id /*: string*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if (layout[i].i === id) return layout[i];
    }
}
/**
 * Returns the first item this layout collides with.
 * It doesn't appear to matter which order we approach this from, although
 * perhaps that is the wrong thing to do.
 *
 * @param  {Object} layoutItem Layout item.
 * @return {Object|undefined}  A colliding layout item, or undefined.
 */ function $1135f1bbdfff0a4d$var$getFirstCollision(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if ($1135f1bbdfff0a4d$var$collides(layout[i], layoutItem)) return layout[i];
    }
}
function $1135f1bbdfff0a4d$var$getAllCollisions(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>$1135f1bbdfff0a4d$var$collides(l, layoutItem));
}
/**
 * Get all static elements.
 * @param  {Array} layout Array of layout objects.
 * @return {Array}        Array of static layout items..
 */ function $1135f1bbdfff0a4d$var$getStatics(layout /*: Layout*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>l.static);
}
/**
 * Move an element. Responsible for doing cascading movements of other elements.
 *
 * Modifies layout items.
 *
 * @param  {Array}      layout            Full layout to modify.
 * @param  {LayoutItem} l                 element to move.
 * @param  {Number}     [x]               X position in grid units.
 * @param  {Number}     [y]               Y position in grid units.
 */ function $1135f1bbdfff0a4d$var$moveElement(layout /*: Layout*/ , l /*: LayoutItem*/ , x /*: ?number*/ , y /*: ?number*/ , isUserAction /*: ?boolean*/ , preventCollision /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // If this is static and not explicitly enabled as draggable,
    // no move is possible, so we can short-circuit this immediately.
    if (l.static && l.isDraggable !== true) return layout;
    // Short-circuit if nothing to do.
    if (l.y === y && l.x === x) return layout;
    $1135f1bbdfff0a4d$var$log(`Moving element ${l.i} to [${String(x)},${String(y)}] from [${l.x},${l.y}]`);
    const oldX = l.x;
    const oldY = l.y;
    // This is quite a bit faster than extending the object
    if (typeof x === "number") l.x = x;
    if (typeof y === "number") l.y = y;
    l.moved = true;
    // If this collides with anything, move it.
    // When doing this comparison, we have to sort the items we compare with
    // to ensure, in the case of multiple collisions, that we're getting the
    // nearest collision.
    let sorted = $1135f1bbdfff0a4d$var$sortLayoutItems(layout, compactType);
    const movingUp = compactType === "vertical" && typeof y === "number" ? oldY >= y : compactType === "horizontal" && typeof x === "number" ? oldX >= x : false;
    // $FlowIgnore acceptable modification of read-only array as it was recently cloned
    if (movingUp) sorted = sorted.reverse();
    const collisions = $1135f1bbdfff0a4d$var$getAllCollisions(sorted, l);
    const hasCollisions = collisions.length > 0;
    // We may have collisions. We can short-circuit if we've turned off collisions or
    // allowed overlap.
    if (hasCollisions && allowOverlap) // Easy, we don't need to resolve collisions. But we *did* change the layout,
    // so clone it on the way out.
    return $1135f1bbdfff0a4d$var$cloneLayout(layout);
    else if (hasCollisions && preventCollision) {
        // If we are preventing collision but not allowing overlap, we need to
        // revert the position of this element so it goes to where it came from, rather
        // than the user's desired location.
        $1135f1bbdfff0a4d$var$log(`Collision prevented on ${l.i}, reverting.`);
        l.x = oldX;
        l.y = oldY;
        l.moved = false;
        return layout; // did not change so don't clone
    }
    // Move each item that collides away from this element.
    for(let i = 0, len = collisions.length; i < len; i++){
        const collision = collisions[i];
        $1135f1bbdfff0a4d$var$log(`Resolving collision between ${l.i} at [${l.x},${l.y}] and ${collision.i} at [${collision.x},${collision.y}]`);
        // Short circuit so we can't infinite loop
        if (collision.moved) continue;
        // Don't move static items - we have to move *this* element away
        if (collision.static) layout = $1135f1bbdfff0a4d$var$moveElementAwayFromCollision(layout, collision, l, isUserAction, compactType, cols);
        else layout = $1135f1bbdfff0a4d$var$moveElementAwayFromCollision(layout, l, collision, isUserAction, compactType, cols);
    }
    return layout;
}
/**
 * This is where the magic needs to happen - given a collision, move an element away from the collision.
 * We attempt to move it up if there's room, otherwise it goes below.
 *
 * @param  {Array} layout            Full layout to modify.
 * @param  {LayoutItem} collidesWith Layout item we're colliding with.
 * @param  {LayoutItem} itemToMove   Layout item we're moving.
 */ function $1135f1bbdfff0a4d$var$moveElementAwayFromCollision(layout /*: Layout*/ , collidesWith /*: LayoutItem*/ , itemToMove /*: LayoutItem*/ , isUserAction /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ ) /*: Layout*/ {
    const compactH = compactType === "horizontal";
    // Compact vertically if not set to horizontal
    const compactV = compactType === "vertical";
    const preventCollision = collidesWith.static; // we're already colliding (not for static items)
    // If there is enough space above the collision to put this element, move it there.
    // We only do this on the main collision as this can get funky in cascades and cause
    // unwanted swapping behavior.
    if (isUserAction) {
        // Reset isUserAction flag because we're not in the main collision anymore.
        isUserAction = false;
        // Make a mock item so we don't modify the item here, only modify in moveElement.
        const fakeItem /*: LayoutItem*/  = {
            x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
            y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
            w: itemToMove.w,
            h: itemToMove.h,
            i: "-1"
        };
        const firstCollision = $1135f1bbdfff0a4d$var$getFirstCollision(layout, fakeItem);
        const collisionNorth = firstCollision && firstCollision.y + firstCollision.h > collidesWith.y;
        const collisionWest = firstCollision && collidesWith.x + collidesWith.w > firstCollision.x;
        // No collision? If so, we can go up there; otherwise, we'll end up moving down as normal
        if (!firstCollision) {
            $1135f1bbdfff0a4d$var$log(`Doing reverse collision on ${itemToMove.i} up to [${fakeItem.x},${fakeItem.y}].`);
            return $1135f1bbdfff0a4d$var$moveElement(layout, itemToMove, compactH ? fakeItem.x : undefined, compactV ? fakeItem.y : undefined, isUserAction, preventCollision, compactType, cols);
        } else if (collisionNorth && compactV) return $1135f1bbdfff0a4d$var$moveElement(layout, itemToMove, undefined, collidesWith.y + 1, isUserAction, preventCollision, compactType, cols);
        else if (collisionNorth && compactType == null) {
            collidesWith.y = itemToMove.y;
            itemToMove.y = itemToMove.y + itemToMove.h;
            return layout;
        } else if (collisionWest && compactH) return $1135f1bbdfff0a4d$var$moveElement(layout, collidesWith, itemToMove.x, undefined, isUserAction, preventCollision, compactType, cols);
    }
    const newX = compactH ? itemToMove.x + 1 : undefined;
    const newY = compactV ? itemToMove.y + 1 : undefined;
    if (newX == null && newY == null) return layout;
    return $1135f1bbdfff0a4d$var$moveElement(layout, itemToMove, compactH ? itemToMove.x + 1 : undefined, compactV ? itemToMove.y + 1 : undefined, isUserAction, preventCollision, compactType, cols);
}
/**
 * Helper to convert a number to a percentage string.
 *
 * @param  {Number} num Any number
 * @return {String}     That number as a percentage.
 */ function $1135f1bbdfff0a4d$var$perc(num /*: number*/ ) /*: string*/ {
    return num * 100 + "%";
}
/**
 * Helper functions to constrain dimensions of a GridItem
 */ const $1135f1bbdfff0a4d$var$constrainWidth = (left /*: number*/ , currentWidth /*: number*/ , newWidth /*: number*/ , containerWidth /*: number*/ )=>{
    return left + newWidth > containerWidth ? currentWidth : newWidth;
};
const $1135f1bbdfff0a4d$var$constrainHeight = (top /*: number*/ , currentHeight /*: number*/ , newHeight /*: number*/ )=>{
    return top < 0 ? currentHeight : newHeight;
};
const $1135f1bbdfff0a4d$var$constrainLeft = (left /*: number*/ )=>Math.max(0, left);
const $1135f1bbdfff0a4d$var$constrainTop = (top /*: number*/ )=>Math.max(0, top);
const $1135f1bbdfff0a4d$var$resizeNorth = (currentSize, _ref, _containerWidth)=>{
    let { left: left, height: height, width: width } = _ref;
    const top = currentSize.top - (height - currentSize.height);
    return {
        left: left,
        width: width,
        height: $1135f1bbdfff0a4d$var$constrainHeight(top, currentSize.height, height),
        top: $1135f1bbdfff0a4d$var$constrainTop(top)
    };
};
const $1135f1bbdfff0a4d$var$resizeEast = (currentSize, _ref2, containerWidth)=>{
    let { top: top, left: left, height: height, width: width } = _ref2;
    return {
        top: top,
        height: height,
        width: $1135f1bbdfff0a4d$var$constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        left: $1135f1bbdfff0a4d$var$constrainLeft(left)
    };
};
const $1135f1bbdfff0a4d$var$resizeWest = (currentSize, _ref3, containerWidth)=>{
    let { top: top, height: height, width: width } = _ref3;
    const left = currentSize.left - (width - currentSize.width);
    return {
        height: height,
        width: left < 0 ? currentSize.width : $1135f1bbdfff0a4d$var$constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        top: $1135f1bbdfff0a4d$var$constrainTop(top),
        left: $1135f1bbdfff0a4d$var$constrainLeft(left)
    };
};
const $1135f1bbdfff0a4d$var$resizeSouth = (currentSize, _ref4, containerWidth)=>{
    let { top: top, left: left, height: height, width: width } = _ref4;
    return {
        width: width,
        left: left,
        height: $1135f1bbdfff0a4d$var$constrainHeight(top, currentSize.height, height),
        top: $1135f1bbdfff0a4d$var$constrainTop(top)
    };
};
const $1135f1bbdfff0a4d$var$resizeNorthEast = function() {
    return $1135f1bbdfff0a4d$var$resizeNorth(arguments.length <= 0 ? undefined : arguments[0], $1135f1bbdfff0a4d$var$resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $1135f1bbdfff0a4d$var$resizeNorthWest = function() {
    return $1135f1bbdfff0a4d$var$resizeNorth(arguments.length <= 0 ? undefined : arguments[0], $1135f1bbdfff0a4d$var$resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $1135f1bbdfff0a4d$var$resizeSouthEast = function() {
    return $1135f1bbdfff0a4d$var$resizeSouth(arguments.length <= 0 ? undefined : arguments[0], $1135f1bbdfff0a4d$var$resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $1135f1bbdfff0a4d$var$resizeSouthWest = function() {
    return $1135f1bbdfff0a4d$var$resizeSouth(arguments.length <= 0 ? undefined : arguments[0], $1135f1bbdfff0a4d$var$resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const $1135f1bbdfff0a4d$var$ordinalResizeHandlerMap = {
    n: $1135f1bbdfff0a4d$var$resizeNorth,
    ne: $1135f1bbdfff0a4d$var$resizeNorthEast,
    e: $1135f1bbdfff0a4d$var$resizeEast,
    se: $1135f1bbdfff0a4d$var$resizeSouthEast,
    s: $1135f1bbdfff0a4d$var$resizeSouth,
    sw: $1135f1bbdfff0a4d$var$resizeSouthWest,
    w: $1135f1bbdfff0a4d$var$resizeWest,
    nw: $1135f1bbdfff0a4d$var$resizeNorthWest
};
/**
 * Helper for clamping width and position when resizing an item.
 */ function $1135f1bbdfff0a4d$var$resizeItemInDirection(direction /*: ResizeHandleAxis*/ , currentSize /*: Position*/ , newSize /*: Position*/ , containerWidth /*: number*/ ) /*: Position*/ {
    const ordinalHandler = $1135f1bbdfff0a4d$var$ordinalResizeHandlerMap[direction];
    // Shouldn't be possible given types; that said, don't fail hard
    if (!ordinalHandler) return newSize;
    return ordinalHandler(currentSize, {
        ...currentSize,
        ...newSize
    }, containerWidth);
}
function $1135f1bbdfff0a4d$var$setTransform(_ref5 /*:: */ ) /*: Object*/ {
    let { top: top, left: left, width: width, height: height } /*: Position*/  = _ref5 /*: Position*/ ;
    // Replace unitless items with px
    const translate = `translate(${left}px,${top}px)`;
    return {
        transform: translate,
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        width: `${width}px`,
        height: `${height}px`,
        position: "absolute"
    };
}
function $1135f1bbdfff0a4d$var$setTopLeft(_ref6 /*:: */ ) /*: Object*/ {
    let { top: top, left: left, width: width, height: height } /*: Position*/  = _ref6 /*: Position*/ ;
    return {
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`,
        height: `${height}px`,
        position: "absolute"
    };
}
/**
 * Get layout items sorted from top left to right and down.
 *
 * @return {Array} Array of layout objects.
 * @return {Array}        Layout, sorted static items first.
 */ function $1135f1bbdfff0a4d$var$sortLayoutItems(layout /*: Layout*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    if (compactType === "horizontal") return $1135f1bbdfff0a4d$var$sortLayoutItemsByColRow(layout);
    if (compactType === "vertical") return $1135f1bbdfff0a4d$var$sortLayoutItemsByRowCol(layout);
    else return layout;
}
/**
 * Sort layout items by row ascending and column ascending.
 *
 * Does not modify Layout.
 */ function $1135f1bbdfff0a4d$var$sortLayoutItemsByRowCol(layout /*: Layout*/ ) /*: Layout*/ {
    // Slice to clone array as sort modifies
    return layout.slice(0).sort(function(a, b) {
        if (a.y > b.y || a.y === b.y && a.x > b.x) return 1;
        else if (a.y === b.y && a.x === b.x) // Without this, we can get different sort results in IE vs. Chrome/FF
        return 0;
        return -1;
    });
}
/**
 * Sort layout items by column ascending then row ascending.
 *
 * Does not modify Layout.
 */ function $1135f1bbdfff0a4d$var$sortLayoutItemsByColRow(layout /*: Layout*/ ) /*: Layout*/ {
    return layout.slice(0).sort(function(a, b) {
        if (a.x > b.x || a.x === b.x && a.y > b.y) return 1;
        return -1;
    });
}
/**
 * Generate a layout using the initialLayout and children as a template.
 * Missing entries will be added, extraneous ones will be truncated.
 *
 * Does not modify initialLayout.
 *
 * @param  {Array}  initialLayout Layout passed in through props.
 * @param  {String} breakpoint    Current responsive breakpoint.
 * @param  {?String} compact      Compaction option.
 * @return {Array}                Working layout.
 */ function $1135f1bbdfff0a4d$var$synchronizeLayoutWithChildren(initialLayout /*: Layout*/ , children /*: ReactChildren*/ , cols /*: number*/ , compactType /*: CompactType*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    initialLayout = initialLayout || [];
    // Generate one layout item per child.
    const layout /*: LayoutItem[]*/  = [];
    $1135f1bbdfff0a4d$var$_react.default.Children.forEach(children, (child /*: ReactElement<any>*/ )=>{
        // Child may not exist
        if (child?.key == null) return;
        const exists = $1135f1bbdfff0a4d$var$getLayoutItem(initialLayout, String(child.key));
        const g = child.props["data-grid"];
        // Don't overwrite the layout item if it's already in the initial layout.
        // If it has a `data-grid` property, prefer that over what's in the layout.
        if (exists && g == null) layout.push($1135f1bbdfff0a4d$var$cloneLayoutItem(exists));
        else // Hey, this item has a data-grid property, use it.
        if (g) {
            if (!$1135f1bbdfff0a4d$var$isProduction) $1135f1bbdfff0a4d$var$validateLayout([
                g
            ], "ReactGridLayout.children");
            // FIXME clone not really necessary here
            layout.push($1135f1bbdfff0a4d$var$cloneLayoutItem({
                ...g,
                i: child.key
            }));
        } else // Nothing provided: ensure this is added to the bottom
        // FIXME clone not really necessary here
        layout.push($1135f1bbdfff0a4d$var$cloneLayoutItem({
            w: 1,
            h: 1,
            x: 0,
            y: $1135f1bbdfff0a4d$var$bottom(layout),
            i: String(child.key)
        }));
    });
    // Correct the layout.
    const correctedLayout = $1135f1bbdfff0a4d$var$correctBounds(layout, {
        cols: cols
    });
    return allowOverlap ? correctedLayout : $1135f1bbdfff0a4d$var$compact(correctedLayout, compactType, cols);
}
/**
 * Validate a layout. Throws errors.
 *
 * @param  {Array}  layout        Array of layout items.
 * @param  {String} [contextName] Context name for errors.
 * @throw  {Error}                Validation error.
 */ function $1135f1bbdfff0a4d$var$validateLayout(layout /*: Layout*/ ) /*: void*/ {
    let contextName /*: string*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Layout";
    const subProps = [
        "x",
        "y",
        "w",
        "h"
    ];
    if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
    for(let i = 0, len = layout.length; i < len; i++){
        const item = layout[i];
        for(let j = 0; j < subProps.length; j++){
            const key = subProps[j];
            const value = item[key];
            if (typeof value !== "number" || Number.isNaN(value)) throw new Error(`ReactGridLayout: ${contextName}[${i}].${key} must be a number! Received: ${value} (${typeof value})`);
        }
        if (typeof item.i !== "undefined" && typeof item.i !== "string") throw new Error(`ReactGridLayout: ${contextName}[${i}].i must be a string! Received: ${item.i} (${typeof item.i})`);
    }
}
// Legacy support for verticalCompact: false
function $1135f1bbdfff0a4d$var$compactType(props /*: ?{ verticalCompact: boolean, compactType: CompactType }*/ ) /*: CompactType*/ {
    const { verticalCompact: verticalCompact, compactType: compactType } = props || {};
    return verticalCompact === false ? null : compactType;
}
function $1135f1bbdfff0a4d$var$log() {
    if (!$1135f1bbdfff0a4d$var$DEBUG) return;
    // eslint-disable-next-line no-console
    console.log(...arguments);
}
const $1135f1bbdfff0a4d$var$noop = ()=>{};
module.exports.noop = $1135f1bbdfff0a4d$var$noop;

});
parcelRegister("91jqs", function(module, exports) {
// this file was prevaled
module.exports = function fastRGLPropsEqual(a, b, isEqualImpl) {
    if (a === b) return true;
    return a.className === b.className && isEqualImpl(a.style, b.style) && a.width === b.width && a.autoSize === b.autoSize && a.cols === b.cols && a.draggableCancel === b.draggableCancel && a.draggableHandle === b.draggableHandle && isEqualImpl(a.verticalCompact, b.verticalCompact) && isEqualImpl(a.compactType, b.compactType) && isEqualImpl(a.layout, b.layout) && isEqualImpl(a.margin, b.margin) && isEqualImpl(a.containerPadding, b.containerPadding) && a.rowHeight === b.rowHeight && a.maxRows === b.maxRows && a.isBounded === b.isBounded && a.isDraggable === b.isDraggable && a.isResizable === b.isResizable && a.allowOverlap === b.allowOverlap && a.preventCollision === b.preventCollision && a.useCSSTransforms === b.useCSSTransforms && a.transformScale === b.transformScale && a.isDroppable === b.isDroppable && isEqualImpl(a.resizeHandles, b.resizeHandles) && isEqualImpl(a.resizeHandle, b.resizeHandle) && a.onLayoutChange === b.onLayoutChange && a.onDragStart === b.onDragStart && a.onDrag === b.onDrag && a.onDragStop === b.onDragStop && a.onResizeStart === b.onResizeStart && a.onResize === b.onResize && a.onResizeStop === b.onResizeStop && a.onDrop === b.onDrop && isEqualImpl(a.droppingItem, b.droppingItem) && isEqualImpl(a.innerRef, b.innerRef);
};

});


parcelRegister("6AOui", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calcGridColWidth = $4ccd44aae118abd4$var$calcGridColWidth;
module.exports.calcGridItemPosition = $4ccd44aae118abd4$var$calcGridItemPosition;
module.exports.calcGridItemWHPx = $4ccd44aae118abd4$var$calcGridItemWHPx;
module.exports.calcWH = $4ccd44aae118abd4$var$calcWH;
module.exports.calcXY = $4ccd44aae118abd4$var$calcXY;
module.exports.clamp = $4ccd44aae118abd4$var$clamp;
/*:: import type { Position } from "./utils";*/ /*:: export type PositionParams = {
  margin: [number, number],
  containerPadding: [number, number],
  containerWidth: number,
  cols: number,
  rowHeight: number,
  maxRows: number
};*/ // Helper for generating column width
function $4ccd44aae118abd4$var$calcGridColWidth(positionParams /*: PositionParams*/ ) /*: number*/ {
    const { margin: margin, containerPadding: containerPadding, containerWidth: containerWidth, cols: cols } = positionParams;
    return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
}
// This can either be called:
// calcGridItemWHPx(w, colWidth, margin[0])
// or
// calcGridItemWHPx(h, rowHeight, margin[1])
function $4ccd44aae118abd4$var$calcGridItemWHPx(gridUnits /*: number*/ , colOrRowSize /*: number*/ , marginPx /*: number*/ ) /*: number*/ {
    // 0 * Infinity === NaN, which causes problems with resize contraints
    if (!Number.isFinite(gridUnits)) return gridUnits;
    return Math.round(colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx);
}
/**
 * Return position on the page given an x, y, w, h.
 * left, top, width, height are all in pixels.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number}  x                      X coordinate in grid units.
 * @param  {Number}  y                      Y coordinate in grid units.
 * @param  {Number}  w                      W coordinate in grid units.
 * @param  {Number}  h                      H coordinate in grid units.
 * @return {Position}                       Object containing coords.
 */ function $4ccd44aae118abd4$var$calcGridItemPosition(positionParams /*: PositionParams*/ , x /*: number*/ , y /*: number*/ , w /*: number*/ , h /*: number*/ , state /*: ?Object*/ ) /*: Position*/ {
    const { margin: margin, containerPadding: containerPadding, rowHeight: rowHeight } = positionParams;
    const colWidth = $4ccd44aae118abd4$var$calcGridColWidth(positionParams);
    const out = {};
    // If resizing, use the exact width and height as returned from resizing callbacks.
    if (state && state.resizing) {
        out.width = Math.round(state.resizing.width);
        out.height = Math.round(state.resizing.height);
    } else {
        out.width = $4ccd44aae118abd4$var$calcGridItemWHPx(w, colWidth, margin[0]);
        out.height = $4ccd44aae118abd4$var$calcGridItemWHPx(h, rowHeight, margin[1]);
    }
    // If dragging, use the exact width and height as returned from dragging callbacks.
    if (state && state.dragging) {
        out.top = Math.round(state.dragging.top);
        out.left = Math.round(state.dragging.left);
    } else if (state && state.resizing && typeof state.resizing.top === "number" && typeof state.resizing.left === "number") {
        out.top = Math.round(state.resizing.top);
        out.left = Math.round(state.resizing.left);
    } else {
        out.top = Math.round((rowHeight + margin[1]) * y + containerPadding[1]);
        out.left = Math.round((colWidth + margin[0]) * x + containerPadding[0]);
    }
    return out;
}
/**
 * Translate x and y coordinates from pixels to grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number} top                     Top position (relative to parent) in pixels.
 * @param  {Number} left                    Left position (relative to parent) in pixels.
 * @param  {Number} w                       W coordinate in grid units.
 * @param  {Number} h                       H coordinate in grid units.
 * @return {Object}                         x and y in grid units.
 */ function $4ccd44aae118abd4$var$calcXY(positionParams /*: PositionParams*/ , top /*: number*/ , left /*: number*/ , w /*: number*/ , h /*: number*/ ) /*: { x: number, y: number }*/ {
    const { margin: margin, containerPadding: containerPadding, cols: cols, rowHeight: rowHeight, maxRows: maxRows } = positionParams;
    const colWidth = $4ccd44aae118abd4$var$calcGridColWidth(positionParams);
    // left = containerPaddingX + x * (colWidth + marginX)
    // x * (colWidth + marginX) = left - containerPaddingX
    // x = (left - containerPaddingX) / (colWidth + marginX)
    let x = Math.round((left - containerPadding[0]) / (colWidth + margin[0]));
    let y = Math.round((top - containerPadding[1]) / (rowHeight + margin[1]));
    // Capping
    x = $4ccd44aae118abd4$var$clamp(x, 0, cols - w);
    y = $4ccd44aae118abd4$var$clamp(y, 0, maxRows - h);
    return {
        x: x,
        y: y
    };
}
/**
 * Given a height and width in pixel values, calculate grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calcluations.
 * @param  {Number} height                  Height in pixels.
 * @param  {Number} width                   Width in pixels.
 * @param  {Number} x                       X coordinate in grid units.
 * @param  {Number} y                       Y coordinate in grid units.
 * @param {String} handle Resize Handle.
 * @return {Object}                         w, h as grid units.
 */ function $4ccd44aae118abd4$var$calcWH(positionParams /*: PositionParams*/ , width /*: number*/ , height /*: number*/ , x /*: number*/ , y /*: number*/ , handle /*: string*/ ) /*: { w: number, h: number }*/ {
    const { margin: margin, maxRows: maxRows, cols: cols, rowHeight: rowHeight } = positionParams;
    const colWidth = $4ccd44aae118abd4$var$calcGridColWidth(positionParams);
    // width = colWidth * w - (margin * (w - 1))
    // ...
    // w = (width + margin) / (colWidth + margin)
    let w = Math.round((width + margin[0]) / (colWidth + margin[0]));
    let h = Math.round((height + margin[1]) / (rowHeight + margin[1]));
    // Capping
    let _w = $4ccd44aae118abd4$var$clamp(w, 0, cols - x);
    let _h = $4ccd44aae118abd4$var$clamp(h, 0, maxRows - y);
    if ([
        "sw",
        "w",
        "nw"
    ].indexOf(handle) !== -1) _w = $4ccd44aae118abd4$var$clamp(w, 0, cols);
    if ([
        "nw",
        "n",
        "ne"
    ].indexOf(handle) !== -1) _h = $4ccd44aae118abd4$var$clamp(h, 0, maxRows);
    return {
        w: _w,
        h: _h
    };
}
// Similar to _.clamp
function $4ccd44aae118abd4$var$clamp(num /*: number*/ , lowerBound /*: number*/ , upperBound /*: number*/ ) /*: number*/ {
    return Math.max(Math.min(num, upperBound), lowerBound);
}

});

parcelRegister("j2P7Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddd5dd286e231b8b$var$_react = $ddd5dd286e231b8b$var$_interopRequireDefault((parcelRequire("8NFma")));

var $2pmb0 = parcelRequire("2pmb0");

var $ddd5dd286e231b8b$var$_propTypes = $ddd5dd286e231b8b$var$_interopRequireDefault((parcelRequire("fb0st")));

var $i1C30 = parcelRequire("i1C30");

var $l8TeM = parcelRequire("l8TeM");

var $1tBXw = parcelRequire("1tBXw");

var $6AOui = parcelRequire("6AOui");

var $bPL40 = parcelRequire("bPL40");

var $ddd5dd286e231b8b$var$_clsx = $ddd5dd286e231b8b$var$_interopRequireDefault((parcelRequire("ase04")));
function $ddd5dd286e231b8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $ddd5dd286e231b8b$var$_defineProperty(e, r, t) {
    return (r = $ddd5dd286e231b8b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ddd5dd286e231b8b$var$_toPropertyKey(t) {
    var i = $ddd5dd286e231b8b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ddd5dd286e231b8b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type { Element as ReactElement, Node as ReactNode } from "react";*/ /*:: import type {
  ReactDraggableCallbackData,
  GridDragEvent,
  GridResizeEvent,
  DroppingPosition,
  Position,
  ResizeHandleAxis
} from "./utils";*/ /*:: import type { PositionParams } from "./calculateUtils";*/ /*:: import type { ResizeHandle, ReactRef } from "./ReactGridLayoutPropTypes";*/ /*:: type PartialPosition = { top: number, left: number };*/ /*:: type GridItemCallback<Data: GridDragEvent | GridResizeEvent> = (
  i: string,
  w: number,
  h: number,
  Data
) => void;*/ /*:: type ResizeCallbackData = {
  node: HTMLElement,
  size: Position,
  handle: ResizeHandleAxis
};*/ /*:: type GridItemResizeCallback = (
  e: Event,
  data: ResizeCallbackData,
  position: Position
) => void;*/ /*:: type State = {
  resizing: ?{ top: number, left: number, width: number, height: number },
  dragging: ?{ top: number, left: number },
  className: string
};*/ /*:: type Props = {
  children: ReactElement<any>,
  cols: number,
  containerWidth: number,
  margin: [number, number],
  containerPadding: [number, number],
  rowHeight: number,
  maxRows: number,
  isDraggable: boolean,
  isResizable: boolean,
  isBounded: boolean,
  static?: boolean,
  useCSSTransforms?: boolean,
  usePercentages?: boolean,
  transformScale: number,
  droppingPosition?: DroppingPosition,

  className: string,
  style?: Object,
  // Draggability
  cancel: string,
  handle: string,

  x: number,
  y: number,
  w: number,
  h: number,

  minW: number,
  maxW: number,
  minH: number,
  maxH: number,
  i: string,

  resizeHandles?: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,

  onDrag?: GridItemCallback<GridDragEvent>,
  onDragStart?: GridItemCallback<GridDragEvent>,
  onDragStop?: GridItemCallback<GridDragEvent>,
  onResize?: GridItemCallback<GridResizeEvent>,
  onResizeStart?: GridItemCallback<GridResizeEvent>,
  onResizeStop?: GridItemCallback<GridResizeEvent>
};*/ /*:: type DefaultProps = {
  className: string,
  cancel: string,
  handle: string,
  minH: number,
  minW: number,
  maxH: number,
  maxW: number,
  transformScale: number
};*/ /**
 * An individual item within a ReactGridLayout.
 */ class $ddd5dd286e231b8b$var$GridItem extends $ddd5dd286e231b8b$var$_react.default.Component /*:: <Props, State>*/  {
    constructor(){
        super(...arguments);
        $ddd5dd286e231b8b$var$_defineProperty(this, "state", {
            resizing: null,
            dragging: null,
            className: ""
        });
        $ddd5dd286e231b8b$var$_defineProperty(this, "elementRef", /*#__PURE__*/ $ddd5dd286e231b8b$var$_react.default.createRef());
        /**
     * onDragStart event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $ddd5dd286e231b8b$var$_defineProperty(this, "onDragStart", (e, _ref)=>{
            let { node: node } = _ref;
            const { onDragStart: onDragStart, transformScale: transformScale } = this.props;
            if (!onDragStart) return;
            const newPosition /*: PartialPosition*/  = {
                top: 0,
                left: 0
            };
            // TODO: this wont work on nested parents
            const { offsetParent: offsetParent } = node;
            if (!offsetParent) return;
            const parentRect = offsetParent.getBoundingClientRect();
            const clientRect = node.getBoundingClientRect();
            const cLeft = clientRect.left / transformScale;
            const pLeft = parentRect.left / transformScale;
            const cTop = clientRect.top / transformScale;
            const pTop = parentRect.top / transformScale;
            newPosition.left = cLeft - pLeft + offsetParent.scrollLeft;
            newPosition.top = cTop - pTop + offsetParent.scrollTop;
            this.setState({
                dragging: newPosition
            });
            // Call callback with this data
            const { x: x, y: y } = (0, $6AOui.calcXY)(this.getPositionParams(), newPosition.top, newPosition.left, this.props.w, this.props.h);
            return onDragStart.call(this, this.props.i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onDrag event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     * @param  {boolean} dontFlush    if true, will not call flushSync
     */ $ddd5dd286e231b8b$var$_defineProperty(this, "onDrag", (e, _ref2, dontFlush)=>{
            let { node: node, deltaX: deltaX, deltaY: deltaY } = _ref2;
            const { onDrag: onDrag } = this.props;
            if (!onDrag) return;
            if (!this.state.dragging) throw new Error("onDrag called before onDragStart.");
            let top = this.state.dragging.top + deltaY;
            let left = this.state.dragging.left + deltaX;
            const { isBounded: isBounded, i: i, w: w, h: h, containerWidth: containerWidth } = this.props;
            const positionParams = this.getPositionParams();
            // Boundary calculations; keeps items within the grid
            if (isBounded) {
                const { offsetParent: offsetParent } = node;
                if (offsetParent) {
                    const { margin: margin, rowHeight: rowHeight } = this.props;
                    const bottomBoundary = offsetParent.clientHeight - (0, $6AOui.calcGridItemWHPx)(h, rowHeight, margin[1]);
                    top = (0, $6AOui.clamp)(top, 0, bottomBoundary);
                    const colWidth = (0, $6AOui.calcGridColWidth)(positionParams);
                    const rightBoundary = containerWidth - (0, $6AOui.calcGridItemWHPx)(w, colWidth, margin[0]);
                    left = (0, $6AOui.clamp)(left, 0, rightBoundary);
                }
            }
            const newPosition /*: PartialPosition*/  = {
                top: top,
                left: left
            };
            // dontFlush is set if we're calling from inside
            if (dontFlush) this.setState({
                dragging: newPosition
            });
            else (0, $2pmb0.flushSync)(()=>{
                this.setState({
                    dragging: newPosition
                });
            });
            // Call callback with this data
            const { x: x, y: y } = (0, $6AOui.calcXY)(positionParams, top, left, w, h);
            return onDrag.call(this, i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onDragStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ $ddd5dd286e231b8b$var$_defineProperty(this, "onDragStop", (e, _ref3)=>{
            let { node: node } = _ref3;
            const { onDragStop: onDragStop } = this.props;
            if (!onDragStop) return;
            if (!this.state.dragging) throw new Error("onDragEnd called before onDragStart.");
            const { w: w, h: h, i: i } = this.props;
            const { left: left, top: top } = this.state.dragging;
            const newPosition /*: PartialPosition*/  = {
                top: top,
                left: left
            };
            this.setState({
                dragging: null
            });
            const { x: x, y: y } = (0, $6AOui.calcXY)(this.getPositionParams(), top, left, w, h);
            return onDragStop.call(this, i, x, y, {
                e: e,
                node: node,
                newPosition: newPosition
            });
        });
        /**
     * onResizeStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node and size information
     */ $ddd5dd286e231b8b$var$_defineProperty(this, "onResizeStop", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStop"));
        // onResizeStart event handler
        $ddd5dd286e231b8b$var$_defineProperty(this, "onResizeStart", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStart"));
        // onResize event handler
        $ddd5dd286e231b8b$var$_defineProperty(this, "onResize", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResize"));
    }
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        // We can't deeply compare children. If the developer memoizes them, we can
        // use this optimization.
        if (this.props.children !== nextProps.children) return true;
        if (this.props.droppingPosition !== nextProps.droppingPosition) return true;
        // TODO memoize these calculations so they don't take so long?
        const oldPosition = (0, $6AOui.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state);
        const newPosition = (0, $6AOui.calcGridItemPosition)(this.getPositionParams(nextProps), nextProps.x, nextProps.y, nextProps.w, nextProps.h, nextState);
        return !(0, $1tBXw.fastPositionEqual)(oldPosition, newPosition) || this.props.useCSSTransforms !== nextProps.useCSSTransforms;
    }
    componentDidMount() {
        this.moveDroppingItem({});
    }
    componentDidUpdate(prevProps /*: Props*/ ) {
        this.moveDroppingItem(prevProps);
    }
    // When a droppingPosition is present, this means we should fire a move event, as if we had moved
    // this element by `x, y` pixels.
    moveDroppingItem(prevProps /*: Props*/ ) {
        const { droppingPosition: droppingPosition } = this.props;
        if (!droppingPosition) return;
        const node = this.elementRef.current;
        // Can't find DOM node (are we unmounted?)
        if (!node) return;
        const prevDroppingPosition = prevProps.droppingPosition || {
            left: 0,
            top: 0
        };
        const { dragging: dragging } = this.state;
        const shouldDrag = dragging && droppingPosition.left !== prevDroppingPosition.left || droppingPosition.top !== prevDroppingPosition.top;
        if (!dragging) this.onDragStart(droppingPosition.e, {
            node: node,
            deltaX: droppingPosition.left,
            deltaY: droppingPosition.top
        });
        else if (shouldDrag) {
            const deltaX = droppingPosition.left - dragging.left;
            const deltaY = droppingPosition.top - dragging.top;
            this.onDrag(droppingPosition.e, {
                node: node,
                deltaX: deltaX,
                deltaY: deltaY
            }, true // dontFLush: avoid flushSync to temper warnings
            );
        }
    }
    getPositionParams() /*: PositionParams*/ {
        let props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        return {
            cols: props.cols,
            containerPadding: props.containerPadding,
            containerWidth: props.containerWidth,
            margin: props.margin,
            maxRows: props.maxRows,
            rowHeight: props.rowHeight
        };
    }
    /**
   * This is where we set the grid item's absolute placement. It gets a little tricky because we want to do it
   * well when server rendering, and the only way to do that properly is to use percentage width/left because
   * we don't know exactly what the browser viewport is.
   * Unfortunately, CSS Transforms, which are great for performance, break in this instance because a percentage
   * left is relative to the item itself, not its container! So we cannot use them on the server rendering pass.
   *
   * @param  {Object} pos Position object with width, height, left, top.
   * @return {Object}     Style object.
   */ createStyle(pos /*: Position*/ ) /*: { [key: string]: ?string }*/ {
        const { usePercentages: usePercentages, containerWidth: containerWidth, useCSSTransforms: useCSSTransforms } = this.props;
        let style;
        // CSS Transforms support (default)
        if (useCSSTransforms) style = (0, $1tBXw.setTransform)(pos);
        else {
            // top,left (slow)
            style = (0, $1tBXw.setTopLeft)(pos);
            // This is used for server rendering.
            if (usePercentages) {
                style.left = (0, $1tBXw.perc)(pos.left / containerWidth);
                style.width = (0, $1tBXw.perc)(pos.width / containerWidth);
            }
        }
        return style;
    }
    /**
   * Mix a Draggable instance into a child.
   * @param  {Element} child    Child element.
   * @return {Element}          Child wrapped in Draggable.
   */ mixinDraggable(child /*: ReactElement<any>*/ , isDraggable /*: boolean*/ ) /*: ReactElement<any>*/ {
        return /*#__PURE__*/ $ddd5dd286e231b8b$var$_react.default.createElement($i1C30.DraggableCore, {
            disabled: !isDraggable,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop,
            handle: this.props.handle,
            cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
            scale: this.props.transformScale,
            nodeRef: this.elementRef
        }, child);
    }
    /**
   * Utility function to setup callback handler definitions for
   * similarily structured resize events.
   */ curryResizeHandler(position /*: Position*/ , handler /*: Function*/ ) /*: Function*/ {
        return (e /*: Event*/ , data /*: ResizeCallbackData*/ )=>/*: Function*/ handler(e, data, position);
    }
    /**
   * Mix a Resizable instance into a child.
   * @param  {Element} child    Child element.
   * @param  {Object} position  Position object (pixel values)
   * @return {Element}          Child wrapped in Resizable.
   */ mixinResizable(child /*: ReactElement<any>*/ , position /*: Position*/ , isResizable /*: boolean*/ ) /*: ReactElement<any>*/ {
        const { cols: cols, minW: minW, minH: minH, maxW: maxW, maxH: maxH, transformScale: transformScale, resizeHandles: resizeHandles, resizeHandle: resizeHandle } = this.props;
        const positionParams = this.getPositionParams();
        // This is the max possible width - doesn't go to infinity because of the width of the window
        const maxWidth = (0, $6AOui.calcGridItemPosition)(positionParams, 0, 0, cols, 0).width;
        // Calculate min/max constraints using our min & maxes
        const mins = (0, $6AOui.calcGridItemPosition)(positionParams, 0, 0, minW, minH);
        const maxes = (0, $6AOui.calcGridItemPosition)(positionParams, 0, 0, maxW, maxH);
        const minConstraints = [
            mins.width,
            mins.height
        ];
        const maxConstraints = [
            Math.min(maxes.width, maxWidth),
            Math.min(maxes.height, Infinity)
        ];
        return /*#__PURE__*/ $ddd5dd286e231b8b$var$_react.default.createElement($l8TeM.Resizable, {
            draggableOpts: {
                disabled: !isResizable
            },
            className: isResizable ? undefined : "react-resizable-hide",
            width: position.width,
            height: position.height,
            minConstraints: minConstraints,
            maxConstraints: maxConstraints,
            onResizeStop: this.curryResizeHandler(position, this.onResizeStop),
            onResizeStart: this.curryResizeHandler(position, this.onResizeStart),
            onResize: this.curryResizeHandler(position, this.onResize),
            transformScale: transformScale,
            resizeHandles: resizeHandles,
            handle: resizeHandle
        }, child);
    }
    /**
   * Wrapper around resize events to provide more useful data.
   */ onResizeHandler(e /*: Event*/ , _ref4 /*:: */ , // 'size' is updated position
    position /*: Position*/ , // existing position
    handlerName /*: string*/ ) /*: void*/ {
        let { node: node, size: size, handle: handle } /*: ResizeCallbackData*/  = _ref4 /*: ResizeCallbackData*/ ;
        const handler = this.props[handlerName];
        if (!handler) return;
        const { x: x, y: y, i: i, maxH: maxH, minH: minH, containerWidth: containerWidth } = this.props;
        const { minW: minW, maxW: maxW } = this.props;
        // Clamping of dimensions based on resize direction
        let updatedSize = size;
        if (node) {
            updatedSize = (0, $1tBXw.resizeItemInDirection)(handle, position, size, containerWidth);
            (0, $2pmb0.flushSync)(()=>{
                this.setState({
                    resizing: handlerName === "onResizeStop" ? null : updatedSize
                });
            });
        }
        // Get new XY based on pixel size
        let { w: w, h: h } = (0, $6AOui.calcWH)(this.getPositionParams(), updatedSize.width, updatedSize.height, x, y, handle);
        // Min/max capping.
        // minW should be at least 1 (TODO propTypes validation?)
        w = (0, $6AOui.clamp)(w, Math.max(minW, 1), maxW);
        h = (0, $6AOui.clamp)(h, minH, maxH);
        handler.call(this, i, w, h, {
            e: e,
            node: node,
            size: updatedSize,
            handle: handle
        });
    }
    render() /*: ReactNode*/ {
        const { x: x, y: y, w: w, h: h, isDraggable: isDraggable, isResizable: isResizable, droppingPosition: droppingPosition, useCSSTransforms: useCSSTransforms } = this.props;
        const pos = (0, $6AOui.calcGridItemPosition)(this.getPositionParams(), x, y, w, h, this.state);
        const child = $ddd5dd286e231b8b$var$_react.default.Children.only(this.props.children);
        // Create the child element. We clone the existing element but modify its className and style.
        let newChild = /*#__PURE__*/ $ddd5dd286e231b8b$var$_react.default.cloneElement(child, {
            ref: this.elementRef,
            className: (0, $ddd5dd286e231b8b$var$_clsx.default)("react-grid-item", child.props.className, this.props.className, {
                static: this.props.static,
                resizing: Boolean(this.state.resizing),
                "react-draggable": isDraggable,
                "react-draggable-dragging": Boolean(this.state.dragging),
                dropping: Boolean(droppingPosition),
                cssTransforms: useCSSTransforms
            }),
            // We can set the width and height on the child, but unfortunately we can't set the position.
            style: {
                ...this.props.style,
                ...child.props.style,
                ...this.createStyle(pos)
            }
        });
        // Resizable support. This is usually on but the user can toggle it off.
        newChild = this.mixinResizable(newChild, pos, isResizable);
        // Draggable support. This is always on, except for with placeholders.
        newChild = this.mixinDraggable(newChild, isDraggable);
        return newChild;
    }
}
module.exports.default = $ddd5dd286e231b8b$var$GridItem;
$ddd5dd286e231b8b$var$_defineProperty($ddd5dd286e231b8b$var$GridItem, "propTypes", {
    // Children must be only a single element
    children: $ddd5dd286e231b8b$var$_propTypes.default.element,
    // General grid attributes
    cols: $ddd5dd286e231b8b$var$_propTypes.default.number.isRequired,
    containerWidth: $ddd5dd286e231b8b$var$_propTypes.default.number.isRequired,
    rowHeight: $ddd5dd286e231b8b$var$_propTypes.default.number.isRequired,
    margin: $ddd5dd286e231b8b$var$_propTypes.default.array.isRequired,
    maxRows: $ddd5dd286e231b8b$var$_propTypes.default.number.isRequired,
    containerPadding: $ddd5dd286e231b8b$var$_propTypes.default.array.isRequired,
    // These are all in grid units
    x: $ddd5dd286e231b8b$var$_propTypes.default.number.isRequired,
    y: $ddd5dd286e231b8b$var$_propTypes.default.number.isRequired,
    w: $ddd5dd286e231b8b$var$_propTypes.default.number.isRequired,
    h: $ddd5dd286e231b8b$var$_propTypes.default.number.isRequired,
    // All optional
    minW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minWidth not Number");
        if (value > props.w || value > props.maxW) return new Error("minWidth larger than item width/maxWidth");
    },
    maxW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxWidth not Number");
        if (value < props.w || value < props.minW) return new Error("maxWidth smaller than item width/minWidth");
    },
    minH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minHeight not Number");
        if (value > props.h || value > props.maxH) return new Error("minHeight larger than item height/maxHeight");
    },
    maxH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxHeight not Number");
        if (value < props.h || value < props.minH) return new Error("maxHeight smaller than item height/minHeight");
    },
    // ID is nice to have for callbacks
    i: $ddd5dd286e231b8b$var$_propTypes.default.string.isRequired,
    // Resize handle options
    resizeHandles: $bPL40.resizeHandleAxesType,
    resizeHandle: $bPL40.resizeHandleType,
    // Functions
    onDragStop: $ddd5dd286e231b8b$var$_propTypes.default.func,
    onDragStart: $ddd5dd286e231b8b$var$_propTypes.default.func,
    onDrag: $ddd5dd286e231b8b$var$_propTypes.default.func,
    onResizeStop: $ddd5dd286e231b8b$var$_propTypes.default.func,
    onResizeStart: $ddd5dd286e231b8b$var$_propTypes.default.func,
    onResize: $ddd5dd286e231b8b$var$_propTypes.default.func,
    // Flags
    isDraggable: $ddd5dd286e231b8b$var$_propTypes.default.bool.isRequired,
    isResizable: $ddd5dd286e231b8b$var$_propTypes.default.bool.isRequired,
    isBounded: $ddd5dd286e231b8b$var$_propTypes.default.bool.isRequired,
    static: $ddd5dd286e231b8b$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $ddd5dd286e231b8b$var$_propTypes.default.bool.isRequired,
    transformScale: $ddd5dd286e231b8b$var$_propTypes.default.number,
    // Others
    className: $ddd5dd286e231b8b$var$_propTypes.default.string,
    // Selector for draggable handle
    handle: $ddd5dd286e231b8b$var$_propTypes.default.string,
    // Selector for draggable cancel (see react-draggable)
    cancel: $ddd5dd286e231b8b$var$_propTypes.default.string,
    // Current position of a dropping element
    droppingPosition: $ddd5dd286e231b8b$var$_propTypes.default.shape({
        e: $ddd5dd286e231b8b$var$_propTypes.default.object.isRequired,
        left: $ddd5dd286e231b8b$var$_propTypes.default.number.isRequired,
        top: $ddd5dd286e231b8b$var$_propTypes.default.number.isRequired
    })
});
$ddd5dd286e231b8b$var$_defineProperty($ddd5dd286e231b8b$var$GridItem, "defaultProps", {
    className: "",
    cancel: "",
    handle: "",
    minH: 1,
    minW: 1,
    maxH: Infinity,
    maxW: Infinity,
    transformScale: 1
});

});
parcelRegister("fb0st", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0c83d16b421d7f5$var$ReactIs, $b0c83d16b421d7f5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("6DzO8"))();

});
parcelRegister("6DzO8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $iz60K = parcelRequire("iz60K");
function $4d52293a79bcab4c$var$emptyFunction() {}
function $4d52293a79bcab4c$var$emptyFunctionWithReset() {}
$4d52293a79bcab4c$var$emptyFunctionWithReset.resetWarningCache = $4d52293a79bcab4c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iz60K) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4d52293a79bcab4c$var$emptyFunctionWithReset,
        resetWarningCache: $4d52293a79bcab4c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iz60K", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $d840288929500773$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $d840288929500773$var$ReactPropTypesSecret;

});



parcelRegister("i1C30", function(module, exports) {
"use strict";

var $luRuI = parcelRequire("luRuI");
var $d1f5d571fb6f90be$require$Draggable = $luRuI.default;
var $d1f5d571fb6f90be$require$DraggableCore = $luRuI.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = $d1f5d571fb6f90be$require$Draggable;
module.exports.default = $d1f5d571fb6f90be$require$Draggable;
module.exports.DraggableCore = $d1f5d571fb6f90be$require$DraggableCore;

});
parcelRegister("luRuI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return $fa65e52d4ea8ce24$var$_DraggableCore.default;
    }
});
module.exports.default = void 0;

var $fa65e52d4ea8ce24$var$React = $fa65e52d4ea8ce24$var$_interopRequireWildcard((parcelRequire("8NFma")));

var $fa65e52d4ea8ce24$var$_propTypes = $fa65e52d4ea8ce24$var$_interopRequireDefault((parcelRequire("fb0st")));

var $fa65e52d4ea8ce24$var$_reactDom = $fa65e52d4ea8ce24$var$_interopRequireDefault((parcelRequire("2pmb0")));

var $ase04 = parcelRequire("ase04");

var $9rcUN = parcelRequire("9rcUN");

var $5KHua = parcelRequire("5KHua");

var $btrc5 = parcelRequire("btrc5");

var $fa65e52d4ea8ce24$var$_DraggableCore = $fa65e52d4ea8ce24$var$_interopRequireDefault((parcelRequire("gzmyL")));

var $fa65e52d4ea8ce24$var$_log = $fa65e52d4ea8ce24$var$_interopRequireDefault((parcelRequire("llTz0")));
function $fa65e52d4ea8ce24$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $fa65e52d4ea8ce24$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($fa65e52d4ea8ce24$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $fa65e52d4ea8ce24$var$_extends() {
    return $fa65e52d4ea8ce24$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fa65e52d4ea8ce24$var$_extends.apply(null, arguments);
}
function $fa65e52d4ea8ce24$var$_defineProperty(e, r, t) {
    return (r = $fa65e52d4ea8ce24$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fa65e52d4ea8ce24$var$_toPropertyKey(t) {
    var i = $fa65e52d4ea8ce24$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fa65e52d4ea8ce24$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class $fa65e52d4ea8ce24$var$Draggable extends $fa65e52d4ea8ce24$var$React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position: position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition: prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, $fa65e52d4ea8ce24$var$_log.default)('Draggable: getDerivedStateFromProps %j', {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        $fa65e52d4ea8ce24$var$_defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, $fa65e52d4ea8ce24$var$_log.default)('Draggable: onDragStart: %j', coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, $5KHua.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        $fa65e52d4ea8ce24$var$_defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, $fa65e52d4ea8ce24$var$_log.default)('Draggable: onDrag: %j', coreData);
            const uiData = (0, $5KHua.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x: x, y: y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, $5KHua.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        $fa65e52d4ea8ce24$var$_defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, $5KHua.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, $fa65e52d4ea8ce24$var$_log.default)('Draggable: onDragStop: %j', coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        if (this.state.dragging) this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        return this.props?.nodeRef?.current ?? $fa65e52d4ea8ce24$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, $5KHua.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, $5KHua.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, $9rcUN.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, $9rcUN.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, $ase04.clsx)(children.props.className || '', defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $fa65e52d4ea8ce24$var$React.createElement($fa65e52d4ea8ce24$var$_DraggableCore.default, $fa65e52d4ea8ce24$var$_extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ $fa65e52d4ea8ce24$var$React.cloneElement($fa65e52d4ea8ce24$var$React.Children.only(children), {
            className: className,
            style: {
                ...children.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
}
module.exports.default = $fa65e52d4ea8ce24$var$Draggable;
$fa65e52d4ea8ce24$var$_defineProperty($fa65e52d4ea8ce24$var$Draggable, "displayName", 'Draggable');
$fa65e52d4ea8ce24$var$_defineProperty($fa65e52d4ea8ce24$var$Draggable, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...$fa65e52d4ea8ce24$var$_DraggableCore.default.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $fa65e52d4ea8ce24$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $fa65e52d4ea8ce24$var$_propTypes.default.oneOfType([
        $fa65e52d4ea8ce24$var$_propTypes.default.shape({
            left: $fa65e52d4ea8ce24$var$_propTypes.default.number,
            right: $fa65e52d4ea8ce24$var$_propTypes.default.number,
            top: $fa65e52d4ea8ce24$var$_propTypes.default.number,
            bottom: $fa65e52d4ea8ce24$var$_propTypes.default.number
        }),
        $fa65e52d4ea8ce24$var$_propTypes.default.string,
        $fa65e52d4ea8ce24$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $fa65e52d4ea8ce24$var$_propTypes.default.string,
    defaultClassNameDragging: $fa65e52d4ea8ce24$var$_propTypes.default.string,
    defaultClassNameDragged: $fa65e52d4ea8ce24$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $fa65e52d4ea8ce24$var$_propTypes.default.shape({
        x: $fa65e52d4ea8ce24$var$_propTypes.default.number,
        y: $fa65e52d4ea8ce24$var$_propTypes.default.number
    }),
    positionOffset: $fa65e52d4ea8ce24$var$_propTypes.default.shape({
        x: $fa65e52d4ea8ce24$var$_propTypes.default.oneOfType([
            $fa65e52d4ea8ce24$var$_propTypes.default.number,
            $fa65e52d4ea8ce24$var$_propTypes.default.string
        ]),
        y: $fa65e52d4ea8ce24$var$_propTypes.default.oneOfType([
            $fa65e52d4ea8ce24$var$_propTypes.default.number,
            $fa65e52d4ea8ce24$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $fa65e52d4ea8ce24$var$_propTypes.default.shape({
        x: $fa65e52d4ea8ce24$var$_propTypes.default.number,
        y: $fa65e52d4ea8ce24$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $btrc5.dontSetMe,
    style: $btrc5.dontSetMe,
    transform: $btrc5.dontSetMe
});
$fa65e52d4ea8ce24$var$_defineProperty($fa65e52d4ea8ce24$var$Draggable, "defaultProps", {
    ...$fa65e52d4ea8ce24$var$_DraggableCore.default.defaultProps,
    axis: 'both',
    bounds: false,
    defaultClassName: 'react-draggable',
    defaultClassNameDragging: 'react-draggable-dragging',
    defaultClassNameDragged: 'react-draggable-dragged',
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
});

});
parcelRegister("9rcUN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $6df0a75a925ca0af$var$addClassName;
module.exports.addEvent = $6df0a75a925ca0af$var$addEvent;
module.exports.addUserSelectStyles = $6df0a75a925ca0af$var$addUserSelectStyles;
module.exports.createCSSTransform = $6df0a75a925ca0af$var$createCSSTransform;
module.exports.createSVGTransform = $6df0a75a925ca0af$var$createSVGTransform;
module.exports.getTouch = $6df0a75a925ca0af$var$getTouch;
module.exports.getTouchIdentifier = $6df0a75a925ca0af$var$getTouchIdentifier;
module.exports.getTranslation = $6df0a75a925ca0af$var$getTranslation;
module.exports.innerHeight = $6df0a75a925ca0af$var$innerHeight;
module.exports.innerWidth = $6df0a75a925ca0af$var$innerWidth;
module.exports.matchesSelector = $6df0a75a925ca0af$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $6df0a75a925ca0af$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $6df0a75a925ca0af$var$offsetXYFromParent;
module.exports.outerHeight = $6df0a75a925ca0af$var$outerHeight;
module.exports.outerWidth = $6df0a75a925ca0af$var$outerWidth;
module.exports.removeClassName = $6df0a75a925ca0af$var$removeClassName;
module.exports.removeEvent = $6df0a75a925ca0af$var$removeEvent;
module.exports.scheduleRemoveUserSelectStyles = $6df0a75a925ca0af$var$scheduleRemoveUserSelectStyles;

var $btrc5 = parcelRequire("btrc5");

var $6df0a75a925ca0af$var$_getPrefix = $6df0a75a925ca0af$var$_interopRequireWildcard((parcelRequire("eTqt6")));
function $6df0a75a925ca0af$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($6df0a75a925ca0af$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let $6df0a75a925ca0af$var$matchesSelectorFunc = '';
function $6df0a75a925ca0af$var$matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!$6df0a75a925ca0af$var$matchesSelectorFunc) $6df0a75a925ca0af$var$matchesSelectorFunc = (0, $btrc5.findInArray)([
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $btrc5.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $btrc5.isFunction)(el[$6df0a75a925ca0af$var$matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[$6df0a75a925ca0af$var$matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function $6df0a75a925ca0af$var$matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if ($6df0a75a925ca0af$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function $6df0a75a925ca0af$var$addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
}
function $6df0a75a925ca0af$var$removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
}
function $6df0a75a925ca0af$var$outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $btrc5.int)(computedStyle.borderTopWidth);
    height += (0, $btrc5.int)(computedStyle.borderBottomWidth);
    return height;
}
function $6df0a75a925ca0af$var$outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $btrc5.int)(computedStyle.borderLeftWidth);
    width += (0, $btrc5.int)(computedStyle.borderRightWidth);
    return width;
}
function $6df0a75a925ca0af$var$innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $btrc5.int)(computedStyle.paddingTop);
    height -= (0, $btrc5.int)(computedStyle.paddingBottom);
    return height;
}
function $6df0a75a925ca0af$var$innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $btrc5.int)(computedStyle.paddingLeft);
    width -= (0, $btrc5.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $6df0a75a925ca0af$var$offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $6df0a75a925ca0af$var$createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = $6df0a75a925ca0af$var$getTranslation(controlPos, positionOffset, 'px');
    return {
        [(0, $6df0a75a925ca0af$var$_getPrefix.browserPrefixToKey)('transform', $6df0a75a925ca0af$var$_getPrefix.default)]: translation
    };
}
function $6df0a75a925ca0af$var$createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = $6df0a75a925ca0af$var$getTranslation(controlPos, positionOffset, '');
    return translation;
}
function $6df0a75a925ca0af$var$getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x: x, y: y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = `translate(${x}${unitSuffix},${y}${unitSuffix})`;
    if (positionOffset) {
        const defaultX = `${typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix}`;
        const defaultY = `${typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix}`;
        translation = `translate(${defaultX}, ${defaultY})` + translation;
    }
    return translation;
}
function $6df0a75a925ca0af$var$getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $btrc5.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, $btrc5.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function $6df0a75a925ca0af$var$getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $6df0a75a925ca0af$var$addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById('react-draggable-style-el');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.type = 'text/css';
        styleEl.id = 'react-draggable-style-el';
        styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
        styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
        doc.getElementsByTagName('head')[0].appendChild(styleEl);
    }
    if (doc.body) $6df0a75a925ca0af$var$addClassName(doc.body, 'react-draggable-transparent-selection');
}
function $6df0a75a925ca0af$var$scheduleRemoveUserSelectStyles(doc /*: ?Document*/ ) {
    // Prevent a possible "forced reflow"
    if (window.requestAnimationFrame) window.requestAnimationFrame(()=>{
        $6df0a75a925ca0af$var$removeUserSelectStyles(doc);
    });
    else $6df0a75a925ca0af$var$removeUserSelectStyles(doc);
}
function $6df0a75a925ca0af$var$removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) $6df0a75a925ca0af$var$removeClassName(doc.body, 'react-draggable-transparent-selection');
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== 'Caret') selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function $6df0a75a925ca0af$var$addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp(`(?:^|\\s)${className}(?!\\S)`))) el.className += ` ${className}`;
}
function $6df0a75a925ca0af$var$removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp(`(?:^|\\s)${className}(?!\\S)`, 'g'), '');
}

});
parcelRegister("btrc5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $85a77f4f3eb7f954$var$dontSetMe;
module.exports.findInArray = $85a77f4f3eb7f954$var$findInArray;
module.exports.int = $85a77f4f3eb7f954$var$int;
module.exports.isFunction = $85a77f4f3eb7f954$var$isFunction;
module.exports.isNum = $85a77f4f3eb7f954$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $85a77f4f3eb7f954$var$findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $85a77f4f3eb7f954$var$isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function $85a77f4f3eb7f954$var$isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === 'number' && !isNaN(num);
}
function $85a77f4f3eb7f954$var$int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function $85a77f4f3eb7f954$var$dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error(`Invalid prop ${propName} passed to ${componentName} - do not set this, set it on the child.`);
}

});

parcelRegister("eTqt6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $ad7abbd09e1a6e42$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $ad7abbd09e1a6e42$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $ad7abbd09e1a6e42$var$getPrefix;
const $ad7abbd09e1a6e42$var$prefixes = [
    'Moz',
    'Webkit',
    'O',
    'ms'
];
function $ad7abbd09e1a6e42$var$getPrefix() /*: string*/ {
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === 'undefined') return '';
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = window.document?.documentElement?.style;
    if (!style) return '';
    if (prop in style) return '';
    for(let i = 0; i < $ad7abbd09e1a6e42$var$prefixes.length; i++){
        if ($ad7abbd09e1a6e42$var$browserPrefixToKey(prop, $ad7abbd09e1a6e42$var$prefixes[i]) in style) return $ad7abbd09e1a6e42$var$prefixes[i];
    }
    return '';
}
function $ad7abbd09e1a6e42$var$browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? `${prefix}${$ad7abbd09e1a6e42$var$kebabToTitleCase(prop)}` : prop;
}
function $ad7abbd09e1a6e42$var$browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? `-${prefix.toLowerCase()}-${prop}` : prop;
}
function $ad7abbd09e1a6e42$var$kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = '';
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === '-') shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $ad7abbd09e1a6e42$var$_default = module.exports.default = $ad7abbd09e1a6e42$var$getPrefix();

});


parcelRegister("5KHua", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $4302fafb5e295bab$var$canDragX;
module.exports.canDragY = $4302fafb5e295bab$var$canDragY;
module.exports.createCoreData = $4302fafb5e295bab$var$createCoreData;
module.exports.createDraggableData = $4302fafb5e295bab$var$createDraggableData;
module.exports.getBoundPosition = $4302fafb5e295bab$var$getBoundPosition;
module.exports.getControlPosition = $4302fafb5e295bab$var$getControlPosition;
module.exports.snapToGrid = $4302fafb5e295bab$var$snapToGrid;

var $btrc5 = parcelRequire("btrc5");

var $9rcUN = parcelRequire("9rcUN");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function $4302fafb5e295bab$var$getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === 'string' ? bounds : $4302fafb5e295bab$var$cloneBounds(bounds);
    const node = $4302fafb5e295bab$var$findDOMNode(draggable);
    if (typeof bounds === 'string') {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === 'parent') boundNode = node.parentNode;
        else {
            // Flow assigns the wrong return type (Node) for getRootNode(),
            // so we cast it to one of the correct types (Element).
            // The others are Document and ShadowRoot.
            // All three implement querySelector() so it's safe to call.
            const rootNode = node.getRootNode();
            boundNode = rootNode.querySelector(bounds);
        }
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $btrc5.int)(boundNodeStyle.paddingLeft) + (0, $btrc5.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $btrc5.int)(boundNodeStyle.paddingTop) + (0, $btrc5.int)(nodeStyle.marginTop),
            right: (0, $9rcUN.innerWidth)(boundNodeEl) - (0, $9rcUN.outerWidth)(node) - node.offsetLeft + (0, $btrc5.int)(boundNodeStyle.paddingRight) - (0, $btrc5.int)(nodeStyle.marginRight),
            bottom: (0, $9rcUN.innerHeight)(boundNodeEl) - (0, $9rcUN.outerHeight)(node) - node.offsetTop + (0, $btrc5.int)(boundNodeStyle.paddingBottom) - (0, $btrc5.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, $btrc5.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $btrc5.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, $btrc5.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $btrc5.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $4302fafb5e295bab$var$snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $4302fafb5e295bab$var$canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function $4302fafb5e295bab$var$canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}
// Get {x, y} positions from event.
function $4302fafb5e295bab$var$getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === 'number' ? (0, $9rcUN.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
    const node = $4302fafb5e295bab$var$findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $9rcUN.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function $4302fafb5e295bab$var$createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, $btrc5.isNum)(draggable.lastX);
    const node = $4302fafb5e295bab$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function $4302fafb5e295bab$var$createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function $4302fafb5e295bab$var$cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $4302fafb5e295bab$var$findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error('<DraggableCore>: Unmounted during event!');
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("gzmyL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1016a22ac7aae16$var$React = $c1016a22ac7aae16$var$_interopRequireWildcard((parcelRequire("8NFma")));

var $c1016a22ac7aae16$var$_propTypes = $c1016a22ac7aae16$var$_interopRequireDefault((parcelRequire("fb0st")));

var $c1016a22ac7aae16$var$_reactDom = $c1016a22ac7aae16$var$_interopRequireDefault((parcelRequire("2pmb0")));

var $9rcUN = parcelRequire("9rcUN");

var $5KHua = parcelRequire("5KHua");

var $btrc5 = parcelRequire("btrc5");

var $c1016a22ac7aae16$var$_log = $c1016a22ac7aae16$var$_interopRequireDefault((parcelRequire("llTz0")));
function $c1016a22ac7aae16$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $c1016a22ac7aae16$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($c1016a22ac7aae16$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $c1016a22ac7aae16$var$_defineProperty(e, r, t) {
    return (r = $c1016a22ac7aae16$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c1016a22ac7aae16$var$_toPropertyKey(t) {
    var i = $c1016a22ac7aae16$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c1016a22ac7aae16$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const $c1016a22ac7aae16$var$eventsFor = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
// Default to mouse events.
let $c1016a22ac7aae16$var$dragEventFor = $c1016a22ac7aae16$var$eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  allowMobileScroll: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class $c1016a22ac7aae16$var$DraggableCore extends $c1016a22ac7aae16$var$React.Component /*:: <DraggableCoreProps>*/  {
    constructor(){
        super(...arguments);
        $c1016a22ac7aae16$var$_defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        $c1016a22ac7aae16$var$_defineProperty(this, "lastX", NaN);
        $c1016a22ac7aae16$var$_defineProperty(this, "lastY", NaN);
        $c1016a22ac7aae16$var$_defineProperty(this, "touchIdentifier", null);
        $c1016a22ac7aae16$var$_defineProperty(this, "mounted", false);
        $c1016a22ac7aae16$var$_defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error('<DraggableCore> not mounted on DragStart!');
            const { ownerDocument: ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, $9rcUN.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, $9rcUN.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === 'touchstart' && !this.props.allowMobileScroll) e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, $9rcUN.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $5KHua.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x: x, y: y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, $5KHua.createCoreData)(this, x, y);
            (0, $c1016a22ac7aae16$var$_log.default)('DraggableCore: handleDragStart: %j', coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, $c1016a22ac7aae16$var$_log.default)('calling', this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, $9rcUN.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $9rcUN.addEvent)(ownerDocument, $c1016a22ac7aae16$var$dragEventFor.move, this.handleDrag);
            (0, $9rcUN.addEvent)(ownerDocument, $c1016a22ac7aae16$var$dragEventFor.stop, this.handleDragStop);
        });
        $c1016a22ac7aae16$var$_defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $5KHua.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, $5KHua.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $5KHua.createCoreData)(this, x, y);
            (0, $c1016a22ac7aae16$var$_log.default)('DraggableCore: handleDrag: %j', coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent('mouseup'));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent('MouseEvents');
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        $c1016a22ac7aae16$var$_defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, $5KHua.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, $5KHua.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $5KHua.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, $9rcUN.scheduleRemoveUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $c1016a22ac7aae16$var$_log.default)('DraggableCore: handleDragStop: %j', coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, $c1016a22ac7aae16$var$_log.default)('DraggableCore: Removing handlers');
                (0, $9rcUN.removeEvent)(thisNode.ownerDocument, $c1016a22ac7aae16$var$dragEventFor.move, this.handleDrag);
                (0, $9rcUN.removeEvent)(thisNode.ownerDocument, $c1016a22ac7aae16$var$dragEventFor.stop, this.handleDragStop);
            }
        });
        $c1016a22ac7aae16$var$_defineProperty(this, "onMouseDown", (e)=>{
            $c1016a22ac7aae16$var$dragEventFor = $c1016a22ac7aae16$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        $c1016a22ac7aae16$var$_defineProperty(this, "onMouseUp", (e)=>{
            $c1016a22ac7aae16$var$dragEventFor = $c1016a22ac7aae16$var$eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        $c1016a22ac7aae16$var$_defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            $c1016a22ac7aae16$var$dragEventFor = $c1016a22ac7aae16$var$eventsFor.touch;
            return this.handleDragStart(e);
        });
        $c1016a22ac7aae16$var$_defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            $c1016a22ac7aae16$var$dragEventFor = $c1016a22ac7aae16$var$eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, $9rcUN.addEvent)(thisNode, $c1016a22ac7aae16$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            (0, $9rcUN.removeEvent)(ownerDocument, $c1016a22ac7aae16$var$eventsFor.mouse.move, this.handleDrag);
            (0, $9rcUN.removeEvent)(ownerDocument, $c1016a22ac7aae16$var$eventsFor.touch.move, this.handleDrag);
            (0, $9rcUN.removeEvent)(ownerDocument, $c1016a22ac7aae16$var$eventsFor.mouse.stop, this.handleDragStop);
            (0, $9rcUN.removeEvent)(ownerDocument, $c1016a22ac7aae16$var$eventsFor.touch.stop, this.handleDragStop);
            (0, $9rcUN.removeEvent)(thisNode, $c1016a22ac7aae16$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, $9rcUN.scheduleRemoveUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        return this.props?.nodeRef ? this.props?.nodeRef?.current : $c1016a22ac7aae16$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $c1016a22ac7aae16$var$React.cloneElement($c1016a22ac7aae16$var$React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
}
module.exports.default = $c1016a22ac7aae16$var$DraggableCore;
$c1016a22ac7aae16$var$_defineProperty($c1016a22ac7aae16$var$DraggableCore, "displayName", 'DraggableCore');
$c1016a22ac7aae16$var$_defineProperty($c1016a22ac7aae16$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $c1016a22ac7aae16$var$_propTypes.default.bool,
    /**
   * `allowMobileScroll` turns off cancellation of the 'touchstart' event
   * on mobile devices. Only enable this if you are having trouble with click
   * events. Prefer using 'handle' / 'cancel' instead.
   *
   * Defaults to `false`.
   */ allowMobileScroll: $c1016a22ac7aae16$var$_propTypes.default.bool,
    children: $c1016a22ac7aae16$var$_propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $c1016a22ac7aae16$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $c1016a22ac7aae16$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $c1016a22ac7aae16$var$_propTypes.default.arrayOf($c1016a22ac7aae16$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $c1016a22ac7aae16$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $c1016a22ac7aae16$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $c1016a22ac7aae16$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $c1016a22ac7aae16$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $c1016a22ac7aae16$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $c1016a22ac7aae16$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $c1016a22ac7aae16$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $c1016a22ac7aae16$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $btrc5.dontSetMe,
    style: $btrc5.dontSetMe,
    transform: $btrc5.dontSetMe
});
$c1016a22ac7aae16$var$_defineProperty($c1016a22ac7aae16$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    allowMobileScroll: false,
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

});
parcelRegister("llTz0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8b6a8f019828644$var$log;
/*eslint no-console:0*/ function $f8b6a8f019828644$var$log() {}

});




parcelRegister("l8TeM", function(module, exports) {
'use strict';
module.exports = function() {
    throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};

module.exports.Resizable = (parcelRequire("5Xcut")).default;

module.exports.ResizableBox = (parcelRequire("4vpuV")).default;

});
parcelRegister("5Xcut", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $455c26c964a85d71$export$1e511d4a378977f5, (v) => $455c26c964a85d71$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $455c26c964a85d71$export$2e2bcd8739ae039, (v) => $455c26c964a85d71$export$2e2bcd8739ae039 = v);
var $455c26c964a85d71$export$1e511d4a378977f5;
var $455c26c964a85d71$export$2e2bcd8739ae039;
"use strict";
$455c26c964a85d71$export$1e511d4a378977f5 = true;
$455c26c964a85d71$export$2e2bcd8739ae039 = void 0;

var $455c26c964a85d71$var$React = $455c26c964a85d71$var$_interopRequireWildcard((parcelRequire("8NFma")));

var $i1C30 = parcelRequire("i1C30");

var $9x1uy = parcelRequire("9x1uy");

var $dhgzR = parcelRequire("dhgzR");
var $455c26c964a85d71$var$_excluded = [
    "children",
    "className",
    "draggableOpts",
    "width",
    "height",
    "handle",
    "handleSize",
    "lockAspectRatio",
    "axis",
    "minConstraints",
    "maxConstraints",
    "onResize",
    "onResizeStop",
    "onResizeStart",
    "resizeHandles",
    "transformScale"
];
function $455c26c964a85d71$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($455c26c964a85d71$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $455c26c964a85d71$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $455c26c964a85d71$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $455c26c964a85d71$var$_extends() {
    $455c26c964a85d71$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $455c26c964a85d71$var$_extends.apply(this, arguments);
}
function $455c26c964a85d71$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $455c26c964a85d71$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $455c26c964a85d71$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $455c26c964a85d71$var$ownKeys(Object(source), !0).forEach(function(key) {
            $455c26c964a85d71$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $455c26c964a85d71$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $455c26c964a85d71$var$_defineProperty(obj, key, value) {
    key = $455c26c964a85d71$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $455c26c964a85d71$var$_toPropertyKey(arg) {
    var key = $455c26c964a85d71$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $455c26c964a85d71$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $455c26c964a85d71$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $455c26c964a85d71$var$_setPrototypeOf(subClass, superClass);
}
function $455c26c964a85d71$var$_setPrototypeOf(o, p) {
    $455c26c964a85d71$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $455c26c964a85d71$var$_setPrototypeOf(o, p);
}
// The base <Resizable> component.
// This component does not have state and relies on the parent to set its props based on callback data.
var $455c26c964a85d71$var$Resizable = /*#__PURE__*/ function(_React$Component) {
    $455c26c964a85d71$var$_inheritsLoose(Resizable, _React$Component);
    function Resizable() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handleRefs = {};
        _this.lastHandleRect = null;
        _this.slack = null;
        return _this;
    }
    var _proto = Resizable.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.resetData();
    };
    _proto.resetData = function resetData() {
        this.lastHandleRect = this.slack = null;
    };
    _proto.runConstraints = function runConstraints(width, height) {
        var _this$props = this.props, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio;
        // short circuit
        if (!minConstraints && !maxConstraints && !lockAspectRatio) return [
            width,
            height
        ];
        // If constraining to min and max, we need to also fit width and height to aspect ratio.
        if (lockAspectRatio) {
            var ratio = this.props.width / this.props.height;
            var deltaW = width - this.props.width;
            var deltaH = height - this.props.height;
            // Find which coordinate was greater and should push the other toward it.
            // E.g.:
            // ratio = 1, deltaW = 10, deltaH = 5, deltaH should become 10.
            // ratio = 2, deltaW = 10, deltaH = 6, deltaW should become 12.
            if (Math.abs(deltaW) > Math.abs(deltaH * ratio)) height = width / ratio;
            else width = height * ratio;
        }
        var oldW = width, oldH = height;
        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.
        var _ref = this.slack || [
            0,
            0
        ], slackW = _ref[0], slackH = _ref[1];
        width += slackW;
        height += slackH;
        if (minConstraints) {
            width = Math.max(minConstraints[0], width);
            height = Math.max(minConstraints[1], height);
        }
        if (maxConstraints) {
            width = Math.min(maxConstraints[0], width);
            height = Math.min(maxConstraints[1], height);
        }
        // If the width or height changed, we must have introduced some slack. Record it for the next iteration.
        this.slack = [
            slackW + (oldW - width),
            slackH + (oldH - height)
        ];
        return [
            width,
            height
        ];
    };
    _proto.resizeHandler = function resizeHandler(handlerName, axis) {
        var _this2 = this;
        return function(e, _ref2) {
            var node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
            // Reset data in case it was left over somehow (should not be possible)
            if (handlerName === 'onResizeStart') _this2.resetData();
            // Axis restrictions
            var canDragX = (_this2.props.axis === 'both' || _this2.props.axis === 'x') && axis !== 'n' && axis !== 's';
            var canDragY = (_this2.props.axis === 'both' || _this2.props.axis === 'y') && axis !== 'e' && axis !== 'w';
            // No dragging possible.
            if (!canDragX && !canDragY) return;
            // Decompose axis for later use
            var axisV = axis[0];
            var axisH = axis[axis.length - 1]; // intentionally not axis[1], so that this catches axis === 'w' for example
            // Track the element being dragged to account for changes in position.
            // If a handle's position is changed between callbacks, we need to factor this in to the next callback.
            // Failure to do so will cause the element to "skip" when resized upwards or leftwards.
            var handleRect = node.getBoundingClientRect();
            if (_this2.lastHandleRect != null) {
                // If the handle has repositioned on either axis since last render,
                // we need to increase our callback values by this much.
                // Only checking 'n', 'w' since resizing by 's', 'w' won't affect the overall position on page,
                if (axisH === 'w') {
                    var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
                    deltaX += deltaLeftSinceLast;
                }
                if (axisV === 'n') {
                    var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
                    deltaY += deltaTopSinceLast;
                }
            }
            // Storage of last rect so we know how much it has really moved.
            _this2.lastHandleRect = handleRect;
            // Reverse delta if using top or left drag handles.
            if (axisH === 'w') deltaX = -deltaX;
            if (axisV === 'n') deltaY = -deltaY;
            // Update w/h by the deltas. Also factor in transformScale.
            var width = _this2.props.width + (canDragX ? deltaX / _this2.props.transformScale : 0);
            var height = _this2.props.height + (canDragY ? deltaY / _this2.props.transformScale : 0);
            // Run user-provided constraints.
            var _this2$runConstraints = _this2.runConstraints(width, height);
            width = _this2$runConstraints[0];
            height = _this2$runConstraints[1];
            var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height;
            // Call user-supplied callback if present.
            var cb = typeof _this2.props[handlerName] === 'function' ? _this2.props[handlerName] : null;
            // Don't call 'onResize' if dimensions haven't changed.
            var shouldSkipCb = handlerName === 'onResize' && !dimensionsChanged;
            if (cb && !shouldSkipCb) {
                e.persist == null || e.persist();
                cb(e, {
                    node: node,
                    size: {
                        width: width,
                        height: height
                    },
                    handle: axis
                });
            }
            // Reset internal data
            if (handlerName === 'onResizeStop') _this2.resetData();
        };
    };
    _proto.renderResizeHandle = function renderResizeHandle(handleAxis, ref) {
        var handle = this.props.handle;
        // No handle provided, make the default
        if (!handle) return /*#__PURE__*/ $455c26c964a85d71$var$React.createElement("span", {
            className: "react-resizable-handle react-resizable-handle-" + handleAxis,
            ref: ref
        });
        // Handle is a function, such as:
        // `handle={(handleAxis) => <span className={...} />}`
        if (typeof handle === 'function') return handle(handleAxis, ref);
        // Handle is a React component (composite or DOM).
        var isDOMElement = typeof handle.type === 'string';
        var props = $455c26c964a85d71$var$_objectSpread({
            ref: ref
        }, isDOMElement ? {} : {
            handleAxis: handleAxis
        });
        return /*#__PURE__*/ $455c26c964a85d71$var$React.cloneElement(handle, props);
    };
    _proto.render = function render() {
        var _this3 = this;
        // Pass along only props not meant for the `<Resizable>`.`
        // eslint-disable-next-line no-unused-vars
        var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, draggableOpts = _this$props2.draggableOpts, width = _this$props2.width, height = _this$props2.height, handle = _this$props2.handle, handleSize = _this$props2.handleSize, lockAspectRatio = _this$props2.lockAspectRatio, axis = _this$props2.axis, minConstraints = _this$props2.minConstraints, maxConstraints = _this$props2.maxConstraints, onResize = _this$props2.onResize, onResizeStop = _this$props2.onResizeStop, onResizeStart = _this$props2.onResizeStart, resizeHandles = _this$props2.resizeHandles, transformScale = _this$props2.transformScale, p = $455c26c964a85d71$var$_objectWithoutPropertiesLoose(_this$props2, $455c26c964a85d71$var$_excluded);
        // What we're doing here is getting the child of this element, and cloning it with this element's props.
        // We are then defining its children as:
        // 1. Its original children (resizable's child's children), and
        // 2. One or more draggable handles.
        return (0, $9x1uy.cloneElement)(children, $455c26c964a85d71$var$_objectSpread($455c26c964a85d71$var$_objectSpread({}, p), {}, {
            className: (className ? className + " " : '') + "react-resizable",
            children: [].concat(children.props.children, resizeHandles.map(function(handleAxis) {
                var _this3$handleRefs$han;
                // Create a ref to the handle so that `<DraggableCore>` doesn't have to use ReactDOM.findDOMNode().
                var ref = (_this3$handleRefs$han = _this3.handleRefs[handleAxis]) != null ? _this3$handleRefs$han : _this3.handleRefs[handleAxis] = /*#__PURE__*/ $455c26c964a85d71$var$React.createRef();
                return /*#__PURE__*/ $455c26c964a85d71$var$React.createElement($i1C30.DraggableCore, $455c26c964a85d71$var$_extends({}, draggableOpts, {
                    nodeRef: ref,
                    key: "resizableHandle-" + handleAxis,
                    onStop: _this3.resizeHandler('onResizeStop', handleAxis),
                    onStart: _this3.resizeHandler('onResizeStart', handleAxis),
                    onDrag: _this3.resizeHandler('onResize', handleAxis)
                }), _this3.renderResizeHandle(handleAxis, ref));
            }))
        }));
    };
    return Resizable;
}($455c26c964a85d71$var$React.Component);
$455c26c964a85d71$export$2e2bcd8739ae039 = $455c26c964a85d71$var$Resizable;
$455c26c964a85d71$var$Resizable.propTypes = $dhgzR.resizableProps;
$455c26c964a85d71$var$Resizable.defaultProps = {
    axis: 'both',
    handleSize: [
        20,
        20
    ],
    lockAspectRatio: false,
    minConstraints: [
        20,
        20
    ],
    maxConstraints: [
        Infinity,
        Infinity
    ],
    resizeHandles: [
        'se'
    ],
    transformScale: 1
};

});
parcelRegister("9x1uy", function(module, exports) {

$parcel$export(module.exports, "cloneElement", () => $6f085a5cc10db651$export$e530037191fcd5d7, (v) => $6f085a5cc10db651$export$e530037191fcd5d7 = v);
var $6f085a5cc10db651$export$1e511d4a378977f5;
var $6f085a5cc10db651$export$e530037191fcd5d7;
"use strict";
$6f085a5cc10db651$export$1e511d4a378977f5 = true;
$6f085a5cc10db651$export$e530037191fcd5d7 = $6f085a5cc10db651$var$cloneElement;

var $6f085a5cc10db651$var$_react = $6f085a5cc10db651$var$_interopRequireDefault((parcelRequire("8NFma")));
function $6f085a5cc10db651$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f085a5cc10db651$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6f085a5cc10db651$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6f085a5cc10db651$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6f085a5cc10db651$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6f085a5cc10db651$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6f085a5cc10db651$var$_defineProperty(obj, key, value) {
    key = $6f085a5cc10db651$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6f085a5cc10db651$var$_toPropertyKey(arg) {
    var key = $6f085a5cc10db651$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $6f085a5cc10db651$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// React.addons.cloneWithProps look-alike that merges style & className.
function $6f085a5cc10db651$var$cloneElement(element, props) {
    if (props.style && element.props.style) props.style = $6f085a5cc10db651$var$_objectSpread($6f085a5cc10db651$var$_objectSpread({}, element.props.style), props.style);
    if (props.className && element.props.className) props.className = element.props.className + " " + props.className;
    return /*#__PURE__*/ $6f085a5cc10db651$var$_react.default.cloneElement(element, props);
}

});

parcelRegister("dhgzR", function(module, exports) {

$parcel$export(module.exports, "resizableProps", () => $9aa9b8cd42ca3384$export$32a002ec6a601762, (v) => $9aa9b8cd42ca3384$export$32a002ec6a601762 = v);
var $9aa9b8cd42ca3384$export$1e511d4a378977f5;
var $9aa9b8cd42ca3384$export$32a002ec6a601762;
"use strict";
$9aa9b8cd42ca3384$export$1e511d4a378977f5 = true;
$9aa9b8cd42ca3384$export$32a002ec6a601762 = void 0;

var $9aa9b8cd42ca3384$var$_propTypes = $9aa9b8cd42ca3384$var$_interopRequireDefault((parcelRequire("fb0st")));
parcelRequire("i1C30");
function $9aa9b8cd42ca3384$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9aa9b8cd42ca3384$var$resizableProps = {
    /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */ axis: $9aa9b8cd42ca3384$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    className: $9aa9b8cd42ca3384$var$_propTypes.default.string,
    /*
  * Require that one and only one child be present.
  * */ children: $9aa9b8cd42ca3384$var$_propTypes.default.element.isRequired,
    /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */ draggableOpts: $9aa9b8cd42ca3384$var$_propTypes.default.shape({
        allowAnyClick: $9aa9b8cd42ca3384$var$_propTypes.default.bool,
        cancel: $9aa9b8cd42ca3384$var$_propTypes.default.string,
        children: $9aa9b8cd42ca3384$var$_propTypes.default.node,
        disabled: $9aa9b8cd42ca3384$var$_propTypes.default.bool,
        enableUserSelectHack: $9aa9b8cd42ca3384$var$_propTypes.default.bool,
        offsetParent: $9aa9b8cd42ca3384$var$_propTypes.default.node,
        grid: $9aa9b8cd42ca3384$var$_propTypes.default.arrayOf($9aa9b8cd42ca3384$var$_propTypes.default.number),
        handle: $9aa9b8cd42ca3384$var$_propTypes.default.string,
        nodeRef: $9aa9b8cd42ca3384$var$_propTypes.default.object,
        onStart: $9aa9b8cd42ca3384$var$_propTypes.default.func,
        onDrag: $9aa9b8cd42ca3384$var$_propTypes.default.func,
        onStop: $9aa9b8cd42ca3384$var$_propTypes.default.func,
        onMouseDown: $9aa9b8cd42ca3384$var$_propTypes.default.func,
        scale: $9aa9b8cd42ca3384$var$_propTypes.default.number
    }),
    /*
  * Initial height
  * */ height: function height() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var props = args[0];
        // Required if resizing height or both
        if (props.axis === 'both' || props.axis === 'y') {
            var _PropTypes$number;
            return (_PropTypes$number = $9aa9b8cd42ca3384$var$_propTypes.default.number).isRequired.apply(_PropTypes$number, args);
        }
        return $9aa9b8cd42ca3384$var$_propTypes.default.number.apply($9aa9b8cd42ca3384$var$_propTypes.default, args);
    },
    /*
  * Customize cursor resize handle
  * */ handle: $9aa9b8cd42ca3384$var$_propTypes.default.oneOfType([
        $9aa9b8cd42ca3384$var$_propTypes.default.node,
        $9aa9b8cd42ca3384$var$_propTypes.default.func
    ]),
    /*
  * If you change this, be sure to update your css
  * */ handleSize: $9aa9b8cd42ca3384$var$_propTypes.default.arrayOf($9aa9b8cd42ca3384$var$_propTypes.default.number),
    lockAspectRatio: $9aa9b8cd42ca3384$var$_propTypes.default.bool,
    /*
  * Max X & Y measure
  * */ maxConstraints: $9aa9b8cd42ca3384$var$_propTypes.default.arrayOf($9aa9b8cd42ca3384$var$_propTypes.default.number),
    /*
  * Min X & Y measure
  * */ minConstraints: $9aa9b8cd42ca3384$var$_propTypes.default.arrayOf($9aa9b8cd42ca3384$var$_propTypes.default.number),
    /*
  * Called on stop resize event
  * */ onResizeStop: $9aa9b8cd42ca3384$var$_propTypes.default.func,
    /*
  * Called on start resize event
  * */ onResizeStart: $9aa9b8cd42ca3384$var$_propTypes.default.func,
    /*
  * Called on resize event
  * */ onResize: $9aa9b8cd42ca3384$var$_propTypes.default.func,
    /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */ resizeHandles: $9aa9b8cd42ca3384$var$_propTypes.default.arrayOf($9aa9b8cd42ca3384$var$_propTypes.default.oneOf([
        's',
        'w',
        'e',
        'n',
        'sw',
        'nw',
        'se',
        'ne'
    ])),
    /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */ transformScale: $9aa9b8cd42ca3384$var$_propTypes.default.number,
    /*
   * Initial width
   */ width: function width() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var props = args[0];
        // Required if resizing width or both
        if (props.axis === 'both' || props.axis === 'x') {
            var _PropTypes$number2;
            return (_PropTypes$number2 = $9aa9b8cd42ca3384$var$_propTypes.default.number).isRequired.apply(_PropTypes$number2, args);
        }
        return $9aa9b8cd42ca3384$var$_propTypes.default.number.apply($9aa9b8cd42ca3384$var$_propTypes.default, args);
    }
};
$9aa9b8cd42ca3384$export$32a002ec6a601762 = $9aa9b8cd42ca3384$var$resizableProps;

});


parcelRegister("4vpuV", function(module, exports) {

$parcel$export(module.exports, "default", () => $347dd602829f9305$export$2e2bcd8739ae039, (v) => $347dd602829f9305$export$2e2bcd8739ae039 = v);
var $347dd602829f9305$export$1e511d4a378977f5;
var $347dd602829f9305$export$2e2bcd8739ae039;
"use strict";
$347dd602829f9305$export$1e511d4a378977f5 = true;
$347dd602829f9305$export$2e2bcd8739ae039 = void 0;

var $347dd602829f9305$var$React = $347dd602829f9305$var$_interopRequireWildcard((parcelRequire("8NFma")));

var $347dd602829f9305$var$_propTypes = $347dd602829f9305$var$_interopRequireDefault((parcelRequire("fb0st")));

var $347dd602829f9305$var$_Resizable = $347dd602829f9305$var$_interopRequireDefault((parcelRequire("5Xcut")));

var $dhgzR = parcelRequire("dhgzR");
var $347dd602829f9305$var$_excluded = [
    "handle",
    "handleSize",
    "onResize",
    "onResizeStart",
    "onResizeStop",
    "draggableOpts",
    "minConstraints",
    "maxConstraints",
    "lockAspectRatio",
    "axis",
    "width",
    "height",
    "resizeHandles",
    "style",
    "transformScale"
];
function $347dd602829f9305$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $347dd602829f9305$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($347dd602829f9305$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $347dd602829f9305$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $347dd602829f9305$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $347dd602829f9305$var$_extends() {
    $347dd602829f9305$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $347dd602829f9305$var$_extends.apply(this, arguments);
}
function $347dd602829f9305$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $347dd602829f9305$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $347dd602829f9305$var$ownKeys(Object(source), !0).forEach(function(key) {
            $347dd602829f9305$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $347dd602829f9305$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $347dd602829f9305$var$_defineProperty(obj, key, value) {
    key = $347dd602829f9305$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $347dd602829f9305$var$_toPropertyKey(arg) {
    var key = $347dd602829f9305$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $347dd602829f9305$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $347dd602829f9305$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $347dd602829f9305$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $347dd602829f9305$var$_setPrototypeOf(subClass, superClass);
}
function $347dd602829f9305$var$_setPrototypeOf(o, p) {
    $347dd602829f9305$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $347dd602829f9305$var$_setPrototypeOf(o, p);
}
var $347dd602829f9305$var$ResizableBox = /*#__PURE__*/ function(_React$Component) {
    $347dd602829f9305$var$_inheritsLoose(ResizableBox, _React$Component);
    function ResizableBox() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            width: _this.props.width,
            height: _this.props.height,
            propsWidth: _this.props.width,
            propsHeight: _this.props.height
        };
        _this.onResize = function(e, data) {
            var size = data.size;
            if (_this.props.onResize) {
                e.persist == null || e.persist();
                _this.setState(size, function() {
                    return _this.props.onResize && _this.props.onResize(e, data);
                });
            } else _this.setState(size);
        };
        return _this;
    }
    ResizableBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        // If parent changes height/width, set that in our state.
        if (state.propsWidth !== props.width || state.propsHeight !== props.height) return {
            width: props.width,
            height: props.height,
            propsWidth: props.width,
            propsHeight: props.height
        };
        return null;
    };
    var _proto = ResizableBox.prototype;
    _proto.render = function render() {
        // Basic wrapper around a Resizable instance.
        // If you use Resizable directly, you are responsible for updating the child component
        // with a new width and height.
        var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize, onResize = _this$props.onResize, onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis, width = _this$props.width, height = _this$props.height, resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = $347dd602829f9305$var$_objectWithoutPropertiesLoose(_this$props, $347dd602829f9305$var$_excluded);
        return /*#__PURE__*/ $347dd602829f9305$var$React.createElement($347dd602829f9305$var$_Resizable.default, {
            axis: axis,
            draggableOpts: draggableOpts,
            handle: handle,
            handleSize: handleSize,
            height: this.state.height,
            lockAspectRatio: lockAspectRatio,
            maxConstraints: maxConstraints,
            minConstraints: minConstraints,
            onResizeStart: onResizeStart,
            onResize: this.onResize,
            onResizeStop: onResizeStop,
            resizeHandles: resizeHandles,
            transformScale: transformScale,
            width: this.state.width
        }, /*#__PURE__*/ $347dd602829f9305$var$React.createElement("div", $347dd602829f9305$var$_extends({}, props, {
            style: $347dd602829f9305$var$_objectSpread($347dd602829f9305$var$_objectSpread({}, style), {}, {
                width: this.state.width + 'px',
                height: this.state.height + 'px'
            })
        })));
    };
    return ResizableBox;
}($347dd602829f9305$var$React.Component);
$347dd602829f9305$export$2e2bcd8739ae039 = $347dd602829f9305$var$ResizableBox;
// PropTypes are identical to <Resizable>, except that children are not strictly required to be present.
$347dd602829f9305$var$ResizableBox.propTypes = $347dd602829f9305$var$_objectSpread($347dd602829f9305$var$_objectSpread({}, $dhgzR.resizableProps), {}, {
    children: $347dd602829f9305$var$_propTypes.default.element
});

});


parcelRegister("bPL40", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resizeHandleType = module.exports.resizeHandleAxesType = module.exports.default = void 0;

var $89d8f6f92848d24e$var$_propTypes = $89d8f6f92848d24e$var$_interopRequireDefault((parcelRequire("fb0st")));

var $89d8f6f92848d24e$var$_react = $89d8f6f92848d24e$var$_interopRequireDefault((parcelRequire("8NFma")));
function $89d8f6f92848d24e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/*:: import type {
  Ref,
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  DragOverEvent,
  EventCallback,
  CompactType,
  Layout,
  LayoutItem,
  ResizeHandleAxis
} from "./utils";*/ /*:: export type ReactRef<T: HTMLElement> = {|
  +current: T | null
|};*/ // util
/*:: export type ResizeHandle =
  | ReactElement<any>
  | ((
      resizeHandleAxis: ResizeHandleAxis,
      ref: ReactRef<HTMLElement>
    ) => ReactElement<any>);*/ // Defines which resize handles should be rendered (default: 'se')
// Allows for any combination of:
// 's' - South handle (bottom-center)
// 'w' - West handle (left-center)
// 'e' - East handle (right-center)
// 'n' - North handle (top-center)
// 'sw' - Southwest handle (bottom-left)
// 'nw' - Northwest handle (top-left)
// 'se' - Southeast handle (bottom-right)
// 'ne' - Northeast handle (top-right)
const $89d8f6f92848d24e$var$resizeHandleAxesType /*: ReactPropsChainableTypeChecker*/  = module.exports.resizeHandleAxesType = $89d8f6f92848d24e$var$_propTypes.default.arrayOf($89d8f6f92848d24e$var$_propTypes.default.oneOf([
    "s",
    "w",
    "e",
    "n",
    "sw",
    "nw",
    "se",
    "ne"
]));
// Custom component for resize handles
const $89d8f6f92848d24e$var$resizeHandleType /*: ReactPropsChainableTypeChecker*/  = module.exports.resizeHandleType = $89d8f6f92848d24e$var$_propTypes.default.oneOfType([
    $89d8f6f92848d24e$var$_propTypes.default.node,
    $89d8f6f92848d24e$var$_propTypes.default.func
]);

/*:: export type Props = {|
  className: string,
  style: Object,
  width: number,
  autoSize: boolean,
  cols: number,
  draggableCancel: string,
  draggableHandle: string,
  verticalCompact: boolean,
  compactType: CompactType,
  layout: Layout,
  margin: [number, number],
  containerPadding: ?[number, number],
  rowHeight: number,
  maxRows: number,
  isBounded: boolean,
  isDraggable: boolean,
  isResizable: boolean,
  isDroppable: boolean,
  preventCollision: boolean,
  useCSSTransforms: boolean,
  transformScale: number,
  droppingItem: $Shape<LayoutItem>,
  resizeHandles: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,
  allowOverlap: boolean,

  // Callbacks
  onLayoutChange: Layout => void,
  onDrag: EventCallback,
  onDragStart: EventCallback,
  onDragStop: EventCallback,
  onResize: EventCallback,
  onResizeStart: EventCallback,
  onResizeStop: EventCallback,
  onDropDragOver: (e: DragOverEvent) => ?({| w?: number, h?: number |} | false),
  onDrop: (layout: Layout, item: ?LayoutItem, e: Event) => void,
  children: ReactChildrenArray<ReactElement<any>>,
  innerRef?: Ref<"div">
|};*/ /*:: export type DefaultProps = $Diff<
  Props,
  {
    children: ReactChildrenArray<ReactElement<any>>,
    width: number
  }
>;*/ var $89d8f6f92848d24e$var$_default = module.exports.default = {
    //
    // Basic props
    //
    className: $89d8f6f92848d24e$var$_propTypes.default.string,
    style: $89d8f6f92848d24e$var$_propTypes.default.object,
    // This can be set explicitly. If it is not set, it will automatically
    // be set to the container width. Note that resizes will *not* cause this to adjust.
    // If you need that behavior, use WidthProvider.
    width: $89d8f6f92848d24e$var$_propTypes.default.number,
    // If true, the container height swells and contracts to fit contents
    autoSize: $89d8f6f92848d24e$var$_propTypes.default.bool,
    // # of cols.
    cols: $89d8f6f92848d24e$var$_propTypes.default.number,
    // A selector that will not be draggable.
    draggableCancel: $89d8f6f92848d24e$var$_propTypes.default.string,
    // A selector for the draggable handler
    draggableHandle: $89d8f6f92848d24e$var$_propTypes.default.string,
    // Deprecated
    verticalCompact: function(props /*: Props*/ ) {
        props.verticalCompact;
    },
    // Choose vertical or hotizontal compaction
    compactType: $89d8f6f92848d24e$var$_propTypes.default.oneOf([
        "vertical",
        "horizontal"
    ]),
    // layout is an array of object with the format:
    // {x: Number, y: Number, w: Number, h: Number, i: String}
    layout: function(props /*: Props*/ ) {
        var layout = props.layout;
        // I hope you're setting the data-grid property on the grid items
        if (layout === undefined) return;
        (parcelRequire("1tBXw")).validateLayout(layout, "layout");
    },
    //
    // Grid Dimensions
    //
    // Margin between items [x, y] in px
    margin: $89d8f6f92848d24e$var$_propTypes.default.arrayOf($89d8f6f92848d24e$var$_propTypes.default.number),
    // Padding inside the container [x, y] in px
    containerPadding: $89d8f6f92848d24e$var$_propTypes.default.arrayOf($89d8f6f92848d24e$var$_propTypes.default.number),
    // Rows have a static height, but you can change this based on breakpoints if you like
    rowHeight: $89d8f6f92848d24e$var$_propTypes.default.number,
    // Default Infinity, but you can specify a max here if you like.
    // Note that this isn't fully fleshed out and won't error if you specify a layout that
    // extends beyond the row capacity. It will, however, not allow users to drag/resize
    // an item past the barrier. They can push items beyond the barrier, though.
    // Intentionally not documented for this reason.
    maxRows: $89d8f6f92848d24e$var$_propTypes.default.number,
    //
    // Flags
    //
    isBounded: $89d8f6f92848d24e$var$_propTypes.default.bool,
    isDraggable: $89d8f6f92848d24e$var$_propTypes.default.bool,
    isResizable: $89d8f6f92848d24e$var$_propTypes.default.bool,
    // If true, grid can be placed one over the other.
    allowOverlap: $89d8f6f92848d24e$var$_propTypes.default.bool,
    // If true, grid items won't change position when being dragged over.
    preventCollision: $89d8f6f92848d24e$var$_propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: $89d8f6f92848d24e$var$_propTypes.default.bool,
    // parent layout transform scale
    transformScale: $89d8f6f92848d24e$var$_propTypes.default.number,
    // If true, an external element can trigger onDrop callback with a specific grid position as a parameter
    isDroppable: $89d8f6f92848d24e$var$_propTypes.default.bool,
    // Resize handle options
    resizeHandles: $89d8f6f92848d24e$var$resizeHandleAxesType,
    resizeHandle: $89d8f6f92848d24e$var$resizeHandleType,
    //
    // Callbacks
    //
    // Callback so you can save the layout. Calls after each drag & resize stops.
    onLayoutChange: $89d8f6f92848d24e$var$_propTypes.default.func,
    // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
    // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
    onDragStart: $89d8f6f92848d24e$var$_propTypes.default.func,
    // Calls on each drag movement.
    onDrag: $89d8f6f92848d24e$var$_propTypes.default.func,
    // Calls when drag is complete.
    onDragStop: $89d8f6f92848d24e$var$_propTypes.default.func,
    //Calls when resize starts.
    onResizeStart: $89d8f6f92848d24e$var$_propTypes.default.func,
    // Calls when resize movement happens.
    onResize: $89d8f6f92848d24e$var$_propTypes.default.func,
    // Calls when resize is complete.
    onResizeStop: $89d8f6f92848d24e$var$_propTypes.default.func,
    // Calls when some element is dropped.
    onDrop: $89d8f6f92848d24e$var$_propTypes.default.func,
    //
    // Other validations
    //
    droppingItem: $89d8f6f92848d24e$var$_propTypes.default.shape({
        i: $89d8f6f92848d24e$var$_propTypes.default.string.isRequired,
        w: $89d8f6f92848d24e$var$_propTypes.default.number.isRequired,
        h: $89d8f6f92848d24e$var$_propTypes.default.number.isRequired
    }),
    // Children must not have duplicate keys.
    children: function(props /*: Props*/ , propName /*: string*/ ) {
        const children = props[propName];
        // Check children keys for duplicates. Throw if found.
        const keys = {};
        $89d8f6f92848d24e$var$_react.default.Children.forEach(children, function(child) {
            if (child?.key == null) return;
            if (keys[child.key]) throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
            keys[child.key] = true;
        });
    },
    // Optional ref for getting a reference for the wrapping div.
    innerRef: $89d8f6f92848d24e$var$_propTypes.default.any
};

});



parcelRegister("ivRjJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7a47af56782ac60$var$React = $d7a47af56782ac60$var$_interopRequireWildcard((parcelRequire("8NFma")));

var $d7a47af56782ac60$var$_propTypes = $d7a47af56782ac60$var$_interopRequireDefault((parcelRequire("fb0st")));

var $92KUL = parcelRequire("92KUL");

var $1tBXw = parcelRequire("1tBXw");

var $jnVoq = parcelRequire("jnVoq");

var $d7a47af56782ac60$var$_ReactGridLayout = $d7a47af56782ac60$var$_interopRequireDefault((parcelRequire("Oz2mM")));
function $d7a47af56782ac60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $d7a47af56782ac60$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d7a47af56782ac60$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $d7a47af56782ac60$var$_extends() {
    return $d7a47af56782ac60$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d7a47af56782ac60$var$_extends.apply(null, arguments);
}
function $d7a47af56782ac60$var$_defineProperty(e, r, t) {
    return (r = $d7a47af56782ac60$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d7a47af56782ac60$var$_toPropertyKey(t) {
    var i = $d7a47af56782ac60$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d7a47af56782ac60$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /*:: import { type Layout, type Pick } from "./utils";*/  /*:: import { type ResponsiveLayout, type OnLayoutChangeCallback, type Breakpoints } from "./responsiveUtils";*/ 
// $FlowFixMe[method-unbinding]
const $d7a47af56782ac60$var$type = (obj)=>Object.prototype.toString.call(obj);
/**
 * Get a value of margin or containerPadding.
 *
 * @param  {Array | Object} param Margin | containerPadding, e.g. [10, 10] | {lg: [10, 10], ...}.
 * @param  {String} breakpoint   Breakpoint: lg, md, sm, xs and etc.
 * @return {Array}
 */ function $d7a47af56782ac60$var$getIndentationValue(param /*: { [key: string]: T } | T*/ , breakpoint /*: string*/ ) /*: T*/ {
    // $FlowIgnore TODO fix this typedef
    if (param == null) return null;
    // $FlowIgnore TODO fix this typedef
    return Array.isArray(param) ? param : param[breakpoint];
}
/*:: type State = {
  layout: Layout,
  breakpoint: string,
  cols: number,
  layouts?: ResponsiveLayout<string>
};*/ /*:: type Props<Breakpoint: string = string> = {|
  ...React.ElementConfig<typeof ReactGridLayout>,

  // Responsive config
  breakpoint?: ?Breakpoint,
  breakpoints: Breakpoints<Breakpoint>,
  cols: { [key: Breakpoint]: number },
  layouts: ResponsiveLayout<Breakpoint>,
  width: number,
  margin: { [key: Breakpoint]: [number, number] } | [number, number],
  /* prettier-ignore *-/
  containerPadding: { [key: Breakpoint]: ?[number, number] } | ?[number, number],

  // Callbacks
  onBreakpointChange: (Breakpoint, cols: number) => void,
  onLayoutChange: OnLayoutChangeCallback,
  onWidthChange: (
    containerWidth: number,
    margin: [number, number],
    cols: number,
    containerPadding: ?[number, number]
  ) => void
|};*/ /*:: type DefaultProps = Pick<
  Props<>,
  {|
    allowOverlap: 0,
    breakpoints: 0,
    cols: 0,
    containerPadding: 0,
    layouts: 0,
    margin: 0,
    onBreakpointChange: 0,
    onLayoutChange: 0,
    onWidthChange: 0
  |}
>;*/ class $d7a47af56782ac60$var$ResponsiveReactGridLayout extends $d7a47af56782ac60$var$React.Component {
    constructor(){
        super(...arguments);
        $d7a47af56782ac60$var$_defineProperty(this, "state", this.generateInitialState());
        // wrap layouts so we do not need to pass layouts to child
        $d7a47af56782ac60$var$_defineProperty(this, "onLayoutChange", (layout /*: Layout*/ )=>{
            this.props.onLayoutChange(layout, {
                ...this.props.layouts,
                [this.state.breakpoint]: layout
            });
        });
    }
    generateInitialState() /*: State*/ {
        const { width: width, breakpoints: breakpoints, layouts: layouts, cols: cols } = this.props;
        const breakpoint = (0, $jnVoq.getBreakpointFromWidth)(breakpoints, width);
        const colNo = (0, $jnVoq.getColsFromBreakpoint)(breakpoint, cols);
        // verticalCompact compatibility, now deprecated
        const compactType = this.props.verticalCompact === false ? null : this.props.compactType;
        // Get the initial layout. This can tricky; we try to generate one however possible if one doesn't exist
        // for this layout.
        const initialLayout = (0, $jnVoq.findOrGenerateResponsiveLayout)(layouts, breakpoints, breakpoint, breakpoint, colNo, compactType);
        return {
            layout: initialLayout,
            breakpoint: breakpoint,
            cols: colNo
        };
    }
    static getDerivedStateFromProps(nextProps /*: Props<*>*/ , prevState /*: State*/ ) /*: ?$Shape<State>*/ {
        if (!(0, $92KUL.deepEqual)(nextProps.layouts, prevState.layouts)) {
            // Allow parent to set layouts directly.
            const { breakpoint: breakpoint, cols: cols } = prevState;
            // Since we're setting an entirely new layout object, we must generate a new responsive layout
            // if one does not exist.
            const newLayout = (0, $jnVoq.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, breakpoint, breakpoint, cols, nextProps.compactType);
            return {
                layout: newLayout,
                layouts: nextProps.layouts
            };
        }
        return null;
    }
    componentDidUpdate(prevProps /*: Props<*>*/ ) {
        // Allow parent to set width or breakpoint directly.
        if (this.props.width != prevProps.width || this.props.breakpoint !== prevProps.breakpoint || !(0, $92KUL.deepEqual)(this.props.breakpoints, prevProps.breakpoints) || !(0, $92KUL.deepEqual)(this.props.cols, prevProps.cols)) this.onWidthChange(prevProps);
    }
    /**
   * When the width changes work through breakpoints and reset state with the new width & breakpoint.
   * Width changes are necessary to figure out the widget widths.
   */ onWidthChange(prevProps /*: Props<*>*/ ) {
        const { breakpoints: breakpoints, cols: cols, layouts: layouts, compactType: compactType } = this.props;
        const newBreakpoint = this.props.breakpoint || (0, $jnVoq.getBreakpointFromWidth)(this.props.breakpoints, this.props.width);
        const lastBreakpoint = this.state.breakpoint;
        const newCols /*: number*/  = (0, $jnVoq.getColsFromBreakpoint)(newBreakpoint, cols);
        const newLayouts = {
            ...layouts
        };
        // Breakpoint change
        if (lastBreakpoint !== newBreakpoint || prevProps.breakpoints !== breakpoints || prevProps.cols !== cols) {
            // Preserve the current layout if the current breakpoint is not present in the next layouts.
            if (!(lastBreakpoint in newLayouts)) newLayouts[lastBreakpoint] = (0, $1tBXw.cloneLayout)(this.state.layout);
            // Find or generate a new layout.
            let layout = (0, $jnVoq.findOrGenerateResponsiveLayout)(newLayouts, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType);
            // This adds missing items.
            layout = (0, $1tBXw.synchronizeLayoutWithChildren)(layout, this.props.children, newCols, compactType, this.props.allowOverlap);
            // Store the new layout.
            newLayouts[newBreakpoint] = layout;
            // callbacks
            this.props.onBreakpointChange(newBreakpoint, newCols);
            this.props.onLayoutChange(layout, newLayouts);
            this.setState({
                breakpoint: newBreakpoint,
                layout: layout,
                cols: newCols
            });
        }
        const margin = $d7a47af56782ac60$var$getIndentationValue(this.props.margin, newBreakpoint);
        const containerPadding = $d7a47af56782ac60$var$getIndentationValue(this.props.containerPadding, newBreakpoint);
        //call onWidthChange on every change of width, not only on breakpoint changes
        this.props.onWidthChange(this.props.width, margin, newCols, containerPadding);
    }
    render() /*: React.Element<typeof ReactGridLayout>*/ {
        /* eslint-disable no-unused-vars */ const { breakpoint: breakpoint, breakpoints: breakpoints, cols: cols, layouts: layouts, margin: margin, containerPadding: containerPadding, onBreakpointChange: onBreakpointChange, onLayoutChange: onLayoutChange, onWidthChange: onWidthChange, ...other } = this.props;
        /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $d7a47af56782ac60$var$React.createElement($d7a47af56782ac60$var$_ReactGridLayout.default, $d7a47af56782ac60$var$_extends({}, other, {
            // $FlowIgnore should allow nullable here due to DefaultProps
            margin: $d7a47af56782ac60$var$getIndentationValue(margin, this.state.breakpoint),
            containerPadding: $d7a47af56782ac60$var$getIndentationValue(containerPadding, this.state.breakpoint),
            onLayoutChange: this.onLayoutChange,
            layout: this.state.layout,
            cols: this.state.cols
        }));
    }
}
module.exports.default = $d7a47af56782ac60$var$ResponsiveReactGridLayout;
// This should only include propTypes needed in this code; RGL itself
// will do validation of the rest props passed to it.
$d7a47af56782ac60$var$_defineProperty($d7a47af56782ac60$var$ResponsiveReactGridLayout, "propTypes", {
    //
    // Basic props
    //
    // Optional, but if you are managing width yourself you may want to set the breakpoint
    // yourself as well.
    breakpoint: $d7a47af56782ac60$var$_propTypes.default.string,
    // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
    breakpoints: $d7a47af56782ac60$var$_propTypes.default.object,
    allowOverlap: $d7a47af56782ac60$var$_propTypes.default.bool,
    // # of cols. This is a breakpoint -> cols map
    cols: $d7a47af56782ac60$var$_propTypes.default.object,
    // # of margin. This is a breakpoint -> margin map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Margin between items [x, y] in px
    // e.g. [10, 10]
    margin: $d7a47af56782ac60$var$_propTypes.default.oneOfType([
        $d7a47af56782ac60$var$_propTypes.default.array,
        $d7a47af56782ac60$var$_propTypes.default.object
    ]),
    // # of containerPadding. This is a breakpoint -> containerPadding map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Padding inside the container [x, y] in px
    // e.g. [10, 10]
    containerPadding: $d7a47af56782ac60$var$_propTypes.default.oneOfType([
        $d7a47af56782ac60$var$_propTypes.default.array,
        $d7a47af56782ac60$var$_propTypes.default.object
    ]),
    // layouts is an object mapping breakpoints to layouts.
    // e.g. {lg: Layout, md: Layout, ...}
    layouts (props /*: Props<>*/ , propName /*: string*/ ) {
        if ($d7a47af56782ac60$var$type(props[propName]) !== "[object Object]") throw new Error("Layout property must be an object. Received: " + $d7a47af56782ac60$var$type(props[propName]));
        Object.keys(props[propName]).forEach((key)=>{
            if (!(key in props.breakpoints)) throw new Error("Each key in layouts must align with a key in breakpoints.");
            (0, $1tBXw.validateLayout)(props.layouts[key], "layouts." + key);
        });
    },
    // The width of this component.
    // Required in this propTypes stanza because generateInitialState() will fail without it.
    width: $d7a47af56782ac60$var$_propTypes.default.number.isRequired,
    //
    // Callbacks
    //
    // Calls back with breakpoint and new # cols
    onBreakpointChange: $d7a47af56782ac60$var$_propTypes.default.func,
    // Callback so you can save the layout.
    // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
    onLayoutChange: $d7a47af56782ac60$var$_propTypes.default.func,
    // Calls back with (containerWidth, margin, cols, containerPadding)
    onWidthChange: $d7a47af56782ac60$var$_propTypes.default.func
});
$d7a47af56782ac60$var$_defineProperty($d7a47af56782ac60$var$ResponsiveReactGridLayout, "defaultProps", {
    breakpoints: {
        lg: 1200,
        md: 996,
        sm: 768,
        xs: 480,
        xxs: 0
    },
    cols: {
        lg: 12,
        md: 10,
        sm: 6,
        xs: 4,
        xxs: 2
    },
    containerPadding: {
        lg: null,
        md: null,
        sm: null,
        xs: null,
        xxs: null
    },
    layouts: {},
    margin: [
        10,
        10
    ],
    allowOverlap: false,
    onBreakpointChange: $1tBXw.noop,
    onLayoutChange: $1tBXw.noop,
    onWidthChange: $1tBXw.noop
});

});
parcelRegister("jnVoq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findOrGenerateResponsiveLayout = $e1ccaf5bb2482488$var$findOrGenerateResponsiveLayout;
module.exports.getBreakpointFromWidth = $e1ccaf5bb2482488$var$getBreakpointFromWidth;
module.exports.getColsFromBreakpoint = $e1ccaf5bb2482488$var$getColsFromBreakpoint;
module.exports.sortBreakpoints = $e1ccaf5bb2482488$var$sortBreakpoints;

var $1tBXw = parcelRequire("1tBXw");
/*:: import type { CompactType, Layout } from "./utils";*/ /*:: export type Breakpoint = string;*/ /*:: export type DefaultBreakpoints = "lg" | "md" | "sm" | "xs" | "xxs";*/ /*:: export type ResponsiveLayout<T: Breakpoint> = {
  +[breakpoint: T]: Layout
};*/ // + indicates read-only
/*:: export type Breakpoints<T: Breakpoint> = {
  +[breakpoint: T]: number
};*/ /*:: export type OnLayoutChangeCallback = (
  Layout,
  { [key: Breakpoint]: Layout }
) => void;*/ /**
 * Given a width, find the highest breakpoint that matches is valid for it (width > breakpoint).
 *
 * @param  {Object} breakpoints Breakpoints object (e.g. {lg: 1200, md: 960, ...})
 * @param  {Number} width Screen width.
 * @return {String}       Highest breakpoint that is less than width.
 */ function $e1ccaf5bb2482488$var$getBreakpointFromWidth(breakpoints /*: Breakpoints<Breakpoint>*/ , width /*: number*/ ) /*: Breakpoint*/ {
    const sorted = $e1ccaf5bb2482488$var$sortBreakpoints(breakpoints);
    let matching = sorted[0];
    for(let i = 1, len = sorted.length; i < len; i++){
        const breakpointName = sorted[i];
        if (width > breakpoints[breakpointName]) matching = breakpointName;
    }
    return matching;
}
/**
 * Given a breakpoint, get the # of cols set for it.
 * @param  {String} breakpoint Breakpoint name.
 * @param  {Object} cols       Map of breakpoints to cols.
 * @return {Number}            Number of cols.
 */ function $e1ccaf5bb2482488$var$getColsFromBreakpoint(breakpoint /*: Breakpoint*/ , cols /*: Breakpoints<Breakpoint>*/ ) /*: number*/ {
    if (!cols[breakpoint]) throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
    return cols[breakpoint];
}
/**
 * Given existing layouts and a new breakpoint, find or generate a new layout.
 *
 * This finds the layout above the new one and generates from it, if it exists.
 *
 * @param  {Object} layouts     Existing layouts.
 * @param  {Array} breakpoints All breakpoints.
 * @param  {String} breakpoint New breakpoint.
 * @param  {String} breakpoint Last breakpoint (for fallback).
 * @param  {Number} cols       Column count at new breakpoint.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @return {Array}             New layout.
 */ function $e1ccaf5bb2482488$var$findOrGenerateResponsiveLayout(layouts /*: ResponsiveLayout<Breakpoint>*/ , breakpoints /*: Breakpoints<Breakpoint>*/ , breakpoint /*: Breakpoint*/ , lastBreakpoint /*: Breakpoint*/ , cols /*: number*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    // If it already exists, just return it.
    if (layouts[breakpoint]) return (0, $1tBXw.cloneLayout)(layouts[breakpoint]);
    // Find or generate the next layout
    let layout = layouts[lastBreakpoint];
    const breakpointsSorted = $e1ccaf5bb2482488$var$sortBreakpoints(breakpoints);
    const breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
    for(let i = 0, len = breakpointsAbove.length; i < len; i++){
        const b = breakpointsAbove[i];
        if (layouts[b]) {
            layout = layouts[b];
            break;
        }
    }
    layout = (0, $1tBXw.cloneLayout)(layout || []); // clone layout so we don't modify existing items
    return (0, $1tBXw.compact)((0, $1tBXw.correctBounds)(layout, {
        cols: cols
    }), compactType, cols);
}
/**
 * Given breakpoints, return an array of breakpoints sorted by width. This is usually
 * e.g. ['xxs', 'xs', 'sm', ...]
 *
 * @param  {Object} breakpoints Key/value pair of breakpoint names to widths.
 * @return {Array}              Sorted breakpoints.
 */ function $e1ccaf5bb2482488$var$sortBreakpoints(breakpoints /*: Breakpoints<Breakpoint>*/ ) /*: Array<Breakpoint>*/ {
    const keys /*: Array<string>*/  = Object.keys(breakpoints);
    return keys.sort(function(a, b) {
        return breakpoints[a] - breakpoints[b];
    });
}

});


parcelRegister("82fVD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d9addbdc7a9791e$var$WidthProvideRGL;

var $5d9addbdc7a9791e$var$React = $5d9addbdc7a9791e$var$_interopRequireWildcard((parcelRequire("8NFma")));

var $5d9addbdc7a9791e$var$_propTypes = $5d9addbdc7a9791e$var$_interopRequireDefault((parcelRequire("fb0st")));

var $5d9addbdc7a9791e$var$_resizeObserverPolyfill = $5d9addbdc7a9791e$var$_interopRequireDefault((parcelRequire("8XZRT")));

var $5d9addbdc7a9791e$var$_clsx = $5d9addbdc7a9791e$var$_interopRequireDefault((parcelRequire("ase04")));
function $5d9addbdc7a9791e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $5d9addbdc7a9791e$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($5d9addbdc7a9791e$var$_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function $5d9addbdc7a9791e$var$_extends() {
    return $5d9addbdc7a9791e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5d9addbdc7a9791e$var$_extends.apply(null, arguments);
}
function $5d9addbdc7a9791e$var$_defineProperty(e, r, t) {
    return (r = $5d9addbdc7a9791e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $5d9addbdc7a9791e$var$_toPropertyKey(t) {
    var i = $5d9addbdc7a9791e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $5d9addbdc7a9791e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type { ReactRef } from "../ReactGridLayoutPropTypes";*/ /*:: type WPDefaultProps = {|
  measureBeforeMount: boolean
|};*/ /*:: type WPProps = {|
  className?: string,
  style?: Object,
  ...WPDefaultProps
|};*/ // eslint-disable-next-line no-unused-vars
/*:: type WPState = {|
  width: number
|};*/ /*:: type ComposedProps<Config> = {|
  ...Config,
  measureBeforeMount?: boolean,
  className?: string,
  style?: Object,
  width?: number
|};*/ const $5d9addbdc7a9791e$var$layoutClassName = "react-grid-layout";
/*
 * A simple HOC that provides facility for listening to container resizes.
 *
 * The Flow type is pretty janky here. I can't just spread `WPProps` into this returned object - I wish I could - but it triggers
 * a flow bug of some sort that causes it to stop typechecking.
 */ function $5d9addbdc7a9791e$var$WidthProvideRGL(ComposedComponent /*: React.AbstractComponent<Config>*/ ) /*: React.AbstractComponent<ComposedProps<Config>>*/ {
    var _WidthProvider;
    return _WidthProvider = class WidthProvider extends $5d9addbdc7a9791e$var$React.Component {
        constructor(){
            super(...arguments);
            $5d9addbdc7a9791e$var$_defineProperty(this, "state", {
                width: 1280
            });
            $5d9addbdc7a9791e$var$_defineProperty(this, "elementRef", /*#__PURE__*/ $5d9addbdc7a9791e$var$React.createRef());
            $5d9addbdc7a9791e$var$_defineProperty(this, "mounted", false);
            $5d9addbdc7a9791e$var$_defineProperty(this, "resizeObserver", void 0);
        }
        componentDidMount() {
            this.mounted = true;
            this.resizeObserver = new $5d9addbdc7a9791e$var$_resizeObserverPolyfill.default((entries)=>{
                const node = this.elementRef.current;
                if (node instanceof HTMLElement) {
                    const width = entries[0].contentRect.width;
                    this.setState({
                        width: width
                    });
                }
            });
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.observe(node);
        }
        componentWillUnmount() {
            this.mounted = false;
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.unobserve(node);
            this.resizeObserver.disconnect();
        }
        render() {
            const { measureBeforeMount: measureBeforeMount, ...rest } = this.props;
            if (measureBeforeMount && !this.mounted) return /*#__PURE__*/ $5d9addbdc7a9791e$var$React.createElement("div", {
                className: (0, $5d9addbdc7a9791e$var$_clsx.default)(this.props.className, $5d9addbdc7a9791e$var$layoutClassName),
                style: this.props.style,
                ref: this.elementRef
            });
            return /*#__PURE__*/ $5d9addbdc7a9791e$var$React.createElement(ComposedComponent, $5d9addbdc7a9791e$var$_extends({
                innerRef: this.elementRef
            }, rest, this.state));
        }
    }, $5d9addbdc7a9791e$var$_defineProperty(_WidthProvider, "defaultProps", {
        measureBeforeMount: false
    }), $5d9addbdc7a9791e$var$_defineProperty(_WidthProvider, "propTypes", {
        // If true, will not render children until mounted. Useful for getting the exact width before
        // rendering, to prevent any unsightly resizing.
        measureBeforeMount: $5d9addbdc7a9791e$var$_propTypes.default.bool
    }), _WidthProvider;
}

});
parcelRegister("8XZRT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6873d325be803505$export$2e2bcd8739ae039);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $6873d325be803505$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $6873d325be803505$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $6873d325be803505$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $6873d325be803505$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($6873d325be803505$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $6873d325be803505$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $6873d325be803505$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $6873d325be803505$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $6873d325be803505$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $6873d325be803505$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $6873d325be803505$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $6873d325be803505$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $6873d325be803505$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $6873d325be803505$var$throttle(this.refresh.bind(this), $6873d325be803505$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$6873d325be803505$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($6873d325be803505$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$6873d325be803505$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $6873d325be803505$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $6873d325be803505$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $6873d325be803505$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $6873d325be803505$var$global$1;
};
// Placeholder of an empty content rectangle.
var $6873d325be803505$var$emptyRect = $6873d325be803505$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $6873d325be803505$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $6873d325be803505$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $6873d325be803505$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $6873d325be803505$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $6873d325be803505$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $6873d325be803505$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $6873d325be803505$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $6873d325be803505$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $6873d325be803505$var$emptyRect;
    var styles = $6873d325be803505$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $6873d325be803505$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $6873d325be803505$var$toFloat(styles.width), height = $6873d325be803505$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $6873d325be803505$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $6873d325be803505$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$6873d325be803505$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $6873d325be803505$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $6873d325be803505$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $6873d325be803505$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $6873d325be803505$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $6873d325be803505$var$isDocumentElement(target) {
    return target === $6873d325be803505$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $6873d325be803505$var$getContentRect(target) {
    if (!$6873d325be803505$var$isBrowser) return $6873d325be803505$var$emptyRect;
    if ($6873d325be803505$var$isSVGGraphicsElement(target)) return $6873d325be803505$var$getSVGContentRect(target);
    return $6873d325be803505$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $6873d325be803505$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $6873d325be803505$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $6873d325be803505$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $6873d325be803505$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $6873d325be803505$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $6873d325be803505$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $6873d325be803505$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $6873d325be803505$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $6873d325be803505$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $6873d325be803505$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $6873d325be803505$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $6873d325be803505$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $6873d325be803505$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $6873d325be803505$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $6873d325be803505$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $6873d325be803505$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $6873d325be803505$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $6873d325be803505$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $6873d325be803505$var$ResizeObserverController.getInstance();
        var observer = new $6873d325be803505$var$ResizeObserverSPI(callback, controller, this);
        $6873d325be803505$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $6873d325be803505$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $6873d325be803505$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $6873d325be803505$var$index = function() {
    // Export existing implementation if available.
    if (typeof $6873d325be803505$var$global$1.ResizeObserver !== 'undefined') return $6873d325be803505$var$global$1.ResizeObserver;
    return $6873d325be803505$var$ResizeObserver;
}();
var $6873d325be803505$export$2e2bcd8739ae039 = $6873d325be803505$var$index;

});


var $13f4c0370d7de649$exports = {};
'use strict';

$13f4c0370d7de649$exports = (parcelRequire("2kzMM"));


var $503937b663c395c4$exports = {};
'use strict';
function $503937b663c395c4$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($503937b663c395c4$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$503937b663c395c4$var$checkDCE();

$503937b663c395c4$exports = (parcelRequire("gNTjK"));




var $8NFma = parcelRequire("8NFma");

parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
const $768a17376248dce8$export$2a1f9a4a898c1733 = {
    requestPending: "pending",
    requestFullfilled: "fullfilled",
    requestRejected: "rejected"
};
const $768a17376248dce8$export$588c7fdda06fbb0a = {
    lead360CacheName: "lead360Cache"
};
const $768a17376248dce8$export$bc6bb0e72ae9e582 = [
    {
        label: 'IST - (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
        value: 'India Standard Time$Asia/Kolkata'
    },
    {
        label: 'SMST - (GMT-11:00) Midway Island, Samoa',
        value: 'Samoa Standard Time$Pacific/Samoa'
    },
    {
        label: 'HAST - (GMT-10:00) Hawaii',
        value: 'Hawaiian Standard Time$US/Hawaii'
    },
    {
        label: 'AK - (GMT-09:00) Alaska',
        value: 'Alaskan Standard Time$US/Alaska'
    },
    {
        label: 'PT - (GMT-08:00) Pacific Time (US and Canada), Tijuana',
        value: 'Pacific Standard Time$US/Pacific'
    },
    {
        label: 'MST - (GMT-07:00) Arizona',
        value: 'US Mountain Standard Time$US/Arizona'
    },
    {
        label: 'MSTM - (GMT-07:00) Chihuahua, La Paz, Mazatlan',
        value: 'Mountain Standard Time (Mexico)$Canada/Mountain'
    },
    {
        label: 'MT - (GMT-07:00) Mountain Time (US and Canada)',
        value: 'Mountain Standard Time$US/Mountain'
    },
    {
        label: 'CST - (GMT-06:00) Guadalajara, Mexico City, Monterrey',
        value: 'Central Standard Time (Mexico)$America/Mexico_City'
    },
    {
        label: 'CT - (GMT-06:00) Central Time (US and Canada)',
        value: 'Central Standard Time$US/Central'
    },
    {
        label: 'CAST - (GMT-06:00) Central America',
        value: 'Central America Standard Time$America/Guatemala'
    },
    {
        label: 'CCST - (GMT-06:00) Saskatchewan',
        value: 'Canada Central Standard Time$Canada/Saskatchewan'
    },
    {
        label: 'EST - (GMT-05:00) Indiana (East)',
        value: 'US Eastern Standard Time$US/East-Indiana'
    },
    {
        label: 'SAPST - (GMT-05:00) Bogota, Lima, Quito',
        value: 'SA Pacific Standard Time$America/Bogota'
    },
    {
        label: 'ET - (GMT-05:00) Eastern Time (US and Canada)',
        value: 'Eastern Standard Time$US/Eastern'
    },
    {
        label: 'CBST - (GMT-04:00) Manaus',
        value: 'Central Brazilian Standard Time$America/Manaus'
    },
    {
        label: 'SAWST - (GMT-04:00) Caracas, La Paz',
        value: 'SA Western Standard Time$America/Caracas'
    },
    {
        label: 'PSAST - (GMT-04:00) Santiago',
        value: 'Pacific SA Standard Time$America/Santiago'
    },
    {
        label: 'AST - (GMT-04:00) Atlantic Time (Canada)',
        value: 'Atlantic Standard Time$Canada/Atlantic'
    },
    {
        label: 'NST - (GMT-03:30) Newfoundland and Labrador',
        value: 'Newfoundland Standard Time$Canada/Newfoundland'
    },
    {
        label: 'SAEST - (GMT-03:00) Buenos Aires, Georgetown',
        value: 'SA Eastern Standard Time$America/Argentina/Buenos_Aires'
    },
    {
        label: 'GNST - (GMT-03:00) Greenland',
        value: 'Greenland Standard Time$America/Godthab'
    },
    {
        label: 'ESAST - (GMT-03:00) Brasilia',
        value: 'E. South America Standard Time$America/Bahia'
    },
    {
        label: 'UTC02 - (GMT-02:00) Mid-Atlantic',
        value: 'Mid-Atlantic Standard Time$Etc/GMT-2'
    },
    {
        label: 'CVT - (GMT-01:00) Cape Verde Islands',
        value: 'Cape Verde Standard Time$Atlantic/Cape_Verde'
    },
    {
        label: 'AZOST - (GMT-01:00) Azores',
        value: 'Azores Standard Time$Atlantic/Azores'
    },
    {
        label: 'GST - (GMT-00:00) Casablanca, Monrovia',
        value: 'Greenwich Standard Time$Africa/Casablanca'
    },
    {
        label: 'GMT - (GMT-00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
        value: 'GMT Standard Time$Europe/London'
    },
    {
        label: 'WET - (GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
        value: 'W. Europe Standard Time$Europe/Amsterdam'
    },
    {
        label: 'ECT - (GMT+01:00) West Central Africa',
        value: 'W. Central Africa Standard Time$Africa/Algiers'
    },
    {
        label: 'RST - (GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
        value: 'Romance Standard Time$Europe/Brussels'
    },
    {
        label: 'CEST - (GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
        value: 'Central European Standard Time$Europe/Sarajevo'
    },
    {
        label: 'CET - (GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
        value: 'Central Europe Standard Time$Europe/Belgrade'
    },
    {
        label: 'NMST - (GMT+02:00) Windhoek',
        value: 'Namibia Standard Time$Africa/Windhoek'
    },
    {
        label: 'SAST - (GMT+02:00) Harare, Pretoria',
        value: 'South Africa Standard Time$Africa/Harare'
    },
    {
        label: 'ISST - (GMT+02:00) Jerusalem',
        value: 'Israel Standard Time$Asia/Jerusalem'
    },
    {
        label: 'GTBST - (GMT+02:00) Athens, Bucharest, Istanbul',
        value: 'GTB Standard Time$Europe/Athens'
    },
    {
        label: 'EET - (GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius',
        value: 'FLE Standard Time$Europe/Kiev'
    },
    {
        label: 'EGST - (GMT+02:00) Cairo',
        value: 'Egypt Standard Time$Egypt'
    },
    {
        label: 'EEST - (GMT+02:00) Minsk',
        value: 'E. Europe Standard Time$Europe/Minsk'
    },
    {
        label: 'MSK - (GMT+03:00) Moscow, St. Petersburg, Volgograd',
        value: 'Russian Standard Time$Europe/Moscow'
    },
    {
        label: 'EAT - (GMT+03:00) Nairobi',
        value: 'E. Africa Standard Time$Africa/Nairobi'
    },
    {
        label: 'ARST - (GMT+03:00) Baghdad',
        value: 'Arabic Standard Time$Asia/Baghdad'
    },
    {
        label: 'ABST - (GMT+03:00) Kuwait, Riyadh',
        value: 'Arab Standard Time$Asia/Kuwait'
    },
    {
        label: 'IRST - (GMT+03:30) Tehran',
        value: 'Iran Standard Time$Asia/Tehran'
    },
    {
        label: 'GET - (GMT+04:00) Tblisi',
        value: 'Georgian Standard Time$Asia/Tbilisi'
    },
    {
        label: 'AZT - (GMT+04:00) Baku',
        value: 'Azerbaijan Standard Time$Asia/Baku'
    },
    {
        label: 'AMT - (GMT+04:00) Yerevan',
        value: 'Caucasus Standard Time$Asia/Yerevan'
    },
    {
        label: 'ARBST - (GMT+04:00) Abu Dhabi, Muscat',
        value: 'Arabian Standard Time$Asia/Muscat'
    },
    {
        label: 'AFT - (GMT+04:30) Kabul',
        value: 'Afghanistan Standard Time$Asia/Kabul'
    },
    {
        label: 'WAST - (GMT+05:00) Islamabad, Karachi, Tashkent',
        value: 'West Asia Standard Time$Asia/Karachi'
    },
    {
        label: 'YEKT - (GMT+05:00) Ekaterinburg',
        value: 'Ekaterinburg Standard Time$Asia/Yekaterinburg'
    },
    {
        label: 'IST - (GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
        value: 'India Standard Time$Asia/Kolkata'
    },
    {
        label: 'NPT - (GMT+05:45) Kathmandu',
        value: 'Nepal Standard Time$Asia/Katmandu'
    },
    {
        label: 'SLT - (GMT+06:00) Sri Jayawardenepura',
        value: 'Sri Lanka Standard Time$Asia/Colombo'
    },
    {
        label: 'NCAST - (GMT+06:00) Almaty, Novosibirsk',
        value: 'N. Central Asia Standard Time$Asia/Almaty'
    },
    {
        label: 'BTT - (GMT+06:00) Astana, Dhaka',
        value: 'Central Asia Standard Time$Asia/Dhaka'
    },
    {
        label: 'MYST - (GMT+06:30) Yangon (Rangoon)',
        value: 'Myanmar Standard Time$Asia/Rangoon'
    },
    {
        label: 'THA - (GMT+07:00) Bangkok, Hanoi, Jakarta',
        value: 'SE Asia Standard Time$Asia/Bangkok'
    },
    {
        label: 'KRAT - (GMT+07:00) Krasnoyarsk',
        value: 'North Asia Standard Time$Asia/Krasnoyarsk'
    },
    {
        label: 'AWST - (GMT+08:00) Perth',
        value: 'W. Australia Standard Time$Australia/Perth'
    },
    {
        label: 'TIST - (GMT+08:00) Taipei',
        value: 'Taipei Standard Time$Asia/Taipei'
    },
    {
        label: 'SNST - (GMT+08:00) Kuala Lumpur, Singapore',
        value: 'Singapore Standard Time$Asia/Singapore'
    },
    {
        label: 'IRKT - (GMT+08:00) Irkutsk, Ulaanbaatar',
        value: 'North Asia East Standard Time$Asia/Irkutsk'
    },
    {
        label: 'CST - (GMT+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi',
        value: 'China Standard Time$Asia/Chongqing'
    },
    {
        label: 'YAKT - (GMT+09:00) Yakutsk',
        value: 'Yakutsk Standard Time$Asia/Yakutsk'
    },
    {
        label: 'TST - (GMT+09:00) Osaka, Sapporo, Tokyo',
        value: 'Tokyo Standard Time$Asia/Tokyo'
    },
    {
        label: 'KST - (GMT+09:00) Seoul',
        value: 'Korea Standard Time$Asia/Seoul'
    },
    {
        label: 'CAUST - (GMT+09:30) Adelaide',
        value: 'Cen. Australia Standard Time$Australia/Adelaide'
    },
    {
        label: 'ACST - (GMT+09:30) Darwin',
        value: 'AUS Central Standard Time$Australia/Darwin'
    },
    {
        label: 'WPST - (GMT+10:00) Guam, Port Moresby',
        value: 'West Pacific Standard Time$Pacific/Guam'
    },
    {
        label: 'VLAT - (GMT+10:00) Vladivostok',
        value: 'Vladivostok Standard Time$Asia/Vladivostok'
    },
    {
        label: 'TAST - (GMT+10:00) Hobart',
        value: 'Tasmania Standard Time$Australia/Hobart'
    },
    {
        label: 'EAST - (GMT+10:00) Brisbane',
        value: 'E. Australia Standard Time$Australia/Brisbane'
    },
    {
        label: 'AEST - (GMT+10:00) Canberra, Melbourne, Sydney',
        value: 'AUS Eastern Standard Time$Australia/Canberra'
    },
    {
        label: 'SBT - (GMT+11:00) Magadan, Solomon Islands, New Caledonia',
        value: 'Central Pacific Standard Time$Asia/Magadan'
    },
    {
        label: 'NZST - (GMT+12:00) Auckland, Wellington',
        value: 'New Zealand Standard Time$Pacific/Auckland'
    },
    {
        label: 'FJT - (GMT+12:00) Fiji Islands, Kamchatka, Marshall Islands',
        value: 'Fiji Standard Time$Pacific/Fiji'
    },
    {
        label: "PHOT - (GMT+13:00) Nuku'alofa",
        value: 'Tonga Standard Time$Pacific/Tongatapu'
    }
];
const $768a17376248dce8$export$45f3f39dac49db7f = {
    ACTIVITES: "activities",
    TASKS: "tasks",
    OPPORTUNITIES: "opportunities",
    ABOUT: "about",
    NOTES: "notes",
    DOCUMENTS: "documents",
    CUSTOM_WIDGET: "customwidget"
};
const $768a17376248dce8$export$1ca33315cf3cdede = {
    [$768a17376248dce8$export$45f3f39dac49db7f.ABOUT]: "leadDetails",
    [$768a17376248dce8$export$45f3f39dac49db7f.NOTES]: "LeadNotes",
    [$768a17376248dce8$export$45f3f39dac49db7f.DOCUMENTS]: "leaddocumentsSummary",
    [$768a17376248dce8$export$45f3f39dac49db7f.ACTIVITES]: "leadActivityHistory",
    [$768a17376248dce8$export$45f3f39dac49db7f.OPPORTUNITIES]: "leadOpportunities",
    [$768a17376248dce8$export$45f3f39dac49db7f.TASKS]: "tasksAndNotes",
    [$768a17376248dce8$export$45f3f39dac49db7f.CUSTOM_WIDGET]: "leadCustomWidget"
};


'use strict';
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const { iterator: $aace3e920a0f1e4d$var$iterator, toStringTag: $aace3e920a0f1e4d$var$toStringTag } = Symbol;
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if ($aace3e920a0f1e4d$var$kindOf(val) !== 'object') return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($aace3e920a0f1e4d$var$toStringTag in val) && !($aace3e920a0f1e4d$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $aace3e920a0f1e4d$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$aace3e920a0f1e4d$var$isObject(val) || $aace3e920a0f1e4d$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 * 
 * @param {*} value The value to test
 * 
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 * 
 * @param {*} formData The formData to test
 * 
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $aace3e920a0f1e4d$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $aace3e920a0f1e4d$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $aace3e920a0f1e4d$var$G = $aace3e920a0f1e4d$var$getGlobal();
const $aace3e920a0f1e4d$var$FormDataCtor = typeof $aace3e920a0f1e4d$var$G.FormData !== 'undefined' ? $aace3e920a0f1e4d$var$G.FormData : undefined;
const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($aace3e920a0f1e4d$var$FormDataCtor && thing instanceof $aace3e920a0f1e4d$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData (GHSA-6chq-wfr3-2hj9).
    const proto = $aace3e920a0f1e4d$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$aace3e920a0f1e4d$var$isFunction(thing.append)) return false;
    const kind = $aace3e920a0f1e4d$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest('URLSearchParams');
const [$aace3e920a0f1e4d$var$isReadableStream, $aace3e920a0f1e4d$var$isRequest, $aace3e920a0f1e4d$var$isResponse, $aace3e920a0f1e4d$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($aace3e920a0f1e4d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($aace3e920a0f1e4d$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $aace3e920a0f1e4d$var$findKey(obj, key) {
    if ($aace3e920a0f1e4d$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    const { caseless: caseless, skipUndefined: skipUndefined } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        const targetKey = caseless && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        if ($aace3e920a0f1e4d$var$isPlainObject(result[targetKey]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(result[targetKey], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$aace3e920a0f1e4d$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) Object.defineProperty(a, key, {
            value: (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$aace3e920a0f1e4d$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest('HTMLFormElement');
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest('RegExp');
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[$aace3e920a0f1e4d$var$toStringTag] === 'FormData' && thing[$aace3e920a0f1e4d$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if ($aace3e920a0f1e4d$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $aace3e920a0f1e4d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $aace3e920a0f1e4d$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $aace3e920a0f1e4d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $aace3e920a0f1e4d$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $aace3e920a0f1e4d$var$isFunction($aace3e920a0f1e4d$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $aace3e920a0f1e4d$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($aace3e920a0f1e4d$var$_global) : $aace3e920a0f1e4d$var$_setImmediate;
// *********************
const $aace3e920a0f1e4d$var$isIterable = (thing)=>thing != null && $aace3e920a0f1e4d$var$isFunction(thing[$aace3e920a0f1e4d$var$iterator]);
var $aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isEmptyObject: $aace3e920a0f1e4d$var$isEmptyObject,
    isReadableStream: $aace3e920a0f1e4d$var$isReadableStream,
    isRequest: $aace3e920a0f1e4d$var$isRequest,
    isResponse: $aace3e920a0f1e4d$var$isResponse,
    isHeaders: $aace3e920a0f1e4d$var$isHeaders,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isReactNativeBlob: $aace3e920a0f1e4d$var$isReactNativeBlob,
    isReactNative: $aace3e920a0f1e4d$var$isReactNative,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable,
    setImmediate: $aace3e920a0f1e4d$var$_setImmediate,
    asap: $aace3e920a0f1e4d$var$asap,
    isIterable: $aace3e920a0f1e4d$var$isIterable
};







'use strict';
class $0139f1d30f4d6bd5$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $0139f1d30f4d6bd5$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$0139f1d30f4d6bd5$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$0139f1d30f4d6bd5$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$0139f1d30f4d6bd5$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$0139f1d30f4d6bd5$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$0139f1d30f4d6bd5$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$0139f1d30f4d6bd5$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$0139f1d30f4d6bd5$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$0139f1d30f4d6bd5$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$0139f1d30f4d6bd5$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$0139f1d30f4d6bd5$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;


// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
'use strict';
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
'use strict';
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup['-'.charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case 'base64':
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf);
    else return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0934e0939605d48c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $8a0a73e6b73fd0c4$export$d622b2ad8d90c771($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $fd07b9cb0132c1f6$require$Buffer = $0934e0939605d48c$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $86ebf0c810395e29$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    const useBlob = _Blob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $fd07b9cb0132c1f6$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReactNative(formData) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $344cf8e4292137b6$var$encode);
    } : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces URL-encoded forms of `:`, `$`, `,`, and spaces with
 * their plain counterparts (`:`, `$`, `,`, `+`).
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $db2f05ec923f2ee7$var$encode;
    const _options = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $344cf8e4292137b6$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;





'use strict';
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true
};






'use strict';
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $344cf8e4292137b6$export$2e2bcd8739ae039);


'use strict';
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a85e5bed82430d61$export$2e2bcd8739ae039,
        FormData: $46b12d255f217052$export$2e2bcd8739ae039,
        Blob: $2e4211376cea43e6$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $232de52881daaba8$exports = {};

$parcel$export($232de52881daaba8$exports, "hasBrowserEnv", () => $232de52881daaba8$export$c4996c4b7b93b0bf);
$parcel$export($232de52881daaba8$exports, "navigator", () => $232de52881daaba8$export$ec7c8efa7f5790ae);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserEnv", () => $232de52881daaba8$export$c0bcc9250309d66);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserWebWorkerEnv", () => $232de52881daaba8$export$c81692cf5af97dac);
$parcel$export($232de52881daaba8$exports, "origin", () => $232de52881daaba8$export$f710a83a91838a36);
const $232de52881daaba8$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $232de52881daaba8$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $232de52881daaba8$export$c0bcc9250309d66 = $232de52881daaba8$export$c4996c4b7b93b0bf && (!$232de52881daaba8$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($232de52881daaba8$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $232de52881daaba8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $232de52881daaba8$export$f710a83a91838a36 = $232de52881daaba8$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $852831b4a152a7ad$export$2e2bcd8739ae039 = {
    ...$232de52881daaba8$exports,
    ...(0, $fb24c6d0b2a74508$export$2e2bcd8739ae039)
};


'use strict';
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(data, new (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).isNode && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(formData) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;


'use strict';
const $e30871f78dcd7f19$var$own = (obj, key)=>obj != null && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $3075bac9f30e7782$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isStream(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFile(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $e30871f78dcd7f19$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $aa000567d8bb5ae2$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $e30871f78dcd7f19$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $e30871f78dcd7f19$var$own(this, 'transitional') || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $e30871f78dcd7f19$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isResponse(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $e30871f78dcd7f19$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(e, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $e30871f78dcd7f19$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $54e5234108b8e954$var$$internals = Symbol('internals');
const $54e5234108b8e954$var$INVALID_HEADER_VALUE_CHARS_RE = /[^\x09\x20-\x7E\x80-\xFF]/g;
function $54e5234108b8e954$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$sanitizeHeaderValue(str) {
    return $54e5234108b8e954$var$trimSPorHTAB(str.replace($54e5234108b8e954$var$INVALID_HEADER_VALUE_CHARS_RE, ''));
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : $54e5234108b8e954$var$sanitizeHeaderValue(String(value));
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $36eacf0f5ae88424$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(header) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;


'use strict';
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $63b8b72909769bf2$var$CanceledError extends (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;







'use strict';
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $bab2be24834f7155$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $bab2be24834f7155$export$2e2bcd8739ae039 = $bab2be24834f7155$var$throttle;



const $a01f222f203440ec$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $48a8aeed25ee768a$export$2e2bcd8739ae039)(50, 250);
    return (0, $bab2be24834f7155$export$2e2bcd8739ae039)((e)=>{
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $a01f222f203440ec$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $a01f222f203440ec$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin), (0, $852831b4a152a7ad$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $852831b4a152a7ad$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $05bf269bfca011f3$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $7c49e720f6231ba2$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $54e5234108b8e954$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), prop, true)
    };
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $f612969e780f42a0$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)((0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin. See GHSA-xx6v-rp6x-q39c.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $3a08e3bf7b3045fa$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $4d3cf801f7fd4dc6$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $f612969e780f42a0$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request aborted', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(msg, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $3075bac9f30e7782$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT : (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $a01f222f203440ec$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $a01f222f203440ec$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $852831b4a152a7ad$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $8bc8ab02f7e95517$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039) ? err : new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $8bc8ab02f7e95517$export$2e2bcd8739ae039 = $8bc8ab02f7e95517$var$composeSignals;


const $ac31e9e363273572$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $ac31e9e363273572$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $ac31e9e363273572$var$readStream(iterable))yield* $ac31e9e363273572$export$71b051935044bd5d(chunk, chunkSize);
};
const $ac31e9e363273572$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $ac31e9e363273572$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $ac31e9e363273572$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $4b9898a31eea6843$var$isFunction } = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039);
const $4b9898a31eea6843$var$globalFetchAPI = (({ Request: Request, Response: Response })=>({
        Request: Request,
        Response: Response
    }))((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).global);
const { ReadableStream: $4b9898a31eea6843$var$ReadableStream, TextEncoder: $4b9898a31eea6843$var$TextEncoder } = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).global;
const $4b9898a31eea6843$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $4b9898a31eea6843$var$factory = (env)=>{
    env = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, $4b9898a31eea6843$var$globalFetchAPI, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $4b9898a31eea6843$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $4b9898a31eea6843$var$isFunction(Request);
    const isResponseSupported = $4b9898a31eea6843$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $4b9898a31eea6843$var$isFunction($4b9898a31eea6843$var$ReadableStream);
    const encodeText = isFetchSupported && (typeof $4b9898a31eea6843$var$TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new $4b9898a31eea6843$var$TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin, {
            body: new $4b9898a31eea6843$var$ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $f612969e780f42a0$export$2e2bcd8739ae039)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $8bc8ab02f7e95517$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $a01f222f203440ec$export$d9fadd12586c18d6)(requestContentLength, (0, $a01f222f203440ec$export$c1b28109d46c3592)((0, $a01f222f203440ec$export$5d35863c355a22a9)(onUploadProgress)));
                    data = (0, $ac31e9e363273572$export$b0119225647bd83)(_request.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $a01f222f203440ec$export$d9fadd12586c18d6)(responseContentLength, (0, $a01f222f203440ec$export$c1b28109d46c3592)((0, $a01f222f203440ec$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                response = new Response((0, $ac31e9e363273572$export$b0119225647bd83)(response.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Network Error', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $4b9898a31eea6843$var$seedCache = new Map();
const $4b9898a31eea6843$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $4b9898a31eea6843$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $4b9898a31eea6843$var$factory(env));
        map = target;
    }
    return target;
};
const $4b9898a31eea6843$var$adapter = $4b9898a31eea6843$export$3105c6651375d4fa();
var $4b9898a31eea6843$export$2e2bcd8739ae039 = $4b9898a31eea6843$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $86ebf0c810395e29$export$2e2bcd8739ae039),
    xhr: (0, $61abd1574bd1dd32$export$2e2bcd8739ae039),
    fetch: {
        get: $4b9898a31eea6843$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $d570c100e0cb7a05$var$getAdapter(adapters, config) {
    adapters = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($d570c100e0cb7a05$var$renderReason).join('\n') : ' ' + $d570c100e0cb7a05$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $d570c100e0cb7a05$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $d570c100e0cb7a05$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $4c74d331112ba968$export$a4ad2735b021c132 = "1.15.1";



'use strict';
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $4c74d331112ba968$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$63efb8494987aa98$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('options must be an object', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};




'use strict';
const $cd0b8e3cbef64068$var$validators = (0, $63efb8494987aa98$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)(),
            response: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            legacyInterceptorReqResOrdering: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $cd0b8e3cbef64068$var$validators.spelling('baseURL'),
            withXsrfToken: $cd0b8e3cbef64068$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $3075bac9f30e7782$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $96666136aaccd2e5$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $96666136aaccd2e5$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    $cd0b8e3cbef64068$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;






'use strict';
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)((0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $e30871f78dcd7f19$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $63b8b72909769bf2$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $3218dd97b5460664$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $4c74d331112ba968$export$a4ad2735b021c132);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $7874d702b64e6994$export$2e2bcd8739ae039);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $16f479813f4fb9c8$export$2e2bcd8739ae039);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a } = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);



let $37fbb54a01ff9d75$var$auth = null;
const $37fbb54a01ff9d75$var$AUTH_STORAGE_KEY = 'auth';
const $37fbb54a01ff9d75$export$f88ba925622e17f1 = ()=>{
    const authDetails = localStorage.getItem($37fbb54a01ff9d75$var$AUTH_STORAGE_KEY) || sessionStorage.getItem($37fbb54a01ff9d75$var$AUTH_STORAGE_KEY);
    if (!authDetails) {
        $37fbb54a01ff9d75$var$auth = null;
        return;
    }
    try {
        $37fbb54a01ff9d75$var$auth = JSON.parse(authDetails);
    } catch (error) {
        // Corrupt storage shouldn't crash app init; getters already treat null auth as signed out.
        console.error("Failed to parse stored auth details:", error);
        $37fbb54a01ff9d75$var$auth = null;
    }
};
const $37fbb54a01ff9d75$export$714d3544202969b = ()=>{
    if (!$37fbb54a01ff9d75$var$auth) $37fbb54a01ff9d75$export$f88ba925622e17f1();
    return $37fbb54a01ff9d75$var$auth?.User;
};
const $37fbb54a01ff9d75$export$550ea6e0aa9f31e3 = ()=>{
    if (!$37fbb54a01ff9d75$var$auth) $37fbb54a01ff9d75$export$f88ba925622e17f1();
    return $37fbb54a01ff9d75$var$auth?.Tokens?.Token;
};
const $37fbb54a01ff9d75$export$b64ebfa99e8dc2a0 = ()=>{
    if (!$37fbb54a01ff9d75$var$auth) $37fbb54a01ff9d75$export$f88ba925622e17f1();
    return $37fbb54a01ff9d75$var$auth?.Tenant?.RegionId;
};
const $37fbb54a01ff9d75$export$aacd81ffe42ab171 = ()=>{
    if (!$37fbb54a01ff9d75$var$auth) $37fbb54a01ff9d75$export$f88ba925622e17f1();
    return $37fbb54a01ff9d75$var$auth?.Tenant?.DisplayName;
};


// Parcel's `--public-url ./` already resolves every bundled asset relative to wherever the bundle
// is served from. CSS and icons opted out of that by being built from a host map keyed on
// window.location.host, so they break the moment the bundle moves to a custom-domain subpath --
// the map misses and falls through to a hardcoded (and wrong-environment) CDN. Reading the
// bundle's own URL puts them back on the same mechanism, so one artifact is correct at any prefix.
//
// The Vite loader is the authoritative source. It computes the dist root from its own src and
// then appends the hashed app script, which Vite emits to <root>/static/js/. Reading
// document.currentScript from inside that app script therefore yields <root>/static/js, one level
// too deep, and every icon and stylesheet URL built from it 404s -- on the normal CDN as much as
// on a custom domain. So prefer the value the loader published.
//
// The key is per-app on purpose: swlite can mount casa-web and lead-360 on the same page from
// different prefixes, and a shared global would leave whichever loaded second resolving its
// assets against the other's base.
const $ecb9f48c91a13dda$var$LOADER_BASE_KEY = "__LEAD360_BUNDLE_BASE__";
const $ecb9f48c91a13dda$var$stripTrailingSlash = (url)=>String(url).replace(/\/$/, "");
const $ecb9f48c91a13dda$var$loaderBase = typeof window !== "undefined" ? window[$ecb9f48c91a13dda$var$LOADER_BASE_KEY] : undefined;
// Fallback for the legacy Parcel entry, which sits at the dist root, so its own URL is the base.
// document.currentScript is read at module scope on purpose: it is only populated while the
// classic script is executing synchronously, which is exactly when this module body runs.
// import.meta.url is NOT an alternative here -- Parcel compiles it to a build-time literal
// ("file:///src/entry.js"), which would silently produce broken URLs rather than failing loudly.
// The /static/js strip only matters if the Vite bundle is ever loaded without its loader.
const $ecb9f48c91a13dda$var$script = typeof document !== "undefined" ? document.currentScript : null;
const $ecb9f48c91a13dda$var$scriptBase = $ecb9f48c91a13dda$var$script ? $ecb9f48c91a13dda$var$stripTrailingSlash(new URL(".", $ecb9f48c91a13dda$var$script.src).href).replace(/\/static\/js$/, "") : "";
const $ecb9f48c91a13dda$export$d2b5531ce9550fb0 = $ecb9f48c91a13dda$var$loaderBase ? $ecb9f48c91a13dda$var$stripTrailingSlash($ecb9f48c91a13dda$var$loaderBase) : $ecb9f48c91a13dda$var$scriptBase;


const $900815ab2142dd8c$var$hostMapping = {
    "app.crm4b2c.com": "fieldsales.crm4b2c.com",
    "app-clone.crm4b2c.com": "fieldsales.crm4b2c.com",
    "app.lsq-staging.com": "fieldsales.lsq-staging.com",
    "app.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "app-us11.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "app-ca12.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "app-ir31.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "app-in21.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "app-in22.leadsquared.com": "fieldsales-in22.leadsquared.com",
    "run.crm4b2c.com": "fieldsales.crm4b2c.com",
    "run.lsq-staging.com": "fieldsales.lsq-staging.com",
    "in21.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "us11.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "ir31.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "ca12.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "run.leadsquared.com": "fieldsales-in21.leadsquared.com",
    "in22.leadsquared.com": "fieldsales-in22.leadsquared.com"
};
const $900815ab2142dd8c$var$orgCode = (0, $37fbb54a01ff9d75$export$714d3544202969b)()?.OrgCode;
const $900815ab2142dd8c$var$marvinHostMapping = {
    "run.crm4b2c.com": `https://service.crm4b2c.com/v1/Marvin.svc/r1`,
    "app.crm4b2c.com": `https://service.crm4b2c.com/v1/Marvin.svc/r1`,
    "app-clone.crm4b2c.com": `https://service.crm4b2c.com/v1/Marvin.svc/r1`,
    "app.lsq-staging.com": `https://service.lsq-staging.com/v1/Marvin.svc/r1`,
    "run.lsq-staging.com": `https://service.lsq-staging.com/v1/Marvin.svc/r1`,
    "us11.lsq-staging.com": `https://service-us11.lsq-staging.com/v1/Marvin.svc/r11`,
    "app-us.lsq-staging.com": `https://service-us11.lsq-staging.com/v1/Marvin.svc/r11`,
    "in21.mxradon.lsq-staging.com": `https://marvin-service-in21.mxradon.lsq-staging.com/v1/Marvin.svc/r1`,
    "app-in21.mxradon.lsq-staging.com": `https://marvin-service-in21.mxradon.lsq-staging.com/v1/Marvin.svc/r1`,
    "ca12.leadsquared.com": `https://marvin-service-ca12.leadsquared.com/v1/Marvin.svc/r12`,
    "app-ca12.leadsquared.com": `https://marvin-service-ca12.leadsquared.com/v1/Marvin.svc/r12`,
    "ir31.leadsquared.com": `https://marvin-service-ir31.leadsquared.com/v1/Marvin.svc/r31`,
    "app-ir31.leadsquared.com": `https://marvin-service-ir31.leadsquared.com/v1/Marvin.svc/r31`,
    "in21.leadsquared.com": `https://marvin-service-in21.leadsquared.com/v1/Marvin.svc/r21`,
    "app-in21.leadsquared.com": `https://marvin-service-in21.leadsquared.com/v1/Marvin.svc/r21`,
    "run.leadsquared.com": `https://marvin-service.leadsquared.com/v1/Marvin.svc/r1`,
    "app.leadsquared.com": `https://marvin-service.leadsquared.com/v1/Marvin.svc/r1`,
    "us11.leadsquared.com": `https://marvin-service-us11.leadsquared.com/v1/Marvin.svc/r11`,
    "app-us11.leadsquared.com": `https://marvin-service-us11.leadsquared.com/v1/Marvin.svc/r11`,
    "in22.leadsquared.com": `https://marvin-service-in22.leadsquared.com/v1/Marvin.svc/r22`,
    "app-in22.leadsquared.com": `https://marvin-service-in22.leadsquared.com/v1/Marvin.svc/r22`,
    "nextgen-mum.leadsquared.com": `https://marvin-service-in21.leadsquared.com/v1/Marvin.svc/r21`,
    "nextgen-sgp.leadsquared.com": `https://marvin-service-in21.leadsquared.com/v1/Marvin.svc/r21`,
    "nextgen-us.leadsquared.com/": `https://marvin-service-us11.leadsquared.com/v1/Marvin.svc/r11`
};
/**
 * The NextGen shell publishes its resolved environment config on the window it shares with this
 * microfrontend, under the key its own helpers read (`___env_var___`). IS_CUSTOM_DOMAIN is added
 * to that config by one script -- the shell's custom-domain deploy step -- so its presence is an
 * exact signal, not a heuristic on the hostname, and it is the same flag the shell's own rest
 * client gates its encryption on.
 */ const $900815ab2142dd8c$var$PLATFORM_ENV_KEY = "___env_var___";
const $900815ab2142dd8c$var$ORGCODE_PLACEHOLDER = "[[ORGCODE]]";
const $900815ab2142dd8c$var$platformEnvConfig = (key)=>typeof window === "undefined" ? undefined : window[$900815ab2142dd8c$var$PLATFORM_ENV_KEY]?.[key];
const $900815ab2142dd8c$export$97f4c254b641e719 = ()=>Boolean($900815ab2142dd8c$var$platformEnvConfig("IS_CUSTOM_DOMAIN"));
const $900815ab2142dd8c$export$8391516e4e7c9635 = ()=>$900815ab2142dd8c$var$platformEnvConfig("GATEWAY_BASE_URL") || "";
const $900815ab2142dd8c$var$getMarvinHost = ()=>{
    const currentHost = window.location.host;
    /**
   * Custom domain: the shell's env config already says which Marvin region this tenant talks to,
   * as a path on the serving origin -- appgateway matches /api/v1/Marvin.svc/** and strips /api
   * before forwarding. Reading its value rather than repeating the region map below keeps the two
   * in step: a region added on their side needs no change here. If the key is ever absent we fall
   * through to the map and the call stays cross-origin and unsealed, which is today's behaviour.
   */ const shellMarvinPath = $900815ab2142dd8c$var$platformEnvConfig("API_URL")?.MARVIN;
    if ($900815ab2142dd8c$export$97f4c254b641e719() && shellMarvinPath) return `${window.location.origin}${shellMarvinPath.replace($900815ab2142dd8c$var$ORGCODE_PLACEHOLDER, $900815ab2142dd8c$var$orgCode)}`;
    const marvinBaseUrl = $900815ab2142dd8c$var$marvinHostMapping[currentHost] || currentHost.includes("localhost") && $900815ab2142dd8c$var$marvinHostMapping["app.crm4b2c.com"] || $900815ab2142dd8c$var$marvinHostMapping["in21.leadsquared.com"];
    return marvinBaseUrl + "/" + $900815ab2142dd8c$var$orgCode;
};
const $900815ab2142dd8c$export$6f250eed5fbbbf6f = $900815ab2142dd8c$var$getMarvinHost();
const $900815ab2142dd8c$var$getHostMapping = (host)=>{
    if (host.includes("staging")) return $900815ab2142dd8c$var$hostMapping["run.lsq-staging.com"];
    else if (host.includes("leadsquared.com")) return $900815ab2142dd8c$var$hostMapping["run.leadsquared.com"];
    return $900815ab2142dd8c$var$hostMapping["run.crm4b2c.com"];
};
const $900815ab2142dd8c$var$envHostMapping = {
    local: "",
    test: "https://casa-lead-360.fieldsales.crm4b2c.com",
    staging: "https://casa-lead-360.fieldsales.lsq-staging.com",
    prod_in21: "https://casa-lead-360-in21.leadsquared.com",
    prod_in22: "https://casa-lead-360-in22.leadsquared.com"
};
const $900815ab2142dd8c$var$getCSSHost = ()=>{
    const currentHost = window.location.host;
    if (currentHost.includes("localhost")) return $900815ab2142dd8c$var$envHostMapping.local;
    if (currentHost.includes("staging.com")) return $900815ab2142dd8c$var$envHostMapping.staging;
    if (currentHost.includes("in22.leadsquared.com")) return $900815ab2142dd8c$var$envHostMapping.prod_in22;
    if (currentHost.includes("leadsquared.com")) return $900815ab2142dd8c$var$envHostMapping.prod_in21;
    return $900815ab2142dd8c$var$envHostMapping.test;
};
const $900815ab2142dd8c$export$3d9f1402b79f9a49 = (0, $ecb9f48c91a13dda$export$d2b5531ce9550fb0) || $900815ab2142dd8c$var$getCSSHost();
const $900815ab2142dd8c$export$5e032988b71f6158 = $900815ab2142dd8c$var$hostMapping?.[window.location.host] || $900815ab2142dd8c$var$getHostMapping(window.location.host);
const $900815ab2142dd8c$export$a0867b79bace5897 = $900815ab2142dd8c$export$97f4c254b641e719() ? `${window.location.origin}/api/fs/casa-service/v1` : `https://${$900815ab2142dd8c$export$5e032988b71f6158}/api/casa-service/v1`;


const $169212bfbf17269b$export$2fb87bbf5418dbe1 = ()=>{
    if (window?.casaHelperUtils?.handleLogOut) window?.casaHelperUtils?.handleLogOut();
    else console.error("unable to redirect to login");
};





const $f6b97f0653be8fc0$export$6c9d0c3cc08fd961 = {
    pending: 0,
    completed: 1,
    cancelled: 2,
    overdue: 3
};
const $f6b97f0653be8fc0$var$fetchTaskCount = async (config)=>{
    const body = {
        Parameter: {
            StatusCode: $f6b97f0653be8fc0$export$6c9d0c3cc08fd961[config?.taskStatus] ?? -1,
            Id: (0, $44a3924e32d3fca5$export$a92b4a6e98c0f64b)()
        },
        Sorting: {
            Direction: 0
        },
        Paging: {
            PageIndex: 1,
            PageSize: 1
        }
    };
    const response = await (0, $59a4e0a7efee5abb$export$959cf6db53f31b9f)(body);
    if (response.status !== 200) throw new Error("Failed to fetch task count");
    return response.data?.TotalRecords;
};
var $f6b97f0653be8fc0$export$2e2bcd8739ae039 = $f6b97f0653be8fc0$var$fetchTaskCount;





const $44a3924e32d3fca5$var$leadWidgetTileStyles = [
    {
        key: "Icon",
        value: "Icon"
    },
    {
        key: "Image",
        value: "Image"
    }
];
const $44a3924e32d3fca5$var$object360WidgetTypes = {
    SINGLE_COUNTER: "singlecounter",
    BANNER: "banner",
    WEB_VIEW: "webview",
    TILE: "tile"
};
const $44a3924e32d3fca5$export$43dc4e2240cb354f = (widgetConfig)=>{
    const { tileStyle: tileStyle, showCount: showCount, widgetStyle: widgetStyle, widgetType: widgetType } = widgetConfig;
    if (widgetStyle === "Detailed" && widgetType === "customwidget") return $44a3924e32d3fca5$var$object360WidgetTypes.WEB_VIEW;
    if (tileStyle === $44a3924e32d3fca5$var$leadWidgetTileStyles[1].value) return $44a3924e32d3fca5$var$object360WidgetTypes.BANNER;
    if (tileStyle === $44a3924e32d3fca5$var$leadWidgetTileStyles[0].value) return showCount ? $44a3924e32d3fca5$var$object360WidgetTypes.SINGLE_COUNTER : $44a3924e32d3fca5$var$object360WidgetTypes.TILE;
    return null;
};
const $44a3924e32d3fca5$export$e2575ed62a2f107b = ()=>{
    return JSON.parse(localStorage.getItem((0, $768a17376248dce8$export$588c7fdda06fbb0a).lead360CacheName) || "{}");
};
const $44a3924e32d3fca5$export$e211dab362b85880 = (cache)=>{
    localStorage.setItem((0, $768a17376248dce8$export$588c7fdda06fbb0a).lead360CacheName, JSON.stringify(cache));
};
const $44a3924e32d3fca5$export$a92b4a6e98c0f64b = ()=>{
    const url = window.location.href;
    const params = new URL(url).searchParams;
    return params.get("LeadID");
};
const $44a3924e32d3fca5$export$8750010911c9f8b9 = ()=>{
    const userDetails = (0, $37fbb54a01ff9d75$export$714d3544202969b)();
    const userTimezone = (0, $768a17376248dce8$export$bc6bb0e72ae9e582).find((timezone)=>timezone.value.split("$")[1] === userDetails?.TimeZone);
    return userTimezone?.value?.split("$")[0] ?? "";
};
const $44a3924e32d3fca5$var$getTaskFilter = (config)=>{
    return {
        status: (0, $f6b97f0653be8fc0$export$6c9d0c3cc08fd961)[config?.taskStatus] ?? -1
    };
};
const $44a3924e32d3fca5$var$getOpportunityFilter = (config)=>{
    return {
        code: config?.opportunityTypes?.[0]?.code
    };
};
const $44a3924e32d3fca5$var$getActivityFilter = (config)=>{
    return {
        activityTypes: config?.activityTypes || [],
        dateFilter: {
            type: config?.dateFilters?.id
        }
    };
};
const $44a3924e32d3fca5$var$openTab = (type, filters)=>{
    window?.lead360HelperUtils?.openTab(type, filters);
};
const $44a3924e32d3fca5$var$openWidgetTab = (config)=>{
    const widgetType = config?.widgetType;
    switch(widgetType){
        case (0, $768a17376248dce8$export$45f3f39dac49db7f).ABOUT:
            $44a3924e32d3fca5$var$openTab((0, $768a17376248dce8$export$1ca33315cf3cdede)[widgetType]);
            break;
        case (0, $768a17376248dce8$export$45f3f39dac49db7f).NOTES:
            $44a3924e32d3fca5$var$openTab((0, $768a17376248dce8$export$1ca33315cf3cdede)[widgetType]);
            break;
        case (0, $768a17376248dce8$export$45f3f39dac49db7f).DOCUMENTS:
            $44a3924e32d3fca5$var$openTab((0, $768a17376248dce8$export$1ca33315cf3cdede)[widgetType]);
            break;
        case (0, $768a17376248dce8$export$45f3f39dac49db7f).TASKS:
            $44a3924e32d3fca5$var$openTab((0, $768a17376248dce8$export$1ca33315cf3cdede)[widgetType], $44a3924e32d3fca5$var$getTaskFilter(config));
            break;
        case (0, $768a17376248dce8$export$45f3f39dac49db7f).OPPORTUNITIES:
            $44a3924e32d3fca5$var$openTab((0, $768a17376248dce8$export$1ca33315cf3cdede)[widgetType], $44a3924e32d3fca5$var$getOpportunityFilter(config));
            break;
        case (0, $768a17376248dce8$export$45f3f39dac49db7f).ACTIVITES:
            $44a3924e32d3fca5$var$openTab((0, $768a17376248dce8$export$1ca33315cf3cdede)[widgetType], $44a3924e32d3fca5$var$getActivityFilter(config));
    }
};
const $44a3924e32d3fca5$export$29ac8f00d0f8fe39 = async (url)=>{
    if (!$44a3924e32d3fca5$export$f8bf049e73c59266(url)) {
        window.open(url, "_blank");
        return;
    }
    const body = {
        data: url,
        leadId: $44a3924e32d3fca5$export$a92b4a6e98c0f64b()
    };
    const response = await (0, $59a4e0a7efee5abb$export$c7ca02db610e3446)(body);
    window.open(response.data, "_blank");
};
const $44a3924e32d3fca5$export$73f97a394323284c = (config)=>{
    const widgetType = config?.widgetType;
    if (widgetType === (0, $768a17376248dce8$export$45f3f39dac49db7f).CUSTOM_WIDGET) {
        $44a3924e32d3fca5$export$29ac8f00d0f8fe39(config?.url);
        return;
    }
    if (typeof window?.lead360HelperUtils?.openTab !== "function") return;
    $44a3924e32d3fca5$var$openWidgetTab(config);
};
const $44a3924e32d3fca5$export$bdcb7d5b3e07911b = ()=>{
    return !!document?.getElementById("mip_pre_reqdata");
};
const $44a3924e32d3fca5$var$mailMergePattern = /@\{([\w-]+):([\w\s[\]-]+),\s?\}/;
const $44a3924e32d3fca5$export$f8bf049e73c59266 = (url)=>{
    return $44a3924e32d3fca5$var$mailMergePattern.test(url);
};


/**
 * Axios adapter over the platform's payload-crypto library, for the NextGen custom-domain
 * deployment (PK-5181).
 *
 * This app is a microfrontend: the NextGen shell appends its bundle as a <script> into its OWN
 * document, so there is no build of ours to put a <script src=".../payload-crypto.min.js"> tag
 * into. The shell already loads that library -- gated on its custom-domain build -- and it lands
 * on the one window we share with it. So the library is never bundled and never loaded here; it
 * is borrowed.
 *
 * Two consequences the plumbing below depends on:
 *
 *  - configure() is NOT called. window.PayloadCrypto is a single instance shared with the shell,
 *    which has already configured it with its own error reporting. Configuring it again would
 *    replace that, and the handshake, session key and IndexedDB record are shared either way.
 *
 *  - Every call is guarded rather than the interceptors being registered once. Our bundle is
 *    appended at an arbitrary point in the shell's lifecycle, so the library may not be resolved
 *    yet; a missing library degrades to plaintext instead of throwing.
 *
 * No crypto happens here. Everything below is plumbing between that library and axios.
 */ 
const $b3a3e0c981385abf$var$REINIT_HEADER = "x-lsq-enc-reinit";
const $b3a3e0c981385abf$var$lib = ()=>typeof window === "undefined" ? undefined : window.PayloadCrypto;
const $b3a3e0c981385abf$export$5371678af074b76 = ()=>Boolean($b3a3e0c981385abf$var$lib());
const $b3a3e0c981385abf$var$parseIfJson = (value)=>{
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(value);
    } catch  {
        // A sealed response that is not JSON is legitimate; hand back the plaintext untouched.
        return value;
    }
};
/**
 * axios splits a request across url/params/data, but prepareRequest wants one url string and one
 * body. getUri with an empty baseURL applies the instance's own param serializer, so arrays and
 * null params serialize exactly as they would on an unencrypted request.
 */ const $b3a3e0c981385abf$var$toRequestUrl = (instance, config)=>{
    try {
        return instance.getUri({
            ...config,
            baseURL: ""
        });
    } catch  {
        return config.url;
    }
};
/**
 * 409 is the gateway rejecting a ticket it can no longer unseal -- an expired or rotated session.
 * Anything else, or a request that has already been replayed once, is handed straight back so a
 * persistent 409 cannot loop.
 */ const $b3a3e0c981385abf$var$shouldReplayAfterReinit = (payloadCrypto, error)=>{
    if (!payloadCrypto) return false;
    if (error?.response?.status !== 409) return false;
    return Boolean(error.config) && !error.config.lsqCryptoRetried;
};
/**
 * Unseal a sealed error body in place.
 *
 * The success interceptor unseals; the error path did not, and it is the only other place a
 * sealed body reaches a call site. Call sites read error.response.data.message, which on a
 * sealed body is a property of a JWE string rather than an object, so it comes back undefined
 * and the UI falls back to a generic message, losing what the server actually said.
 *
 * decryptResponse returns its input unchanged when the body is not sealed, so this is inert on
 * plaintext errors. A failure here must never replace the original error: the caller needs the
 * status it actually got, not a decryption fault.
 */ const $b3a3e0c981385abf$var$unsealErrorBody = async (payloadCrypto, error)=>{
    const response = error?.response;
    if (!payloadCrypto || !response || response.data === undefined || response.data === null) return;
    try {
        const decrypted = await payloadCrypto.decryptResponse(response.data);
        if (decrypted !== response.data) response.data = $b3a3e0c981385abf$var$parseIfJson(decrypted);
    } catch  {
    /* leave the body exactly as it arrived */ }
};
function $b3a3e0c981385abf$export$1801e4d5dec3e576(instance) {
    // Off the custom domain there is no gateway at `${window.location.origin}/api/gw` to hand a
    // sealed request to, and the API calls are cross-origin anyway. Register nothing at all there
    // rather than pay an interceptor hop per request for a branch that never fires.
    if (!(0, $900815ab2142dd8c$export$97f4c254b641e719)()) return instance;
    instance.interceptors.request.use(async (config)=>{
        const payloadCrypto = $b3a3e0c981385abf$var$lib();
        if (!payloadCrypto) return config;
        const gatewayBaseUrl = (0, $900815ab2142dd8c$export$8391516e4e7c9635)();
        // Stashed before anything is sealed so a 409 retry re-seals from the original rather than
        // sealing the ciphertext a second time.
        if (!config.lsqCryptoOriginal) config.lsqCryptoOriginal = {
            url: config.url,
            params: config.params,
            data: config.data
        };
        // prepareRequest resolves to { url, body, encrypted, headers } -- an object, not a tuple.
        const prepared = await payloadCrypto.prepareRequest($b3a3e0c981385abf$var$toRequestUrl(instance, config), {
            body: config.data,
            gatewayBaseUrl: gatewayBaseUrl
        });
        config.url = prepared.url;
        // The params are now inside `url`; leaving them set would append them a second time.
        config.params = undefined;
        if (prepared.body !== null && prepared.body !== undefined) config.data = prepared.body;
        // Its headers carry the ticket and, once a body has been sealed, Content-Type:
        // application/jose. The instance default of application/json would make the gateway
        // read a JWE as JSON, so these have to win over the instance headers.
        config.headers = {
            ...config.headers,
            ...prepared.headers
        };
        return config;
    });
    instance.interceptors.response.use(async (response)=>{
        const payloadCrypto = $b3a3e0c981385abf$var$lib();
        if (!payloadCrypto) return response;
        const decrypted = await payloadCrypto.decryptResponse(response.data);
        if (decrypted !== response.data) response.data = $b3a3e0c981385abf$var$parseIfJson(decrypted);
        // The gateway asks for a fresh session out of band; renewing now keeps the cost off the
        // next request's critical path.
        if (response.headers?.[$b3a3e0c981385abf$var$REINIT_HEADER]) await payloadCrypto.reinit({
            gatewayBaseUrl: (0, $900815ab2142dd8c$export$8391516e4e7c9635)()
        });
        return response;
    }, async (error)=>{
        const payloadCrypto = $b3a3e0c981385abf$var$lib();
        // Before any early return, and for every status: a sealed body is lost either way.
        await $b3a3e0c981385abf$var$unsealErrorBody(payloadCrypto, error);
        if (!$b3a3e0c981385abf$var$shouldReplayAfterReinit(payloadCrypto, error)) return Promise.reject(error);
        try {
            await payloadCrypto.reinit({
                gatewayBaseUrl: (0, $900815ab2142dd8c$export$8391516e4e7c9635)()
            });
        } catch  {
            return Promise.reject(error);
        }
        const { config: config } = error;
        return instance.request({
            ...config,
            ...config.lsqCryptoOriginal || {},
            lsqCryptoOriginal: undefined,
            lsqCryptoRetried: true
        });
    });
    return instance;
}


// Function to get the authorization token
const $276c95cd1d1c837b$var$axiosInstanceWeb = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).create({
    baseURL: (0, $900815ab2142dd8c$export$a0867b79bace5897),
    headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        "User-Agent": false
    },
    withCredentials: false
});
// Payload encryption (FSP-5412). Registered before the response interceptor below on purpose:
// axios runs response interceptors in registration order, so this one opens a sealed body before
// the handler below reads it, and retries a 409 from an expired session before anything can
// surface it to the user. It is a no-op outside the NextGen custom-domain deployment.
(0, $b3a3e0c981385abf$export$1801e4d5dec3e576)($276c95cd1d1c837b$var$axiosInstanceWeb);
if ((0, $44a3924e32d3fca5$export$bdcb7d5b3e07911b)()) $276c95cd1d1c837b$var$axiosInstanceWeb.defaults.withCredentials = true;
else if ((0, $37fbb54a01ff9d75$export$550ea6e0aa9f31e3)() && (0, $37fbb54a01ff9d75$export$b64ebfa99e8dc2a0)()) {
    // Use the fetch adapter so same-origin requests don't carry cookies. XHR always sends them
    // same-origin regardless of withCredentials; fetch honours credentials: 'omit'. Requires axios >= 1.7.
    // Guarded on the credentials being present: without them this would drop cookies AND send no
    // token, leaving the request with no credentials at all. Falling through keeps the XHR adapter,
    // which still sends same-origin cookies.
    $276c95cd1d1c837b$var$axiosInstanceWeb.defaults.adapter = "fetch";
    $276c95cd1d1c837b$var$axiosInstanceWeb.defaults.withCredentials = "omit";
    $276c95cd1d1c837b$var$axiosInstanceWeb.defaults.headers.common["x-lsq-marvin-token"] = (0, $37fbb54a01ff9d75$export$550ea6e0aa9f31e3)();
    $276c95cd1d1c837b$var$axiosInstanceWeb.defaults.headers.common["x-lsq-regionId"] = (0, $37fbb54a01ff9d75$export$b64ebfa99e8dc2a0)();
}
// Add a request interceptor to capture the start time
$276c95cd1d1c837b$var$axiosInstanceWeb.interceptors.request.use((config)=>{
    config.startTime = performance.now(); // Record the start time
    return config;
});
$276c95cd1d1c837b$var$axiosInstanceWeb.interceptors.response.use((response)=>{
    const endTime = performance.now(); // Record the end time
    const duration = endTime - response.config.startTime;
    response.responseTime = duration;
    if (response.headers?.authorization) {
        const encryptedToken = (0, $0934e0939605d48c$export$a143d493d941bafc).from(response.headers.authorization, "utf-8").toString("base64");
        sessionStorage.setItem("casa-authorization-token", encryptedToken);
        $276c95cd1d1c837b$var$axiosInstanceWeb.defaults.headers.common["authorization"] = (0, $0934e0939605d48c$export$a143d493d941bafc).from(encryptedToken, "base64").toString("utf-8");
    }
    return response;
}, (error)=>{
    if (error?.response?.status === 401) (0, $169212bfbf17269b$export$2fb87bbf5418dbe1)();
    return Promise.reject(error);
});
var $276c95cd1d1c837b$export$2e2bcd8739ae039 = $276c95cd1d1c837b$var$axiosInstanceWeb;









// Function to get the authorization token
const $0343015684128409$var$axiosInstanceMarvin = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).create({
    baseURL: (0, $900815ab2142dd8c$export$6f250eed5fbbbf6f),
    headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        "User-Agent": false
    }
});
// Payload encryption (FSP-5412). marvinHost is a path on the serving origin on the custom-domain
// deployment, where appgateway seals /api/v1/Marvin.svc/** on the same route table as the
// FieldSales APIs. Registered before the response interceptor below for the same reason as in
// axiosInstance.js, and a no-op everywhere else.
(0, $b3a3e0c981385abf$export$1801e4d5dec3e576)($0343015684128409$var$axiosInstanceMarvin);
if ((0, $44a3924e32d3fca5$export$bdcb7d5b3e07911b)()) $0343015684128409$var$axiosInstanceMarvin.defaults.withCredentials = true;
else if ((0, $37fbb54a01ff9d75$export$550ea6e0aa9f31e3)() && (0, $37fbb54a01ff9d75$export$b64ebfa99e8dc2a0)()) {
    $0343015684128409$var$axiosInstanceMarvin.defaults.headers.common["x-lsq-marvin-token"] = (0, $37fbb54a01ff9d75$export$550ea6e0aa9f31e3)();
    $0343015684128409$var$axiosInstanceMarvin.defaults.headers.common["x-lsq-regionId"] = (0, $37fbb54a01ff9d75$export$b64ebfa99e8dc2a0)();
}
// Add a request interceptor to capture the start time  
$0343015684128409$var$axiosInstanceMarvin.interceptors.request.use((config)=>{
    config.startTime = performance.now(); // Record the start time  
    return config;
});
$0343015684128409$var$axiosInstanceMarvin.interceptors.response.use((response)=>{
    const endTime = performance.now(); // Record the end time  
    const duration = endTime - response.config.startTime;
    response.responseTime = duration;
    if (response.headers?.authorization) {
        const encryptedToken = (0, $0934e0939605d48c$export$a143d493d941bafc).from(response.headers.authorization, "utf-8").toString("base64");
        sessionStorage.setItem("casa-authorization-token", encryptedToken);
        $0343015684128409$var$axiosInstanceMarvin.defaults.headers.common["authorization"] = (0, $0934e0939605d48c$export$a143d493d941bafc).from(encryptedToken, "base64").toString("utf-8");
    }
    return response;
}, (error)=>{
    if (error?.response?.status === 401) (0, $169212bfbf17269b$export$2fb87bbf5418dbe1)();
    return Promise.reject(error);
});
var $0343015684128409$export$2e2bcd8739ae039 = $0343015684128409$var$axiosInstanceMarvin;


// Lead-360 config used to be cached by the browser for 15 minutes via HTTP cache
// headers. Security asked us to drop those headers, so we cache the response in
// sessionStorage instead: per-tab, cleared on tab close, and bounded by the same
// 15-minute TTL. Keyed per leadTypeId since the config differs by lead type.
const $59a4e0a7efee5abb$var$LEAD360_CACHE_TTL_MS = 900000;
const $59a4e0a7efee5abb$var$lead360CacheKey = (leadTypeId)=>`lead360:${leadTypeId || "default"}`;
const $59a4e0a7efee5abb$var$readLead360Cache = (key)=>{
    try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        const { data: data, ts: ts } = JSON.parse(raw);
        if (!ts || Date.now() - ts > $59a4e0a7efee5abb$var$LEAD360_CACHE_TTL_MS) {
            sessionStorage.removeItem(key);
            return null;
        }
        // Wrap so the caller can tell "cache hit" from a cached-but-falsy value.
        return {
            data: data
        };
    } catch  {
        // Corrupt entry / storage unavailable — treat as a cache miss.
        return null;
    }
};
const $59a4e0a7efee5abb$var$writeLead360Cache = (key, data)=>{
    try {
        sessionStorage.setItem(key, JSON.stringify({
            data: data,
            ts: Date.now()
        }));
    } catch  {
    // Private mode / quota exceeded — caching is best-effort, so ignore.
    }
};
const $59a4e0a7efee5abb$export$85322ecaf33761f0 = async ()=>{
    const leadTypeId = await window.lead360HelperUtils?.getLeadTypeId();
    const cacheKey = $59a4e0a7efee5abb$var$lead360CacheKey(leadTypeId);
    const cached = $59a4e0a7efee5abb$var$readLead360Cache(cacheKey);
    if (cached) // Mirror the axios response shape the caller expects.
    return {
        status: 200,
        data: cached.data
    };
    const response = await (0, $276c95cd1d1c837b$export$2e2bcd8739ae039).get(`/lead-360/user?leadTypeId=${leadTypeId || "default"}`);
    if (response?.status === 200) $59a4e0a7efee5abb$var$writeLead360Cache(cacheKey, response.data);
    return response;
};
const $59a4e0a7efee5abb$export$73b84337c4da92bc = async (key)=>{
    try {
        const response = await (0, $276c95cd1d1c837b$export$2e2bcd8739ae039).post(`/widgets/signedUrl`, {
            keys: [
                key
            ]
        });
        return response.data.urls[0]; // Adjust the response to match the actual structure of your API response
    } catch (error) {
        console.error("Error fetching image URL:", error);
        return null; // Return null if there's an error
    }
};
const $59a4e0a7efee5abb$export$959cf6db53f31b9f = async (body)=>{
    return await (0, $0343015684128409$export$2e2bcd8739ae039).post(`Lead/Task/Get`, body);
};
const $59a4e0a7efee5abb$export$37dd67474bba4014 = async (body)=>{
    return await (0, $0343015684128409$export$2e2bcd8739ae039).post(`Activity/Get`, body);
};
const $59a4e0a7efee5abb$export$cca3dfc63b71dec2 = async (body)=>{
    return await (0, $0343015684128409$export$2e2bcd8739ae039).post(`Activity/Get`, body);
};
const $59a4e0a7efee5abb$export$c7ca02db610e3446 = async (body)=>{
    return await (0, $0343015684128409$export$2e2bcd8739ae039).post(`/Connector/MailMergedContent/Get`, body);
};



const $53a8347334f1af9b$export$8b850913fd7982ab = (setCssLoad = ()=>{})=>{
    setCssLoad({
        responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending
    });
    try {
        // The new (Vite) build loads its own hashed CSS via the casalead360entry
        // loader, so skip the legacy initialize360.css injection there. Detected
        // via LEAD360_ASSET_VERSION, which only the new build sets — so the legacy
        // Parcel build keeps injecting initialize360.css exactly as before.
        if ((0, $900815ab2142dd8c$export$3d9f1402b79f9a49) && true) {
            const link2 = document.createElement("link");
            link2.href = `${0, $900815ab2142dd8c$export$3d9f1402b79f9a49}/initialize360.css`;
            link2.rel = "stylesheet";
            document.head.appendChild(link2);
        }
        setCssLoad({
            responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestFullfilled
        });
    } catch (error) {
        console.error(error);
        setCssLoad({
            responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestRejected
        });
    }
};
const $53a8347334f1af9b$var$initializeLead360 = async (setLead360)=>{
    try {
        setLead360({
            responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending,
            data: null
        });
        const response = await (0, $59a4e0a7efee5abb$export$85322ecaf33761f0)();
        if (response.status === 200) {
            if (!response.data?.leadPage) throw new Error("Lead360 config not found");
            setLead360({
                responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestFullfilled,
                data: response.data
            });
        } else throw new Error("Failed to fetch lead360");
    } catch (error) {
        console.error(error);
        setLead360({
            responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestRejected,
            data: null
        });
        window.lead360HelperUtils?.handleFallback();
    }
};
const $53a8347334f1af9b$var$getWidgetMap = (lead360)=>{
    const widgetMap = {};
    lead360?.data?.leadPage?.widgets?.forEach((widget)=>{
        widgetMap[widget.id] = widget;
    });
    return widgetMap;
};
const $53a8347334f1af9b$var$useInitializeLead360 = ()=>{
    const [lead360, setLead360] = (0, $8NFma.useState)({
        responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending,
        data: null
    });
    const [cssLoad, setCssLoad] = (0, $8NFma.useState)({
        responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending
    });
    (0, $8NFma.useEffect)(()=>{
        $53a8347334f1af9b$var$initializeLead360(setLead360);
        $53a8347334f1af9b$export$8b850913fd7982ab(setCssLoad);
    }, []);
    return {
        loading: lead360.responseStatus === (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending || cssLoad.responseStatus === (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending,
        error: lead360.responseStatus === (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestRejected || cssLoad.responseStatus === (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestRejected,
        pageConfig: lead360?.data?.leadPage?.config,
        widgetMap: $53a8347334f1af9b$var$getWidgetMap(lead360),
        initialize: $53a8347334f1af9b$var$initializeLead360
    };
};
var $53a8347334f1af9b$export$2e2bcd8739ae039 = $53a8347334f1af9b$var$useInitializeLead360;



parcelRequire("8NFma");
var $a228a8739d2924a4$exports = {};

$a228a8739d2924a4$exports = (parcelRequire("Oz2mM")).default;

$a228a8739d2924a4$exports.utils = (parcelRequire("1tBXw"));

$a228a8739d2924a4$exports.calculateUtils = (parcelRequire("6AOui"));

$a228a8739d2924a4$exports.Responsive = (parcelRequire("ivRjJ")).default;

$a228a8739d2924a4$exports.Responsive.utils = (parcelRequire("jnVoq"));

$a228a8739d2924a4$exports.WidthProvider = (parcelRequire("82fVD")).default;



var $084cd804fcbb83a9$export$21221b8db8b0424b;
var $084cd804fcbb83a9$export$1f6849bc3d1575b6;
$084cd804fcbb83a9$export$21221b8db8b0424b = `x2UIGG_reactGridLayout`;
$084cd804fcbb83a9$export$1f6849bc3d1575b6 = `x2UIGG_reactGridWrapper`;


const $e3447d102e285015$var$ResponsiveGridLayout = (0, $a228a8739d2924a4$exports.WidthProvider)((0, $a228a8739d2924a4$exports.Responsive));
const $e3447d102e285015$var$ReactGrid = ({ config: config = {}, children: children })=>{
    const defaultConfig = {
        rowHeight: 20,
        margin: [
            15,
            20
        ],
        containerPadding: [
            5,
            10
        ],
        isDraggable: false,
        isResizable: false
    };
    const finalConfig = {
        ...defaultConfig,
        ...config
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: $084cd804fcbb83a9$export$1f6849bc3d1575b6,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($e3447d102e285015$var$ResponsiveGridLayout, {
            ...finalConfig,
            className: `${$084cd804fcbb83a9$export$21221b8db8b0424b} ${config?.className}`,
            children: children
        })
    });
};
var $e3447d102e285015$export$2e2bcd8739ae039 = $e3447d102e285015$var$ReactGrid;



parcelRequire("8NFma");

parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");




const $632925c94ff46815$var$fetchOpportunityCount = async (config)=>{
    try {
        const body = {
            PageIndex: 1,
            PageSize: 1,
            Columns: "Status",
            SearchText: "",
            IsOpportunity: true,
            SortOn: "CreatedOn",
            SortBy: 1
        };
        const customFilters = {
            GrpConOp: "and",
            QueryTimeZone: (0, $44a3924e32d3fca5$export$8750010911c9f8b9)(),
            Conditions: []
        };
        body.CustomFilters = JSON.stringify(customFilters);
        const advancedSearch = {
            GrpConOp: "and",
            Conditions: [
                {
                    Type: "Activity",
                    ConOp: "and",
                    RowCondition: [
                        {
                            SubConOp: "and",
                            LSO: "ActivityEvent",
                            LSO_Type: "PAEvent",
                            Operator: "eq",
                            RSO: config?.opportunityTypes?.[0]?.code,
                            RSO_IsMailMerged: false
                        }
                    ]
                },
                {
                    Type: "Activity",
                    ConOp: "and",
                    RowCondition: [
                        {
                            SubConOp: "and",
                            LSO: "RelatedProspectId",
                            LSO_Type: "String",
                            Operator: "eq",
                            RSO: (0, $44a3924e32d3fca5$export$a92b4a6e98c0f64b)(),
                            RSO_IsMailMerged: false
                        }
                    ]
                }
            ]
        };
        body.AdvancedSearch = JSON.stringify(advancedSearch);
        const response = await (0, $59a4e0a7efee5abb$export$37dd67474bba4014)(body);
        if (response.status !== 200) throw new Error("Failed to fetch opportunity count");
        return response.data?.RecordCount;
    } catch (error) {
        console.error(error);
        throw new Error(error.message);
    }
};
var $632925c94ff46815$export$2e2bcd8739ae039 = $632925c94ff46815$var$fetchOpportunityCount;




const $41d9698be97ec553$var$getActivityType = (config)=>{
    const activityType = config?.activityTypes?.[0]?.id;
    if (activityType !== "select_all") return activityType;
    return null;
};
const $41d9698be97ec553$var$fetchActivityCount = async (config)=>{
    try {
        const body = {
            PageIndex: 1,
            PageSize: 1,
            Columns: "LeadIdentifier,ActivityEvent_Note,PACreatedOn,Owner,Status,P_ProspectStage,P_mx_City,P_PhotoUrl,P_mx_State,P_mx_Country,P_DoNotEmail,P_DoNotCall",
            SearchText: "",
            IsOpportunity: false,
            SortOn: "ModifiedOn",
            SortBy: 1
        };
        const activityType = $41d9698be97ec553$var$getActivityType(config);
        if (activityType) body.Code = activityType;
        const customFilters = {
            GrpConOp: "and",
            QueryTimeZone: (0, $44a3924e32d3fca5$export$8750010911c9f8b9)(),
            Conditions: []
        };
        body.CustomFilters = JSON.stringify(customFilters);
        const advancedSearch = {
            GrpConOp: "And",
            Conditions: [
                {
                    Type: "Activity",
                    ConOp: "and",
                    RowCondition: [
                        activityType !== "select_all" && {
                            SubConOp: "And",
                            LSO: "ActivityEvent",
                            LSO_Type: "PAEvent",
                            Operator: "eq",
                            RSO_IsMailMerged: false,
                            RSO: activityType
                        },
                        {
                            SubConOp: "And",
                            LSO_Type: "DateTime",
                            LSO: "ActivityTime",
                            Operator: "eq",
                            RSO: config?.dateFilters?.id
                        }
                    ].filter(Boolean)
                },
                {
                    Type: "Lead",
                    ConOp: "and",
                    RowCondition: [
                        {
                            SubConOp: "And",
                            LSO: "ProspectID",
                            LSO_Type: "String",
                            Operator: "eq",
                            RSO_IsMailMerged: false,
                            RSO: (0, $44a3924e32d3fca5$export$a92b4a6e98c0f64b)()
                        },
                        {
                            RSO: ""
                        }
                    ]
                }
            ],
            QueryTimeZone: "India Standard Time"
        };
        body.AdvancedSearch = JSON.stringify(advancedSearch);
        const response = await (0, $59a4e0a7efee5abb$export$cca3dfc63b71dec2)(body);
        if (response.status !== 200) throw new Error("Failed to fetch activity count");
        return response.data?.RecordCount;
    } catch (error) {
        throw new Error(error.message);
    }
};
var $41d9698be97ec553$export$2e2bcd8739ae039 = $41d9698be97ec553$var$fetchActivityCount;


const $9c0521c08832fcc3$var$apiMap = {
    [(0, $768a17376248dce8$export$45f3f39dac49db7f).ACTIVITES]: (0, $41d9698be97ec553$export$2e2bcd8739ae039),
    [(0, $768a17376248dce8$export$45f3f39dac49db7f).TASKS]: (0, $f6b97f0653be8fc0$export$2e2bcd8739ae039),
    [(0, $768a17376248dce8$export$45f3f39dac49db7f).OPPORTUNITIES]: (0, $632925c94ff46815$export$2e2bcd8739ae039)
};
const $9c0521c08832fcc3$var$initialize = async (setCount, config)=>{
    setCount({
        responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending,
        data: null
    });
    try {
        const api = $9c0521c08832fcc3$var$apiMap[config.widgetType];
        if (!api) throw new Error(`No API found for widget type: ${config.widgetType}`);
        const response = await api(config);
        setCount({
            responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestFullfilled,
            data: response
        });
    } catch (error) {
        console.error(error);
        setCount({
            responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestRejected,
            data: null
        });
    }
};
const $9c0521c08832fcc3$var$useCount = (config)=>{
    const [count, setCount] = (0, $8NFma.useState)({
        responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending,
        data: null
    });
    (0, $8NFma.useEffect)(()=>{
        $9c0521c08832fcc3$var$initialize(setCount, config);
    }, [
        config
    ]);
    return {
        initialize: ()=>$9c0521c08832fcc3$var$initialize(setCount, config),
        loading: count.responseStatus === (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending,
        error: count.responseStatus === (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestRejected,
        count: count.data
    };
};
var $9c0521c08832fcc3$export$2e2bcd8739ae039 = $9c0521c08832fcc3$var$useCount;



parcelRequire("8NFma");


// Per-deploy asset path segment, injected ONLY by the new (Vite) build as
// "static/<version>" so public images resolve to the cache-busted, 1-year
// immutable /static tree. The legacy Parcel build does not set it, so it falls
// back to the unversioned root path and its output is unchanged.
const $f835912be3e3e623$var$assetVersion = undefined;
const $f835912be3e3e623$var$Icon = ({ src: src, alt: alt, width: width = 24, height: height = 24, color: color })=>{
    const iconSrc = $f835912be3e3e623$var$assetVersion ? `${0, $900815ab2142dd8c$export$3d9f1402b79f9a49}/${$f835912be3e3e623$var$assetVersion}/${src}` : `${0, $900815ab2142dd8c$export$3d9f1402b79f9a49}/${src}`;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: `lead360IconWrapper ${color}`,
        style: {
            width: width,
            height: height
        },
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
            src: iconSrc,
            alt: alt,
            "data-testid": "lead360-icon"
        })
    });
};
var $f835912be3e3e623$export$2e2bcd8739ae039 = $f835912be3e3e623$var$Icon;



parcelRequire("8NFma");

const $be0c07f0fc4aecc3$var$Text = ({ text: text, className: className = "", color: color = "var(--N100)" })=>{
    if (text === undefined || text === null || text === "") return null;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: `lead360Text ${className}`,
        title: text,
        style: {
            color: color
        },
        "data-testid": "lead360-text",
        children: text
    });
};
var $be0c07f0fc4aecc3$export$2e2bcd8739ae039 = $be0c07f0fc4aecc3$var$Text;



const $c9b5aa5335b87032$var$CounterWidget = ({ widgetInformation: widgetInformation, onWidgetEdit: onWidgetEdit })=>{
    const { config: config = {} } = widgetInformation || {};
    const { identifier: identifier, icon: icon } = config || {};
    const { count: count, loading: loading, error: error, initialize: initialize } = (0, $9c0521c08832fcc3$export$2e2bcd8739ae039)(config);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        onClick: onWidgetEdit,
        className: "lead360CounterWrapper",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "lead360CounterContent",
                children: [
                    !error && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $be0c07f0fc4aecc3$export$2e2bcd8739ae039), {
                        text: loading ? "..." : count,
                        className: "ng_h_5_b",
                        color: "rgb(var(--ng-neutral-90))"
                    }),
                    error && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                        className: "retryButton",
                        onClick: initialize,
                        children: "retry"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $be0c07f0fc4aecc3$export$2e2bcd8739ae039), {
                        text: identifier,
                        className: "ng_p_1_sb",
                        color: "rgb(var(--ng-neutral-60))"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f835912be3e3e623$export$2e2bcd8739ae039), {
                src: `images/${icon?.imgName}.svg`,
                alt: identifier,
                width: "32px",
                height: "32px"
            })
        ]
    });
};
var $c9b5aa5335b87032$export$2e2bcd8739ae039 = $c9b5aa5335b87032$var$CounterWidget;




var $8NFma = parcelRequire("8NFma");



var $8NFma = parcelRequire("8NFma");



const $1aec3f72a44569a1$var$fetchMailMergeContent = async (url, setMailMergeContent)=>{
    const mailMergeMatches = (0, $44a3924e32d3fca5$export$f8bf049e73c59266)(url);
    if (!mailMergeMatches) {
        setMailMergeContent({
            responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestFullfilled,
            response: url
        });
        return;
    }
    const body = {
        data: url,
        leadId: (0, $44a3924e32d3fca5$export$a92b4a6e98c0f64b)()
    };
    setMailMergeContent({
        responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending
    });
    try {
        const response = await (0, $59a4e0a7efee5abb$export$c7ca02db610e3446)(body);
        setMailMergeContent({
            responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestFullfilled,
            response: response.data
        });
    } catch (error) {
        console.log(error);
        setMailMergeContent({
            responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestRejected
        });
    }
};
const $1aec3f72a44569a1$var$useMailMerge = (config)=>{
    const [mailMergeContent, setMailMergeContent] = (0, $8NFma.useState)({
        responseStatus: (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending
    });
    const url = config?.url || "https://run.crm4b2c.com/a/HomeBuilder";
    (0, $8NFma.useEffect)(()=>{
        $1aec3f72a44569a1$var$fetchMailMergeContent(url, setMailMergeContent);
    }, [
        url
    ]);
    return {
        url: mailMergeContent.response,
        loading: mailMergeContent.responseStatus === (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestPending,
        error: mailMergeContent.responseStatus === (0, $768a17376248dce8$export$2a1f9a4a898c1733).requestRejected,
        initialize: ()=>{
            $1aec3f72a44569a1$var$fetchMailMergeContent(url, setMailMergeContent);
        }
    };
};
var $1aec3f72a44569a1$export$2e2bcd8739ae039 = $1aec3f72a44569a1$var$useMailMerge;



parcelRequire("8NFma");

parcelRequire("8NFma");
var $343b8da7d5ce5f7c$export$4a6dd88bada4e7d2;
var $343b8da7d5ce5f7c$export$e43906f94426ecee;
$343b8da7d5ce5f7c$export$4a6dd88bada4e7d2 = `Q3Qv2W_shimmer`;
$343b8da7d5ce5f7c$export$4a6dd88bada4e7d2;
$343b8da7d5ce5f7c$export$e43906f94426ecee = `Q3Qv2W_shimmerWrapper`;


const $2305be7861b8ff26$var$Shimmer = ({ width: width, height: height })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: $343b8da7d5ce5f7c$export$e43906f94426ecee,
        style: {
            width: width,
            height: height
        },
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: $343b8da7d5ce5f7c$export$4a6dd88bada4e7d2
        })
    });
};
var $2305be7861b8ff26$export$2e2bcd8739ae039 = $2305be7861b8ff26$var$Shimmer;


var $85cda4618ac35cf2$export$699282540ad85892;
var $85cda4618ac35cf2$export$c194ed59d73b3b7f;
var $85cda4618ac35cf2$export$1c20a5e91d81595c;
var $85cda4618ac35cf2$export$7360d40c436ca991;
$85cda4618ac35cf2$export$699282540ad85892 = `Zd0Aka_cardSkeleton`;
$85cda4618ac35cf2$export$c194ed59d73b3b7f = `Zd0Aka_dashboardSkeleton`;
$85cda4618ac35cf2$export$1c20a5e91d81595c = `Zd0Aka_shadowWrapper`;
$85cda4618ac35cf2$export$7360d40c436ca991 = `Zd0Aka_singleRow`;


const $456c9202f2ec3414$var$CardSkeleton = ({ size: size = "small" })=>{
    if (size === "large") return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: $85cda4618ac35cf2$export$699282540ad85892,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2305be7861b8ff26$export$2e2bcd8739ae039), {
                width: "60px",
                height: "60px"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2305be7861b8ff26$export$2e2bcd8739ae039), {
                width: "120px",
                height: "16px"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2305be7861b8ff26$export$2e2bcd8739ae039), {
                width: "100%",
                height: "20px"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2305be7861b8ff26$export$2e2bcd8739ae039), {
                width: "70%",
                height: "20px"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2305be7861b8ff26$export$2e2bcd8739ae039), {
                width: "80px",
                height: "32px"
            })
        ]
    });
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: $85cda4618ac35cf2$export$1c20a5e91d81595c,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2305be7861b8ff26$export$2e2bcd8739ae039), {
                width: "100px",
                height: "40px"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: $85cda4618ac35cf2$export$7360d40c436ca991,
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2305be7861b8ff26$export$2e2bcd8739ae039), {
                        width: "80%",
                        height: "20px"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2305be7861b8ff26$export$2e2bcd8739ae039), {
                        width: "20%",
                        height: "20px"
                    })
                ]
            })
        ]
    });
};
var $456c9202f2ec3414$export$2e2bcd8739ae039 = $456c9202f2ec3414$var$CardSkeleton;


function $deca8c5143b79c98$export$2e2bcd8739ae039({ widgetInformation: widgetInformation = {} }) {
    const { config: config = {}, identifier: identifier } = widgetInformation;
    const { url: url, loading: loading, error: error, initialize: initialize } = (0, $1aec3f72a44569a1$export$2e2bcd8739ae039)(config);
    console.log(url);
    const [zoomScale, setZoomScale] = (0, $8NFma.useState)("1.0");
    const [zoomPercentage, setZoomPercentage] = (0, $8NFma.useState)("100%");
    const handleZoomIn = (e)=>{
        e.stopPropagation();
        const newZoom = Math.min(Number(zoomScale) + 0.1, 1.5).toFixed(1);
        setZoomPercentage((100 / Number(newZoom)).toFixed(2) + "%");
        setZoomScale(newZoom);
    };
    const handleZoomOut = (e)=>{
        e.stopPropagation();
        const newZoom = Math.max(Number(zoomScale) - 0.1, 0.5).toFixed(1);
        setZoomPercentage((100 / Number(newZoom)).toFixed(2) + "%");
        setZoomScale(newZoom);
    };
    const openInNewWindow = ()=>{
        window.open(url, "_blank", "noopener,noreferrer");
    };
    if (loading) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {
        size: "large"
    });
    if (error) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
        className: "webview-widget-retry-button",
        onClick: (e)=>{
            e.stopPropagation();
            initialize();
        },
        children: "retry"
    });
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: `webview-widget widget-container`,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                onClick: openInNewWindow,
                className: "navigate-button",
                "aria-label": "Open in new window",
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f835912be3e3e623$export$2e2bcd8739ae039), {
                    src: `images/${"lsq_external_link_white"}.svg`,
                    alt: "icon",
                    className: "icon",
                    isWidgetIcon: false,
                    color: "black"
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: "zoom-controls",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        onClick: handleZoomIn,
                        children: "+"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        onClick: handleZoomOut,
                        children: "-"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: "frame",
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("iframe", {
                    target: "_parent",
                    src: url,
                    role: "web-view",
                    title: identifier,
                    style: {
                        width: zoomPercentage,
                        height: zoomPercentage,
                        transform: `scale(${zoomScale})`,
                        transformOrigin: "0% 0%"
                    }
                })
            })
        ]
    });
}



parcelRequire("8NFma");


var $8NFma = parcelRequire("8NFma");


const $d5147c6d9df89f95$export$fe58198efe02b173 = async (activeDashboardId, widget, setBannerData, forceFetch)=>{
    const { id: id, config: config } = widget;
    const counterCache = (0, $44a3924e32d3fca5$export$e2575ed62a2f107b)();
    const activeWidgetCache = counterCache?.[activeDashboardId]?.[id];
    if (!forceFetch && activeWidgetCache?.image === config.image.imageKey) setBannerData((prevData)=>({
            ...prevData,
            imageURL: activeWidgetCache.imageURL
        }));
    else {
        const imageUrlData = await (0, $59a4e0a7efee5abb$export$73b84337c4da92bc)(config.image.imageKey);
        if (imageUrlData) {
            setBannerData((prevData)=>({
                    ...prevData,
                    imageURL: imageUrlData
                }));
            const tempCounterCache = (0, $44a3924e32d3fca5$export$e2575ed62a2f107b)();
            const updatedCache = {
                ...tempCounterCache,
                [activeDashboardId]: {
                    ...tempCounterCache[activeDashboardId],
                    [id]: {
                        image: config.image.imageKey,
                        imageURL: imageUrlData
                    }
                }
            };
            (0, $44a3924e32d3fca5$export$e211dab362b85880)(updatedCache);
        }
    }
};
const $d5147c6d9df89f95$var$useBannerData = (widget, activeDashboardId = "default")=>{
    const { id: id, config: config } = widget;
    const [bannerData, setBannerData] = (0, $8NFma.useState)(config);
    const [loading, setLoading] = (0, $8NFma.useState)(true);
    const [reloaded, setReloaded] = (0, $8NFma.useState)(false);
    const loadData = (0, $8NFma.useCallback)(async (forceFetch)=>{
        setLoading(true);
        try {
            if (config?.image) await $d5147c6d9df89f95$export$fe58198efe02b173(activeDashboardId, widget, setBannerData, forceFetch);
        } catch (error) {
            console.error(`Error loading data for widget ${id}:`, error);
        } finally{
            setLoading(false);
        }
    }, []);
    const reloadImage = ()=>{
        if (!reloaded) loadData(true);
        setReloaded(true);
    };
    (0, $8NFma.useEffect)(()=>{
        loadData();
    }, []);
    return {
        bannerData: bannerData,
        loading: loading,
        reloadImage: reloadImage
    };
};
var $d5147c6d9df89f95$export$2e2bcd8739ae039 = $d5147c6d9df89f95$var$useBannerData;


function $d1d254dea52113f4$export$2e2bcd8739ae039({ widgetInformation: widgetInformation }) {
    const { bannerData: bannerData, loading: loading, reloadImage: reloadImage } = (0, $d5147c6d9df89f95$export$2e2bcd8739ae039)(widgetInformation);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: `banner-container show-frame`,
        role: "banner",
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "image-container",
            children: loading || !bannerData?.imageURL ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                className: "overflow-ellipsis",
                children: "Banner"
            }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                src: `${bannerData?.imageURL}`,
                alt: "img",
                onError: reloadImage
            })
        })
    });
}



parcelRequire("8NFma");
var $b15a6cf473d46a7a$export$f19221a5b2d5c36a;
$b15a6cf473d46a7a$export$f19221a5b2d5c36a = `aUa3Iq_itemSubWrapper`;




const $d54d8cf67d501dc2$var$TileWidget = ({ widgetInformation: widgetInformation, onWidgetEdit: onWidgetEdit })=>{
    const { identifier: identifier, icon: icon } = widgetInformation?.config || {};
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: $b15a6cf473d46a7a$export$f19221a5b2d5c36a,
        title: identifier,
        onClick: onWidgetEdit,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $f835912be3e3e623$export$2e2bcd8739ae039), {
                src: `images/${icon?.imgName}.svg`,
                alt: identifier,
                width: "32px",
                height: "32px"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $be0c07f0fc4aecc3$export$2e2bcd8739ae039), {
                text: identifier,
                className: "ng_p_1_sb",
                color: "rgb(var(--ng-neutral-60))"
            })
        ]
    });
};
var $d54d8cf67d501dc2$export$2e2bcd8739ae039 = $d54d8cf67d501dc2$var$TileWidget;



const $712e40098d9c7563$var$widgetMapping = {
    banner: (0, $d1d254dea52113f4$export$2e2bcd8739ae039),
    singlecounter: (0, $c9b5aa5335b87032$export$2e2bcd8739ae039),
    webview: (0, $deca8c5143b79c98$export$2e2bcd8739ae039),
    tile: (0, $d54d8cf67d501dc2$export$2e2bcd8739ae039)
};
const $712e40098d9c7563$var$WidgetWrapper = ({ data: data })=>{
    if (!data) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h1", {
        children: "Widget not found"
    });
    const widgetType = (0, $44a3924e32d3fca5$export$43dc4e2240cb354f)(data.config);
    if (!widgetType) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h1", {
        children: "Widget not found"
    });
    const Widget = $712e40098d9c7563$var$widgetMapping[widgetType];
    return Widget ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(Widget, {
        widgetInformation: data
    }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h1", {
        children: "Widget not found"
    });
};
var $712e40098d9c7563$export$2e2bcd8739ae039 = $712e40098d9c7563$var$WidgetWrapper;



parcelRequire("8NFma");

parcelRequire("8NFma");



const $c53d1f446eeb45f1$var$DashboardSkeleton = ()=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: $85cda4618ac35cf2$export$c194ed59d73b3b7f,
        "data-testid": "dashboard-skeleton",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                className: $85cda4618ac35cf2$export$1c20a5e91d81595c,
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $2305be7861b8ff26$export$2e2bcd8739ae039), {
                    width: "100%",
                    height: "40px"
                })
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: $85cda4618ac35cf2$export$7360d40c436ca991,
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        className: $85cda4618ac35cf2$export$7360d40c436ca991,
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {
                                size: "large"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {
                                size: "large"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        className: $85cda4618ac35cf2$export$7360d40c436ca991,
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {
                            size: "large"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {
                size: "large"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {
                size: "large"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                className: $85cda4618ac35cf2$export$7360d40c436ca991,
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $456c9202f2ec3414$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $c53d1f446eeb45f1$export$2e2bcd8739ae039 = $c53d1f446eeb45f1$var$DashboardSkeleton;


const $37014cf662997bc7$var$Skeleton = ({ type: type = "dashboard" })=>{
    const typeMapping = {
        dashboard: (0, $c53d1f446eeb45f1$export$2e2bcd8739ae039)
    };
    const SkeletonType = typeMapping[type] || (0, $c53d1f446eeb45f1$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(SkeletonType, {});
};
var $37014cf662997bc7$export$2e2bcd8739ae039 = $37014cf662997bc7$var$Skeleton;


var $1bebd2eb4334c24a$export$404f92a58dfc35b9;
var $1bebd2eb4334c24a$export$d45d45b2c4a7441e;
var $1bebd2eb4334c24a$export$1c4e4560041c6881;
$1bebd2eb4334c24a$export$404f92a58dfc35b9 = `_2gTf6G_lead360GridWrapper`;
$1bebd2eb4334c24a$export$d45d45b2c4a7441e = `_2gTf6G_parentWrapper`;
$1bebd2eb4334c24a$export$1c4e4560041c6881 = `_2gTf6G_widgetWrapper`;



parcelRequire("8NFma");

const $675ebb3232dd3c50$var$RetryComponent = ({ onRetry: onRetry = ()=>{} })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        className: "retry-container",
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("h2", {
                className: "retry-title",
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("p", {
                className: "retry-message",
                children: "Please try again."
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("button", {
                className: "retry-button",
                onClick: onRetry,
                children: "Retry"
            })
        ]
    });
};
var $675ebb3232dd3c50$export$2e2bcd8739ae039 = $675ebb3232dd3c50$var$RetryComponent;



const $b40593aa2126b457$var$Lead360 = ()=>{
    const { loading: loading, error: error, widgetMap: widgetMap, pageConfig: pageConfig, initialize: initialize } = (0, $53a8347334f1af9b$export$2e2bcd8739ae039)();
    const gridConfig = {
        className: $1bebd2eb4334c24a$export$404f92a58dfc35b9,
        layouts: {
            lg: pageConfig
        },
        breakpoints: {
            lg: 956,
            xxs: 320
        },
        cols: {
            lg: 16,
            xxs: 4
        },
        rowHeight: 20,
        margin: [
            16,
            16
        ],
        containerPadding: [
            5,
            0
        ],
        isDraggable: false,
        isResizable: false
    };
    if (loading) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $37014cf662997bc7$export$2e2bcd8739ae039), {
        type: "dashboard"
    });
    if (error) {
        if (window.lead360HelperUtils?.handleFallback) return null;
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $675ebb3232dd3c50$export$2e2bcd8739ae039), {
            onRetry: initialize
        });
    }
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        className: $1bebd2eb4334c24a$export$d45d45b2c4a7441e,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e3447d102e285015$export$2e2bcd8739ae039), {
            config: gridConfig,
            children: pageConfig?.map((widget)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    "data-grid": widget,
                    className: $1bebd2eb4334c24a$export$1c4e4560041c6881,
                    onClick: ()=>(0, $44a3924e32d3fca5$export$73f97a394323284c)(widgetMap[widget.id]?.config),
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $712e40098d9c7563$export$2e2bcd8739ae039), {
                        "data-grid": widget,
                        data: widgetMap[widget.id]
                    })
                }, widget.id))
        })
    });
};
var $b40593aa2126b457$export$2e2bcd8739ae039 = $b40593aa2126b457$var$Lead360;



const $e998e36c7d3822d2$var$Module = ({ name: name })=>{
    const defaultModule = (0, $b40593aa2126b457$export$2e2bcd8739ae039);
    const moduleMapping = {
        lead360: (0, $b40593aa2126b457$export$2e2bcd8739ae039)
    };
    const Module = moduleMapping[name] || defaultModule;
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8NFma.StrictMode), {
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            className: "moduleWrapper",
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)(Module, {})
        })
    });
};
var $e998e36c7d3822d2$export$2e2bcd8739ae039 = $e998e36c7d3822d2$var$Module;


const $cebbcc51771ac8cf$var$renderApp = (containerId, moduleName)=>{
    const container = document.getElementById(containerId);
    const root = (0, $503937b663c395c4$exports.createRoot)(container);
    root.render(/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e998e36c7d3822d2$export$2e2bcd8739ae039), {
        name: moduleName
    }));
};
window.ReactLead360 = {
    renderApp: $cebbcc51771ac8cf$var$renderApp
};

})();
//# sourceMappingURL=initialize360.js.map
